angular.module('Itao.IndicatorMap', ['ngAnimate', 'ngSanitize', 'ui.tree', 'ui.tree-filter', 'dndLists', 'ui.bootstrap', 'textAngular', 'rzModule'])
  .config(['$provide', function($provide) {
    'use strict';
    $provide.decorator('taOptions', ['taRegisterTool', 'taToolFunctions', '$delegate', 'ModalService', 'mapConfig', function(taRegisterTool, taToolFunctions, taOptions, ModalService, mapConfig){

      taRegisterTool('insertLinkModal', {
        tooltiptext: 'add link',
        iconclass: 'fa fa-link',
        action: function(promise, restoreSelection){
          var that = this;
          ModalService.createCustomModal({}, {
            templateUrl: mapConfig.templateBasePath + 'modals/addLink.html',
            controller: 'TextfieldModalController'
          }).result.then(function(urlAdress){
            if (urlAdress) {
              restoreSelection(); // selection will be lost in the modal interaction - you need to have rangy core and rangy saveselection enabled, or the minified rangy bundle from the repo
              that.$editor().wrapSelection('createLink', urlAdress, true);
              promise.resolve(); // this tells the editor you're done and bindings should be updated now
            }
          });
          return false;
        },
        activeState: function(commonElement){
          if(commonElement) return commonElement[0].tagName === 'A';
          return false;
        }/*,
         onElementSelect: {
         element: 'a',
         action: taToolFunctions.aOnSelectAction
         }*/
      });
      taOptions.classes = {
        focussed: 'focussed',
        toolbar: 'btn-toolbar',
        toolbarGroup: 'btn-group btn-group-sm',
        toolbarButton: 'btn btn-default',
        toolbarButtonActive: 'active',
        disabled: 'disabled',
        textEditor: '',
        htmlEditor: ''
      };
      return taOptions;
    }]);
  }]);

/**
 * Very basic provider for everything that needs to configured on runtime
 */
angular.module('Itao.IndicatorMap').provider('mapConfig', function () {
  'use strict';
  var config = {
    templateBasePath: '/templates/',
    widgetExport: {
      cssUrl: location.origin + '/vendor/itao/itaohyperion/Resources/Public/JavaScript/Hyperion/dist/css/hyperion.css',
      remoteUrl: 'http://localhost:8081/v1/generateImage'
    },
    registeredUserMode: false,
    styling: {
      default: {
        weight: 1,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.7,
        fillColor: '#333333',
        complexColorSet: ['rgba(35,187,30,1)','rgba(35,187,30,.8)','rgba(35,187,30,.6)','rgba(35,187,30,.4)','rgba(35,187,30,.2)','rgba(35,187,30,.1)']
      },
      hover: {
        weight: 1,
        dashArray: '0',
        fillOpacity: 1
      },
      selected: {
        weight: 2,
        dashArray: '0',
        color: 'black'
      }
    },
    defaultLabels: {
      showId: false,
      showTitle: true,
      showValue: false
    },
    chartColors: [
      '#1B9E77',
      '#D95F02',
      '#7570B3',
      '#E7298A',
      '#66A61E',
      '#E6AB02',
      '#A6761D',
      '#666666'
    ],
    chartColorAt: function(number){
      return config.chartColors[number % config.chartColors.length];
    },
    tileLayer: {
      url: 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpandmbXliNDBjZWd2M2x6bDk3c2ZtOTkifQ._QA7i5Mpkd_m30IGElHziw',
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
      '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
      'Imagery © <a href="http://mapbox.com">Mapbox</a>',
    },
    defaultBaseLayer: null,
    numberOfScales: 6,
    defaultSelectedClassMethod: 'width',
    defaultGridWidgetHeight: 1,
    axisMaxValue: null,
    absoluteIndicatorsDecimalPlaces: 0,
    relativeIndicatorsDecimalPlaces: 1,
    availableDataLayerTypeUids: [],
    showIndicatorTypeInMapHover: false,
    redLines: [],
    avgKey: 'avg',
    avgName: 'Durchschnitt'
  };
  return {
    setConfig: function (configName, value) {
      config[configName] = value;
    },
    $get: function () {
      return config;
    }
  };
});

angular.module('Itao.IndicatorMap').filter('inArray', ['$filter', function ($filter) {
  'use strict';

  return function (list, arrayFilter, element) {
    if (arrayFilter) {
      return $filter('filter')(list, function (listItem) {
        return arrayFilter.indexOf(listItem[element]) > -1;
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').factory('ColorSetService', ['mapConfig', function (mapConfig) {
  'use strict';

  /**
   * @param uid
   * @param name
   * @param colors
   * @constructor
   */
  function ColorSet(uid, name, colors) {
    this.uid = uid;
    this.name = name;
    this.colors = colors;
  }

  return {
    createColorSet: function (uid, name, colors) {
      return new ColorSet(uid, name, colors);
    }
  };
}]);

angular.module('Itao.IndicatorMap').factory('DataLayerService', function () {
  'use strict';

  /**
   *
   * @param {Object} layer the dataLayer
   * @param {String} districtUid the districtUid
   * @param {String} indicatorUid the indicatorUid
   * @returns {*}
   */
  function getValueForDistrictAndIndicator(layer, districtUid, indicatorUid) {
    if(layer.hasOwnProperty(districtUid) && layer[districtUid].hasOwnProperty(indicatorUid)) {
      return layer[districtUid][indicatorUid];
    } else {
      return null;
    }
  }

  /**
   *
   * @param {Object} layer the dataLayer
   * @param {String} indicatorUid the indicatorUid
   * @returns {number} the maximum value for the given indicator
   */
  function getMaxValueForIndicator(layer, indicatorUid) {
    var values = [];
    for(var districtUid in layer.districts) {
      if(layer.districts.hasOwnProperty(districtUid)) {
        values.push(getValueForDistrictAndIndicator(layer, districtUid, indicatorUid));
      }
    }
    return Math.max.apply(null, values);
  }

  return {
    getValueForDistrictAndIndicator: getValueForDistrictAndIndicator,
    getMaxValueForIndicator: getMaxValueForIndicator
  };
});

angular.module('Itao.IndicatorMap').service('DistrictStyling', ['mapConfig', function (mapConfig) {
  'use strict';
  return {

    /**
     * Returns the ol styling object for a given indicator and value
     * uses the configurable styles from the mapConfig
     * hover style is applied on top of selected style
     *
     * @param {Indicator} indicator the indicator to use
     * @param {float} value the value of the district
     * @param {float} fillOpacity configurable opacity for the fill color
     * @param {boolean} selected apply selected style
     * @param {boolean} hover apply hover style
     *
     * @returns {object}
     */
    getStyleForIndicatorAndValue: function (indicator, value, fillOpacity, selected, hover) {
      var styling = angular.copy(mapConfig.styling.default);
      if(angular.isNumber(fillOpacity)) {
        styling.fillOpacity = fillOpacity;
      }
      if(selected === true) {
        for(var selectedProperty in mapConfig.styling.selected) {
          styling[selectedProperty] = mapConfig.styling.selected[selectedProperty];
        }
      }
      if(hover === true) {
        for(var hoverProperty in mapConfig.styling.hover) {
          styling[hoverProperty] = mapConfig.styling.hover[hoverProperty];
        }
      }
      styling.fillColor = indicator ? indicator.getColorForValue(value) : selected ? mapConfig.styling.selected.fillColor : mapConfig.styling.default.fillColor;
      return styling;
    }
  };
}]);

angular.module('Itao.IndicatorMap').factory('IndicatorService', ['mapConfig', 'UtilityService', function (mapConfig, UtilityService) {
  'use strict';

  /**
   *
   * @param uid
   * @param name
   * @param key
   * @param unit
   * @param category
   * @param type
   * @param list
   * @param isDefault
   * @param defaultScale
   * @param defaultColorSet
   * @param indication
   * @param hint
   * @param source
   * @param statement
   * @param calculation
   * @param defaultInvert
   * @param classidentifier
   * @param sorting
   * @param categorical
   * @param listIndex
   * @param prefix
   * @param redLines
   * @constructor
   */
  function Indicator(uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines) {
    this.uid = uid;
    this.name = name;
    this.key = key;
    this.unit = unit;
    this.category = category;
    this.type = type;
    this.list = list;
    this.isDefault = isDefault;
    this.defaultScale = defaultScale;
    this.defaultColorSet = defaultColorSet;
    this.indication = indication;
    this.hint = hint;
    this.source = source;
    this.statement = statement;
    this.calculation = calculation;
    this.defaultInvert = defaultInvert;
    this.inverted = false;
    this.class = classidentifier;
    this.sorting = sorting;
    this.listIndex = listIndex;
    this.categorical = categorical;
    this.prefix = prefix != null ? prefix : '';
    this.redLines = redLines ? redLines.split(";") : '';
  }

  Indicator.prototype.invertScale = function () {
    this.reverseColors();
    this.reversePointColors();
    this.inverted = !this.inverted;
  };

  Indicator.prototype.reverseColors = function() {
    if(!this.scales) return;
    var invertedColors = [];
    this.scales.forEach(function (scale, index) {
      invertedColors.push(scale.color);
    });
    invertedColors.reverse();
    this.scales.forEach(function (scale, index) {
      scale.color = invertedColors[index];
    });
  };

  Indicator.prototype.reversePointColors = function() {
    if(!this.pointScales) return;
    var invertedColors = [];
    this.pointScales.forEach(function (scale, index) {
      invertedColors.push(scale.color);
    });
    invertedColors.reverse();
    this.pointScales.forEach(function (scale, index) {
      scale.color = invertedColors[index];
    });
  };

  /**
   *
   * @param dataLayer
   * @param selectedIndicator
   * @param colorSet
   * @param method
   * @param numberOfScales
   */
  Indicator.prototype.updateScales = function(dataLayer, selectedIndicator, colorSet, method, numberOfScales) {
    this.scales = UtilityService.buildIndicatorScales(dataLayer, this, colorSet, method, numberOfScales);
    if(this.defaultInvert) {
      this.reverseColors();
    }
  };

  /**
   * @param dataLayer
   * @param selectedIndicator
   * @param colorSet
   * @param method
   * @param numberOfScales
   */
  Indicator.prototype.updatePointScales = function(dataLayer, selectedIndicator, colorSet, method, numberOfScales) {
    if(!dataLayer) return;
    this.pointScales = UtilityService.buildIndicatorScales(dataLayer, this, colorSet, method, numberOfScales);
    if(this.defaultInvert) {
      this.reversePointColors();
    }
  };

  /**
   * Returns the Color for a given value
   * or the configured value from the notAvailable Styling options
   * if the value does not match any range in the scale
   * @param {float} value
   * @returns {string}
   */
  Indicator.prototype.getColorForValue = function (value) {
    if(value === null) return mapConfig.styling.default.fillColor;
    return this.scales.reduce(function (memory, scale) {
      if (scale.isValueInsideScale(value)) {
        return scale.color;
      }
      return memory;
    }, mapConfig.styling.default.fillColor);
  };

  /**
   * Returns the Color for a given value
   * or the configured value from the notAvailable Styling options
   * if the value does not match any range in the scale
   * @param {float} value
   * @returns {string}
   */
  Indicator.prototype.getPointColorForValue = function (value) {
    if(value === null) return mapConfig.styling.default.fillColor;
    return this.pointScales.reduce(function (memory, scale) {
      if (scale.isValueInsideScale(value)) {
        return scale.color;
      }
      return memory;
    }, mapConfig.styling.default.fillColor);
  };

  /**
   *
   * @param indicators
   * @param uids
   * @returns {{}}
   */
  function filterIndicatorsByUids(indicators, uids) {
    var filteredIndicators = {},
        allUids = uids;
    allUids.forEach(function(uid) {
      if(indicators && indicators.hasOwnProperty(uid) && indicators[uid] != null) {
        if(uids.indexOf(uid) > -1) indicators[uid].hasShapeData = true;
        filteredIndicators[uid] = indicators[uid];
      } else {
        //console.warn('Indicator ' + uid + ' is referenced, but not found in indicators. This probably means that an indicatorData references an indicator that is not loaded.');
      }
    });
    return filteredIndicators;
  }

  /**
   *
   * @param indicators
   * @returns {{}}
   */
  function filterOutSetIndicators(indicators) {
    if(!indicators) return {};
    var filteredIndicators = {};
    angular.forEach(indicators, function(indicator, uid) {
      if((!indicator.list && !indicator.type) || indicator.isDefault) {
        filteredIndicators[uid] = indicator;
      }
    });
    return filteredIndicators;
  }

  /**
   *
   * @param indicators
   * @param indicatorSets
   * @returns Array
   */
  function findIndicatorSetsInIndicators(indicators, indicatorSets) {
    if(!indicators) return [];
    var filteredIndicatorSets = [];
    angular.forEach(indicators, function(indicator) {
      if(indicator.isDefault) {
        filteredIndicatorSets.push(indicatorSets.filter(function(type) {
          return type.uid == indicator.type;
        })[0]);
      }
    });
    return filteredIndicatorSets.sort(function(a,b) {
      return a.sorting - b.sorting;
    });
  }

  return {
    createIndicator: function (uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines) {
      return new Indicator(uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines);
    },
    filterIndicatorsByUids: filterIndicatorsByUids,
    filterOutSetIndicators: filterOutSetIndicators,
    findIndicatorSetsInIndicators: findIndicatorSetsInIndicators
  };
}]);

angular.module('Itao.IndicatorMap').factory('IndicatorCategoryService', function () {
  'use strict';

  /**
   * IndicatorCategory constructor
   * @param {Integer} uid uid of IndicatorCategory
   * @param {String} name name of IndicatorCategory
   * @param {IndicatorCategory} parent of this IndicatorCategory
   * @constructor
   */
  function IndicatorCategory(uid, name, parent, classIdentifier, sorting) {
    this.uid = uid;
    this.name = name;
    this.parent = parent;
    this.categories = [];
    this.class = classIdentifier;
    this.sorting = sorting;
  }

  return {
    createIndicatorCategory: function (uid, name, parent, classIdentifier, sorting) {
      return new IndicatorCategory(uid, name, parent, classIdentifier, sorting);
    }
  };
});

angular.module('Itao.IndicatorMap').factory('IndicatorSetService', function () {
  'use strict';

  /**
   * IndicatorSet constructor
   * @param {Integer} uid uid of IndicatorSet
   * @param {String} name name of IndicatorSet
   * @param lists
   * @param category
   * @param {String} classidentifier
   * @param colorSet
   * @param sorting
   * @param unit
   * @constructor
   */
  function IndicatorSet(uid, name, lists, category, classidentifier, colorSet, sorting, unit) {
    this.uid = uid;
    this.name = name;
    this.lists = lists;
    this.category = category;
    this.indicators = [];
    this.defaultIndicator = {};
    this.class = classidentifier;
    this.colorSetUid = colorSet;
    this.colorSet = null;
    this.sorting = sorting;
    this.unit = unit;
  }

  /**
   * maps all Indicators to the Set or its lists
   * @param {Object} indicators
   */
  IndicatorSet.prototype.addIndicators = function (indicators) {
    var thisSet = this;
    for(var indicatorUid in indicators) {
      if(indicators.hasOwnProperty(indicatorUid)) {
        var indicator = indicators[indicatorUid];

        if (indicator.type === thisSet.uid) {
          thisSet.indicators.push(indicator);
          if (indicator.isDefault) {
            thisSet.defaultIndicator = indicator;
          }
        }
        var listIndex = thisSet.hasList(indicator.list);
        if (listIndex > -1) {
          // thisSet.lists[listIndex].indicators.push(indicator); // no sorting of list-indicators
          thisSet.lists[listIndex].indicators[indicator.listIndex] = indicator;
          if (indicator.isDefault) {
            thisSet.defaultIndicator = indicator;
            thisSet.unit = indicator.unit;
          }
        }
      }
    }
  };

  /**
   * populates colorSets into the indicatorSets and indicatorLists
   * @param colorSets
   */
  IndicatorSet.prototype.populateColorSets = function (colorSets) {
    if(this.colorSetUid != null && this.colorSetUid !== '0') {
      var currentIndicatorSet = this;
      this.colorSet = colorSets.filter(function(colorSet) {
        return colorSet.uid === currentIndicatorSet.colorSetUid;
      })[0];

      this.lists = this.lists.map(function(list) {
        list.colorSet = colorSets.filter(function(colorSet) {
          return colorSet.uid === list.colorSet;
        })[0];
        return list;
      });
    }
  };

  /**
   * Checks for List
   * @param listId
   * @returns {number}
   */
  IndicatorSet.prototype.hasList = function (listId) {
    return this.lists.reduce(function (prevVal, currentList, index) {
      if (currentList.uid === listId) {
        return index;
      } else {
        return prevVal;
      }
    }, -1);
  };

  /**
   * Checks for List
   * @returns {number}
   */
  IndicatorSet.prototype.getDefaultIndicator = function () {
    return this.indicators.reduce(function (prevVal, currentIndicator) {
      if (currentIndicator.isDefault) {
        return currentIndicator;
      } else {
        return prevVal;
      }
    }, -1);
  };

  return {
    createIndicatorSet: function (uid, name, lists, category, classidentifier, colorSet, sorting) {
      return new IndicatorSet(uid, name, lists, category, classidentifier, colorSet, sorting);
    }
  };
});

angular.module('Itao.IndicatorMap').factory('IndicatorSetHandling', function () {
  'use strict';

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param indicatorSet
   */
  function sortIndicatorsAndLists(indicatorSet) {
    return indicatorSet.indicators
      .filter(function(indicator){
        return indicator.list === false;
      })
      .concat(indicatorSet.lists)
      .sort(function(a,b){
        return a.listIndex - b.listIndex;
      });
  }

  /**
   *
   * @param indicatorSet
   */
  function sortIndicatorsAndListsFlat(indicatorSet) {
    return sortIndicatorsAndLists(indicatorSet).reduce(function(list, indicatorOrList) {
      if(isList(indicatorOrList)) {
        return list.concat(indicatorOrList.indicators)/*.sort(function(a,b){
          return a.listIndex - b.listIndex;
        })*/;
      } else {
        return list.concat([indicatorOrList])
      }
    }, []);
  }

  return {
    sortIndicatorsAndListsFlat: sortIndicatorsAndListsFlat,
    sortIndicatorsAndLists: sortIndicatorsAndLists
  };
});

angular.module('Itao.IndicatorMap').factory('IndicatorTree', function () {
  'use strict';

  /**
   * IndicatorTree constructor
   * @param {Object} indicators the indicators
   * @param {Object} categories the categories
   * @param {Object} indicatorSets the indicatorsets
   * @returns {Array}
   */
  function buildIndicatorTree(indicators, categories, indicatorSets) {
    var indicatorsObject = angular.copy(indicators);
    var categoriesObject = angular.copy(categories);
    var indicatorSetsObject = angular.copy(indicatorSets);

    return filterAndSortTree(buildTreeFromFlatCategories(addIndicatorSetsToCategories(indicatorSetsObject, addIndicatorsToCategories(indicatorsObject, categoriesObject))));

  }

  /**
   *
   * @param {Object} indicatorsObject the indicators
   * @param {Object} categoriesObject the categories
   * @returns {Object} the categoriesObject with added indicators
   */
  function addIndicatorsToCategories(indicatorsObject, categoriesObject) {

    for(var indicatorUid in indicatorsObject) {
      if(indicatorsObject && indicatorsObject.hasOwnProperty(indicatorUid)) {
        var indicator = indicatorsObject[indicatorUid];
        indicator.title = indicator.name;
        if(indicator.category && !indicator.type && !indicator.list && categoriesObject[indicator.category]) {
          if(categoriesObject[indicator.category].items) {
            categoriesObject[indicator.category].items.push(indicator);
          } else {
            categoriesObject[indicator.category].items = [indicator];
          }
        }
      }
    }

    return categoriesObject;
  }

  /**
   *
   * @param {Object} indicatorSetsObject the indicatorsSets
   * @param {Object} categoriesObject the categories
   * @returns {Object} the categoriesObject with added indicatorSets
   */
  function addIndicatorSetsToCategories(indicatorSetsObject, categoriesObject) {
    for(var indicatorSetUid in indicatorSetsObject) {
      if(indicatorSetsObject.hasOwnProperty(indicatorSetUid)) {
        var indicatorSet = indicatorSetsObject[indicatorSetUid];
        indicatorSet.title = indicatorSet.name;
        if(indicatorSet.category && categoriesObject[indicatorSet.category]) {
          if(categoriesObject[indicatorSet.category].items) {
            categoriesObject[indicatorSet.category].items.push(indicatorSet);
          } else {
            categoriesObject[indicatorSet.category].items = [indicatorSet];
          }

        }
      }
    }
    return categoriesObject;
  }

  /**
   * Builds a tree from a flat categoriesObject
   *
   * @param {Object} categoriesObject the categories
   * @returns {Array} the tree
   */
  function buildTreeFromFlatCategories(categoriesObject) {
    var tree = [];
    for(var categoryUid in categoriesObject) {
      if(categoriesObject.hasOwnProperty(categoryUid)) {
        var category = categoriesObject[categoryUid];
        category.title = category.name;

        var parentUid = category.parent;
        if(parentUid && categoriesObject.hasOwnProperty(parentUid)) {
          var parent = categoriesObject[parentUid];
          if(!parent.items) {
            parent.items = [];
          }
          parent.items.push(category);
          parent.items.sort(compareItemsForSorting); // sorting is done here to prevent from walking the complete tree for sorting
        } else {
          tree.push(category); // rootcategories
        }
      }
    }
    return tree;
  }

  /**
   * filter for null values
   * @param {*} item item to check
   * @returns {boolean}
   */
  function filterNull(item) {
    return item != null;
  }

  /**
   * filter empty categories and sort by 'compareItemsForSorting'
   * @param {Array} tree the tree to filter
   * @returns {Array}
   */
  function filterAndSortTree(tree) {
    for(var i= 0; i < tree.length; i++) {
      var node = tree[i];
      if(node.class === 'category') {
        if(!angular.isArray(tree[i].items)) {
          tree[i] = null; // remove category without items
        } else {
          var subItems = filterAndSortTree(node.items);
          if(subItems.length === 0) {
            tree[i] = null; // remove category with all items filtered out
          } else {
            tree[i].items = subItems;
          }
        }
      }
    }

    return tree.filter(filterNull).sort(compareItemsForSorting);
  }

  /**
   * comparefunction for sorting tree items
   * categories are sorted first, after that it`s alphabetically
   *
   * @param {Object} a first item
   * @param {Object} b second item
   * @returns {number}
   */
  function compareItemsForSorting(a, b) {
    if(a.class === 'category' && b.class !== 'category') {
      return -1;
    }
    if(a.class !== 'category' && b.class === 'category') {
      return 1;
    }
    var sortResult = 0;
    if(a.hasOwnProperty('sorting') && a.sorting != null && b.hasOwnProperty('sorting') && b.sorting != null) {
      sortResult = a.sorting - b.sorting;
    }
    if(angular.isNumber(sortResult) && sortResult !== 0) {
      return sortResult;
    } else {
      return a.title.localeCompare(b.title);
    }
  }

  return {

    /**
     * Returns the Indicator-Tree
     * @param indicators
     * @param categories
     * @param indicatorSets
     * @returns {IndicatorTree}
     */
    buildIndicatorTree: buildIndicatorTree
  };
});

angular.module('Itao.IndicatorMap').factory('ScaleService', function () {
  'use strict';

  /**
   * Scale constructor
   * @param from
   * @param to
   * @param color
   * @param name
   * @constructor
   */
  function Scale(from, to, color, name) {
    this.from = parseFloat(from);
    this.to = parseFloat(to);
    this.color = color;
    this.name = name;
  }

  Scale.prototype.isValueInsideScale = function (value) {
    return value >= this.from && value <= this.to;
  };

  return {
    createScale: function (from, to, color, name) {
      return new Scale(from, to, color, name);
    }
  };
});

/**
 * This service serves as an interface how a real BookmarkService should be implemented! Do not use in Production!
 */
angular.module('Itao.IndicatorMap').factory('BookmarkService', ['$q', function($q){
  'use strict';
  return {

    /**
     * Creates a new bookmark
     * @param {String} title Title of the bookmark
     * @param {Integer} categoryId Id of the bookmark's category
     * @param {Object} config Configuration object of the app's state
     * @returns {Promise}
     */
    createBookmark: function (title, categoryId, config) {
      var deferred = $q.defer();
      deferred.resolve({
        id: Math.random() * 1000,
        title: title,
        uri: location.href,
        category: categoryId,
        config: JSON.stringify(config)
      });
      return deferred.promise;
    },

    /**
     * Deletes a bookmark by its id
     * @param {Integer} bookmarkId bookmark's id
     * @returns {Promise}
     */
    deleteBookmark: function(bookmarkId) {
      var deferred = $q.defer();
      deferred.resolve(true);
      return deferred.promise;
    }
  };

}]);

angular.module('Itao.IndicatorMap').factory('d3', function () {
  'use strict';

  if (!angular.isDefined(d3) || !angular.isObject(d3)) {
    throw 'd3 has to be loaded for D3Service';
  }

  /**
   * Helperfunction for creating accessor functions
   * @param {String} field the property name to return, if undefined the datum will be returned
   * @returns {Function}
   */
  var accessor = function (field) {
    return function (datum) {
      return typeof(field) === 'undefined' ? datum : datum[field];
    };
  };

  /**
   * Helperfunction for composing functions, commonly used for composing accessor functions with scale functions
   * @param {Function} g the outer function
   * @param {Function} h the inner function
   * @returns {Function}
   */
  var compose = function (g, h) {
    return function () {
      return g(h.apply(null, arguments));
    };
  };

  /**
   * German number and time formatting
   * @type {{numberFormat, timeFormat}}
   */
  var germanFormat = d3.locale({
    'decimal': ',',
    'thousands': '.',
    'grouping': [3],
    'currency': ['€', ''],
    'dateTime': '%a %b %e %X %Y',
    'date': '%d.%m.%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    'shortDays': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    'shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
  });

  var gridColor = '#ddd';
  var gridWidth = '1px';

  /**
   * Generatorfunction for grid generation
   *
   * @param scale
   * @param x1
   * @param x2
   * @param y1
   * @param y2
   * @param tickCount
   * @param duration
   * @returns {Function}
   */
  var addGridLines = function (scale, x1, x2, y1, y2, tickCount, duration) {

    var applyLinePosition = function (selection) {
      selection.attr({
        'x1': x1 === null ? function (d) {
          return scale(d);
        } : x1,
        'x2': x2 === null ? function (d) {
          return scale(d);
        } : x2,
        'y1': y1 === null ? function (d) {
          return scale(d);
        } : y1,
        'y2': y2 === null ? function (d) {
          return scale(d);
        } : y2
      });
    };

    return function (selection) {
      var horizontalGridGroup = selection.selectAll(".horizontalGridGroup").data([1]);
      horizontalGridGroup.enter().append('g').attr({
        'class': 'horizontalGridGroup',
        'fill': 'none',
        'shape-rendering': 'crispEdges',
        'stroke': gridColor,
        'stroke-width': gridWidth
      });

      var horizontalGrid = horizontalGridGroup.selectAll("line.horizontalGrid").data(scale.ticks(tickCount), accessor());
      horizontalGrid.enter()
        .append("line")
        .attr('class', 'horizontalGrid')
        .call(applyLinePosition);

      horizontalGrid.transition().duration(duration)
        .call(applyLinePosition);

      horizontalGrid.exit().remove();

      return this;
    }
  };

  /**
   * Add horizontal grid lines to a diagram
   *
   * use like this:
   * g.call(addHorizontalGridLines(...))
   *
   * @param yScale
   * @param x1
   * @param x2
   * @param tickCount
   * @param duration
   * @returns {Function}
   */
  var addHorizontalGridLines = function (yScale, x1, x2, tickCount, duration) {
    return addGridLines(yScale, x1, x2, null, null, tickCount, duration);
  };

  /**
   * Add vertical grid lines to a diagram
   *
   * use like this:
   * g.call(addVerticalGridLines(...))
   *
   * @param xScale
   * @param y1
   * @param y2
   * @param tickCount
   * @param duration
   * @returns {Function}
   */
  var addVerticalGridLines = function (xScale, y1, y2, tickCount, duration) {
    return addGridLines(xScale, null, null, y1, y2, tickCount, duration);
  };

  /**
   * Add highlight lines to diagram
   *
   * use like this:
   * g.call(addHighlightLines(...))
   *
   * @param values
   * @param y
   * @param width
   * @param duration
   * @param minMax
   * @returns {Function}
   */
  var addHorizontalHighlightLines = function (values, y, width, duration, minMax) {
    return function (selection) {
      if (angular.isArray(values) && values.length > 0) {
        var redLineInitialY = y(0);
        var cssClass = minMax ? 'highlightLine highlightLine--min-max' : 'highlightLine';

        var redLine = selection.selectAll('.highlightLine')
          .data(values);

        redLine.enter().append('line')
          .attr('class', cssClass)
          .style('stroke-width', '4')
          .style('shape-rendering', 'crispEdges')
          .attr('pointer-events', 'none')
          .attr('x1', 0)
          .attr('y1', redLineInitialY)
          .attr('x2', width)
          .attr('y2', redLineInitialY);

        redLine.transition().duration(duration)
          .attr('x2', width)
          .attr('y1', function (d) {
            return y(d);
          })
          .attr('y2', function (d) {
            return y(d);
          });

        redLine.exit().remove();
      }
    };
  };

  /**
   * Add highlight lines to diagram
   *
   * use like this:
   * g.call(addHighlightLines(...))
   *
   * @param values
   * @param y
   * @param x
   * @param width
   * @param duration
   * @returns {Function}
   */
  var addHorizontalHighlightArea = function (values, y, x, width, duration) {
    return function (selection) {
      if (angular.isArray(values) && values.length > 0) {
        var initialY = y(0),
          initialX = x(0);

        var redLine = selection.selectAll('.highlightArea')
          .data(values);

        redLine.enter().append('rect')
          .attr('class', 'highlightArea')
          .attr('width', 0)
          .attr('x', initialX)
          .attr('y', initialY)
          .attr('height', 0);

        redLine.transition().duration(duration)
          .attr('y', function (d) {
            return y(Math.max(0, d));
          })

          .attr('width', width)
          .attr('height', function (d) {
            return Math.abs(y(0) - y(d));
          });

        redLine.exit().remove();
      } else {
        selection.selectAll('.highlightArea')
          .remove();
      }
    };
  };

  /**
   * add min-max-highlight-area to diagram
   *
   * use like this:
   * g.call(addHighlightLines(...))
   *
   * @param minMax
   * @param y
   * @param x
   * @param width
   * @param duration
   * @returns {Function}
   */
  var addHorizontalMinMaxHighlightArea = function (minMax, y, x, width, duration) {
    return function (selection) {
      if (angular.isArray(minMax) && minMax.length > 0) {
        var initialY = y(0),
          initialX = x(0);

        var redLine = selection.selectAll('.highlightArea')
          .data([minMax]);

        redLine.enter().append('rect')
          .attr('class', 'highlightArea highlightArea--min-max')
          .attr('width', 0)
          .attr('x', initialX)
          .attr('y', initialY)
          .attr('height', 0);

        redLine.transition().duration(duration)
          .attr('y', 0)

          .attr('width', width)
          .attr('height', function (d) {
            return Math.abs(y(d[1]));
          });

        redLine.exit().remove();
      } else {
        selection.selectAll('.highlightArea')
          .remove();
      }
    };
  };

  /**
   * Add highlight lines to diagram
   *
   * use like this:
   * g.call(addHighlightLines(...))
   *
   * @param values
   * @param y
   * @param x
   * @param height
   * @param duration
   * @returns {Function}
   */
  var addVerticalHighlightArea = function (values, y, x, height, duration) {
    return function (selection) {
      if (angular.isArray(values) && values.length > 0) {
        var initialY = y(0),
          initialX = x(0);

        var redLine = selection.selectAll('.highlightArea')
          .data(values);

        redLine.enter().append('rect')
          .attr('class', 'highlightArea')
          .attr('width', 0)
          .attr('x', initialX)
          .attr('y', initialY)
          .attr('height', 0);

        redLine.transition().duration(duration)
          .attr('x', function (d) {
            return x(Math.min(0, d));
          })

          .attr('height', height)
          .attr('width', function (d) {
            return Math.abs(x(0) - x(d));
          });

        redLine.exit().remove();
      }
    }
  };

  /**
   * Add highlight lines to diagram
   *
   * use like this:
   * g.call(addHighlightLines(...))
   *
   * @param values
   * @param x
   * @param height
   * @param duration
   * @returns {Function}
   */
  var addVerticalHighlightLines = function (values, x, height, duration) {
    return function (selection) {
      if (angular.isArray(values) && values.length > 0) {
        var redLineInitialX = x(0);

        var redLine = selection.selectAll('.highlightLine')
          .data(values);

        redLine.enter().append('line')
          .attr('class', 'highlightLine')
          .style('stroke-width', '4')
          .style('shape-rendering', 'crispEdges')
          .attr('pointer-events', 'none')
          .attr('y1', 0)
          .attr('x1', redLineInitialX)
          .attr('y2', height)
          .attr('x2', redLineInitialX);

        redLine.transition().duration(duration)
          .attr('y2', height)
          .attr('x1', function (d) {
            return x(d);
          })
          .attr('x2', function (d) {
            return x(d);
          });

        redLine.exit().remove();
      }
    }
  };

  /**
   * The colors to display the indicators in
   *
   * @type {string[]}
   */
  var indicatorColors = [
    '#1b9e77',
    '#d95f02',
    '#7570b3',
    '#e7298a',
    '#66a61e',
    '#e6ab02',
    '#a6761d',
    '#666666'
  ];

  var buildColorFunction = function (colors) {
    return function (number) {
      return colors[number % colors.length];
    };
  };

  var indicatorColorAt = buildColorFunction(indicatorColors);

  //store commonly used d3 helper functions under hyperion namespace
  d3.hyperion = {
    addHorizontalHighlightLines: addHorizontalHighlightLines,
    addHorizontalHighlightArea: addHorizontalHighlightArea,
    addHorizontalMinMaxHighlightArea: addHorizontalMinMaxHighlightArea,
    addVerticalHighlightArea: addVerticalHighlightArea,
    addVerticalHighlightLines: addVerticalHighlightLines,
    accessor: accessor,
    compose: compose,
    germanFormat: germanFormat,
    indicatorColors: indicatorColors,
    buildColorFunction: buildColorFunction,
    indicatorColorAt: indicatorColorAt,
    addHorizontalGridLines: addHorizontalGridLines,
    addVerticalGridLines: addVerticalGridLines
  };

  return d3;
});

/**
 * This service serves as an interface how a real exportService should be implemented! Do not use in Production!
 */
angular.module('Itao.IndicatorMap').factory('ExportService', ['$http', 'mapConfig', 'HyperionDataService', function($http, mapConfig, HyperionDataService){
  'use strict';

  // ToDo: Use new Export-Service KECK or BSt instead
  // Test: Local installation like KECK
  // refactor: exportAsPdf
  // refactor: exportAsImage
  //

  var exportSettings = mapConfig.widgetExport;
  var cssUrl = exportSettings.cssUrl + '?v=61';
  var remoteUrl = exportSettings.remoteUrl + '?v=60';
  // Tests
  // remoteUrl = 'http://localhost:8081/v1/generateImage';
  // cssUrl = "https://app.keck-atlas.de/hyperion.css?v=60";

  var exportedClass = 'exported-widget itao-pluginView';
  var rootUri = jQuery('#communeUserData').data('root-uri');

  /**
   * Wraps the html with a special element to mark it as an export
   * @param htmlString
   */
  function wrapAsExportedWidget(htmlString) {
    return '<div class="' + exportedClass + '">' + htmlString + '</div>';
  }

  return {

    /**
     * @param {String} data markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @returns {Promise}
     */
    exportAsXlsx: function (data, filetype, filename) {
      var template = '<form action="/index.php?actionName=exportDataToXlsx&controllerName=AtlasJson&eID=hyperionAjax&extensionName=ItaoHyperion&pluginName=Pi102" method="post" class="hidden"> <input type="hidden" id="export-filename" name="filename" value="" /> <input type="hidden" name="filetype" id="export-filetype" value="" /> <input type="hidden" id="export-data" name="data" value="" /> <button class="btn btn-primary" type="submit"></button></form>';
      var $form = jQuery(template);

      // Add values
      $form.find('#export-data').val(JSON.stringify(data));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val(filetype);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    },


    /**
     * @param {String} data markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @returns {Promise}
     */
    exportAsCsv: function (data, filetype, filename) {
      var template = '<form action="/index.php?actionName=exportDataToCsv&controllerName=AtlasJson&eID=hyperionAjax&extensionName=ItaoHyperion&pluginName=Pi102" method="post" class="hidden"> <input type="hidden" id="export-filename" name="filename" value="" /> <input type="hidden" name="filetype" id="export-filetype" value="" /> <input type="hidden" id="export-data" name="data" value="" /> <button class="btn btn-primary" type="submit"></button></form>';
      var $form = jQuery(template);

      // Add values
      $form.find('#export-data').val(JSON.stringify(data));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val(filetype);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    },

    /**
     * Sends the given markup to an export server and save the response as an image download
     * To do this in a cross-browser way, a temporary html <form> is created, submitted and removed afterwards
     * @param {String} html markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @param {Array[Int, Int]} dimensions Array containing the width and height of the widget
     * @returns {Promise}
     */
    exportAsImage: function (html, filetype, filename, dimensions) {
      convertHtmlToPng(
        {
          html: wrapAsExportedWidget(html),
          filename: filename,
          filetype: filetype,
          dimensions: dimensions.join('x'),
          cssUrl: cssUrl
        }
      );
    },

    /**
     * Sends the given markup to an export server and save the response as an image download
     * To do this in a cross-browser way, a temporary html <form> is created, submitted and removed afterwards
     * @param {String} html markup as string
     * @param {String} filename name of the file
     * @param {Array[Int, Int]} dimensions Array containing the width and height of the widget
     * @returns {Promise}
     */
    exportAsPdf: function (html, filename, dimensions) {

      // Add values
      $form.find('#export-html').val(wrapAsExportedWidget(html));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val('pdf');
      $form.find('#export-dimensions').val(dimensions.join('x'));
      $form.find('#export-cssUrl').val(cssUrl);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    }
  }

}]);

angular.module('Itao.IndicatorMap').factory('GridItemConfig', function(){
  'use strict';

  var uniqueItemPrefix = 'griditem_';

  /**
   * Generates Math.random-based unique IDs
   * @returns {string}
   */
  function generateID() {
    // https://gist.github.com/gordonbrander/2230317
    return Math.random().toString(36).substr(2, 9);
  }

  /**
   * Returns a unique name for naming grid items
   * @returns {string}
   */
  function generateUniqueItemName() {
    return uniqueItemPrefix + generateID();
  }


  /**
   * Flattens an object of grid configuration into an array, adding the key as property
   * @param {Object} gridConfigurationObject an object of grid configurations
   * @return {Array}
   */
  function flatObjectToArray(gridConfigurationObject){
    var array = [];
    angular.forEach(gridConfigurationObject, function(value, key) {
      if(angular.isObject(value)) {
        value.propertyName = key;
      }
      array.push(value);
    });
    return array;
  }


  /**
   * Sorts an array of grid configurations for lowest y and x value, so the items can get added in the right order
   * @param {Object} gridConfiguration an object of grid configurations
   * @return {Array}
   */
  function sortGridConfigs(gridConfiguration) {
    var gridConfigArray = flatObjectToArray(gridConfiguration);
    return gridConfigArray.sort(function(a, b) {
      if(a.y < b.y) {
        return -1;
      }
      if(a.y === b.y && a.x < b.x) {
        return -1;
      }
      return 1;
    });
  }

  return {
    generateUniqueItemName: generateUniqueItemName,
    sortGridConfigs: sortGridConfigs
  };

});

angular.module('Itao.IndicatorMap').factory('GridItemWidgetCompiler', ['$compile', function($compile){
  'use strict';

  /**
   * Map object which connects widgetKey with its compileFunction
   * @type {Object}
   */
  var keyToDirectiveMap = {
    'barChart': compileBarChart,
    'setBarChart': compileSetBarChart,
    'barChartDoubleAxis': compileBarChartDoubleAxis,
    'barChartYears': compileBarChartYears,
    'barChartYearsWithoutArea': compileBarChartYearsWithoutArea,
    'horizontalBarChart': compileHorizontalBarChart,
    'horizontalStackedBarChart': compileHorizontalStackedBarChart,
    'horizontalStackedSetBarChart': compileHorizontalStackedSetBarChart,
    'stackedSetBarChart': compileStackedSetBarChart,
    'setRefPointBarChart': compileSetRefPointBarChart,
    'stackedSetAbsoluteBarChart': compileStackedSetAbsoluteBarChart,
    'stackedGroupedSetBarChart': compileStackedGroupedSetBarChart,
    'lineChart': compileLineChart,
    'scatterPlot': compileScatterPlot,
    'featureTable': compileFeatureTable,
    'transposedFeatureTable': compileTransposedFeatureTable,
    'setTable': compileSetTable,
    'map': compileMap,
    'districtsPieChart': compileDistrictsPieChart,
    'textfield': compileTextfield
  };

  /**
   * Returns the template function for a textfield and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileTextfield(config) {
    return $compile('<textfield config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></textfield>');
  }

  /**
   * Returns the template function for a featureTable and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileFeatureTable(config) {
    return $compile('<feature-table layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" ></feature-table>');
  }

  /**
   * Returns the template function for a transposedFeatureTable and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileTransposedFeatureTable(config) {
    return $compile('<transposed-feature-table layer="diagramData.selectedDataLayer" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" color-sets="diagramData.colorSets" indicators="diagramData.indicators" config="config.widget" ></transposed-feature-table>');
  }

  /**
   * Returns the template function for a setTable
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetTable(config) {
    return $compile('<set-table layer="diagramData.selectedDataLayer" disabled-district-keys="diagramData.disabledDistrictKeys" selected-indicator-set="diagramData.selectedIndicatorSet" disabled-list-index="diagramData.disabledListIndex" color-sets="diagramData.colorSets" config="config.widget"></set-table>');
  }

  /**
   * Returns the template function for a map and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileMap(config) {
    // console.log("config inside compiler", config);
    return $compile('<indicator-map '
      + 'districts="diagramData.districts" '
      + 'selected-districts="diagramData.selectedDistricts" '
      + 'selected-indicators="diagramData.indicators" '
      + 'layers="diagramData.layers" '
      + 'poi-layers="diagramData.poiLayers" '
      + 'poi-layer-types="diagramData.poiDataLayerTypes" '
      + 'poi-data="diagramData.poiData" '
      + 'color-sets="diagramData.colorSets" '
      + 'indicator-sets="diagramData.indicatorSets" '
      + 'config="config.widget" '
      + 'selected-data-layer="diagramData.selectedDataLayer" '
      + 'selected-poi-layer="diagramData.selectedPoiLayer" '
      + 'select-district="selectDistrict(district)" '
      + 'deselect-district="deselectDistrict(district)" '
      + 'dimension-x="{{config.width}}" dimension-y="{{config.height}}" '
      + '></indicator-map>');
  }

  /**
   * Returns the template function for a barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChart(config) {
    return $compile('<bar-chart layer="diagramData.selectedDataLayer" selected-chart-colorset="diagramData.selectedChartColorset" colorsets="diagramData.colorSets" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetBarChart(config) {
    return $compile('<set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></set-bar-chart>');
  }

  /**
   * Returns the template function for a barChartYears and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartYears(config) {
    return $compile('<bar-chart-years layers="diagramData.layers" selected-chart-colorset="diagramData.selectedChartColorset" decimals-override="diagramData.decimalsOverride" max-axis-value-override="diagramData.maxAxisValueOverride" disabled-district-keys="diagramData.disabledDistrictKeys" disabled-data-layers="diagramData.disabledDataLayers" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart-years>');
  }

  /**
   * Returns the template function for a barChartYearsWithoutArea and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartYearsWithoutArea(config) {
    return $compile('<bar-chart-years layers="diagramData.layers" selected-chart-colorset="diagramData.selectedChartColorset" disabled-district-keys="diagramData.disabledDistrictKeys" disabled-data-layers="diagramData.disabledDataLayers" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}" without-area="1"></bar-chart-years>');
  }

  /**
   * Returns the template function for a barChartDoubleAxis and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartDoubleAxis(config) {
    return $compile('<bar-chart-double-axis layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart-double-axis>');
  }

  /**
   * Returns the template function for a horizontalBarChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalBarChart(config) {
    return $compile('<horizontal-bar-chart layer="diagramData.selectedDataLayer" selected-chart-colorset="diagramData.selectedChartColorset" colorsets="diagramData.colorSets" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalStackedBarChart(config) {
    return $compile('<horizontal-stacked-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" indicators="diagramData.indicators" indicator-sets="diagramData.indicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-bar-chart>');
  }

  /**
   * Returns the template function for a stacked set barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalStackedSetBarChart(config) {
    return $compile('<horizontal-stacked-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedSetBarChart(config) {
    return $compile('<stacked-set-bar-chart use-absolute-values="0" layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedSetAbsoluteBarChart(config) {
    return $compile('<stacked-set-bar-chart use-absolute-values="1" layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-set-bar-chart>');
  }

   /**
   * Returns the template function for a barChart with reference point and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetRefPointBarChart(config) {
    return $compile('<set-ref-point-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></set-ref-point-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedGroupedSetBarChart(config) {
    return $compile('<stacked-grouped-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-grouped-set-bar-chart>');
  }

  /**
   * Returns the template function for a lineChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileLineChart(config) {
    return $compile('<line-chart layer="diagramData.selectedDataLayer" layers="diagramData.layers" yearly-mode="diagramData.enableYearlyMode" disabled-data-layers="diagramData.disabledDataLayers" no-data-districts="diagramData.noDataDistricts" selected-district-key="diagramData.selectedDistrictKey" selected-districts="diagramData.selectedDistricts" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></line-chart>');
    //return $compile('<horizontal-stacked-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a scatterPlot and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileScatterPlot(config) {
    return $compile('<scatter-plot layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></scatter-plot>');
  }

  /**
   * Returns the template function for a barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileDistrictsPieChart(config) {
    return $compile('<districts-pie-chart layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></districts-pie-chart>');
  }

  /**
   * Returns the template function for a widgets identified by a key
   * @param {String} key key of the directive
   * @param {Object} config configuration object of grid item
   * @returns {Function} a angular template function returned by $compile
   */
  function generateTemplateFunctionByType(key, config) {
    var templateFunction = keyToDirectiveMap[key];
    if(angular.isFunction(templateFunction)) {
      return templateFunction(config);
    } else {
      throw new Error('No compile function specified for type ' + key + ' in GridItemWidgetCompiler');
    }
  }


  return {
    generateTemplateFunctionByType: generateTemplateFunctionByType
  };

}]);

angular.module('Itao.IndicatorMap').factory('ModalService', ['$uibModal', function($uibModal) {
  'use strict';

  /**
   * Default options for uiBootstrapModal
   *  @type {{size: string, templateUrl: string, controller: string}}
   */
  var defaultOptions = {
    size: 'lg',
    templateUrl: '',
    controller: 'CustomModalController'
  };

  /**
   *
   * @param {object} inputData object which contains the data which should be available in the modal
   * @param {object} options configuration object for the modal initialization
   * @returns {object} modalInstance
   */
  function createCustomModal(inputData, options) {
    var config = angular.extend(defaultOptions, options);
    return $uibModal.open({
      templateUrl: config.templateUrl,
      size: config.size,
      controller: config.controller,
      backdrop: config.backdrop ? config.backdrop : true,
      keyboard: !!config.keyboard,
      resolve: {
        data: function () {
          return inputData;
        }
      }
    });
  }

  return {
    createCustomModal: createCustomModal
  };

}]);

angular.module('Itao.IndicatorMap').factory('UtilityService', ['ScaleService', '$sce', function (ScaleService, $sce) {
  'use strict';

  /**
   *
   * @param {Array} dataLayerTypes the dataLayerTypes to search in
   * @param {String} id the id to search for
   * @returns {DataLayerType | undefined}
   */
  function findDataLayerTypeByID(dataLayerTypes, id) {
    return dataLayerTypes.filter(function (dataLayerType) {
      return dataLayerType.id === id;
    }).shift();
  }

  /**
   * @param {Array} dataLayers the dataLayers to search in
   * @param {String} id the id to search for
   * @returns {DataLayer | undefined}
   */
  function findDataLayerByID(dataLayers, id) {
    return dataLayers.filter(function (dataLayer) {
      return dataLayer.uid === id;
    }).shift();
  }

  /**
   *
   * @param {Array} dataLayers the dataLayers to search in
   * @param {String} year the year to search for
   * @returns {DataLayer | undefined}
   */
  function findDataLayerByYear(dataLayers, year) {
    return dataLayers.filter(function (dataLayer) {
      return dataLayer.year === year;
    }).shift();
  }

  /**
   *
   * @param {Array} indicators the indicators to search in
   * @param {Array} ids the ids to search for
   * @returns {Array.<Indicator>}
   */
  function findIndicatorsByIDs(indicators, ids) {
    return indicators.filter(function (indicator) {
      return ids.indexOf(indicator.uid) > -1;
    });
  }

  /**
   *
   * @param {Array} colorSets
   * @param {String} uid
   * @returns {Array}
     */
  function findColorSetByUid(colorSets, uid) {
    return colorSets.filter(function (colorSet) {
      return colorSet.uid === uid;
    }).shift();
  }

  /**
   *
   * @param {Array} indicatorSets the indicatorSets to search in
   * @param {String} uid the uid to search for
   * @returns {IndicatorSet | undefined}
   */
  function findIndicatorSetByUid(indicatorSets, uid) {
    return indicatorSets.filter(function (indicatorSet) {
      return indicatorSet.uid === uid;
    }).shift();
  }

  /**
   * @param {Array} indicatorSets the indicatorsets to search in
   * @param {Array} indicators the indicators to search for
   * @returns {Array}
   */
  function findIndicatorSetsByIndicators(indicatorSets, indicators) {
    var newIndicatorSets = [];
    indicators.forEach(function (indicator) {
      if (indicator.type) {
        var type = findIndicatorSetByUid(indicatorSets, indicator.type);
        if (newIndicatorSets.indexOf(type) < 0) {
          newIndicatorSets.push(type);
        }
      }
    });
    return newIndicatorSets;
  }

  /**
   *
   * @param {Array} dataLayer all districts
   * @param {Indicator} indicator the indicatorID of the selected indicator
   * @param {Array} colorSet array of colors
   * @param {String} method
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildIndicatorScales(dataLayer, indicator, colorSet, method, numberOfScales) {
    var scales = [],
      values = [],
      selectedIndicatorID = indicator.uid,
      legend = 0;

    if(dataLayer.legend && dataLayer.legend[indicator.uid] && dataLayer.legend[indicator.uid]['map']) {
      legend = dataLayer.legend[indicator.uid]['map'];
      numberOfScales = legend.scales ? legend.scales.length : 0;
    } else if(indicator.defaultScale) {
      numberOfScales = indicator.defaultScale.length - 1;
    } else {
      numberOfScales = numberOfScales ? numberOfScales : 6;
    }

    method = method ? method : 'width';

    for(var districtUid in dataLayer.districts) {
      if(dataLayer.districts.hasOwnProperty(districtUid)
        && dataLayer.hasOwnProperty(districtUid)
        && dataLayer[districtUid].hasOwnProperty(selectedIndicatorID)
        && dataLayer[districtUid][selectedIndicatorID] !== null) {

        values.push(dataLayer[districtUid][selectedIndicatorID]);
      }
    }

    if(!values.length) return null;

    values.sort(sortNumber);
    if(legend) {
      return buildLegendScales(legend, colorSet, numberOfScales);
    }
    if(indicator.defaultScale) {
      return buildFixedScales(colorSet, indicator.defaultScale, numberOfScales);
    }
    if (method === 'width') {
      scales = buildScaleSameWidth(colorSet, numberOfScales, values);
    } else if (method === 'count') {
      scales = buildScaleSameClassCount(dataLayer, colorSet, numberOfScales, values);
    }

    return scales;
  }


  /**
   * @param {Object} colorSet
   * @param {Array} defaultScales
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildFixedScales(colorSet, defaultScales, numberOfScales) {
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      from = defaultScales[i];
      to = defaultScales[i+1];
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  /**
   * @param {Object} legend
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildLegendScales(legend, colorSet, numberOfScales) {
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      from = legend.scales[i].from;
      to = legend.scales[i].to;
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  /**
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @param {Array} values
   * @returns {Array}
   */
  function buildScaleSameWidth(colorSet, numberOfScales, values) {
    var maxValue = Math.max.apply(null, values);
    var minValue = Math.min.apply(null, values);

    // allways include 0 in legend
    if(maxValue < 0) {
      maxValue = 0;
    }
    if(minValue > 0) {
      minValue = 0;
    }

    var stepSize = Math.ceil(((maxValue - minValue)/ numberOfScales) * 100) / 100;
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      if(i === 0) {
        from = minValue;
      } else {
        from = scales[scales.length -1].to;
      }
      to = Math.ceil((minValue + (i+1) * stepSize) * 100)/100;
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }
    return scales;
  }

  /**
   * @param {DataLayer} dataLayer
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @param {Array} values
   * @returns {Array}
   */
  function buildScaleSameClassCount(dataLayer, colorSet, numberOfScales, values) {
    numberOfScales = Math.min(values.length, numberOfScales);
    var numDataInClass = parseInt(values.length / numberOfScales);
    var to;
    var from;
    var scales = [];
    for (var i = 1; i <= numberOfScales; i++) {
      if (i === 1) {
        // first class
        from = Math.floor(values[0] * 100) / 100;
      } else {
        from = scales[scales.length - 1].to;
      }
      if(i === (+numberOfScales)) {
        to = Math.ceil(values[values.length - 1] * 100) / 100;
      } else if(numDataInClass === 1 && i === 1) {
        to = Math.ceil((from + (+values[1])) * 100 / 2) / 100;
      } else {
        to = Math.ceil(values[i * numDataInClass - 1] * 100) / 100;
      }

      var color = colorSet && colorSet.colors[i - 1] ? colorSet.colors[i - 1] : '#cccccc';
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  function sortNumber(a, b) {
    return a - b;
  }

  function scaleForValue(scales, colorset, value) {
    return scales.map(function(scale, i){
      scale.color = colorset && colorset.colors[i] ? colorset.colors[i].color : '';
      return scale;
    }).filter(function(scale){
      return scale.from <= value && value < scale.to;
    })[0];
  }

  function iconSvg(scale) {
    if(!scale) return '';
    switch (scale.icon) {
      case 'icon-square':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><rect fill="' + scale.color + '" width="10" height="10" transform="translate(3 3)"></rect></svg>');
      case 'icon-diamond':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><rect fill="' + scale.color + '" width="10" height="10" transform="rotate(45 5 5) translate(4)"></rect></svg>');
      case 'icon-circle':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><circle fill="' + scale.color + '" r="7" transform="translate(8 8)"></circle></svg>');
      case 'icon-not-available':
        // return $sce.trustAsHtml('<span class="svg-not-available"></span>');
        return $sce.trustAsHtml('<svg width="16" height="16" viewBox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"/><path fill="#74777a" d="M5.5,8.7l0.038-1H10l-0.038,1H5.01Z"/></svg>');
      case 'icon-info':
        // return $sce.trustAsHtml('<span class="svg-info"></span>');
        return $sce.trustAsHtml('<svg width="16" height="16" viewBox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"/><path fill="#74777a" d="M7.2,7.5l1,0.038V12l-1-.038V7.014Z"/><circle class="cls-3" cx="7.7" cy="5.5" r="0.75" fill="#74777a"/></svg>');
      default: return $sce.trustAsHtml('<svg width="15px" height="15px" viewbox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"></circle></svg>');
    }
  }

  return {
    findDataLayerTypeByID: findDataLayerTypeByID,
    findDataLayerByID: findDataLayerByID,
    findDataLayerByYear: findDataLayerByYear,
    findIndicatorsByIDs: findIndicatorsByIDs,
    findIndicatorSetByUid: findIndicatorSetByUid,
    findColorSetByUid: findColorSetByUid,
    buildIndicatorScales: buildIndicatorScales,
    scaleForValue: scaleForValue,
    iconSvg: iconSvg,
    findIndicatorSetsByIndicators: findIndicatorSetsByIndicators
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorDataLayerTimeLine', ['mapConfig', '$interval', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerTimeLine.html',
    restrict: 'E',
    scope: {
      selectedDataLayer: '=',
      selectedDataLayerType: '=',
      layers: '=',
      availableIndicators: '=',
      onDataLayerSelect: '&',
      selectedIndicator: '=',
      yearsOverwrite: '='
    },
    link: function (scope, element) {
      scope.layers = [];
      scope.years = Object.keys(scope.layers);
      scope.yearsToHide = mapConfig.yearsToHide;

      var layerInterval = null;

      scope.intervalIsRunning = false;
      scope.playLayers = function () {
        if (!scope.years.length) {
          saveYearsInsideArray();
        }
        layerInterval = $interval(showNextYear, 1000);

        jQuery(element).find('.progress').addClass('running');
        scope.intervalIsRunning = true;
      };

      function showNextYear() {
        var currentYearIndex = scope.years.indexOf(scope.selectedDataLayer.year),
          nextIndex = currentYearIndex + 1;

        if (currentYearIndex === scope.years.length - 1) {
          nextIndex = 0;
        }

        var nextLayer = scope.layers[scope.years[nextIndex]];
        scope.onDataLayerSelect({dataLayer: nextLayer});
        scope.layersSlider.value = scope.years[nextIndex];
      }

      scope.stopLayers = function () {
        jQuery(element).find('.progress').removeClass('running');
        $interval.cancel(layerInterval);
        scope.intervalIsRunning = false;
      };

      function saveYearsInsideArray() {
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (selectedIndicator && scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        if (!scope.availableIndicators) return;
        var availableIndicatorUids = Object.keys(scope.availableIndicators).map(function (id) {
          return +id;
        });

        angular.forEach(scope.layers, function (layer, year) {
          var intersections = layer.indicators.filter(function (e) {
            return availableIndicatorUids.indexOf(e) !== -1;
          });

          if (intersections.length === 0) {
            scope.years.splice(scope.years.indexOf(year), 1);
          }
        });
        rebuildSlider();
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
        rebuildSlider();
      });

      function rebuildSlider() {
        var stepsArray = [];

        //var years = mapConfig.yearsToHide ? scope.years.filter(function (year) {
        //  return mapConfig.yearsToHide.indexOf(year) === -1;
        //}) : scope.years;

        var years = scope.years;
        angular.forEach(years, function (year, index) {
          var legendString = '';
          if (years.length > 5 && index > 0 && index < years.length - 1) {
            legendString = "'" + year.substring(2);
          } else {
            legendString = year;
          }
          stepsArray.push({value: +year, legend: legendString});
        });

        scope.layersSlider.options.stepsArray = stepsArray;
        scope.layersSlider.value = scope.selectedDataLayer ? scope.selectedDataLayer.year : years.indexOf[0];
      }

      scope.layersSlider = {
        value: 0,
        options: {
          onChange: function () {
            scope.onDataLayerSelect({dataLayer: scope.layers[scope.layersSlider.value]});
          },
          showSelectionBar: true,
          hidePointerLabels: true,
          showTicksValues: true
        }
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorDataLayerTypes', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerTypes.html',
    restrict: 'E',
    scope: {
      types: '=',
      selectedDataLayerType: '=',
      layers: '=',
      onDataLayerTypeSelect: '&'
    },
    link: function (scope) {
      scope.config = {
        typeUid: 0
      };

      scope.$watch('config.typeUid', function (selectedTypeUid) {
        if(!selectedTypeUid) return;
        angular.forEach(scope.types, function(type) {
          if(type.uid == selectedTypeUid && selectedTypeUid != scope.selectedDataLayerType.uid) {
            scope.onDataLayerTypeSelect({dataLayerType: type});
          }
        });
      });

      scope.$watch('selectedDataLayerType.uid', function (selectedTypeUid) {
          scope.config.typeUid = selectedTypeUid;
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorDataLayers', ['mapConfig', '$interval', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayers.html',
    restrict: 'E',
    scope: {
      selectedDataLayer: '=',
      selectedDataLayerType: '=',
      layers: '=',
      onDataLayerSelect: '&'
    },
    link: function (scope, element) {
      var years = [];
      var layerInterval = null;

      scope.intervalIsRunning = false;
      scope.playLayers = function() {
        if(!years.length) {
          saveYearsInsideArray();
        }
        layerInterval = $interval(showNextYear, 5000);

        jQuery(element).find('.progress').addClass('running');
        scope.intervalIsRunning = true;
      };

      function showNextYear() {
        var currentYearIndex = years.indexOf(scope.selectedDataLayer.year),
          nextIndex = currentYearIndex+1;

        if(currentYearIndex === years.length-1) {
          nextIndex = 0
        }

        var nextLayer = scope.layers[years[nextIndex]];
        scope.onDataLayerSelect({dataLayer: nextLayer});
      }

      scope.stopLayers = function() {
        jQuery(element).find('.progress').removeClass('running');
        $interval.cancel(layerInterval);
        scope.intervalIsRunning = false;
      };

      function saveYearsInsideArray() {
        angular.forEach(scope.layers, function(layer) {
          years.push(layer.year);
        });
      }
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtOverlay', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtOverlay.html',
    replace: true,
    scope: {
      districtInfo: '='
    },
    link: function (scope, element) {
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtSearch', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'districtSearch.html',
    restrict: 'E',
    scope: {
      districts: '=',
      showResults: '='
    },

    link: function (scope) {
      scope.language = mapConfig.language;
      scope.translations = mapConfig.translations;
      scope.friends = [
        {name: 'Peter', age: 20},
        {name: 'Pablo', age: 55},
        {name: 'Linda', age: 20},
        {name: 'Marta', age: 37},
        {name: 'Othello', age: 20},
        {name: 'Markus', age: 32}
      ];

      scope.filterFunction = function (element) {
        return element.name.match(/^Ma/) ? true : false;
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorIndicators', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicators.html',
    restrict: 'E',
    scope: {
      data: '=',
      treeOptions: '=',
      treeFilter: '=',
      indicators: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&'
    },
    link: function (scope) {
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('labelSelect', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'labelselect.html',
    restrict: 'E',
    scope: {
      optionStates: '=',
      changeTooltip: '&',
      selectedIndicator: '='
    },
    link: function (scope) {
      scope.optionStates = angular.isUndefined(scope.optionStates) ? mapConfig.defaultLabels : scope.optionStates;

      /**
       * Manages the optionStates when a option was clicked/selected
       */
      scope.selectOption = function () {
        scope.changeTooltip();
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorLegend', ['mapConfig', function (mapConfig) {
  'use strict';

  /**
   * Returns the scale width for a given number of scales
   * @param {Integer} numberOfScales number of scales
   * @returns {number}
   */
  function getScaleWidth(numberOfScales) {
    return (100 / numberOfScales) -2;
  }

  return {
    templateUrl: mapConfig.templateBasePath + 'legend.html',
    restrict: 'E',
    replace: true,
    scope: {
      indicator: '=',
      mapIndicator: '=',
      numberOfScales: '=',
      indicators: '=',
      mode: '='
    },
    link: function (scope) {
      if (scope.indicator && !scope.mapIndicator) {
        scope.precision = scope.precision || 2;
      } else if(scope.mapIndicator && scope.mapIndicator.scales) {
        scope.precision = scope.precision || 2;
      }

      scope.$watch('numberOfScales', function (numberOfScales) {
        if (angular.isNumber(numberOfScales)) {
          scope.scaleWidth = getScaleWidth(numberOfScales + 1);
        }
      });

      scope.$watch('indicators', function (indicators) {
        scope.pointIndicators = [];
        for(var i = 0, length = indicators.length; i < length; i++) {
          if(indicators[i].hasPointData) {
            var activeData = false;
            angular.forEach(indicators[i].availablePoiTypes, function(poiType) {
              if(poiType.active) activeData = true;
            });
            if(activeData) scope.pointIndicators.push(indicators[i]);
          }
        }
      }, true);
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorMap', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'map.html',
    controller: 'IndicatorMapController',
    scope: {
      districts: '=',
      selectedDistricts: '=',
      layers: '=',
      config: '=',
      indicators: '=',
      selectedIndicators: '=',
      selectedDataLayer: '=',
      colorSets: '=',
      indicatorSets: '=',
      poiLayers: '=',
      poiLayerTypes: '=',
      selectedPoiLayer: '=',
      poiData: '=',
      selectDistrict: '&',
      singleSelectDistrict: '&',
      deselectDistrict: '&',
      dimensionX: '@',
      dimensionY: '@',
      blToZoom: '='
    },
    link: function (scope, element, attrs) {

    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorSelectedIndicators', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'selectedIndicators.html',
    restrict: 'E',
    scope: {
      selectedIndicators: '=',
      onIndicatorDeselect: '&',
      setSelectedIndicator: '&',
      selectedDataLayer: '=',
      poiLayerTypes: '=',
      selectPoiIndicator: '&'
    },
    link: function (scope) {
      var insertedAt;
      scope.chartColorAt = mapConfig.chartColorAt;

      scope.indicatorInserted = function (index) {
        insertedAt = index;
      };

      /**
       * Reorder the selectedIndicators in the globalScope and selects the first
       * @param {Event} event move event
       * @param {Integer} index index
       */
      scope.indicatorMoved = function (event, index) {
        // Have to do that workaround, because the copied Object from "angular-drag-and-drop-lists"
        // is just a normal object - not an Indicator with its prototype-functions
        // ToDo: There is a unsexy effect caused of this workaround when you drop an item
        scope.selectedIndicators[insertedAt] = scope.selectedIndicators[index];
        scope.selectedIndicators.splice(index, 1);
        scope.setSelectedIndicator();
      };

      scope.$watch('selectedDataLayer', function (selectedDataLayer) {
        if(angular.isArray(scope.selectedIndicators)) {
          if(angular.isObject(selectedDataLayer)) {
            // remove unavailable indicators
            for(var i = 0; i < scope.selectedIndicators.length; i++) {
              if(selectedDataLayer.indicators.indexOf(scope.selectedIndicators[i].uid) === -1) {
                scope.selectedIndicators.splice(i, 1);
              }
            }
          } else {
            scope.selectedIndicators.splice(0, scope.selectedIndicators.length);
          }
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('barChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, indicators, selectedDistricts, disabledDistrictKeys) {
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });
    var data = [];
    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid) && disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1) {
        var valueArray = indicators.map(function (indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key};
        });
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
          values: valueArray,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var barChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      displayValues = false,
      decimals,
      maxAxisValue,
      svgHeight = 200,
      color = d3.hyperion.indicatorColorAt,
      redLines = null,
      redLinesMinMaxMode = false,
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var filteredIndicators = indicators.filter(function (indicator) {
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }
        if (maxValue < 0) {
          maxValue = 0;
        }

        if (maxAxisValue) {
          maxValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));

        margin.bottom = 15 + 7 * districtLabelDigits;
        margin.bottom = Math.min(svgHeight / 2, margin.bottom);

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function (d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            if (!decimals) {
              decimals = filteredIndicators[indicatorNumber].unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var district = data[districtNumber], value;
            if (filteredIndicators[indicatorNumber].unit === '%') {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + colorFromBar(d, indicatorNumber) + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + filteredIndicators[indicatorNumber].name.replace('<br/>', '').replace('<br>', '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
          return lineValue <= maxValue;
        });

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // only draw bars if indicators are left
        if (angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {
          if (!redLinesMinMaxMode) {
            g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));
          } else {
            g.call(d3.hyperion.addHorizontalMinMaxHighlightArea(redLines, y, x0, width, duration));
          }

          var unit = indicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ',10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function (d) {
              return y(Math.max(0, accessor('value')(d)));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(accessor('value')(d)));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          if (displayValues) {
            // new labels
            labels
              .enter()
              .append('text')
              .attr('y', y(0))
              .attr('stroke-width', '0');

            // update labels
            labels
              .transition().duration(duration)
              .attr("class", "chart-value")
              .text(function (d) {
                if (accessor('unit')(d) === '%') {
                  return germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(accessor('value')(d)) + '%';
                } else {
                  // if (accessor('unit')(d) === "m&#178;") {
                  //   var unitSign = "m²";
                  // } else {
                  //   var unitSign = accessor('unit')(d);
                  // }
                  // var unitSign = indicators[0].unit;
                  var unitSign = '';
                  return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d)) + unitSign;
                }
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d) {
                return y(Math.max(0, accessor('value')(d))) - 4;
              });

            // remove unused labels
            labels.exit().transition().duration(duration)
              .attr('y', y(0))
              .remove();
          } else {
            labels.transition().duration(duration)
              .attr('y', y(0))
              .remove();
          }
          features.exit().remove();

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration, redLinesMinMaxMode));
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for redLinesMinMaxMode
     * @param {Function} [newRedLinesMinMaxMode] new redLinesMinMaxMode function
     * @returns {*}
     */
    chart.redLinesMinMaxMode = function (newRedLinesMinMaxMode) {
      if (!arguments.length) {
        return redLinesMinMaxMode;
      } else {
        redLinesMinMaxMode = newRedLinesMinMaxMode;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-barChart').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      indicators: '=',
      colorsets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.displayValues = scope.config.displayValues || false;
      scope.config.fullscreen = scope.config.fullscreen || false;

      var barChartFunction = barChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }
        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var color;
        var redLines = null;
        var redLinesMinMaxMode = null;
        var decimals = null;
        var maxAxisValue = null;

        if (scope.layer.legend != null) {
          color = d3.hyperion.buildColorFunction(filteredIndicators.map(function (indicator) {
            if (scope.layer.legend[indicator.uid] && scope.layer.legend[indicator.uid].chart) {
              var legend = scope.layer.legend[indicator.uid].chart;

              var colorsetUid = legend.colorSet;
              var indicatorColorSet = scope.colorsets.filter(function (colorSet) {
                return +colorSet.uid === +colorsetUid;
              })[0];

              if (legend && legend.redLines) {
                redLines = legend.redLines;
                redLinesMinMaxMode = legend.redLinesMinMaxMode;
              }

              if (legend && legend.decimals) {
                decimals = legend.decimals;
              }

              if (legend && legend.maxAxisValue) {
                maxAxisValue = legend.maxAxisValue;
              }

              var indicatorColor = '';
              if (indicatorColorSet != null) {
                indicatorColor = indicatorColorSet.colors[0].color;
              }

              return indicatorColor;
            } else {
              return d3.hyperion.indicatorColorAt;
            }
          }));
        } else if (scope.selectedChartColorset) {
          color = d3.hyperion.buildColorFunction(scope.selectedChartColorset.colors.map(function (color) {
            return color.color;
          }));
        } else {
          color = d3.hyperion.indicatorColorAt;
        }

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts, scope.disabledDistrictKeys);
        barChartFunction
          .color(color)
          .indicators(indicators)
          .redLines(redLines)
          .redLinesMinMaxMode(redLinesMinMaxMode)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .displayValues(scope.config.displayValues)
          .decimals(decimals)
          .maxAxisValue(maxAxisValue)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartFunction);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();

        // remove tooltip dom element
        if (angular.isDefined(barChartFunction.tip())) {
          barChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('barChartDoubleAxis', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function(d, i) {
    return i;
  };
  var combineData = function(layer, indicators, selectedDistricts) {
    var selectedUids = selectedDistricts.map(function(district){
      return district.uid;
    });
    var data = [];
    for(var districtUid in layer.districts) {
      if(layer.hasOwnProperty(districtUid)) {
        var valueArray = indicators.map(function(indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key, unit: indicator.unit};
        });
        data.push({key: layer.districts[districtUid].key, name: layer.districts[districtUid].name, values: valueArray, selected: selectedUids.indexOf(districtUid) !== -1});
      }
    }
    return data;
  };

  /**
   * calculate the maximum value
   *
   * @param {array} data the data array
   * @param {boolean} absoluteFlag use absolute values (false for relative values)
   * @returns {float}
   */
  var calculateMaxValue = function(data, absoluteFlag) {
    return d3.max(data.map(function(current){
      return d3.max(current.values.filter(function(value) {
        return (value.unit !== '%') === absoluteFlag;
      }), accessor('value'));
    }));
  };

  /**
   * calculate the minimum value
   *
   * @param {array} data the data array
   * @param {boolean} absoluteFlag use absolute values (false for relative values)
   * @returns {float}
   */
  var calculateMinValue = function(data, absoluteFlag) {
    return d3.min(data.map(function(current){
      return d3.min(current.values.filter(function(value) {
        return (value.unit !== '%') === absoluteFlag;
      }), accessor('value'));
    }));
  };

  /**
   * check if the given valueObject is a relative value
   *
   * @param {Object} value a valueObject
   * @returns {boolean}
   */
  function isRelativeValue(value) {
    return value.unit === '%';
  }

  /**
   * scale a value by one of the given scales depending on the unit
   * @param {Object} value the valueobject
   * @param {Function} absoluteScale the scale for absolute values
   * @param {Function} relativeScale the scale for relative values
   * @returns {Number} the scaled value
   */
  function scaleValueObject(value, absoluteScale, relativeScale) {
    return isRelativeValue(value) ? relativeScale(accessor('value')(value)) : absoluteScale(accessor('value')(value));
  }

  /**
   *
   * @param {Number} value the value to scale
   * @param {String} unit the unit string
   * @param {Function} absoluteScale the scale for absolute values
   * @param {Function} relativeScale the scale for relative values
   * @returns {Number} the scaled value
   */
  function scaleValue(value, unit, absoluteScale, relativeScale) {
    return scaleValueObject({value: value, unit: unit}, absoluteScale, relativeScale);
  }

  var barChartDoubleAxis = function() {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      margin = {top: 20, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function(selection) {
      selection.each(function(data) {
        var filteredIndicators = indicators.filter(function(indicator){
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        var absoluteIndicators = filteredIndicators.filter(function(indicator){
          return indicator.unit !== '%' && disabledIndicators.indexOf(indicator.key) === -1;
        });

        var relativeIndicators = filteredIndicators.filter(function(indicator){
          return indicator.unit === '%' && disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values
        var minAbsoluteValue = calculateMinValue(data, true);
        var maxAbsoluteValue = calculateMaxValue(data, true);
        var absoluteRatio = maxAbsoluteValue / (maxAbsoluteValue - minAbsoluteValue);

        var minRelativeValue = calculateMinValue(data, false);
        var maxRelativeValue = calculateMaxValue(data, false);
        var relativeRatio = maxRelativeValue / (maxRelativeValue - minRelativeValue);

        var allSameSign = false;
        // check that 0 is included and on the same line for both axis
        if(absoluteIndicators.length > 0 && relativeIndicators.length > 0) {
          // if all numbers are positive set floor to zero
          if (minAbsoluteValue > 0 && minRelativeValue > 0 && minRelativeValue > 0 && maxRelativeValue > 0) {
            allSameSign = true;
            minAbsoluteValue = 0;
            minRelativeValue = 0;
          }

          // if all numbers are negative set ceiling to zero
          if (minAbsoluteValue < 0 && minRelativeValue < 0 && minRelativeValue < 0 && maxRelativeValue < 0) {
            allSameSign = true;
            maxAbsoluteValue = 0;
            maxRelativeValue = 0;
          }

          // align zero line if necessary
          if (!allSameSign && absoluteRatio !== relativeRatio) {
            if (absoluteRatio < relativeRatio) {
              // adjust minRelativeValue
              minRelativeValue = minAbsoluteValue/maxAbsoluteValue*maxRelativeValue;
            } else {
              // adjust minAbsoluteValue
              minAbsoluteValue = minRelativeValue/maxRelativeValue*maxAbsoluteValue;
            }
          }
        } else if(absoluteIndicators.length > 0) {
          // adjustments for only absolute indicators
          if(minAbsoluteValue > 0 ) {
            minAbsoluteValue = 0;
          }
          if(maxAbsoluteValue < 0) {
            maxAbsoluteValue = 0;
          }
          if(minAbsoluteValue === maxAbsoluteValue) {
            minAbsoluteValue -= 1;
            maxAbsoluteValue += 1;
          }
        } else if(relativeIndicators.length > 0) {
          // adjustments for only relative indicators
          if(minRelativeValue > 0 ) {
            minRelativeValue = 0;
          }
          if(maxRelativeValue < 0) {
            maxRelativeValue = 0;
          }
          if(minRelativeValue === maxRelativeValue) {
            minRelativeValue -= 1;
            maxRelativeValue += 1;
          }
        }

        //calculate the space needed for the y-axis labels
        var labelDigitsLeft = Math.max(germanNumberFormat(',')(Math.round(maxAbsoluteValue)).length, germanNumberFormat(',')(Math.round(minAbsoluteValue)).length);
        margin.left = 20 + 10 * labelDigitsLeft;

        var labelDigitsRight = Math.max(germanNumberFormat(',')(Math.round(maxRelativeValue)).length, germanNumberFormat(',')(Math.round(minRelativeValue)).length);
        margin.right = 30 + 10 * labelDigitsRight;

        var districtLabelDigits = d3.max(data.map(function(d) {
          return accessor(districtLabelProperty)(d).length;
        }));
        margin.bottom = 15 + 7 * districtLabelDigits;

        margin.bottom = Math.min(svgHeight / 2, margin.bottom); // use a maximum of half the widget for labels

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if(angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function(d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function(){
            return [-5, 0];
          })
          .html(function(d, indicatorNumber, districtNumber){
            var district = data[districtNumber], value;
            if(filteredIndicators[indicatorNumber].unit) {
              value = numberFormat(d.value)+filteredIndicators[indicatorNumber].unit;
            } else {
              value = d.value;
            }
            return '<div class="d3-tip-border" style="border-color:'+colorFromBar(d, indicatorNumber)+';"><b>'+district.name+' ('+district.key+')</b><br><span>'+filteredIndicators[indicatorNumber].name+':</span> <span>'+value+'</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.1)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        // scale for bar values
        var yAbsolute = d3.scale.linear()
          .range([height, 0])
          .domain([minAbsoluteValue, maxAbsoluteValue]);

        var yRelative = d3.scale.linear()
          .range([height, 0])
          .domain([minRelativeValue, maxRelativeValue]);

        /**
         * used for initial rendering of bars
         * @param {Object} d valueObject
         * @returns {Number}
         */
        function scaled0Point(d) {
          return scaleValue(0, d.unit, yAbsolute, yRelative);
        }

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxisAbsolute = d3.svg.axis()
          .scale(yAbsolute)
          .orient('left')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(germanNumberFormat(','));

        var yAxisRelative = d3.svg.axis()
          .scale(yRelative)
          .orient('right')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(function(d){
            return germanNumberFormat(',')(d) + '%';
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', 'end')
          .style('font-weight', function(d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .attr('dx', '-.8em')
          .attr('dy', '.15em')
          .attr('transform', 'rotate(-65)');

        gEnter.append('g')
          .attr('class', 'y axis left')
          .append('text')
          .attr('class', 'label-absolute')
          .attr('dy', '-0.5em')
          .style('text-anchor', 'middle')
          .text('Absolute Werte');

        gEnter.append('g')
          .attr('transform', 'translate(' + width + ',0)')
          .attr('class', 'y axis right')
          .append('text')
          .attr('class', 'label-relative')
          .attr('dy', '-0.5em')
          .style('text-anchor', 'middle')
          .text('Relative Werte');

        g.select('.y.axis.left')
          .transition().duration(duration)
          .call(yAxisAbsolute);

        g.select('.y.axis.right')
          .attr('transform', 'translate(' + width + ',0)')
          .transition().duration(duration)
          .call(yAxisRelative);

        // only draw bars if indicators are left
        if(angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function(d){
              return 'translate('+ x0(d[districtLabelProperty])+')';
            })
            .attr('stroke-width', function(d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', scaled0Point)
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function(d){
              return scaleValue(Math.max(0, accessor('value')(d)), d.unit, yAbsolute, yRelative);
            })
            .attr('height', function(d) {
              return Math.abs(scaleValue(0, d.unit, yAbsolute, yRelative) - scaleValue(accessor('value')(d), d.unit, yAbsolute, yRelative));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .remove();
          features.exit().remove();
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function(newIndicators) {
      if(!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function(newDisabledIndicators) {
      if(!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newdistrictLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function(newdistrictLabelProperty) {
      if(!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function(newHeight) {
      if(!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function() {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function(element) {
    return element.closest('.grid-stack-item-content-barChartDoubleAxis').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChartDoubleAxis.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;

      var barChartDoubleAxisFunction = barChartDoubleAxis();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function(watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if(newHeight == null) {
          newHeight = calculateChartHeight(element);
        }
        var indicators = scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function(indicator){
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts);
        barChartDoubleAxisFunction
          .indicators(indicators)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartDoubleAxisFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);

      var legendHeightWatcher = scope.$watch(function() {
        return calculateChartHeight(element);
      }, function(newValue, oldValue){
        if(newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function() {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();

        // remove tooltip dom element
        if(angular.isDefined(barChartDoubleAxisFunction.tip())) {
          barChartDoubleAxisFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('colorSetLegend', ['mapConfig', function (mapConfig) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'colorSetLegend.html',
    restrict: 'E',
    replace: true,
    scope: {
      colorSet: '=',
      hideColorset: '='
    },
    link: function (scope) {
      // for print-style to add !importand and prevent converting to rgb()
      scope.ngAttrScaleColor = function(color) {
        return  'background-color: '+color+' !important';
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('detailedLegend', ['UtilityService', 'mapConfig', '$timeout', function (UtilityService, mapConfig, $timeout) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'detailedLegend.html',
    restrict: 'E',
    replace: true,
    scope: {
      clickable: '=',
      type: '=',
      disabledListIndex: '=?',
      noDataDistricts: '=?',
      disabledDistrictKeys: '=',
      disabledYears: '=',
      years: '=',
      colorSets: '=',
      selectedDataLayer: '=',
      selectedIndicator: '=',
      mouseOverFeature: '=?',
      mouseOverDistrict: '=?',
      mouseOverProperty: '=?',
      mouseOverYear: '=?',
      highlightTwin: '=?',
    },
    link: function (scope) {
      var availableDistricts = [];
      var timer;

      /**
       * sets legend with given config
       */
      var setLegend = function () {
        if (!scope.selectedDataLayer || !scope.selectedIndicator || !scope.selectedDataLayer.legend || !scope.selectedDataLayer.legend[scope.selectedIndicator.uid] || !scope.selectedDataLayer.legend[scope.selectedIndicator.uid][scope.type]) {
          scope.legend = {};
          scope.showHighlightLine = false;
        } else {
          scope.legend = scope.selectedDataLayer.legend[scope.selectedIndicator.uid][scope.type];
          scope.showHighlightLine = (scope.legend.redLines && scope.legend.redLines.length > 0) || mapConfig.redLines.length > 0;

          angular.forEach(scope.colorSets, function (colorSet) {
            if (colorSet.uid == scope.legend.colorSet) {
              scope.selectedColorSet = colorSet;
            }
          });

          scope.disabledListIndex = scope.disabledListIndex && scope.disabledListIndex.length ? scope.disabledListIndex : [];
          if (!scope.clickable && scope.legend.scales) {
            scope.legend.scales.forEach(function (scale, index) {
              if (scale.radio && index > 0) {
                scope.disabledListIndex.push(index);
              } else if (scope.legend.yearlyLegend && scope.years && scope.mouseOverProperty !== 'index') {
                scale.year = scope.years[index - 1]; // index-1 when using area-chart (leave out first legend-item) - check for new yearly-line-chart
              }
            });
          }

          if (scope.legend.districtLegend) {
            var districtUid;
            for (districtUid in scope.selectedDataLayer.districts) {
              availableDistricts.push(scope.selectedDataLayer.districts[districtUid].key);
            }
          }
        }
      };

      /**
       * set mouse-over for district
       * @param district
       */
      scope.setMouseOverDistrict = function (district) {
        if (district === undefined) return;
        if (district) {
          scope.mouseOverDistrict = district;
        } else {
          scope.mouseOverDistrict = null;
        }
      };

      /**
       * set mouse-over for index
       * @param scale
       * @param idx
       */
      scope.setMouseOver = function (scale, idx) {
        if (scale === undefined) {
          scope.mouseOverFeature = null;
          if (timer) {
            $timeout.cancel(timer);
            timer = undefined;
          }
        } else if (scale.district) {
          scope.mouseOverFeature = scale.district;
        } else if (scope.mouseOverProperty && scope.mouseOverProperty === 'index') {
          timer = $timeout(function () {
            scope.mouseOverFeature = idx;
          }, 250);
        } else if (scale.year) {
          scope.mouseOverFeature = scale.year;
        }
      };

      scope.legend = undefined;

      scope.disabledListIndex = scope.disabledListIndex ? scope.disabledListIndex : [];
      scope.$watch('selectedDataLayer', function () {
        setLegend();
      });
      scope.$watch('selectedIndicator', function () {
        setLegend();
      });
      scope.$watch('disabledYears', function () {
        setLegend();
      });

      scope.disabledDistrictScale = function (districtKey) {
        return scope.disabledDistrictKeys && (scope.disabledDistrictKeys.indexOf(districtKey) > -1 || scope.noDataDistricts.indexOf(districtKey) > -1 || availableDistricts.indexOf(districtKey) === -1);
      };

      scope.showHighlightLine = mapConfig.redLines.length > 0;

      scope.iconSvg = function (scale, color) {
        var tempScale = angular.copy(scale);
        tempScale.color = color;
        if (!scale.icon) return '';
        return UtilityService.iconSvg(tempScale);
      };

      // for print-style to add !importand and prevent converting to rgb()
      scope.ngAttrScaleColor = function (color) {
        return 'background-color: ' + color + ' !important';
      };

      scope.disableIndex = function (index, reverse) {
        if (reverse) {
          scope.disabledListIndex = [];
          angular.forEach(scope.legend.scales, function (scale, scaleIndex) {
            if (scale.radio && index !== scaleIndex) {
              scope.disabledListIndex.push(scaleIndex);
            }
          });
        } else {
          if (scope.disabledListIndex.indexOf(index) === -1) {
            scope.disabledListIndex.push(index);
          } else {
            scope.disabledListIndex.splice(scope.disabledListIndex.indexOf(index), 1);
          }
        }
      };

      scope.$watchCollection('noDataDistricts', setLegend);
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('barChartYears', ['d3', 'mapConfig', '$timeout', function (d3, mapConfig, $timeout) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layers, indicator, disabledDataLayers, selectedDistricts, disabledDistrictKeys, withoutArea, colors, years) {
    if (indicator == null) {
      return [];
    }

    var allDistricts = {};
    var data = [];

    years.forEach(function (year, index) {
      for (var districtUid in layers[year].districts) {
        var value = layers[year][districtUid] && layers[year][districtUid][indicator.uid] ? layers[year][districtUid][indicator.uid] : null;
        if (layers[year][districtUid] && disabledDistrictKeys.indexOf(layers[year].districts[districtUid].key) === -1) {
          var key = layers[year].districts[districtUid].key;
          if (!allDistricts[key]) {
            allDistricts[key] = {
              key: key,
              name: layers[year].districts[districtUid].name,
              hasNoGeoData: layers[year].districts[districtUid].hasNoGeoData,

              values: []
            };
          }

          var yearDisabled = disabledDataLayers.map(function (year) {
            return +year;
          }).indexOf(year) !== -1;

          if (!yearDisabled && value != null) {
            allDistricts[key].values.push({
              districtuid: districtUid,
              year: +year,
              value: value,
              color: layers[year].color,
              key: key,
              name: layers[year].districts[districtUid].name,
              unit: indicator.unit
            });
          }
        }
      }
    });

    for (var district in allDistricts) {
      data.push(allDistricts[district]);
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var barChartYears = function () {
    var indicator = {},
      years = [],
      withoutArea = false,
      districtLabelProperty = 'key',
      svgHeight = 200,
      areaColor = '#000',
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      displayValues = false,
      focusIndex,
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }

        if (maxValue < 0) {
          maxValue = 0;
        }

        // max-axis-value
        if (maxAxisValue) {
          maxValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        // decimals
        if (!decimals && decimals !== 0) {
          decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
        }

        var axisFormatString = ',.' + (maxValue < 7 ? '1' : '0') + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((indicator.prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (indicator.prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = 1;
        if (data.length > 0) {
          districtLabelDigits = d3.max(data.map(function (d) {
            return accessor(districtLabelProperty)(d).length;
          }));
        }

        margin.bottom = Math.min(svgHeight / 2, 15 + 7 * districtLabelDigits);

        var container = d3.select(this).datum([data]).classed('bar-chart-years', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, yearNumber, districtNumber) {
            var district = data[districtNumber], value;
            if (indicator.unit === '%') {
              value = indicator.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = indicator.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + d.color + ';"><b>' + district.name + ' (' + district.key + ')</b><br>' + d.year + ': <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(years)
          .rangeBands([0, x0.rangeBand()]);

        var xLine = d3.scale.linear()
          .domain([d3.min(years), d3.max(years)])
          .range([0, x0.rangeBand()]);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicator.prefix + germanNumberFormat(axisFormatString)(d);
          });

        var redLines = indicator.redLines ? indicator.redLines : mapConfig.redLines;

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '')
          .attr('dominant-baseline', 'central');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        var area = d3.svg.area()
          .x(function (d, i) {
            return xLine(d.year);
          })
          .y0(y(0))
          .y1(function (d) {
            return y(Math.min(maxValue, d.value));
          });

        // only draw bars if years and an indicator are present
        if (angular.isArray(years) && years.length > 0 && angular.isObject(indicator) && indicator.hasOwnProperty('key')) {

          var unit = indicator.unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .classed('visually-hidden', !withoutArea && years.length > 1)
            .attr('stroke', 'black');

          features
            .classed('visually-hidden', !withoutArea && years.length > 1)
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            })
            .attr('data-key', function (d) {
              return accessor('key')(d);
            });

          var featureAreas = g.selectAll('.featureArea')
            .data(data, accessor('key'));

          var $svg = jQuery(svg[0]);

          // since the mousemove is debounced we need to check if the mouse left the area in the meantime
          var mouseOverActive = false;

          /**
           * show features (bars) by key
           * @param element
           * @param key
           */
          var showFeaturesByKey = function (element, key) {
            jQuery(element).attr('class', 'featureArea visually-hidden');
            $svg.find('.feature[data-key="' + key + '"]').attr('class', 'feature');
          };

          /**
           * hide features (bars) by key
           * @param element
           * @param key
           */
          var hideFeaturesByKey = function (element, key) {
            jQuery(element).attr('class', 'featureArea');
            $svg.find('.feature[data-key="' + key + '"]').attr('class', 'feature visually-hidden');
          };

          /**
           * handle mouse-move event and show/hide bars
           * @param event
           */
          var mouseMoveFunction = function (event) {
            if (mouseOverActive) {
              $svg.find('.featureArea').each(function (index, element) {
                var key = jQuery(element).data('key');
                var clientRect = element.getBoundingClientRect();
                var x = clientRect.left;
                var width = clientRect.width;
                if (event.pageX > x && event.pageX < (x + width)) {
                  // show bars - hide area
                  showFeaturesByKey(element, key);
                } else {
                  // show area - hide bars
                  hideFeaturesByKey(element, key);
                }
              });
            } else {
              resetMouseMoveFunction();
            }
          };

          var resetMouseMoveFunction = function () {
            mouseOverActive = false;
            $svg.find('.featureArea').attr('class', 'featureArea');
            $svg.find('.feature').attr('class', 'feature visually-hidden');
          };

          if (!withoutArea && years.length > 1) {
            featureAreas
              .enter().append('path')
              .classed('featureArea', true)
              .attr('fill', areaColor)
              .attr('transform', function (d) {
                return 'translate(' + x0(d[districtLabelProperty]) + ')';
              })
              .attr('d', function (d) {
                return area(d.values);
              });

            featureAreas
              .transition().duration(duration)
              .attr('d', function (d) {
                return area(d.values);
              })
              .attr('transform', function (d) {
                return 'translate(' + x0(d[districtLabelProperty]) + ')';
              })
              .attr('data-key', function (d) {
                return accessor('key')(d);
              });
            // clear mouse events on repeated paints
            $svg.off('mouseenter');
            $svg.off('mousemove');
            $svg.off('mouseleave');

            $svg.mouseenter(function () {
              mouseOverActive = true;
            });

            $svg.mousemove(_.debounce(mouseMoveFunction, 50, {maxWait: 150}));

            $svg.mouseleave(function () {
              mouseOverActive = false;
              resetMouseMoveFunction();
            });
          } else {
            $svg.off('mouseenter');
            $svg.off('mousemove');
            $svg.off('mouseleave');
            featureAreas.remove();
          }
          features.exit().remove();
          featureAreas.exit().remove();

          var barXValue = compose(x1, accessor('year'));
          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('year'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', accessor('color'))
            .attr('width', 0)
            .attr('x', barXValue)
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', accessor('color'))
            .attr('class', function (d) {
              return 'bar-' + (d.year);
            })
            .attr('width', x1.rangeBand())
            .attr('x', barXValue)
            .attr('y', function (d) {
              return y(Math.min(maxValue, Math.max(0, accessor('value')(d))));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(Math.min(maxValue, accessor('value')(d))));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();

          g.selectAll('line.highlightLine').remove();
          g.selectAll('line.highlightArea').remove();

          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration));
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('year'));

          if (displayValues) {
            labels.enter()
              .append('text')
              .attr('class', 'chart-value')
              .attr('writing-mode', 'tb')
              .attr('y', 0);

            // update labels
            labels
              .text(function (d) {
                return germanNumberFormat('.0f')(accessor('value')(d));
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d, i) {
                // var plus = i % 2 === 0 ? 0 : 14;
                return y(Math.max(0, accessor('value')(d))) - 8;
              })
              .attr('dx', '-4');
            // remove unused labels
            labels.exit()
              .remove();
          } else {
            labels
              .remove();
          }
        } else {
          // remove all bars if no indicators are active
          jQuery(svg[0]).off('mousemove');
          g.selectAll('rect').remove();
          g.selectAll('line').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for years
     * @param {int} [newYears] set of years
     * @returns {*}
     */
    chart.years = function (newYears) {
      if (!arguments.length) {
        return years;
      } else {
        years = newYears;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newWithoutArea] name of property to use for districtlabels
     * @returns {*}
     */
    chart.withoutArea = function (newWithoutArea) {
      if (!arguments.length) {
        return withoutArea;
      } else {
        withoutArea = newWithoutArea;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newFocusIndex] height of the diagram
     * @returns {*}
     */
    chart.focusYear = function (newFocusIndex) {
      if (!arguments.length) {
        return focusIndex;
      } else {
        focusIndex = newFocusIndex;
        return chart;
      }
    };

    /**
     * getter/setter for areaColor
     * @param {Function} [newAreaColor] new areaColor function
     * @returns {*}
     */
    chart.areaColor = function (newAreaColor) {
      if (!arguments.length) {
        return areaColor;
      } else {
        areaColor = newAreaColor;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-barChartYears,.grid-stack-item-content-barChartYearsWithoutArea').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChartYears.html',
    scope: {
      layers: '=',
      selectedDistricts: '=',
      disabledDataLayers: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      decimalsOverride: '=',
      maxAxisValueOverride: '=',
      indicators: '=',
      mouseOverFeature: '=',
      dimensionX: '@',
      dimensionY: '@',
      withoutArea: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.withoutArea = scope.config.withoutArea || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.yearsToHide = mapConfig.yearsToHide ? mapConfig.yearsToHide : [];

      var barChartYearsFunction = barChartYears();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (!Object.keys(scope.layers)[0] || !scope.layers[Object.keys(scope.layers)[0]] || Object.keys(scope.layers[Object.keys(scope.layers)[0]].districts).length === scope.disabledDistrictKeys.length || !scope.selectedChartColorset) {
          return null;
        }

        scope.withoutArea = scope.config.withoutArea ? '1' : false;

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var years = Object.keys(scope.layers);
        var filteredYears = years
          .filter(function (year) {
            return scope.layers[year].indicators.indexOf(filteredIndicators[0].uid) !== -1;
          })
          .filter(function (year) {
            return scope.yearsToHide.indexOf(year) === -1;
          })
          .map(function (year) {
            return +year;
          });

        if (!filteredYears.length) {
          scope.disabledDataLayers = [];
        }

        var colors = scope.selectedChartColorset.colors.map(function (color) {
          return color.color;
        });
        var colorAt = 1;
        var areaColor = colors[0];
        var yearsToShow = [];


        /** overwrite first legend-entry with displayed years */
        var displayedYears = filteredYears.filter(function (year) {
          return scope.disabledDataLayers.indexOf('' + year) < 0;
        });

        var legend = undefined;
        var firstYear = displayedYears[0],
          lastYear = displayedYears[displayedYears.length - 1],
          fromYearLabel = firstYear,
          toYearLabel = lastYear,
          indicatorUid = filteredIndicators[0].uid;

        if (scope.layers[firstYear] && scope.layers[firstYear].legend && scope.layers[firstYear].legend[indicatorUid] && scope.layers[firstYear].legend[indicatorUid].chart.yearLabelOverride) {
          fromYearLabel = scope.layers[firstYear].legend[indicatorUid].chart.yearLabelOverride;
        }

        if (scope.layers[lastYear] && scope.layers[lastYear].legend && scope.layers[lastYear].legend[indicatorUid] && scope.layers[lastYear].legend[indicatorUid].chart.yearLabelOverride) {
          toYearLabel = scope.layers[lastYear].legend[indicatorUid].chart.yearLabelOverride;
          legend = scope.layers[lastYear].legend[indicatorUid].chart;
        }

        var filteredColors = [];
        if (legend && legend.scales) {
          legend.scales.forEach(function (scale, index) {
            if(scale.text){
              filteredColors.push(colors[index]);
            }
          });
        } else {
          filteredColors = colors;
        }

        /** bind color to year */
        filteredYears.forEach(function (year) {
          if (scope.disabledDataLayers.indexOf(year+'') < 0) {
            scope.layers[year].color = filteredColors[colorAt];
            yearsToShow.push(year);
          }
          colorAt++;
        });

        /** get chart-data to display */
        var data = combineData(scope.layers, filteredIndicators[0], scope.disabledDataLayers, scope.selectedDistricts, scope.disabledDistrictKeys, scope.withoutArea === '1', colors, filteredYears);

        /** call chart-functions */
        barChartYearsFunction
          .areaColor(areaColor)
          .indicator(filteredIndicators[0])
          .districtLabelProperty(scope.config.districtLabelProperty)
          .focusYear(scope.mouseOverFeature)
          .years(yearsToShow)
          .withoutArea(scope.withoutArea === '1')
          .displayValues(scope.config.displayValues)
          .decimals(scope.decimalsOverride)
          .maxAxisValue(scope.maxAxisValueOverride)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartYearsFunction);

        $timeout(function () {
          jQuery('.legend-item:first .color-set-colors .legend-scale-text').html(fromYearLabel + ' - ' + toYearLabel);
        }, 10);
      };

      jQuery(document).on("fullscreen", rerender);

      var layersWatcher = scope.$watch('layers', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var disabledDataLayersWatcher = scope.$watchCollection('disabledDataLayers', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var withoutAreaWatcher = scope.$watch('config.withoutArea', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var selectedChartColorsetWatcher = scope.$watch('selectedChartColorset', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layersWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        disabledDataLayersWatcher();
        disabledDistrictKeysWatcher();
        withoutAreaWatcher();
        displayValuesWatcher();
        selectedChartColorsetWatcher();

        // remove tooltip dom element
        if (angular.isDefined(barChartYearsFunction.tip())) {
          barChartYearsFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('bookmarkContainer', ['mapConfig', 'communeConfig', 'BookmarkService', 'ModalService', function(mapConfig, communeConfig, BookmarkService, ModalService) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'bookmarkContainer.html',
    scope: {
      'currentConfig': '=',
      'bookmarks': '=',
      'onBookmarkSelect': '&',
      'categories': '='
    },
    link: function(scope){
      if(!angular.isArray(scope.bookmarks)) {
        scope.bookmarks = [];
      }
      scope.selection = {};
      scope.selectableCategories = [];
      scope.showEditButtons = communeConfig.showEditOptions;
      scope.selectableCategories = [];

      scope.$watchCollection('bookmarks', function() {
        if(!scope.categories) return;
        scope.selectableCategories = scope.categories.filter(categorySelectFilter);
      });

      var categorySelectFilter = function(category) {
        if(!scope.bookmarks) return;
        return scope.bookmarks.filter(function (bookmark) {
            return bookmark && bookmark.category == category.id;
          }).length > 0;
      };

      /**
       * Creates a new bookmark. Opens a new modal window for data input
       */
      scope.addBookmark = function() {
        ModalService.createCustomModal({
          categories: scope.categories
        }, {
          templateUrl: mapConfig.templateBasePath + 'modals/bookmarkCreate.html',
          controller: 'BookmarkModalController'
        })
          .result
          .then(function(newBookmarkData) {
            return BookmarkService.createBookmark(newBookmarkData.title, newBookmarkData.categoryId, scope.currentConfig);
          })
          .then(function(newBookmark) {
            scope.bookmarks.push(newBookmark);
          })
          .catch(function(dismissReason) {
            console.log(dismissReason);
          });
      };

      /**
       * Deletes a given bookmark. Opens a new modal window for confirmation
       * @param {object} bookmark Bookmark object which should be deleted
       */
      scope.deleteBookmark = function(bookmark) {
        ModalService.createCustomModal({},
          {
            templateUrl: mapConfig.templateBasePath + 'modals/bookmarkDelete.html',
            controller: 'CustomModalController'
          })
          .result
          .then(function() {
            return BookmarkService.deleteBookmark(bookmark.id);
          })
          .then(function() {
            scope.bookmarks.splice(scope.bookmarks.indexOf(bookmark), 1);
          });
      };

      /**
       * Invokes the callbackFunction when a single bookmark gets selected
       * @param {object} bookmark Bookmark object which should be loaded
       */
      scope.loadBookmark = function(bookmark) {
        scope.onBookmarkSelect({
          bookmark: bookmark
        });
      };

    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('bookmarkNavigation', ['mapConfig', 'communeConfig', 'BookmarkService', function(mapConfig, communeConfig, BookmarkService) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'bookmarkNavigation.html',
    scope: {
      'currentConfig': '=',
      'bookmarks': '=',
      'onBookmarkSelect': '&',
      'categories': '='
    },
    link: function(scope){
      if(!angular.isArray(scope.bookmarks)) {
        scope.bookmarks = [];
      }

      scope.selection = {};
      scope.selectableCategories = [];
      scope.showEditButtons = communeConfig.showEditOptions;
      scope.selectableCategories = [];

      /**
       * Invokes the callbackFunction when a single bookmark gets selected
       * @param {object} bookmark Bookmark object which should be loaded
       */
      scope.loadBookmark = function(bookmark) {
        scope.onBookmarkSelect({
          bookmark: bookmark
        });
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('chartDistrictLegend', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'chartDistrictLegend.html',
    scope: {
      districts: '=',
      districtColorFunction: '=',
      selectedDistricts: '=',
      disabledDistricts: '='
    },
    link: function(scope) {

      scope.isSelected = function(districtkey) {

        return (scope.selectedDistricts.map(function(d) {
          return d.key;
        }).indexOf(districtkey) !== -1);
      };

      /**
       * toggle one indicator of the currently selected indicators
       *
       * @param {String} districtKey the indicator to toggle
       */
      scope.toggleDistrict = function(districtKey) {
        var index = scope.disabledDistricts.indexOf(districtKey);
        if(index > -1) {
          scope.disabledDistricts.splice(index, 1);
        } else {
          scope.disabledDistricts.push(districtKey);
        }
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('chartIndicatorLegend', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'chartIndicatorLegend.html',
    scope: {
      indicators: '=',
      disabledIndicators: '='
    },
    link: function(scope) {

      /**
       * toggle one indicator of the currently selected indicators
       *
       * @param {String} indicatorKey the indicator to toggle
       */
      scope.toggleIndicator = function(indicatorKey) {
        var index = scope.disabledIndicators.indexOf(indicatorKey);
        if(index > -1) {
          scope.disabledIndicators.splice(index, 1);
        } else {
          scope.disabledIndicators.push(indicatorKey);
        }
      };

      /**
       * get a color from the colorset by number
       * @param {int} number the index of the color
       * @returns {String} the color code
       */
      scope.color = function(number) {
        return d3.hyperion.indicatorColorAt(number);
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtReport', ['mapConfig', 'communeConfig', function(mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '='
    },
    link: function (scope) {

      var data = getDistrictData();
    }
  }
}]);

angular.module('Itao.IndicatorMap').directive('simpleBar', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport/simpleBar.html',
    scope: {
      selectedDataLayer: "=",
      selectedDistrict: "=",
      relativeIndicator: "=",
      absoluteIndicator: "="
    },
    link: function (scope, element) {
      var absoluteNumberFormat = germanNumberFormat(',.0f');
      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        if (!scope.selectedDistrict || !scope.selectedDataLayer || angular.equals(scope.selectedDataLayer, {}) || !scope.selectedDataLayer[scope.selectedDistrict.uid]) {
          return;
        }
        scope.relativeValue = scope.selectedDataLayer[scope.selectedDistrict.uid][scope.relativeIndicator];
        scope.absoluteValue = absoluteNumberFormat(scope.selectedDataLayer[scope.selectedDistrict.uid][scope.absoluteIndicator]);
      };

      var layerWatcher = scope.$watch('selectedDataLayer', rerender);
      var districtWatcher = scope.$watch('selectedDistrict', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        districtWatcher();
      });
    }
  };
}]).filter('germanNumber', ['d3', function(d3) {
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat,
      numberFormat = germanNumberFormat(',.1f');
  return function(number) {
    return numberFormat(number);
  };
}]);

angular.module('Itao.IndicatorMap').directive('stackedBar', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var stackedSetBarChart = function () {
    var colors = [];
    var stackHeader = '';
    var barWidth = 80;
    var duration = 400,
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {
        // reverse data to sort indicators from bottom to top
        data.reverse();
        var container = d3.select(this).datum([data]).classed('education-participation', true);
        var heightFactor = 2;
        var prevHeight = [0];
        var total = 0;
        var svgMarginTop = 20;
        // Total and stackHeights
        data.forEach(function (value, i) {
          if (value != null) {
            total += value;
            prevHeight.push(prevHeight[i] + value);
          } else {
            prevHeight.push(prevHeight[i]);
          }
        });

        var marginTop = 100 - total + svgMarginTop;
        var svgWidth = 150,
          svgHeight = (total * heightFactor) + (marginTop * heightFactor);
        prevHeight = prevHeight.map(function (height) {
          return height + marginTop;
        });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var stack = svg.selectAll('g').data([data]);
        // svg.selectAll('.margin-group').attr('transform', 'translate(' + (svgWidth/2) + ',' + (svgHeight/2) + ')');

        var stackEnter = stack.enter()
          .append('g')
          .attr('class', 'margin-group');

        var bars = stack.selectAll('rect')
          .data(data);

        var barsEnter = bars
          .enter()
          .append('rect')
          .attr('width', barWidth);

        bars
          .transition()
          .duration(duration)
          .attr('height', function (d) {
            return d * heightFactor;
          })
          .attr('y', function (d, i) {
            return prevHeight[i] * heightFactor;
          })
          .attr('x', 0)
          .attr('width', barWidth)
          .attr("fill", function (d, i) {
            return colors[i];
          });

        var rectLabels = stack.selectAll(".rectLabel")
          .data(function (d) {
            return d;
          });

        var rectLabelsEnter = rectLabels
          .enter().append("text")
          .attr("class", "rectLabel")
          .attr("alignment-baseline", "middle")
          .attr("fill", "#000000");

        rectLabels
          .transition()
          .duration(duration)
          .text(function (d, i) {
            if (d != null) {
              return numberFormat(d);
            } else {
              return '';
            }
          })
          .attr("x", function (d) {
            return barWidth + 10;
          })
          .attr("y", function (d, i) {
            var dataHeight = d * heightFactor;
            var pHeight = prevHeight[i] * heightFactor;
            var y = (pHeight + dataHeight) - (dataHeight / 2);
            return y < 235 ? y : 235;
          });

        // Top List sum
        var topValue = svg
          .selectAll(".barSum")
          .data([data]);

        var topValueEnter = topValue
          .enter()
          .append("text")
          .attr("class", function () {
            if (stackHeader) {
              return "barSum stack-header";
            } else {
              return "barSum";
            }
          })
          .attr("text-anchor", "middle")
          .attr("fill", "#000000");

        topValue.transition().duration(duration)
          .attr("x", function (d, i) {
            return barWidth / 2;
          })
          .attr("y", function (d, i) {
            return marginTop * heightFactor - 10;
          })
          .text(function (d, i) {
            if (!total) return '—';
            if (stackHeader) {
              return stackHeader;
            } else {
              return numberFormat(total);
            }
          });

        // Sonderfall leerer stack - Überschrift soll stehen bleiben
        if (!total && stackHeader) {
          // Top List sum
          var emptyStackHeader = svg
            .selectAll(".empty")
            .data([data]);

          var emptyStackHeaderEnter = emptyStackHeader
            .enter()
            .append("text")
            .attr("class", 'empty')
            .attr("text-anchor", "middle")
            .attr("fill", "#000000");

          emptyStackHeader.transition().duration(duration)
            .attr("x", function (d, i) {
              return barWidth / 2;
            })
            .attr("y", 30) // y on 100%
            .text(stackHeader);

          emptyStackHeader.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('height', 0)
            .remove();
        } else {
          svg.selectAll(".empty").remove();
        }

        rectLabels.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        topValue.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        bars.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();
      });
    };

    /**
     * getter/setter for colors
     * @param {Function} [newColorSet] new color function
     * @returns {*}
     */
    chart.colors = function (newColorSet) {
      if (!arguments.length) {
        return colors;
      } else {
        colors = newColorSet;
        return chart;
      }
    };

    /**
     * getter/setter for colors
     * @param {Function} [newStackHeader] new color function
     * @returns {*}
     */
    chart.stackHeader = function (newStackHeader) {
      if (!arguments.length) {
        return stackHeader;
      } else {
        stackHeader = newStackHeader;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport/stackedBar.html',
    scope: {
      selectedDataLayer: "=",
      selectedDistrict: "=",
      stackIndicatorIds: "=",
      colors: "=",
      stackBlank: "=",
      stackHeader: "="
    },
    link: function (scope, element) {
      var stackedSetBarChartFunction = stackedSetBarChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        var chartColors = scope.colors ? scope.colors : ["#ff6600", "#ffb380", "#003399", "#80afff", "#ffcc00", "#ffe680", "#339933", "#9fdf9f"];
        if (!scope.selectedDistrict || !scope.selectedDataLayer || angular.equals(scope.selectedDataLayer, {})) {
          d3.select(element[0]).select('svg').remove();
          return;
        }
        var data = [];
        scope.stackIndicatorIds.forEach(function (id) {
          var value = scope.selectedDataLayer[scope.selectedDistrict.uid] ? scope.selectedDataLayer[scope.selectedDistrict.uid][id] : null;
          if (value) {
            data.push(value);
          } else {
            data.push(null);
          }
        });
        if(scope.stackBlank && scope.stackIndicatorIds.length === 1 && data[0] !== null) {
          data.push(100 - data[0]);
        }

        // set colorSet
        stackedSetBarChartFunction
          .colors(chartColors)
          .stackHeader(scope.stackHeader);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(stackedSetBarChartFunction);
      };

      var layerWatcher = scope.$watch('selectedDataLayer', rerender);
      var indicatorSetsWatcher = scope.$watchCollection('indicatorSets', rerender);
      var districtWatcher = scope.$watch('selectedDistrict', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        districtWatcher();
        indicatorSetsWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtCheckboxes', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtCheckboxes.html',
    scope: {
      selectedDataLayer: '=',
      disabledDistrictKeys: '=',
      noDataDistricts: '=',
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];

      jQuery('#districtToggle').click(function () {
        jQuery(this).closest('.district-container').toggleClass('open');
      });

      // Toggle selection for a given district by key
      scope.toggleSelection = function toggleSelection(districtKey) {
        var index = scope.disabledDistrictKeys.indexOf(districtKey);
        if (index > -1) {
          scope.disabledDistrictKeys.splice(index, 1);
        } else {
          scope.disabledDistrictKeys.push(districtKey);
        }
      };

      scope.uncheckAll = function toggleSelection() {
        if (scope.disabledDistrictKeys.length) {
          scope.disabledDistrictKeys = [];
        } else {
          scope.disabledDistrictKeys = Object.keys(scope.selectedDataLayer.districts).map(function (num) {
            return scope.selectedDataLayer.districts[num].key;
          }).filter(function (key) {
            return ['ost', 'west', 'de'].indexOf(key.toLowerCase()) === -1;
          });
        }
      };

      scope.hasData = function (districtKey) {
        return scope.noDataDistricts ? scope.noDataDistricts.indexOf(districtKey) === -1 : true;
      };

      scope.$watch('selectedDataLayer', function (dataLayer) {
        if (dataLayer && dataLayer.hasOwnProperty('districts')) {
          var oldKeys = angular.copy(scope.disabledDistrictKeys);
          var newKeys = Object.keys(dataLayer.districts).map(function (num) {
            return dataLayer.districts[num].key;
          });
          angular.forEach(oldKeys, function (oldKey) {
            if (newKeys.indexOf(oldKey) === -1) {
              scope.disabledDistrictKeys.splice(scope.disabledDistrictKeys.indexOf(oldKey), 1);
            }
          });
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtKeyRadios', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtKeyRadios.html',
    scope: {
      districts: '=',
      selectedDistrictKey: '='
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];
      jQuery('#districtToggle').click(function(){
        jQuery(this).closest('.district-container').toggleClass('open');
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtRadios', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtRadios.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '='
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];

      jQuery('#districtToggle').click(function () {
        jQuery(this).closest('.district-container').toggleClass('open');
      });

      // Toggle selection for a given district by key
      scope.toggleSelection = function toggleSelection(district) {
        scope.selectedDistrict = +district.uid;
      };

      scope.$watch('selectedDataLayer', function (dataLayer) {
        if (dataLayer && dataLayer.hasOwnProperty('districts')) {
          var oldKeys = angular.copy(scope.disabledDistrictKeys);
          var newKeys = Object.keys(dataLayer.districts).map(function (num) {
            return dataLayer.districts[num].key;
          });
          angular.forEach(oldKeys, function (oldKey) {
            if (newKeys.indexOf(oldKey) === -1) {
              scope.disabledDistrictKeys.splice(scope.disabledDistrictKeys.indexOf(oldKey), 1);
            }
          });
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtSelect', ['mapConfig', 'communeConfig', function(mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtSelect.html',
    scope: {
      unselectedDistricts: '=',
      selectedDistrictKeys: '=',
      selectedDistricts: '=',
      onDistrictSelect: '&',
      onDistrictDeselect: '&'
    },
    link: function (scope) {
      scope.selectedDistrictKeys = scope.selectedDistrictKeys || [];
      scope.selectedDistricts = [];
      scope.searchterm = '';
      scope.showsearch = false;
      scope.searchfilter = function(searchterm) {
        return function(district) {
          var name = district.name.toLowerCase();
          var key = district.key.toLowerCase();
          var term = searchterm.toLowerCase();
          return (name.indexOf(term) !== -1) || (key.indexOf(term) !== -1);
        };
      };

      scope.test = function(district) {
        scope.onDistrictSelect({district: district})
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('districtsPieChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;

  var combineData = function (layer, indicator, selectedDistricts, disabledDistricts) {
    if (indicator == null) {
      return [];
    }
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });
    var data = [];
    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid)) {
        var value = disabledDistricts.indexOf(layer.districts[districtUid].key) === -1 ? +layer[districtUid][indicator.uid] : 0;
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          value: value,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var districtsPieChart = function () {
    var indicator = {},
      districtColorFunction = function () {
        return '';
      },
      svgHeight = 200,
      margin = {top: 20, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function (selection) {
      selection.each(function (data) {

        var container = d3.select(this).datum([data]).classed('districts-pie-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var sum = d3.sum(data, accessor('value'));

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function (d) {
            var centroid = labelArc.centroid(d);
            var bbox = this.getBBox();
            // open tip above labels
            return [centroid[1] - bbox.y - 17, centroid[0] - bbox.x - (bbox.width / 2)];
          })
          .html(function (d) {
            var value;
            if (indicator.unit) {
              value = numberFormat(d.data.value) + indicator.unit;
            } else {
              value = d.value + ' (' + numberFormat((d.value / sum) * 100) + '%)';
            }
            return '<div class="d3-tip-border" style="border-color:' + districtColorFunction(d.data) + ';"><b>' + d.data.name + ' (' + d.data.key + ')</b><br><span style="color:' + districtColorFunction(d.data) + ';">' + indicator.name + ':</span> <span>' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);

        g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + (margin.left + width / 2) + ',' + (margin.top + height / 2) + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var pieRadius = Math.min(width, height) / 2;
        var pieLayout = d3.layout.pie()
          .value(accessor('value'))
          .sort(null);

        var arc = d3.svg.arc()
          .innerRadius(0)
          .outerRadius(pieRadius);

        function arcTween(a) {
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function (t) {
            return arc(i(t));
          };
        }

        function labelTransformTween(a) {
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function (t) {
            return 'translate(' + labelArc.centroid(i(t)) + ')';
          }
        }

        var labelArc = d3.svg.arc()
          .innerRadius(pieRadius / 2)
          .outerRadius(pieRadius);

        // only draw bars if indicators are left
        if (angular.isObject(indicator) && indicator.hasOwnProperty('key')) {

          var features = g.selectAll('.feature')
            .data(pieLayout(data), function (d) {
              return d.data.key;
            });

          features.enter()
            .append('g')
            .attr('class', 'feature');

          var arcs = features.selectAll('path')
            .data(function (d) {
              return [d];
            }, function (d) {
              return d.data.key;
            });

          arcs.enter().append('path')
            .each(function (d) {
              this._current = d;
            });

          arcs.transition().duration(duration)
            .attrTween('d', arcTween)
            .attr('fill', function (d) {
              return districtColorFunction(d.data);
            });

          var labels = features.selectAll('text')
            .data(function (d) {
              return [d];
            }, function (d) {
              return d.data.key;
            });

          labels.enter().append('text')
            .each(function (d) {
              this._current = d;
            });

          labels
            .text(function (d) {
              var value;
              if (d.endAngle - d.startAngle < 80 / pieRadius) {
                // exclude labels on small arcs
                return '';
              }
              if (indicator.unit) {
                value = numberFormat(d.data.value) + indicator.unit;
              } else {
                value = d.value;
              }
              return value;
            })
            .transition().duration(duration)
            .attrTween('transform', labelTransformTween);

          // add tooltips to bars
          arcs.call(tip);
          arcs.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          arcs.exit().remove();
          labels.exit().remove();
          features.exit().remove();

        } else {
          g.selectAll('path').remove();
          g.selectAll('text').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for districtColorFunction
     * @param {Function} [newDistrictColorFunction] function to get a color from a district
     * @returns {*}
     */
    chart.districtColorFunction = function (newDistrictColorFunction) {
      if (!arguments.length) {
        return districtColorFunction;
      } else {
        districtColorFunction = newDistrictColorFunction;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-districtsPieChart').height() - jQuery(element).find('chart-district-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtsPieChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.indicatorToShow = scope.config.indicatorToShow || '';
      scope.config.disabledDistricts = scope.config.disabledDistricts || [];
      scope.config.fullscreen = scope.config.fullscreen || false;

      var districtsPieChartFunction = districtsPieChart();
      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicatorToShow = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData && indicator.key === scope.config.indicatorToShow;
        })[0];


        var districtColorFunction = (function (districtObject) {
          var keys = Object.keys(districtObject).map(function (d) {
            return districtObject[d].key;
          });
          return function (d) {
            return color(keys.indexOf(d.key));
          }
        })(scope.layer.districts);

        scope.districtColorFunction = districtColorFunction;

        var data = combineData(scope.layer, indicatorToShow, scope.selectedDistricts, scope.config.disabledDistricts);

        districtsPieChartFunction
          .indicator(indicatorToShow)
          .districtColorFunction(districtColorFunction)
          .height(newHeight);
        d3.select(element.find('.chart-wrap')[0])
          .data([data])
          .call(districtsPieChartFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', function (newValue, oldValue, scope) {
        if (angular.isArray(newValue) && newValue.length > 0) {
          if (scope.config.indicatorToShow === ''
            || scope.config.indicatorToShow == null
            || newValue.map(function (d) {
              return d.key;
            }).indexOf(scope.config.indicatorToShow) === -1) {
            // select first as default
            scope.config.indicatorToShow = newValue[0].key;
          }
        } else {
          scope.config.indicatorToShow = '';
        }
        rerender();
      });
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var indicatorToShowWatcher = scope.$watch('config.indicatorToShow', rerender);
      var disabledDistrictsWatcher = scope.$watchCollection('config.disabledDistricts', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        indicatorToShowWatcher();
        disabledDistrictsWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();

        // remove tooltip dom element
        if (angular.isDefined(districtsPieChartFunction.tip())) {
          districtsPieChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('donutChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var donutChart = function () {
    var
      svgHeight = 135,
      svgWidth,
      color = '',
      transformToTimeFormat = false,
      margin = {top: 5, right: 5, bottom: 5, left: 5},
      arcWidth = 32,
      numberFormat = germanNumberFormat(',.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f');

    var chart = function (selection) {
      selection.each(function (data) {

        var container = d3.select(this).datum([data]).classed('donut-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom,
          outerRadius = Math.min(width, height) / 2;

        var addHeight = transformToTimeFormat ? 60 : 0;
        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + (svgHeight + addHeight))
          .attr('height', (svgHeight + addHeight))
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').attr('transform', 'translate(' + (svgWidth / 2) + ',' + ((svgHeight + addHeight) / 2) + ')');

        var donutArc = d3.svg.arc()
          .innerRadius(outerRadius - arcWidth)
          .outerRadius(outerRadius)
          .startAngle(0)
          .endAngle(function (d) {
            if (d == null) {
              return 0;
            }
            return 2 * Math.PI * (d / 100);
          });

        var background = gEnter.selectAll('.background')
          .data([100]);

        background.enter().append('path')
          .attr('class', 'background')
          .attr('fill', '#eee')
          .attr('d', donutArc);

        var donut = g.selectAll('.donut')
          .data(data);

        donut
          .enter()
          .append('path')
          .attr('fill', color)
          .attr('d', donutArc(0))
          .attr('class', 'donut');

        donut
          .attr('d', donutArc);

        var transformToTime = function (number) {
          number = 9.5;
          var hoursAndMinutes = number.toString().split('.');
          var hours = hoursAndMinutes[0];
          var minutes = hoursAndMinutes[1] ? (hoursAndMinutes[1] / 10 * 6).toString().substr(0, 2) : '00';
          minutes = minutes.length < 2 ? minutes + '0' : minutes;

          return hours + ":" + minutes;
        };

        var label = g.selectAll('.donut-label')
          .data(data);

        label.enter()
          .append('text')
          .attr('text-anchor', 'middle')
          .attr('class', 'donut-label')
          .attr('dy', '0.4em');

        label.text(function (d) {
          if (transformToTimeFormat && d !== null) {
            return transformToTime(d);
          } else {
            return d == null ? '—' : numberFormat(d);
          }
        });

        if (transformToTimeFormat) {
          var footer = g.selectAll('.donut-footer')
            .data(data);

          footer.enter()
            .append('text')
            .attr('text-anchor', 'middle')
            .attr('class', 'donut-footer')
            .attr('dy', '6.5em');

          footer.text(function (d) {
            if (transformToTimeFormat && d !== null) {
              return "Durchschnittliche Öffnungsdauer aller KiTas: " + transformToTime(d) + " Stunden pro Tag (Median) ";
            } else {
              return d == null ? '—' : numberFormat(d);
            }
          });
        }
      });
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newSvgWidth] new color function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = parseInt(newSvgWidth);
        svgHeight = svgWidth;
        return chart;
      }
    };

    /**
     * getter/setter for newTransformToTimeFormat
     * @param {Function} [newTransformToTimeFormat] new transformToTimeFormat function
     * @returns {*}
     */
    chart.transformToTimeFormat = function (newTransformToTimeFormat) {
      if (!arguments.length) {
        return transformToTimeFormat;
      } else {
        transformToTimeFormat = newTransformToTimeFormat;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'donutChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      timeFormat: '@',
      indicatorUid: '@',
      color: '&',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var donutChartFunction = donutChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && scope.indicatorUid != null && scope.color != null && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {
          var value = scope.selectedDataLayer[scope.selectedDistrict.uid][scope.indicatorUid];

          donutChartFunction
            .transformToTimeFormat(scope.timeFormat)
            .svgWidth(scope.svgWidth)
            .color(scope.color);

          d3.select(element.find('.widget-inner:first')[0])
            .data([[value]])
            .call(donutChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorSetsIndicators = scope.$watchCollection('indicatorSets', rerender);
      var colorWatcher = scope.$watch('color', rerender);
      var transformToTimeFormatWatcher = scope.$watch('transformToTimeFormat', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        transformToTimeFormatWatcher();
        selectedDistrictWatcher();
        indicatorSetsIndicators();
        colorWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('export', ['mapConfig', 'ExportService', 'HyperionDataService','$http', function (mapConfig, ExportService, HyperionDataService, $http) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'export.html',
    scope: {
      types: '=',
      data: '=',
      filename: '@',
      source: '@'
    },
    link: function (scope, element) {
      var $contentContainer = jQuery('.itao-pluginView:first');
      scope.exportWidget = function (type) {
        if (type == 'csv') {
          ExportService.exportAsCsv(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'xlsx') {
          ExportService.exportAsXlsx(
            scope.data,
            type,
            scope.filename
          );
        } else {
          ExportService.exportAsImage(
            $contentContainer.html(),
            type,
            scope.filename,
            [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())],
            scope.source
          );
        }
      };

      scope.htmlToPdf = function (id) {
        $http.get('/_assets/19afb7c62e901835de82505ec5bff8a5/Css/reportExport.css')
          .then(function(response) {
            var localStylesContent = response.data;
            var htmlString = document.getElementById(id).innerHTML;

            var context = {
              html: htmlString,
              styles: localStylesContent,
              filename: 'report_export.pdf'
            };

            var code = `module.exports=async({page: page, context:context})=>{
              await page.setContent('<html><head><style>' + context.styles + '</style></head><body>' + context.html + '</body></html>');

              var output = await page.pdf({
                path: 'output.pdf',
                format: 'A4',
                landscape: true,
                printBackground: true,
                margin: { top: 40, right: 40, bottom: 40, left: 40 },
              });
              return{data:output,type:'application/pdf'}
            }`;

            HyperionDataService.convertHtml(code, context).then(function(pathData) {
              var link = document.createElement('a');
              link.href = window.origin + '/' + pathData.data;
              link.target = '_blank';
              link.click();
            }).catch(function (error) {
              console.error('Error loading execute browserless script:', error);
            });
          })
          .catch(function(error) {
            console.error('Error loading local styles:', error);
          })
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('exportPreview', ['mapConfig', 'ExportService', 'ModalService', function (mapConfig, ExportService, ModalService) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'exportPreview.html',
    scope: {
      types: '=',
      filename: '@',
      source: '@',
      config: '='
    },
    link: function (scope, element) {
      // default lm-source
      var $contentContainer = jQuery('.itao-pluginView:first');
      scope.exportPreview = function () {
        ModalService.createCustomModal({
          types: scope.types,
          source: scope.source,
          config: scope.config
        }, {
          templateUrl: MAP_TEMPLATE_BASE_PATH + 'modals/exportPreview.html',
          controller: 'ExportPreviewModalController',
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        })
      };

      var exportWidget = function (type, html, source, dimensions) {
        if(type == 'csv') {
          ExportService.exportAsCsv(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'xlsx') {
          ExportService.exportAsXlsx(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'pdf') {
          ExportService.exportAsPdf(
            html,
            scope.filename,
            dimensions,
            source
          );
        } else {
          ExportService.exportAsImage(
            html,
            type,
            scope.filename,
            dimensions,
            source
          );
        }
      };

      scope.htmlToPdf = function (id) {
        var $contentContainer = jQuery('#' + id);
        ExportService.exportAsPdf(
          $contentContainer[0].outerHTML,
          scope.filename,
          [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())],
          '<div class="source"><b>Quelle:</b> Ländermonitor Frühkindliche Bildungssysteme, www.laendermonitor.de</div>'
        );
      }
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('featureTable', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var identity = d3.hyperion.accessor();
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var numberFormat = germanNumberFormat(',.2f');

  var featureTable = function () {
    var indicators = [],
      selectedDistrictKeys = [];

    var table = function (selection) {
      selection.each(function (data) {
        var heads = indicators.reduce(function (prev, current) {
          return prev.concat(current.name);
        }, ['Schlüssel', 'Gebiet']);

        var keys = indicators.reduce(function (prev, current) {
          return prev.concat(current.uid);
        }, ['key', 'name']);

        var container = d3.select(this).data([data]);

        var thead = container.select('thead');
        var headings = thead.selectAll('tr').data([heads]);

        headings.enter()
          .append('tr');

        var th = headings.selectAll('th')
          .data(heads);

        th.enter()
          .append('th')
          .attr('class', function (d, i) {
            if (i > 1) {
              return 'align-right';
            }
            return '';
          })
          .append('span');

        th.exit().remove();

        th.select('span')
          .html(identity);

        if (angular.isObject(data)) {
          var bodyData = [['<b>Durchschnitt</b>', ''].concat(indicators.map(function(indicator){
            return data.avg.hasOwnProperty(indicator.uid) && data.avg[indicator.uid] != null ? data.avg[indicator.uid] : '-';
          }))];

          for(var districtUid in data.districts) {
            bodyData.push(keys.map(function(key){
              if(key === 'key') {
                return data.districts[districtUid][key];
              } else if(key === 'name') {
                if(data.districts[districtUid].url) {
                  return '<a class="report-link" title="Gebiets-Bericht anzeigen (neues Fenster)" href="' + data.districts[districtUid].url + '" target="_blank">' + data.districts[districtUid].name + '</a>';
                } else {
                  return data.districts[districtUid].name;
                }
              } else {
                var value = data[districtUid][key];
                if(value == null) {
                  value = '-';
                }
                return value;
              }
            }));
          }

          var tbody = container.select('tbody');
          var rows = tbody.selectAll('tr').data(bodyData, function (d, i) {
            return d[0] !== undefined ? d[0] : i;
          });

          rows.enter()
            .append('tr');

          rows.attr('class', function(d) {
            return selectedDistrictKeys.indexOf(d[0]) === -1 ? '' : 'selected';
          });

          rows.exit().remove();

          var elements = rows.selectAll('td')
            .data(identity);

          elements.enter()
            .append('td')
            .attr('class', function (d, i) {
              if (i > 1) {
                return 'align-right';
              }
              return '';
            });

          elements.exit().remove();

          elements
            .html(function (d, i) {
              var unitText = '';
              if (i > 1 && d !== '-') {
                unitText = indicators[i - 2].unit;
              }

              if(unitText) {
                d = numberFormat(d);
              }
              return d + unitText;
            });
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    table.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return table;
      }
    };

    /**
     * getter/setter for selectedDistrictKeys
     * @param {Array} [newSelectedDistrictKeys] set of new selectedDistrictKeys
     * @returns {*}
     */
    table.selectedDistrictKeys = function (newSelectedDistrictKeys) {
      if (!arguments.length) {
        return selectedDistrictKeys;
      } else {
        selectedDistrictKeys = newSelectedDistrictKeys;
        return table;
      }
    };

    return table;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'featureTable.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      config: '='
    },
    link: function (scope, element) {

      scope.config.fullscreen = scope.config.fullscreen || false;
      jQuery(element).find('.table-wrap').on('scroll', function(){
        jQuery(element).find('.table-overlay-wrap').find('table').css({'margin-left': -jQuery(this).scrollLeft()});
      });

      var featureTableFunction = featureTable();
      d3.select(element[0]).classed('feature-table', true);
      var rerender = function () {
        featureTableFunction
          .indicators(scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
          }))
          .selectedDistrictKeys(scope.selectedDistricts.map(function(d) {
            return d.key;
          }));


        var elementSelection = d3.select(element.find('.widget-inner:first')[0]);
        elementSelection.selectAll('table')
          .datum(scope.layer)
          .call(featureTableFunction);
      };

      scope.fillExportFields = function () {
        // JSON for Table-Export
        scope.indicatorJson = angular.toJson(scope.indicators);
        scope.layerJson = angular.toJson(scope.layer);

        setTimeout(function(){
          scope.indicatorJson = scope.layerJson = '';
        }, 100);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('horizontalBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, indicators, selectedDistricts, disabledDistrictKeys) {
    if (!layer) return [];
    var data = [];
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });

    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid) && disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1) {
        var valueArray = indicators.map(function (indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key};
        });
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
          values: valueArray,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var horizontalBarChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      displayValues = false,
      color = d3.hyperion.indicatorColorAt,
      redLines = null,
      margin = {top: 40, right: 40, bottom: 40, left: 50},
      duration = 400,
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var filteredIndicators = indicators.filter(function (indicator) {
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);

        if (minValue > 0) {
          minValue = 0;
        }

        if (maxValue < 0) {
          maxValue = 0;
        }

        if (mapConfig.axisMaxValue != null && maxValue < mapConfig.axisMaxValue) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';
        var maxDomainValue = maxAxisValue ? maxAxisValue : maxValue;
        var container = d3.select(this).datum([data]).classed('horizontal-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars
        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));

        margin.left = Math.min(15 + 8 * districtLabelDigits, svgWidth / 2); // use a maximum of half the widget for labels

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function (d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            var district = data[districtNumber], value;
            if (!decimals) {
              decimals = filteredIndicators[indicatorNumber].unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            if (filteredIndicators[indicatorNumber].unit === '%') {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + colorFromBar(d, indicatorNumber) + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + filteredIndicators[indicatorNumber].name + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var y0 = d3.scale.ordinal()
          .rangeRoundBands([0, height], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var y1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, y0.rangeBand()]);

        // scale for bar values
        var x = d3.scale.linear()
          .range([0, width])
          .domain([minValue, maxDomainValue])
          .nice();

        var tickCount = Math.min(svgWidth / 90, 10);

        var xAxis = d3.svg.axis()
          .scale(x)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          })
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y0)
          .orient('left');

        g.call(d3.hyperion.addVerticalGridLines(x, height, 0, tickCount, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        // only draw bars if indicators are left
        if (angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {

          redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
            return lineValue <= maxValue;
          });
          g.call(d3.hyperion.addVerticalHighlightArea(redLines, y0, x, height, duration));
          var unit = filteredIndicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'left')
            .attr('dominant-baseline', 'text-before-edge');
          // .attr('transform', 'translate(0,'+(height/2)+')rotate(-90)')

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('transform', function (d) {
              return 'translate(0,' + y0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke', 'black')
            .attr('x', 0);

          features
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            })
            .transition().duration(duration)
            .attr('transform', function (d) {
              return 'translate(0,' + y0(d[districtLabelProperty]) + ')';
            });

          features.exit().remove();

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('height', y1.rangeBand())
            .attr('y', compose(y1, sortedAccessor))
            .attr('x', x(0))
            .attr('width', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('height', y1.rangeBand())
            .attr('y', compose(y1, sortedAccessor))
            .attr('x', function (d) {
              return x(Math.min(0, accessor('value')(d)));
            })
            .attr('width', function (d) {
              return Math.abs(x(0) - x(accessor('value')(d)));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('height', 0)
            .remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          if (displayValues) {
            // new labels
            labels
              .enter()
              .append('text')
              .attr('x', x(0))
              .attr('stroke-width', '0');

            // update labels
            labels
              .transition().duration(duration)
              .attr("class", "chart-value horizontal")
              .text(function (d) {
                return germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
              })
              .attr('y', function (d, i) {
                return (y1.rangeBand() / 2) + (y1.rangeBand() * i) + 4;
              })
              .attr('x', function (d) {
                return x(Math.max(0, accessor('value')(d))) + 4;
              });

            // remove unused labels
            labels.exit().transition().duration(duration)
              .attr('x', x(0))
              .remove();
          } else {
            labels.transition().duration(duration)
              .attr('x', x(0))
              .remove();
          }

          g.call(d3.hyperion.addVerticalHighlightLines(redLines, x, height, duration));
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newDistrictLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newDistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newDistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-horizontalBarChart');

    return content.height() - jQuery(content).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'horizontalBarChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      colorsets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var horizontalBarChartFunction = horizontalBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var color,
          redLines = null,
          legend,
          decimals,
          maxAxisValue;

        if (scope.layer.legend != null) {
          color = d3.hyperion.buildColorFunction(filteredIndicators.map(function (indicator) {
            if (scope.layer.legend[indicator.uid]) {
              var colorsetUid = scope.layer.legend[indicator.uid].chart.colorSet;
              var indicatorColorSet = scope.colorsets.filter(function (colorSet) {
                return colorSet.uid === colorsetUid;
              })[0];

              legend = scope.layer.legend[indicator.uid];
              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }

              var indicatorColor = '';
              if (indicatorColorSet != null) {
                indicatorColor = indicatorColorSet.colors[0].color;
              }
              return indicatorColor;
            } else {
              return d3.hyperion.indicatorColorAt;
            }
          }));
        } else if (scope.selectedChartColorset) {
          color = d3.hyperion.buildColorFunction(scope.selectedChartColorset.colors.map(function (color) {
            return color.color;
          }));
        } else {
          color = d3.hyperion.indicatorColorAt;
        }

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts, scope.disabledDistrictKeys);
        horizontalBarChartFunction
          .color(color)
          .redLines(redLines)
          .indicators(indicators)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .displayValues(scope.config.displayValues)
          .decimals(decimals)
          .maxAxisValue(maxAxisValue)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(horizontalBarChartFunction);
      };

      jQuery(document).on("fullscreen", rerender);
      var layerWatcher = scope.$watchCollection('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();

        // remove tooltip dom element
        if (angular.isDefined(horizontalBarChartFunction.tip())) {
          horizontalBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('addWidget', ['$rootScope', function ($rootScope) {
  'use strict';
  var addEventName = 'createNewWidget';

  return {
    restrict: 'A',
    scope: {
      'addWidget': '@'
    },
    link: function(scope, element){
      element.on('click', function() {
        $rootScope.$broadcast(addEventName, {
          type: scope.addWidget
        });
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('gridContainer', ['$timeout', 'mapConfig', function($timeout, mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'gridContainer.html',
    controller: 'GridController',
    scope: {
      onChange: '&',
      onDragStart: '&',
      onDragStop: '&',
      onResizeStart: '&',
      onResizeStop: '&',
      options: '=',
      diagramData: '=',
      config: '=',
      selectDistrict: '&',
      deselectDistrict: '&'
    },
    controllerAs: 'ctrl',
    link: function (scope, element, attrs, controller) {
      scope.config = scope.config || {};
      scope.config.grids = scope.config.grids || {};

      element.on('change', function (e, items) {
        $timeout(function() {
          scope.$apply();
          scope.onChange({event: e, items: items});
        });
      });

      element.on('dragstart', function(e, ui) {
        scope.onDragStart({event: e, ui: ui});
      });

      element.on('dragstop', function(e, ui) {
        $timeout(function() {
          scope.$apply();
          scope.onDragStop({event: e, ui: ui});
        });
      });

      element.on('resizestart', function(e, ui) {
        scope.onResizeStart({event: e, ui: ui});
      });

      element.on('resizestop', function(e, ui) {
        $timeout(function() {
          scope.$apply();
          scope.onResizeStop({event: e, ui: ui});
        });
      });

      // Init gridstack container
      scope.gridstackHandler = controller.init(element, scope.options);
    }
  };

}]);
angular.module('Itao.IndicatorMap').directive('gridItem', ['$timeout', '$http', 'mapConfig', 'GridItemWidgetCompiler', 'ExportService', function($timeout, $http, mapConfig, GridItemWidgetCompiler, ExportService) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'gridItem.html',
    controller: 'GridController',
    //it needs the grid container's controller instance since the gridstack initialization is done inside it
    require: '^gridContainer',
    scope: {
      config: '=',
      diagramData: '=',
      gridItemName: '@',
      selectDistrict: '&',
      deselectDistrict: '&'
    },
    link: function (scope, element, attrs, controller) {
      scope.config = scope.config || {};
      scope.config.widget = scope.config.widget || {};
      var $contentContainer = element.find('.grid-stack-item-content');
      // If type is specified, compile, render and append widget
      if (scope.config.type) {
        $contentContainer.addClass('grid-stack-item-content-' + scope.config.type);
        var widgetTemplateFunction = GridItemWidgetCompiler.generateTemplateFunctionByType(scope.config.type, scope.config);
        $contentContainer.append(widgetTemplateFunction(scope));
      }

      jQuery(element).attr('data-gs-x', scope.config.x);
      jQuery(element).attr('data-gs-y', scope.config.y);
      jQuery(element).attr('data-gs-width', scope.config.width);
      jQuery(element).attr('data-gs-height', scope.config.height);

      var unwatchX = scope.$watch(function(){
        return jQuery(element).attr('data-gs-x');
      }, function(val) {
        scope.config.x = val;
      });

      var unwatchY = scope.$watch(function(){
        return jQuery(element).attr('data-gs-y');
      }, function(val) {
        scope.config.y = val;
      });

      scope.$watch(function(){
        return jQuery(element).attr('data-gs-width');
      }, function(val) {
        scope.config.width = val;
      });

      scope.$watch(function(){
        return jQuery(element).attr('data-gs-height');
      }, function(val) {
        scope.config.height = val;
      });

      scope.decreaseWidgetHeight = function() {
        controller.decreaseWidgetHeight(element);
      };

      scope.increaseWidgetHeight = function() {
        controller.increaseWidgetHeight(element);
      };

      scope.removeWidget = function() {
        scope.$destroy();
        controller.removeItem(element);
        controller.removeFromCollection(scope.gridItemName);
      };
      scope.exportWidget = function(type) {
        ExportService.exportAsImage(
          $contentContainer.html(),
          type,
          'hyperion-export',
          [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())]
        );
      };

      element.bind('$destroy', function() {
        unwatchY();
        unwatchX();
        scope.$destroy();
      });

      // Initialize directive as gridstack element
      controller.makeWidget(element);

    }

  };

}]);

angular.module('Itao.IndicatorMap').directive('widgetAdderGroup', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'widgetAdderGroup.html',
    restrict: 'E',
    scope: {
      numberOfIndicatorSets: '='
    },
    link: function(scope) {
      scope.showPriviligedWidgets = angular.copy(mapConfig.registeredUserMode);
      scope.$watch('numberOfIndicatorSets', function (numberOfIndicatorSets) {
        scope.showIndicatorSetCharts = numberOfIndicatorSets > 0;
      });
  }
  };
}]);

angular.module('Itao.IndicatorMap').directive('horizontalStackedSetBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = accessor('color');

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];
        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }

      if (listObject.sum < 99.99 && listObject.unit === "%") {
        listObject.nOffset = 100 - listObject.sum;
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, disabledListIndex, colorset, legend) {
    var indicatorsWithoutLists = selectedIndicatorSet.indicators.filter(function (indicator) {
      return indicator.list === false;
    });

    var unit = indicatorsWithoutLists[0].unit;

    var listCount = 0;
    var listsAndIndicators = indicatorsWithoutLists
      .concat(selectedIndicatorSet.lists)
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      })
      .map(function (listOrIndicator, index, allElements) {
        var subElementsCount = 0;
        if (listCount === 0 && listOrIndicator) {
          listOrIndicator.legendIndex = 0;
          listCount++;
        } else if (listOrIndicator) {
          if (allElements[listCount - 1].hasOwnProperty('indicators')) {
            subElementsCount = allElements[index - 1].indicators.filter(function (indicator) {
              return !!indicator;
            }).length;
          }
          listOrIndicator.legendIndex = allElements[listCount - 1].legendIndex + subElementsCount + 1;
          listCount++;
        }
        return listOrIndicator;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var barIndex = -1;
      return {
        // first level: districts
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        listValues: listsAndIndicators.map(function (listOrIndicator, index) {
          // second level: indicatorLists
          var isList = listOrIndicator.hasOwnProperty('indicators');
          var subValues = null;
          var sum = 0;
          var prefix = isList ? (listOrIndicator.indicators[0] != null ? listOrIndicator.indicators[0].prefix : '') : listOrIndicator.prefix;
          barIndex++;

          var listOrIndicatorName = isList ? listOrIndicator.title : listOrIndicator.name;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(listOrIndicator.legendIndex)) {
              listOrIndicatorName = legend.chart.scales[listOrIndicator.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + listOrIndicator.legendIndex + ' using ' + listOrIndicatorName + ' instead.');
            }
          }

          var listCount = 0;
          if (isList) {
            // get values for every indicator in the list
            subValues = listOrIndicator.indicators.map(function (indicator, index) {
              barIndex++;
              if (!layer[districtUid].hasOwnProperty(indicator.uid)) {
                return null;
              }
              listCount++;
              // third level: values per indicator
              var valueLegendIndex = listOrIndicator.legendIndex + listCount;
              var value = 0;
              if (layer[districtUid][indicator.uid] != null) {
                value = (+layer[districtUid][indicator.uid]);
              }

              var valueName = indicator.name;
              if (legend != null) {
                if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                  valueName = legend.chart.scales[valueLegendIndex].text;
                } else {
                  console.warn('Scale is missing index ' + listOrIndicator.legendIndex + '. Using ' + valueName + ' instead.');
                }
              }

              return {
                value: value,
                unit: indicator.unit,
                prefix: indicator.prefix,
                offset: 0,
                name: valueName,
                idx: barIndex,
                color: colorset[valueLegendIndex % colorset.length],
                legendIndex: valueLegendIndex,
                key: indicator.key
              };
            }).filter(function (value) {
              return value !== null;
            }).map(offsetMappingFunction('value'))
          } else {
            // value for single indicator without list
            if (layer[districtUid].hasOwnProperty(listOrIndicator.uid)) {
              sum = (+layer[districtUid][listOrIndicator.uid]);
            } else {
              sum = null;
            }
          }

          return {
            isList: isList,
            name: listOrIndicatorName,
            key: listOrIndicator.key,
            uid: listOrIndicator.uid,
            prefix: prefix,
            sum: sum,
            unit: unit,
            offset: 0,
            idx: barIndex,
            legendIndex: listOrIndicator.legendIndex,
            color: colorset[listOrIndicator.legendIndex % colorset.length],
            values: subValues
          };
        }).filter(function (item, idx) {
          return disabledListIndex.indexOf(idx) === -1;
        }).filter(function (listOrIndicator) {
          return (listOrIndicator.isList === false && listOrIndicator.sum !== null) || (listOrIndicator.isList && listOrIndicator.values.length > 0);
        }).map(sumMappingFunction('value', 'values'))
          .map(offsetMappingFunction('sum'))
          .map(function (listOrIndicator) {
            // add empty array for values in indicator
            if (!listOrIndicator.isList) {
              listOrIndicator.values = [];
            }
            return listOrIndicator;
          })
      };
    }).map(sumMappingFunction('sum', 'listValues'));
  };

  var horizontalStackedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      margin = {top: 40, right: 40, bottom: 40, left: 50},
      duration = 400,
      displayValues = false,
      tip,
      redLines,
      decimals,
      maxAxisValue,
      sumTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var keyDigits = d3.max(data.map(function (d) {
          return accessor('key')(d).length;
        }));

        margin.left = 10 + 13 * keyDigits;

        var xFormatter = germanNumberFormat(',.' + decimals + '%');
        var xAxisFormatter = decimals ? xFormatter : germanNumberFormat("%");
        var getLabelBy = function (property, d, featureData) {
          return d.prefix + ((d.unit === '%') ? xFormatter(d[property] / 100) : (germanNumberFormat(',.' + decimals + 'f')(d[property]) + ' (' + xFormatter(d[property] / featureData.sum) + ')'));
        }

        var container = d3.select(this).datum([data]).classed('horizontal-stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }
        if (angular.isDefined(sumTip)) {
          sumTip.destroy();
        }

        sumTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + getLabelBy('sum', d, featureData) + '</span></div>';
          });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + getLabelBy('value', d, featureData) + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, height], 0.3)
          .domain(data.map(accessor('key')));

        var barScale = d3.scale.linear()
          .domain([0, 1])
          .range([0, width]);

        var tickCount = Math.min(svgWidth / 90, 10);

        var xAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + xAxisFormatter(d).replace('%', '');
          })
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('left');
        redLines = redLines ? redLines : mapConfig.redLines;
        var lineScale = d3.scale.linear()
          .domain([0, maxAxisValue ? maxAxisValue : 100])
          .range([0, width]);

        g.call(d3.hyperion.addVerticalGridLines(barScale, height, 0, tickCount, duration));
        g.call(d3.hyperion.addVerticalHighlightArea(redLines, featureScale, lineScale, height, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'middle')
          .attr('dominant-baseline', 'initial')
          .attr('transform', 'translate(' + (width / 2 + margin.left) + ',' + (height + margin.top + margin.bottom) + ')')
          .text('in %');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function (d) {
            return 'translate(0,' + featureScale(accessor('key')(d)) + ')';
          });

        features
          .transition().duration(duration)
          .attr('transform', function (d) {
            return 'translate(0,' + featureScale(accessor('key')(d)) + ')';
          });

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('listValues'), accessor('uid'));

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', 'translate(0,0)');

        lists.transition().duration(duration)
          .attr('transform', function (d, i, j) {
            if (d.unit === '%') {
              return 'translate(' + barScale(d.offset / 100) + ',0)';
            } else {
              return 'translate(' + barScale(d.offset / lists[j].parentNode.__data__.sum) + ',0)';
            }
          });

        lists.exit().remove();

        var sumBars = lists.selectAll('.sum')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        sumBars.enter()
          .append('rect')
          .attr('class', function (d) {
            return 'sum focus-bar_' + d.idx + (d.isList ? '' : ' sum__' + d.key);
          })
          .classed('sum-only', function (d) {
            return !d.isList;
          })
          .attr('x', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', 0)
          .attr('height', featureScale.rangeBand());

        sumBars.classed('sum-only', function (d) {
          return !d.isList;
        })
          .transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', featureScale.rangeBand())
          .attr('width', function (d, i, j) {
            // fetch sum from feature for scaling the sum
            return d.unit === '%' ? barScale(d.sum / 100) : barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum);
          });

        sumBars.exit().remove();

        var sumOnly = lists.selectAll('.sum-only');
        if (sumOnly.size() > 0) {
          sumOnly.call(sumTip);
          lists.selectAll('.sum-only').on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.show(d, i, j);
            }
          })
            .on('mouseout', function (d) {
              if (d.color.toLowerCase() !== '#ffffff') {
                sumTip.hide(d);
              }
            });
        }

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', featureScale.rangeBand());

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('class', function (d) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .attr('x', function (d, i, j) {
            if (d.offset === 0) return 0;
            return d.unit === '%' ? barScale(d.offset / 100) : barScale(d.offset / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.offset / values[j].parentNode.parentNode.__data__.sum);
          })
          .attr('width', function (d, i, j) {
            if (d.value === 0) return 0;
            return d.unit === '%' ? barScale(d.value / 100) : barScale(d.value / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.value / values[j].parentNode.parentNode.__data__.sum);
          })
          .attr('height', featureScale.rangeBand());

        values.exit().remove();

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          })
            .on('mouseout', function (d) {
              if (d.color.toLowerCase() !== '#ffffff') {
                tip.hide(d);
              }
            });
        }

        var labels = lists.selectAll('text.value-label')
          .data(accessor('values'));
        //.data(function (d) {
        //  return [{sum: d.sum, color: d.color, name: d.name, isList: d.isList, unit: d.unit, prefix: d.prefix}];
        //});

        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addVerticalHighlightLines(redLines, lineScale, height, duration));

        labels.enter()
          .append('text')
          .attr('x', 0);

        // update labels
        labels
          .attr('class', function (d) {
            return "value-label horizontal " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .text(function (d, i, j) {
            //return germanNumberFormat('.' + decimals + 'f')(accessor('value')(d));
            var featureData = values[j].parentNode.parentNode.__data__;
            return getLabelBy('value', d, featureData);
            //return d.prefix + ((d.unit === '%') ? xFormatter(d.value / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.value) + ' (' + xFormatter(d.value / featureData.sum) + ')'))
          })
          .attr('x', function (d, i, j) {
            //console.log(d,i,j);
            if (d.value === 0) return 0;
            var labelX = displayValues ? d.offset + d.value : d.value;
            return d.unit === '%' ? barScale(labelX / 100) : barScale(labelX / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
          })
          .attr('y', function (d, i) {
            return (featureScale.rangeBand() / 2);
          })
          .attr('dx', 4)
          .attr('dy', 4);

        // remove unused labels
        labels.exit()
          .remove();

        var sumLabels = lists.selectAll('text.sum-label')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              idx: d.legendIndex
            }];
          });

        sumLabels.enter()
          .append('text')
          .attr('x', 0);

        // update labels
        sumLabels
          .attr('class', function (d) {
            return "sum-label horizontal " + " focus-bar_" + d.idx;
          })
          .attr('x', function (d, i, j) {
            if (displayValues) return 0;
            return d.unit === '%' ? barScale(d.sum / 100) : barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum);
          })
          .text(function (d, i, j) {
            var sumValue = accessor('sum')(d);
            if (sumValue !== 0) {
              var featureData = values[j].parentNode.parentNode.__data__;
              return getLabelBy('sum', d, featureData);
              //return d.prefix + ((d.unit === '%') ? xFormatter(d.sum / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.sum) + ' (' + xFormatter(d.sum / featureData.sum) + ')'))
              //return germanNumberFormat('.' + decimals + 'f')(accessor('sum')(d));
            } else {
              return '';
            }

          })
          .attr('y', function (d, i) {
            return (featureScale.rangeBand() / 2);
          })
          .attr('dx', 4)
          .attr('dy', 4);
        // remove unused labels
        sumLabels.exit()
          .remove();
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-horizontalStackedSetBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'horizontalStackedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.disabledListIndex = scope.disabledListIndex || [];

      var horizontalStackedSetBarChartFunction = horizontalStackedSetBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines = null,
          decimals,
          maxAxisValue;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            if (!decimals) {
              decimals = scope.selectedIndicatorSet.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend);

            horizontalStackedSetBarChartFunction
              .indicators(indicators)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(horizontalStackedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var disabledListIndexWatcher = scope.$watch('disabledListIndex', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();
        // remove tooltip dom element
        if (angular.isDefined(horizontalStackedSetBarChartFunction.tip())) {
          horizontalStackedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('lineChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  //var color = function () {
  var colorset = d3.hyperion.indicatorColors;
  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var avgKey = mapConfig.avgKey;
  var avgName = mapConfig.avgName;
  var hideLegendScale = [];
  var colorDistrictMapping;

  /**
   * combines data of given layer and indicators
   * define colors using given colorset
   * data combines for single layer to display lines of each district
   *
   * @param layer
   * @param setIndicators
   * @param disabledDistrictKeys
   * @param disabledListIndex
   * @param colorset
   * @returns {{data: {name, key}[], yearsWithData: *[], noDataDistricts: *[]}}
   */
  var combineData = function (layer, setIndicators, disabledDistrictKeys, disabledListIndex, colorset) {
    var indicatorsWithoutLists = setIndicators;

    /**
     * filter out districts if disabledDistrictKeys is set
     * @type {string[]}
     */
    var filteredDistricts = Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    });

    var data, yearsWithDataArray = [], noDataDistricts = [];
    var valueCheck = indicatorsWithoutLists.map(function () {
      return 0;
    });

    /**
     * map through districts and combines with indicatorData which are not added to indicator-type-lists
     * @type {{name, key}[]}
     */
    data = filteredDistricts.map(function (districtUid, distIdx) {
      var valueArray = indicatorsWithoutLists.map(function (indicator, index) {
        var indicatorName = indicator.name;
        var value;

        /**
         * adds value from layer
         */
        if (layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
          valueCheck[index]++;
        }

        /**
         * check if value is set and save to control-array
         */
        if (value !== null && yearsWithDataArray.indexOf(indicatorName) === -1) {
          yearsWithDataArray.push(indicatorName);
        }

        return {
          value: value,
          key: layer.districts[districtUid].key,
          id: layer.districts[districtUid].key,
          unit: indicator.unit,
          prefix: indicator.prefix,
          districtUid: districtUid,
          year: indicatorName,
          name: layer.districts[districtUid].name
        };
      }).filter(function (valueItem) {
        return !!valueItem.value;
      });

      /**
       * defines district-object
       * @type {{name, key, color, lastYear, lastValue, data, label}}
       */
      var districtObject = {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name
      };

      /**
       * adds properties to districtObject
       */
      if (valueArray.length) {
        districtObject.color = colorDistrictMapping[districtObject.key] ? colorDistrictMapping[districtObject.key] : colorset[distIdx % colorset.length];
        districtObject.lastYear = valueArray[valueArray.length - 1].year;
        districtObject.lastValue = valueArray[valueArray.length - 1].value;
        districtObject.data = valueArray;
        districtObject.label = {keys: [], y: []};
      }

      return districtObject;
    }).filter(function (district) {
      var hasData = district.data && district.data.length > 0;
      if (!hasData) {
        noDataDistricts.push(district.key);
      }
      return hasData;
    });

    return {data: data, yearsWithData: yearsWithDataArray, noDataDistricts: noDataDistricts};
  };

  /**
   * combines data of given layers and indicators
   * define colors using given colorset
   * data combines for multiple layers to display lines of each indicator for one district
   *
   * @param layers
   * @param indicatorSet
   * @param disabledDataLayers
   * @param districtKey
   * @param colors
   * @param years
   * @returns {{data: *[], yearsWithData: *[], noDataDistricts: *[]}}
   */
  var combineYearlyData = function (layers, indicatorSet, disabledDataLayers, districtKey, colors, years) {
    var data = [], yearsWithDataArray = [], noDataDistricts = [], colorIdx = 0;

    /**
     * loop through indicators and set value-array for each year
     */
    indicatorSet.indicators.sort(function (a, b) {
      return a.sorting - b.sorting;
    });
    indicatorSet.indicators.forEach(function (indicator, index) {

      /**
       * ignore list-entries from legends
       * lists are not displayed in charts
       */
      if (indicator.list && index === 0 || (indicatorSet.indicators[index - 1] && indicatorSet.indicators[index - 1].list && indicatorSet.indicators[index - 1].list !== indicator.list)) {
        colorIdx++;
      }

      /**
       * write value to array
       */
      var valueArray = years.map(function (year) {
        var layer = layers[year],
          districtUid,
          value;

        /** get district from layer by district-key */
        for (var iUid in layer.districts) {
          if (layer.districts[iUid].key === districtKey) {
            districtUid = iUid;
            break;
          }
        }

        /**
         * sets value from layer by district and indicator
         */
        if (districtUid && layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
        }

        /**
         * check if value is set and save to control-array
         */
        if (value !== null && yearsWithDataArray.indexOf(year) === -1) {
          yearsWithDataArray.push(year);
        }

        return {
          value: value,
          key: colorIdx,
          id: indicator.uid,
          unit: indicator.unit,
          prefix: indicator.prefix,
          districtUid: indicator.uid,
          year: year,
          name: indicator.name
        };
      }).filter(function (valueItem) {
        return !!valueItem.value;
      });

      /**
       * defines lineObject
       * @type {{name, key, color, lineIndex, lastYear, lastValue, data, label}}
       */
      var lineObject = {
        key: colorIdx,
        name: indicator.name
      };

      /**
       * adds lineObjectProperties if valueArray has data
       */
      if (valueArray.length) {
        lineObject.color = colorset[colorIdx];
        lineObject.lineIndex = colorIdx; // uses color-index for to let out list-entries of legend
        lineObject.lastYear = valueArray[valueArray.length - 1].year;
        lineObject.lastValue = valueArray[valueArray.length - 1].value;
        lineObject.data = valueArray;
        lineObject.label = {keys: [], y: []};
      }

      colorIdx++;
      data.push(lineObject);
    });

    return {data: data, yearsWithData: yearsWithDataArray, noDataDistricts: noDataDistricts};
  };

  /**
   * defines lineChart-function to render visualization using d3
   * @returns {chart}
   */
  var lineChart = function () {
    var indicator = {},
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      tip,
      redLines = null,
      labelMargin = 15,
      svgHeight = 200,
      focusDistrict = null,
      decimals,
      maxAxisValue,
      years;

    var chart = function (selection) {
      selection.each(function (data) {
        var minValue = 0,
          maxValue = 100,
          maxDomainValue,
          unit = indicator.defaultIndicator.unit,
          labelDigits = Math.max(germanNumberFormat(',')(Math.round(maxValue)).length, germanNumberFormat(',')(Math.round(minValue)).length);

        /**
         * defines chart-margins
         * @type {number}
         */
        margin.left = 20 + 10 * labelDigits;

        var container = d3.select(this).datum([data]).classed('line-chart', true),
          svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        /**
         * define chart-dimensions
         * @type {number}
         */
        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom,
          value;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        /**
         * defines d3-tip for mouse-over tooltips
         */
        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            if (d.unit) {
              value = germanNumberFormat(',.' + decimals + 'f')(d.value) + d.unit;
            } else {
              value = germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border"><b>' + d.name + '</b><br/>' + '<span>' + d.year + ':</span> <span>' + value + '</span>';
          });

        /**
         * select svg from container and adds data-array
         */
        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio


        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

        svg.select('.axis-unit-label')
          .text(unit === '%' ? 'in %' : '');

        /**
         * set viewBox of the svg
         */
        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth);

        /**
         * defines tickCount by svgHeight
         */
        var tickCount = Math.min(svgHeight / 40, 10);

        /**
         * defines main-margin-group and adds data-array
         */
        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        /**
         * check for max-axis-value to define scale of y-axis
         */
        if (maxAxisValue) {
          maxDomainValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxDomainValue = mapConfig.axisMaxValue;
        } else {
          maxDomainValue = maxValue;
        }

        /**
         * defines d3-x-scale
         */
        var x = d3.scale.ordinal()
          .rangePoints([0, width - labelMargin])
          .domain(years);

        /**
         * defines d3-y-scale using linear-function
         * sets domain-value-array by min and max value
         */
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxDomainValue])
          .nice();

        /**
         * defines d3-xAxis
         */
        var xAxis = d3.svg.axis()
          .scale(x)
          .orient('bottom')
          .tickValues(years);

        /**
         * definex d3-yAxis
         */
        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(germanNumberFormat(decimals ? ',.' + decimals + 'f' : ','));

        /**
         * adds x-axis to main-margin-group
         */
        gEnter.append('g')
          .classed('x axis', true)
          .attr('transform', 'translate(0,' + height + ')');

        /**
         * adds y-axis to main-margin-group
         */
        gEnter.append('g')
          .classed('y axis', true)
          .attr('y', height);

        if (angular.isArray(data) && data.length > 0) {
          /**update x axis by given data */
          g.select('.x.axis')
            .transition().duration(duration)
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

          /** update y axis by given data */
          g.select('.y.axis')
            .transition().duration(duration)
            .attr('y', height)
            .call(yAxis);

          /**
           * scale by year-property
           * for single layer-visualization the year-property is used by district-keys
           */
          var x0 = d3.scale.ordinal()
            .rangeRoundBands([0, width - labelMargin], 0.3)
            .domain(data.map(accessor('year')));

          /**
           * adds grid-lines by d3.hyperion-service
           */
          g.call(d3.hyperion.addHorizontalGridLines(y, width - labelMargin, 0, tickCount, duration));
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width - labelMargin, duration));

          /**
           * defines line-generator by year and value-accessor
           */
          var lineGen = d3.svg.line()
            .x(compose(x, accessor('year')))
            .y(compose(y, accessor('value')));

          /**
           * defines lines
           */
          var lines = g.selectAll('.line')
            .data(data, accessor('key'));

          /**
           * enter lines and adds colors and stroke-width
           */
          lines.enter().append('path')
            .style('stroke', accessor('color'))
            .style('stroke-width', 2.5)
            .attr('class', function (d) {
              return focusDistrict === d.key || focusDistrict === d.lineIndex ? 'line line-focus' : 'line';
            });

          /**
           * draw lines
           */
          lines.transition().duration(duration)
            .style('fill', 'none')
            .attr('d', function (d) {
              return lineGen(d.data);
            })
            .attr('class', function (d) {
              return 'line focus-line_' + d.key;
            });

          /**
           * removes unused lines
           */
          lines.exit().remove();

          /**
           * create dots selection
           */
          var dotgroup = g.selectAll('.dotgroup')
            .data(data, accessor('key'));

          /** add new dots */
          dotgroup.enter()
            .append('g')
            .attr('fill', accessor('color'))
            .classed('dotgroup', true);

          /**
           * defines dots and adds data
           */
          var dots = dotgroup.selectAll('.dot')
            .data(function (d) {
              return d.data;
            });

          /** updates dots position and css-class */
          dots.enter()
            .append('circle')
            .classed('dot', true);

          dots.attr('class', function (d) {
            return 'dot focus-line_' + d.key + ' key-' + d.year + '-' + d.districtUid/* + focusClass*/;
          })
            .transition().duration(duration)
            .attr('r', 4)
            .attr('cx', compose(x, accessor('year')))
            .attr('cy', compose(y, accessor('value')));

          /**
           * binds d3-tips to dots
           */
          if (dots.size() > 0) {
            dots.call(tip);
          } else {
            tip.destroy();
          }

          var labelYs = [],
            labelOffset = 5;
          data.forEach(function (item) {
            var labelY = y(accessor('lastValue')(item));
            var self = labelY;
            var overlap = false;
            var a = {top: self - labelOffset, bottom: self + labelOffset};
            for (var j = 0; j < labelYs.length; j++) {
              var that = labelYs[j];
              if (self !== that) {
                var b = {top: that - labelOffset, bottom: that + labelOffset};
                if (!(
                  b.top > a.bottom ||
                  b.bottom < a.top
                )) {
                  data[j].label.keys.push(item.key);
                  data[j].label.y.push(labelY);
                  overlap = true;
                  break;
                }
              }
            }
            if (!overlap) {
              item.label.keys.push(item.key);
              item.label.y.push(labelY);
            }
            labelYs.push(labelY);
          });

          /**
           * voronoi calculator
           * extends mouse-over for dots using d3-voronoi-function
           * voronoi used for showing the tooltip of the point closest to the cursor
           */
          var voronoi = d3.geom.voronoi()
            .x(compose(x, accessor('year')))
            .y(compose(y, accessor('value')))
            .clipExtent([[0, 0], [width, height]]);

          var voronoiData = data.reduce(function (prev, current) {
            return prev.concat(current.data);
          }, []);

          var voronoiPolygons = g.selectAll('.voronoi')
            .data(voronoi(voronoiData));

          /**
           * add voronoi pahts and register mouseEvents for tooltips
           */
          voronoiPolygons.enter()
            .append('path')
            .style('fill', 'none')
            .style('pointer-events', 'all')
            .attr('class', 'voronoi')
            .on('mouseover', function (d) {
              var dot = g.select('.key-' + d.point.year + '-' + d.point.districtUid);
              tip.show(d.point, dot.node());
            })
            .on('mouseout', function (d) {
              tip.hide(d.point);
            });

          /**
           * updates voronoi paths
           */
          voronoiPolygons
            .attr('d', function (d) {
              if (d == null) {
                return '';
              }
              return 'M' + d.join('L') + 'Z';
            });

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width - labelMargin, duration));

          /**
           * deletes unused voronoi paths
           */
          voronoiPolygons.exit().remove();
          dots.exit().remove();
          dotgroup.exit().remove();
        } else {
          /**
           * remove chart if no data is given
           */
          if (angular.isDefined(tip)) {
            tip.destroy();
          }
          g.selectAll('.dotgroup').remove();
          g.selectAll('.voronoi').remove();
          g.selectAll('.dot').remove();
          g.selectAll('.label').remove();
          g.selectAll('.line').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newFocusDistrict] height of the diagram
     * @returns {*}
     */
    chart.focusDistrict = function (newFocusDistrict) {
      if (!arguments.length) {
        return focusDistrict;
      } else {
        focusDistrict = newFocusDistrict;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    /**
     * getter/setter for years
     * @param {Array} [newYears] set of new years
     * @returns {*}
     */
    chart.years = function (newYears) {
      if (!arguments.length) {
        return years;
      } else {
        years = newYears;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-lineChart').height() - 25;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'lineChart.html',
    scope: {
      indicators: '=',
      indicatorSets: '=',
      colorsets: '=',
      selectedDistricts: '=',
      selectedDistrictKey: '=',
      noDataDistricts: '=',
      disabledDataLayers: '=',
      yearlyMode: '=',
      layers: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '=',
      mouseOverFeature: '='
    },
    link: function (scope, element) {
      var lineChartFunction = lineChart();
      scope.config.indicatorToShow = scope.config.indicatorToShow || '';
      scope.config.disabledDistricts = scope.config.disabledDistricts || [];
      scope.config.fullscreen = scope.config.fullscreen || false;

      var data, height;
      /**
       * removes old chart
       */
      var removeChart = function () {
        scope.config.selectedIndicatorSet = null;
        d3.select(element[0]).select('svg').remove();
      };

      /**
       * defines rerender-function
       * rerender is always called if watched properties changed
       */
      var rerender = function () {
        scope.selectedIndicatorSet = undefined;
        var years = Object.keys(scope.layers);
        var filteredYears = [];
        var redLines,
          indicators = scope.indicators.filter(function (indicator) {
            return indicator.hasShapeData;
          });

        //var districtsKeyUidMapping = {};
        //angular.forEach(scope.layer.districts, function (district) {
        //  districtsKeyUidMapping[district.key] = district.uid;
        //});

        /**
         * calculates chartHeight
         * @type {number}
         */
        height = calculateChartHeight(element);

        var decimals,
          maxAxisValue;
        if (angular.isArray(indicators) && indicators.length > 0 /*&& indicators[0].isDefault*/) {

          /**
           * first selected indicator belongs to an indicatorSet
           * @type {unknown[]}
           */
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });

          if (selectedSets.length > 0) {
            /**
             * set selectedIndicatorSet
             * @type {*}
             */
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            /**
             * get defaultIndicatorUid from selectedIndicatorSet
             * needed for legend
             * @type {number}
             */
            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);

            /**
             * get defaultColorSet from d3.hyperion-service
             * @type {string[]}
             */
            colorset = d3.hyperion.indicatorColors;
            var legend = null;
            colorDistrictMapping = {};

            /**
             * get legend by defaultIndicatorUid
             */
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              legend = scope.layer.legend[defaultIndicatorUid];
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+legend.chart.colorSet);
              })[0].colors.map(function (color, idx) {
                colorDistrictMapping[legend.chart.scales[idx].district] = color.color;
                return color.color;
              });

              /**
               * get decimals from legend
               */
              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              /**
               * get maxAxisValue from legend
               */
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              /**
               * get redLines from legend
               */
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines; // ToDo: Where to use redLines
              }
            }

            /**
             * disable scales by hideLegendScale-Array
             */
            if (legend && legend.chart && legend.chart.scales) {
              legend.chart.scales.forEach(function (scale, idx) {
                scale.disabled = hideLegendScale.indexOf(idx) > -1;
              });
            }

            /**
             * display multiple years and indicator-set-children focused on one district if yearlyMode mode is active
             * else
             * display multiple district as lines focused on one year and indicator
             */
            if (scope.yearlyMode) {
              scope.yearsToHide = mapConfig.yearsToHide ? mapConfig.yearsToHide : [];
              filteredYears = years
                .filter(function (year) {
                  return scope.layers[year].indicators.indexOf(indicators[0].uid) !== -1 && scope.disabledDataLayers.indexOf(year) === -1;
                })
                .filter(function (year) {
                  return scope.yearsToHide.indexOf(year) === -1;
                })
                .map(function (year) {
                  return +year;
                });

              /**
               * combines data for multiple years
               * @type {{data: *[], yearsWithData: *[], noDataDistricts: *[]}}
               */
              data = combineYearlyData(scope.layers, scope.selectedIndicatorSet, scope.disabledDataLayers, scope.selectedDistrictKey, colorset.colors, filteredYears);
            } else {
              var setIndicators = scope.selectedIndicatorSet.indicators.filter(function (indicator, idx) {
                return indicator.list === false;
              }).sort(function (a, b) {
                return a.listIndex - b.listIndex;
              });

              /**
               * combines data for single year
               * @type {{data: {name, key}[], yearsWithData: *[], noDataDistricts: *[]}}
               */
              data = combineData(scope.layer, setIndicators, scope.disabledDistrictKeys, scope.disabledListIndex, colorset);

              /**
               * add no data districts to index
               */
              data.noDataDistricts.forEach(function (districtKey) {
                if (scope.noDataDistricts.indexOf(districtKey) === -1) {
                  scope.noDataDistricts.push(districtKey);
                }
              });
            }

            /**
             * filter out none-data-years
             */
            if (!filteredYears.length) {
              scope.disabledDataLayers = [];
            }

            /**
             * calls lineChartFunction
             */
            lineChartFunction
              .height(height)
              .indicator(scope.selectedIndicatorSet)
              .focusDistrict(scope.mouseOverFeature)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .years(data.yearsWithData);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data.data])
              .call(lineChartFunction);
          } else {
            removeChart();
          }
        } else {
          removeChart();
        }
      };

      /**
       * defines watcher
       */
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var layersWatcher = scope.$watch('layers', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var indicatorToShowWatcher = scope.$watch('config.indicatorToShow', rerender);
      var disabledDistrictsWatcher = scope.$watchCollection('config.disabledDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var layerWatcher = scope.$watch('layer', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var disabledDataLayersWatcher = scope.$watchCollection('disabledDataLayers', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var disabledListIndexWatcher = scope.$watchCollection('disabledListIndex', rerender);
      var selectedDistrictKeyWatcher = scope.$watch('selectedDistrictKey', rerender);

      /**
       * removes watcher on destroy
       */
      element.on('$destroy', function () {
        layersWatcher();
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        indicatorToShowWatcher();
        disabledDistrictsWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        disabledListIndexWatcher();
        disabledDataLayersWatcher();
        selectedDistrictKeyWatcher();

        /** removes tooltip dom element */
        if (angular.isDefined(lineChartFunction.tip())) {
          lineChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('overviewLayerTypeSelect', ['mapConfig', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'overviewLayerTypeSelect.html',
    restrict: 'E',
    scope: {
      types: '=',
      year: '=',
      selectedDataLayerType: '=',
      onDataLayerTypeSelect: '&',
      onDistrictSelect: '&',
      blToZoom: '='
    },
    link: function (scope) {
      scope.showResultList = false;
      scope.districts = {};
      scope.selectedUid = null;
      scope.typeUids = mapConfig.availableDataLayerTypeUids;
      scope.searchResults = false;
      scope.blZoomOptions = mapConfig.keyLandMapping;

      var searchObject = {},
          searchObjectFlat = {};

      jQuery.getJSON(mapConfig.templateBasePath + "districtReport/districtReportSearch.json", function(json) {
        searchObject = json;
        convertSearchObject(searchObject);
      });

      scope.findDistrictByValue = function(searchWord){
        if(!searchWord) return;
        districtSearch(searchWord);
      };

      var districtSearch = function(searchWord) {
        if(searchWord.length < 3) return;
        scope.searchResults = [];

        for (var gKey in searchObjectFlat) {
          var resultEntry = searchObject.gemeinden[gKey];
          var regEx = new RegExp('\\b'+searchWord,'gi');
          if (searchObjectFlat[gKey].match(regEx)
            || (searchObject.kreise[resultEntry.kreis] && searchObject.kreise[resultEntry.kreis].match(regEx))) {
            var resultObject = {
              'name': highlightSearchWord(searchWord, resultEntry.name),
              'kreis': {
                'name': highlightSearchWord(searchWord, searchObject.kreise[resultEntry.kreis]),
                'key': resultEntry.kreis
              },
              'jugendamt': {
                'name': searchObject.jugendaemter[resultEntry.jugendamt],
                'key': resultEntry.jugendamt
              }
            };
            if(searchObject.jugendaemter[resultEntry.jugendamt] && searchObject.kreise[resultEntry.kreis]) {
              scope.searchResults.push(resultObject);
            }
          }
        }
      };

      var highlightSearchWord = function(searchWord, hit){
        if(!hit) return;
        var reg = new RegExp('('+searchWord+')', 'gi');
        return hit.replace(reg, '<span class="highlighted">$1</span>');
      };

      scope.selectDistrict = function (district, type) {
        if(type != scope.selectedDataLayerType.uid) {
          scope.selectLayerTypeUid(type);
        }
        // district = 'BE';
        scope.onDistrictSelect({district: district});
      };

      scope.selectLayerTypeUid = function(uid) {
        if(scope.selectedUid != uid) {
          angular.forEach(scope.types, function(type) {
            if(type.uid == uid) {
              scope.onDataLayerTypeSelect({dataLayerType: type});
              scope.selectedUid = uid;
            }
          });
        }
      };

      scope.$watch('selectedDataLayerType', function(dataLayerType) {
        if(dataLayerType != null) {
          scope.selectedUid = dataLayerType.uid;
        }
      });

      scope.$watch('year', function(year) {
        getDistricts();
      });

      scope.$watch('types', function(types) {
        if(!types || !scope.year) return;
        getDistricts();
      }, true);

      function getDistricts() {
        if(!scope.types) return;
        scope.types.forEach(function(type) {
          if(type.layers && type.layers[scope.year] && !scope.districts[type.uid]) {
            scope.districts[type.uid] = Object.keys(type.layers[scope.year].districts).map(function(key) {
              return type.layers[scope.year].districts[key];
            });
          }
        });
      }

      var convertSearchObject = function(searchObject) {
        angular.forEach(searchObject.gemeinden, function(gemeinde, gemeindeKey){
          searchObjectFlat[gemeindeKey] = gemeinde.name;
        });
      };

      scope.onTextClick = function ($event) {
        $event.target.select();
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('horizontalStackedBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
    'use strict';

    var accessor = d3.hyperion.accessor;
    var compose = d3.hyperion.compose;
    var selectedIndicatorSets = [];
    var selectedIndicatorSet = 0;
    var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
    var colors = [];
    var color = d3.hyperion.indicatorColorAt;
    var sortedAccessor = function (d, i) {
        return i;
    };

    var combineData = function (layer, indicators, selectedIndicatorSet, districtLabelProperty) {
        var dataSet = [],
            districtStacks = {},
            differenceStacks = [],
            districtNames = [],
            setIndicators = selectedIndicatorSet.lists[0].indicators;

        // stack data
        angular.forEach(setIndicators, function (indicator, i) {
            var districtData = [];
            for (var districtUid in layer.districts) {
                if (layer.hasOwnProperty(districtUid) && selectedIndicatorSet) {
                    var districtKey = layer.districts[districtUid][districtLabelProperty];
                    districtNames.push(districtKey);
                    var data = {
                        y: +layer[districtUid][indicator.uid],
                        x: districtKey,
                        name: layer.districts[districtUid].name,
                        indicator: indicator.name,
                        prefix: indicator.prefix,
                        indicatorKey: indicator.key
                    };
                }
                districtData.push(data);
                if (i < setIndicators.length / 2) {
                    if (!districtStacks[districtUid]) districtStacks[districtUid] = 0;
                    districtStacks[districtUid] += layer[districtUid][indicator.uid];
                }
            }
            dataSet.push(districtData);
        });
        // get Max-Value
        districtStacks = Object.keys(districtStacks).map(function (key) {
            return districtStacks[key];
        });
        var maxValue = Math.max.apply(null, districtStacks);

        var marginData = [];
        angular.forEach(districtStacks, function (value, index) {
            differenceStacks.push(maxValue - value);
            marginData.push({
                y: (maxValue - value),
                x: districtNames[index]
            });
        });
        dataSet.unshift(marginData);
        return d3.layout.stack()(dataSet);
    };

    /**
     * Creates the Color-Array Set-Bars
     * @param numberOfIndicators
     * @returns {Array}
     */
    var buildColorArray = function (numberOfIndicators) {
        var numberOfColors = Math.ceil((numberOfIndicators) / 2),
            configColors = mapConfig.styling.default.complexColorSet,
            colors = [];

        for (var i = 0; i < numberOfIndicators; i++) {
            if (i < numberOfColors) {
                colors.push(configColors[i]);
            } else {
                colors.push(configColors[numberOfIndicators - (i + 1)]);
            }
        }
        colors.unshift('rgba(0,0,0,0)');
        return colors;
    };

    var calculateMaxValue = function (data) {
        return d3.max(data[data.length - 1].map(function (current) {
            return current.y + current.y0;
        }));
    };

    var calculateMinValue = function (data) {
        return d3.min(data[data.length - 1].map(function (current) {
            return current.y + current.y0;
        }));
    };

    var horizontalStackedBarChart = function () {
        var indicators = [],
            svgHeight = 200,
            margin = {top: 20, right: 40, bottom: 20, left: 50},
            duration = 400,
            numberFormat = germanNumberFormat(',.'+mapConfig.relativeIndicatorsDecimalPlaces+'f'),
            tip;

        var chart = function (selection) {
            selection.each(function (data) {
                // calculate min and max values and check that 0 is included
                var minValue = calculateMinValue(data);
                var maxValue = calculateMaxValue(data);
                if (minValue > 0) {
                    minValue = 0;
                }
                if (maxValue < 0) {
                    maxValue = 0;
                }

                var keyDigits = d3.max(data[0].map(function (d) {
                    return accessor('x')(d).length;
                }));
                margin.left = 10 + 13 * keyDigits;

                // Invert the x and y values, and y0 becomes x0 --> Horizontal-Stack
                data = data.map(function (group) {
                    return group.map(function (d) {
                        return {
                            x: d.y,
                            y: d.x,
                            x0: d.y0,
                            name: d.name,
                            indicator: d.indicator,
                            indicatorKey: d.indicatorKey
                        };
                    });
                });

                var container = d3.select(this).datum([data]).classed('horizontal-stacked-bar-chart', true);
                var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

                var width = svgWidth - margin.left - margin.right,
                    height = svgHeight - margin.top - margin.bottom;

                if (angular.isDefined(tip)) {
                    tip.destroy();
                }

                tip = d3.tip()
                    .attr('class', 'd3-tip')
                    .offset(function () {
                        return [-5, 0];
                    })
                    .html(function (d, indicatorNumber, districtNumber) {
                        var value = d.prefix + numberFormat(d.x) + " %";
                        return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + d.name + ' (' + d.y + ')</b><br><span style="color:#000000;">' + d.indicator.replace('<br/>', '').replace('<br>','').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
                    });

                var svg = container.selectAll('svg').data([data]);
                var svgEnter = svg.enter()
                    .append('svg')
                    .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

                var stack = svg.selectAll('.stack').data([data]);
                var stackEnter = stack.enter().append('g')
                    .attr('class', 'stack')
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');


                stack.transition().duration(duration)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
                    .attr('height', svgHeight)
                    .attr('width', svgWidth); // set viewBox of the svg

                var g = stack.selectAll('g').data(data);

                var xScale = d3.scale.linear()
                        .range([0, width])
                        .domain([minValue, maxValue])
                        .nice(),
                    districts = data[0].map(function (d) {
                        return d.y;
                    }),
                    yScale = d3.scale.ordinal()
                        .rangeRoundBands([0, height], .1)
                        .domain(districts),
                    xAxis = d3.svg.axis()
                        .scale(xScale)
                        .orient('bottom'),
                    yAxis = d3.svg.axis()
                        .scale(yScale)
                        .orient('left');

                g.call(d3.hyperion.addVerticalHighlightLines(mapConfig.redLines, x, height, duration));

                var gEnter = g.enter()
                    .append('g')
                    .style('fill', function (d, i) {
                        return colors[i];
                    })
                    .attr('class', 'margin-group');

                // xAxis
                stackEnter.append('g')
                    .attr('class', 'x axis')
                    .attr('transform', 'translate(0,' + height + ')');

                stack.select('.x.axis')
                    .transition().duration(duration)
                    .attr('transform', 'translate(0,' + height + ')')
                    .attr('fill', '#000000')
                    .call(xAxis);

                // yAxis
                stackEnter.append('g')
                    .attr('class', 'y axis');

                stack.select('.y.axis')
                    .transition().duration(duration)
                    .attr('fill', '#000000')
                    .call(yAxis);

                // vertical Middle-Line
                var middleLineAt = data[Math.ceil(((data.length - 1) / 2)) + 1][0]['x0'];
                stackEnter.append('line')
                    .attr('class', 'middle-line');

                stack.select('.middle-line')
                    .transition().duration(duration)
                    .attr('x1', xScale(middleLineAt))
                    .attr('x2', xScale(middleLineAt))
                    .attr('y1', 0)
                    .attr('y2', height)
                    .attr("stroke-width", 1);

                // draw new bars
                var bars = g.selectAll('rect')
                    .data(function (d) {
                        return d;
                    });

                bars
                    .enter()
                    .append('rect')
                    .attr('height', yScale.rangeBand())
                    .attr('y', function (d, i) {
                        return yScale(d.y);
                    })
                    .attr('x', xScale(0))
                    .attr('width', 0);

                bars
                    .transition().duration(duration)
                    .attr('x', function (d) {
                        return xScale(d.x0);
                    })
                    .attr('y', function (d, i) {
                        return yScale(d.y);
                    })
                    .attr('height', yScale.rangeBand())
                    .attr('width', function (d) {
                        return xScale(d.x);
                    });

                // add tooltips to bars
                bars.call(tip);
                bars.on('mouseover', tip.show)
                    .on('mouseout', tip.hide);

                // remove unused bars
                bars.exit().transition().duration(duration)
                    .attr('width', 0)
                    .attr('height', 0)
                    .remove();
            });
        };

        /**
         * getter/setter for indicators
         * @param {Array} [newIndicators] set of new indicators
         * @returns {*}
         */
        chart.indicators = function (newIndicators) {
            if (!arguments.length) {
                return indicators;
            } else {
                indicators = newIndicators;
                return chart;
            }
        };

        /**
         * getter/setter for svgHeight
         * @param {int} [newHeight] height of the diagram
         * @returns {*}
         */
        chart.height = function (newHeight) {
            if (!arguments.length) {
                return svgHeight;
            } else {
                svgHeight = newHeight;
                return chart;
            }
        };

        /**
         *
         * @returns {*}
         */
        chart.tip = function () {
            return tip;
        };

        return chart;
    };

    /**
     * @param {HTMLElement} element the chart element
     * @returns {number}
     */
    var calculateChartHeight = function (element) {
        var content = element.closest('.grid-stack-item-content-horizontalStackedBarChart');
        return content.height() - jQuery(content).find('.selected-indicator-set').height() - 10;
    };

    return {
        restrict: 'E',
        templateUrl: mapConfig.templateBasePath + 'horizontalStackedBarChart.html',
        scope: {
            layer: '=',
            indicators: '=',
            indicatorSets: '=',
            dimensionX: '@',
            dimensionY: '@',
            mouseOverFeature: '=',
            config: '='
        },
        link: function (scope, element) {
            scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
            scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
            scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
            scope.config.fullscreen = scope.config.fullscreen || false;

            scope.setSelectedIndicatorSet = function (indicatorSet) {
                if (indicatorSet.lists[0].indicators.length !== scope.config.selectedIndicatorSet.lists[0].indicators.length) {
                    d3.select(element[0]).select('svg').remove();
                }
                scope.config.selectedIndicatorSet = scope.indicatorSetToShow;
            };

            var horizontalStackedBarChartFunction = horizontalStackedBarChart();

            /**
             * update the chart from one of the watchers
             *
             * @param {*} watcherNewValue new value of the watcher
             * @param {*} watcherOldValue old value of the watcher
             * @param {*} watcherScope new scope from the watcher
             * @param {Number} newHeight the height for the svg
             */
            var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
                if (newHeight == null) {
                    newHeight = calculateChartHeight(element);
                }

                var indicators = scope.indicators;
                scope.selectedIndicatorSets = [];

                angular.forEach(indicators, function (indicator) {
                    if (indicator.isDefault) {
                        angular.forEach(scope.indicatorSets, function (indicatorSet) {
                            if (indicatorSet.defaultIndicator.uid === indicator.uid && scope.selectedIndicatorSets.indexOf(indicatorSet) < 0) {
                                scope.selectedIndicatorSets.push(indicatorSet);
                            }
                        });
                    }
                });

                if (scope.selectedIndicatorSets.length) {
                    scope.indicatorSetToShow = scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet ? scope.config.selectedIndicatorSet : scope.selectedIndicatorSets[0];

                    var data = combineData(scope.layer, indicators, scope.indicatorSetToShow, scope.config.districtLabelProperty);
                    colors = buildColorArray(data.length - 1);
                    horizontalStackedBarChartFunction
                        .indicators(indicators)
                        .height(newHeight);

                    d3.select(element.find('.widget-inner:first')[0])
                        .data([data])
                        .call(horizontalStackedBarChartFunction);
                } else {
                    d3.select(element[0]).select('svg').remove();
                }
            };

            jQuery(document).on("fullscreen", rerender);

            var layerWatcher = scope.$watchCollection('layer', rerender);
            var indicatorWatcher = scope.$watchCollection('indicators', rerender);
            var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
            var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
            var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
            var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
            var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

            var legendHeightWatcher = scope.$watch(function () {
                return calculateChartHeight(element);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && newValue > 0) {
                    rerender(newValue, oldValue, null, newValue);
                }
            });

            // remove watcher on destroy
            element.on('$destroy', function () {
                layerWatcher();
                indicatorWatcher();
                indicatorSetWatcher();
                dimensionWatcher();
                legendHeightWatcher();
                selectedIndicatorSet();
                districtLabelPropertyWatcher();
                fullscreenWatcher();
                // remove tooltip dom element
                if (angular.isDefined(horizontalStackedBarChartFunction.tip())) {
                    horizontalStackedBarChartFunction.tip().destroy();
                }
            });
        }
    };
}]);

angular.module('Itao.IndicatorMap').directive('overviewPersonalChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var compose = d3.hyperion.compose;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var overviewPersonalChart = function () {
    var svgWidth = 600,
      svgHeight = 350,
      colors = ['#0075a1', '#e17c00', '#366666', '#c5bd76', '#700030', '#64B0CA'],
      duration = 400,
      hideLines = false,
      margin = {top: 30, right: 5, bottom: 10, left: 24},
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {
        //calculate min and max values and check that 0 is included
        var minValue = 0;
        var maxValue = d3.max(data);

        var numberOfBars = data.length;
        maxValue = maxValue <= 15 ? 15 : maxValue;

        var axisFormatString = ',.0f';

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var colorFromBar = function (d, i) {
          return colors[i];
        };

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for each bar per district
        var x = d3.scale.ordinal()
          .domain([0, 1, 2, 3, 4, 5].slice(0, numberOfBars)) // use only active indicators
          .rangeRoundBands([0, width], 0.3);

        var paddingAround = 20.5; // rangeRoundBands arg 4 in px - fixed...

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        // var tickCount = Math.min(svgHeight / 40, 10);
        var tickCount = 4;

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return d ? germanNumberFormat(axisFormatString)(d) : '';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // g.call(d3.hyperion.addHorizontalHighlightLines([3,7.5], y, width, duration));

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'left')
          .attr('x', 0)
          .attr('dominant-baseline', 'text-before-edge')
          .text('1 : x');

        var highlightData = [];
        if(!hideLines) {
          highlightData = [3.0, 3.0, 7.5, 4.9, 3.75, null].slice(0, numberOfBars);
        }
        var paddingHighlightLineAndArea = (((width - (paddingAround * 2)) / numberOfBars) - x.rangeBand()) / 2;

        var hightlightAreas = g.selectAll('.highlightArea')
          .data(highlightData);

        // draw new bars
        hightlightAreas
          .enter()
          .append('rect')
          .attr('width', 0)
          .attr('class', 'highlightArea')
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all areas
        hightlightAreas
          .attr('width', x.rangeBand() + (paddingHighlightLineAndArea * 2))
          .attr('x', function (d, i) {
            return x(i) - paddingHighlightLineAndArea;
          })
          .attr('y', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused areas
        hightlightAreas.exit()
          .remove();

        var bars = g.selectAll('rect.value-bar')
          .data(data);

        // draw new bars
        bars
          .enter()
          .append('rect')
          .attr('class', 'value-bar')
          .style('fill', colorFromBar)
          .attr('width', 0)
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all bars
        bars
          .style('fill', colorFromBar)
          .attr('width', x.rangeBand())
          .attr('x', compose(x, sortedAccessor))
          .attr('y', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused bars
        bars.exit()
          .remove();

        var barLines = g.selectAll('line.bar-line')
          .data(highlightData);

        // draw new lines
        barLines
          .enter()
          .append('line')
          .attr('class', 'bar-line')
          .style('stroke-width', '0')
          .attr('pointer-events', 'none')
          .attr('x1', 0)
          .attr('x2', 0)
          .attr('y1', y(0))
          .attr('y2', y(0));

        // update all bars
        barLines
          .style('stroke-width', function (d) {
            return d ? '4' : '0';
          })
          .attr('x1', function (d, i) {
            return x(i) - paddingHighlightLineAndArea;
          })
          .attr('x2', function (d, i) {
            return x(i) + x.rangeBand() + paddingHighlightLineAndArea;
          })
          .attr('y1', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('y2', function (d) {
            return d ? y(d) : y(0);
          });

        // remove unused bars
        barLines.exit()
          .remove();

        var barLabels = g.selectAll('.barLabel')
          .data(data);

        barLabels.enter()
          .append('text')
          .attr('class', 'barLabel')
          .attr('text-anchor', 'middle');

        barLabels
          .attr('x', function (d, i) {
            return x(i) + (x.rangeBand() / 2);
          })
          .attr('y', function (d) {
            return d ? y(d) - 15 : y(0)-10;
          })
          .text(function (d) {
            return d ? '1 : ' + numberFormat(d) : '—';
          });

        barLabels.exit()
          .remove();
      });
    };

    /**
     * getter/setter for svgWidth
     * @param {Function} [newSvgWidth] new svgWidth function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = newSvgWidth;
        return chart;
      }
    };

    /**
     * getter/setter for svgWidth
     * @param {Function} [newHideLines] new svgWidth function
     * @returns {*}
     */
    chart.hideLines = function (newHideLines) {
      if (!arguments.length) {
        return hideLines;
      } else {
        hideLines = newHideLines;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'overviewPersonalChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      indicatorUids: '=',
      hideRedLines: '=',
      numberOfDisplayedBars: '=',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var overviewPersonalChartFunction = overviewPersonalChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        var indicatorsToDisplay;
        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && angular.isArray(scope.indicatorUids) && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {

          if (scope.numberOfDisplayedBars) {
            indicatorsToDisplay = scope.indicatorUids.slice(0, scope.numberOfDisplayedBars); // dont display sixt bar... Hortgruppen ->
          }

          var values = indicatorsToDisplay.map(function (uid) {
            return scope.selectedDataLayer[scope.selectedDistrict.uid][uid];
          });

          overviewPersonalChartFunction.svgWidth(scope.svgWidth).hideLines(scope.hideRedLines);

          d3.select(element.find('.widget-inner:first')[0])
            .data([values])
            .call(overviewPersonalChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorUidsIndicators = scope.$watchCollection('indicatorUids', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        selectedDistrictWatcher();
        indicatorUidsIndicators();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('overviewQualificationChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var compose = d3.hyperion.compose;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var overviewQualificationChart = function () {
    var
      svgHeight = 350,
      svgWidth = 600,
      colors = ['#366666', '#95ac00', '#7db0ca', '#c5bd76'],
      duration = 400,
      margin = {top: 30, right: 5, bottom: 0, left: 20},
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {

        //calculate min and max values and check that 0 is included
        var minValue = 0;
        var maxValue = d3.max(data);
        if(!maxValue) maxValue = 100;
        var axisFormatString = ',.0f';

        var container = d3.select(this).datum([data]).classed('overview-qualification-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var colorFromBar = function (d, i) {
          return colors[i];
        };

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for each bar per district
        var x = d3.scale.ordinal()
          .domain([0, 1, 2, 3]) // use only active indicators
          .rangeRoundBands([0, width], 0.3);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        var bars = g.selectAll('rect')
          .data(data);

        // draw new bars
        bars
          .enter()
          .append('rect')
          .attr('class', 'value-bar')
          .style('fill', colorFromBar)
          .attr('width', 0)
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all bars
        bars
          .style('fill', colorFromBar)
          .attr('width', x.rangeBand())
          .attr('x', compose(x, sortedAccessor))
          .attr('y', function (d) {
            return !!d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return !!d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused bars
        bars.exit()
          .remove();

        var barLabels = g.selectAll('.barLabel')
          .data(data);

        barLabels.enter()
          .append('text')
          .attr('class', 'barLabel')
          .attr('text-anchor', 'middle');

        barLabels
          .attr('x', function (d, i) {
            return x(i) + (x.rangeBand() / 2);
          })
          .attr('y', function (d) {
            return !!d ? y(d) - 15 : y(0)-10;
          })
          .text(function (d) {
            return !!d ? numberFormat(d) : '—';
          });

        barLabels.exit()
          .remove();
      });
    };


    /**
     * getter/setter for svgWidth
     * @param {Function} [newSvgWidth] new svgWidth function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = newSvgWidth;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'overviewQualificationChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      indicatorUids: '=',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var overviewQualificationChartFunction = overviewQualificationChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {

        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && angular.isArray(scope.indicatorUids) && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {

          overviewQualificationChartFunction.svgWidth(scope.svgWidth);
          var values = scope.indicatorUids.map(function (uid) {
            return scope.selectedDataLayer[scope.selectedDistrict.uid][uid];
          });

          d3.select(element.find('.widget-inner:first')[0])
            .data([values])
            .call(overviewQualificationChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorUidsIndicators = scope.$watchCollection('indicatorUids', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        selectedDistrictWatcher();
        indicatorUidsIndicators();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('scatterPlot', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var xValue = d3.hyperion.accessor('x');
  var yValue = d3.hyperion.accessor('y');
  var keyValue = d3.hyperion.accessor('key');
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;

  var combineDataAndIndicators = function(data, indicatorX, indicatorY, selectedDistricts) {
    var dataArray = [];
    var selectedUids = selectedDistricts.map(function(district){
      return district.uid;
    });
    for(var districtUid in data.districts) {
      if(data[districtUid].hasOwnProperty(indicatorX.uid) && data[districtUid][indicatorX.uid] != null && data[districtUid].hasOwnProperty(indicatorY.uid) && data[districtUid][indicatorY.uid] != null) {
        var selected = selectedUids.indexOf(districtUid) !== -1;
        dataArray.push({uid: districtUid, key: data.districts[districtUid].key, name: data.districts[districtUid].name, x: data[districtUid][indicatorX.uid], y: data[districtUid][indicatorY.uid], selected: selected});
      }
    }
    return dataArray;
  };

  var uniqueDataDotsForVoronoi = function(a) {
    var seen = {};
    return a.filter(function(item) {
      var itemString = (item.x +'-'+ item.y).replace('.', '_');
      return seen.hasOwnProperty(itemString) ? false : (seen[itemString] = item);
    });
  };

  /**
   * returns a function to apply values depending on the 'selected' property
   *
   * @param selectdValue
   * @param unselectedValue
   * @returns {Function}
   */
  function valueDependingOnSelected(selectdValue, unselectedValue) {
    return function(d) {
      return d.selected ? selectdValue : unselectedValue;
    };
  }

  var scatterPlot = function() {

    var indicatorX = null,
      indicatorY = null,
      selectedDistricts = [],
      margin = {top: 20, right: 40, bottom: 40, left: 60},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function(selection) {
      selection.each(function(unformattedData) {
        if(indicatorX == null || indicatorY == null) {
          d3.select(this).selectAll('svg').remove();
          d3.select(this).selectAll('p').remove();
          d3.select(this).append('p').text('Es müssen mindestens zwei Indikatoren ausgewählt sein.');
          return;
        } else {
          d3.select(this).selectAll('p').remove();
        }
        var data = combineDataAndIndicators(unformattedData, indicatorX, indicatorY, selectedDistricts);

        var container = d3.select(this).datum([data]).classed('scatter-plot', true);

        var svgWidth = selection.node().offsetWidth - 10,
          svgHeight = selection.node().offsetHeight - 10; // add 10px space for preventing scrollbars

        var yExtent = d3.extent(data, yValue);

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max(germanNumberFormat(',')(Math.round(yExtent[0])).length, germanNumberFormat(',')(Math.round(yExtent[1])).length);
        margin.left = 45 + 10 * labelDigits;

        var width = svgWidth - margin.left -margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var x = d3.scale.linear()
          .range([0, width])
          .domain(d3.extent(data, xValue))
          .nice();

        var y = d3.scale.linear()
          .range([height, 0])
          .domain(yExtent)
          .nice();

        var xAxis = d3.svg.axis()
          .scale(x)
          .orient('bottom')
          .ticks(Math.min(svgWidth / 90, 10))
          .tickFormat(germanNumberFormat(','));

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(germanNumberFormat(','));

        if(angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function(){
            return [-5, 0];
          })
          .html(function(d){
            var x, y;
            if(indicatorX.unit) {
              x = numberFormat(d.x);
            } else {
              x = d.x;
            }
            if(indicatorY.unit) {
              y = numberFormat(d.y);
            } else {
              y = d.y;
            }
            return '<div class="d3-tip-border"><b>'+d.name+' ('+d.key+')</b><br/>'
              +'<span style="color:'+color(0)+'">'+indicatorX.name+':</span> <span>'+x+indicatorX.unit+'</span><br/>'
              +'<span  style="color:'+color(1)+'">'+indicatorY.name+':</span> <span>'+y+indicatorY.unit+'</span></div>';
          });

        // add x axis
        gEnter.append('g')
          .classed('x axis', true)
          .attr('transform', 'translate(0,' + height + ')')
          .append('text')
          .classed('x label', true)
          .attr('fill', color(0))
          .attr('x', width/2)
          .attr('dy', '2.6em')
          .style('text-anchor', 'middle');

        // update x axis label
        g.select('.x.label')
          .text(indicatorX.name)
          .transition().duration(duration)
          .attr('x', width/2);

        //update x axis
        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        // add y axis
        gEnter.append('g')
          .classed('y axis', true)
          .attr('y', height)
          .append('text')
          .classed('y label', true)
          .attr('fill', color(1))
          .attr('transform', 'rotate(-90)')
          .attr('x', -height/2)
          .attr('dy', '-' + (margin.left - 15))
          .style('text-anchor', 'middle');

        // update y axis label
        g.select('.y.label')
          .text(indicatorY.name)
          .transition().duration(duration)
          .attr('dy', '-' + (margin.left - 15))
          .attr('x', -height/2);

        // update y axis
        g.select('.y.axis')
          .transition().duration(duration)
          .attr('y', height)
          .call(yAxis);

        // create dots selection
        var dots = g.selectAll('.feature')
          .data(data, keyValue);

        // add new dots
        dots.enter()
          .append('circle')
          .attr('class', function(d){
            return 'feature uid-'+ d.uid;
          });

        // update dots position
        dots.transition().duration(duration)
          .attr('r', valueDependingOnSelected(3, 2))
          .attr('cx', compose(x, xValue))
          .attr('cy', compose(y, yValue))
          .attr('stroke', 'black')
          .attr('fill', valueDependingOnSelected('#f29400', 'black'))
          .attr('stroke-width', valueDependingOnSelected('1px', '0px'));

        dots.call(tip);

        // voronoi calculator
        var voronoi = d3.geom.voronoi()
          .x(compose(x, xValue))
          .y(compose(y, yValue))
          .clipExtent([[0, 0], [width, height]]);

        // voronoi used for showing the tooltip of the point closest to the cursor
        // points with the same values have to be filtered, because a voronoi cannot be computed for duplicates
        var voronoiPolygons = g.selectAll('.voronoi')
          .data(voronoi(uniqueDataDotsForVoronoi(data)));

        // add voronoi pahts and register mouseEvents for tooltips
        voronoiPolygons.enter()
          .append('path')
          .style('fill', 'none')
          .style('pointer-events', 'all')
          .attr('class', 'voronoi')
          .on('mouseover', function(d) {
            var dot = g.select('.uid-'+d.point.uid);
            tip.show(d.point, dot.node());
          })
          .on('mouseout', function(d){
            tip.hide(d.point);
          });

        // update voronoi paths
        voronoiPolygons
          .attr('d', function(d) {
            return 'M' + d.join('L') + 'Z';
          });

        // delete unused voronoi paths
        voronoiPolygons.exit().remove();

        // remove old dots
        dots.exit().remove();
      });
    };

    /**
     * getter/setter for x-indicator
     * @param {Array} [newIndicatorX] new indicator for x scale
     * @returns {*}
     */
    chart.indicatorX = function(newIndicatorX) {
      if(!arguments.length) {
        return indicatorX;
      } else {
        indicatorX = newIndicatorX;
        return chart;
      }
    };

    /**
     * getter/setter for y-indicator
     * @param {Array} [newIndicatorY] new indicator for y scale
     * @returns {*}
     */
    chart.indicatorY = function(newIndicatorY) {
      if(!arguments.length) {
        return indicatorY;
      } else {
        indicatorY = newIndicatorY;
        return chart;
      }
    };

    /**
     * getter/setter for selected districts
     * @param {Array} [newSelectedDistricts] selected districts
     * @returns {*}
     */
    chart.selectedDistricts = function(newSelectedDistricts) {
      if(!arguments.length) {
        return selectedDistricts;
      } else {
        selectedDistricts = newSelectedDistricts;
        return chart;
      }
    };

    /**
     * getter for the tooltip
     *
     * @returns {*}
     */
    chart.tip = function() {
      return tip;
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'scatterPlot.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.fullscreen = scope.config.fullscreen || false;
      var scatterPlotFunction = scatterPlot();

      var rerender = function() {
        var indicators = scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
        });
        scatterPlotFunction
          .selectedDistricts(scope.selectedDistricts)
          .indicatorX(indicators[0] || null)
          .indicatorY(indicators[1] || null);

        d3.select(element.find('.widget-inner:first')[0])
          .data([scope.layer])
          .call(scatterPlotFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      // remove watcher on destroy
      element.on('$destroy', function() {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        // remove tooltip dom element
        if(angular.isDefined(scatterPlotFunction.tip())) {
          scatterPlotFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('setBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var hideLegendScale = [];

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, setIndicators, disabledDistrictKeys, disabledListIndex, colorset, legend) {
    var indicatorsWithoutLists = setIndicators;
    hideLegendScale = [];
    var numberOfDistricts = Object.keys(layer.districts).length;
    //var valueCheck = Object.keys(layer.districts).map(function () {
    //  return indicatorsWithoutLists.map(function() {
    //    return 0;
    //  });
    //});

    var valueCheck = indicatorsWithoutLists.map(function () {
      //return Object.keys(layer.districts).map(function () {
      //  return 0;
      //});
      return 0;
    });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var valueArray = indicatorsWithoutLists.map(function (indicator, index) {
        var indicatorName = indicator.name;
        if (legend != null) {
          if (legend.chart.scales.hasOwnProperty(index)) {
            indicatorName = legend.chart.scales[index].text;
          } else {
            console.warn('Scale is missing index ' + index + '. Using ' + indicatorName + ' instead.');
          }
        }
        var value = 0;
        if (layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
          valueCheck[index]++;
        }

        return {
          value: value,
          key: indicator.key,
          color: colorset[index % colorset.length],
          name: indicatorName,
          unit: indicator.unit,
          prefix: indicator.prefix
        };
      });/*.filter(function (item, idx) {
        return disabledListIndex.indexOf(idx) === -1;
      });*/

      return {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        values: valueArray
      };
    }).map(function (districtItem) {
      districtItem.values = districtItem.values.filter(function (valueArray, valueIndex) {
        if (valueCheck[valueIndex] !== numberOfDistricts) {
          return disabledListIndex.indexOf(valueIndex) === -1;
        } else {
          hideLegendScale.push(valueIndex);
          return false;
        }
      });
      return districtItem;
    });
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var setBarChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      displayValues = false,
      color = d3.hyperion.indicatorColorAt,
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      redLines = null,
      numberFormat = germanNumberFormat(',.2f'),
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }
        if (maxValue < 0) {
          maxValue = 0;
        }

        if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((indicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (indicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));
        margin.bottom = 15 + 7 * districtLabelDigits;

        margin.bottom = Math.min(svgHeight / 2, margin.bottom);

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            var district = data[districtNumber], value;
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            if (d.unit === '%') {
              value = d.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = d.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + d.color + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        // var redLines = mapConfig.redLines.filter(function(lineValue) { return lineValue <= maxValue; });
        redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
          return lineValue <= maxValue;
        });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(data[0].values.length < 2 ? [0] : d3.range(data[0].values.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxAxisValue ? maxAxisValue : maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));
        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // only draw bars if indicators are left
        if (angular.isArray(indicators) && indicators.length > 0) {

          var unit = indicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', accessor('color'))
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', accessor('color'))
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function (d) {
              return y(Math.max(0, Math.min(maxValue, accessor('value')(d))));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(Math.min(maxValue, accessor('value')(d))));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();
          features.exit().remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration));

          if (displayValues) {
            labels.enter()
              .append('text')
              .attr('class', 'chart-value')
              .attr('y', 0);

            // update labels
            labels
              .text(function (d) {
                return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d) {
                return y(Math.max(0, accessor('value')(d))) - 4;
              });
            // remove unused labels
            labels.exit()
              .remove();
          } else {
            labels
              .remove();
          }

        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-setBarChart').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setBarChart.html',
    scope: {
      layer: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      colorsets: '=',
      indicators: '=',
      indicatorSets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var setBarChartFunction = setBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines;
        scope.selectedIndicatorSet = [];

        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            var decimals,
              maxAxisValue;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];


              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var setIndicators = scope.selectedIndicatorSet.indicators.filter(function (indicator, idx) {
              return indicator.list === false;
            }).sort(function (a, b) {
              return a.listIndex - b.listIndex;
            });

            if (scope.disabledListIndex.length !== setIndicators.length) {
              var data = combineData(scope.layer, setIndicators, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend);

              if (legend.chart && legend.chart.scales) {
                legend.chart.scales.forEach(function (scale, idx) {
                  scale.disabled = hideLegendScale.indexOf(idx) > -1;
                });
              }

              setBarChartFunction
                .indicators(setIndicators)
                .districtLabelProperty(scope.config.districtLabelProperty)
                .disabledIndicators(scope.config.disabledIndicators)
                .displayValues(scope.config.displayValues)
                .redLines(redLines)
                .decimals(decimals)
                .maxAxisValue(maxAxisValue)
                .height(newHeight);

              d3.select(element.find('.widget-inner:first')[0])
                .data([data])
                .call(setBarChartFunction);
            } else {
              removeChart();
            }
          } else {

            removeChart();
          }
        }
      };

      var removeChart = function () {
        scope.config.selectedIndicatorSet = null;
        d3.select(element[0]).select('svg').remove();
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var disabledListIndexWatcher = scope.$watchCollection('disabledListIndex', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();

        // remove tooltip dom element
        if (angular.isDefined(setBarChartFunction.tip())) {
          setBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('setHintTable', ['d3', 'mapConfig', 'IndicatorSetHandling', 'UtilityService', '$compile', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param district
   * @returns {string}
   */
  function prepareTableHead(district) {
    var headHtml = '<thead><tr><th>'+district.name+'</th><th>Anmerkungen</th></tr></thead>';

    return headHtml;
  }

  /**
   *
   * @param layer
   * @param indicator
   * @param district
   * @returns {string}
   */
  function bodyRowFromDistrict(layer, indicator, district) {
    var description = '-';
    if(layer.descriptions[district] && layer.descriptions[district][indicator.uid] != null) {
      description = layer.descriptions[district][indicator.uid];
    }
    return '<tr><td>'+indicator.name+'</td><td>' + description + '</td></tr>';
  }

  /**
   * @param layer
   * @param indicators
   * @param district
   */
  function prepareTableBody(layer, indicators, district) {
    return indicators.map(function(indicator) {
      return bodyRowFromDistrict(layer, indicator, district);
    });
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setHintTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      selectedDistrict: '=',
      config: '='
    },
    link: function (scope, element) {
      var activeDistrict = null;
      function rerender() {
        if(scope.selectedIndicatorSet != null && scope.layer != null) {
          if(!scope.selectedDistrict) scope.selectedDistrict = Object.keys(scope.layer)[0];
          if(!scope.layer.districts[scope.selectedDistrict]) {
            var newDistrict;
            angular.forEach(scope.layer.districts, function(district){
              if(district.key == activeDistrict.key)
                newDistrict = district;
            });

            activeDistrict = newDistrict ? newDistrict : scope.layer.districts[Object.keys(scope.layer)[0]];
            scope.selectedDistrict = activeDistrict.uid;
          } else {
            activeDistrict = scope.layer.districts[scope.selectedDistrict];
          }

          var head = prepareTableHead(activeDistrict);
          var sortedIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);
          var body = prepareTableBody(scope.layer, sortedIndicators, scope.selectedDistrict);
          element.find('table').html(head + body);
          $compile(element.find('table').contents())(scope);
        }
      }

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        selectedDistrictWatcher();
        layerWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('setRefPointBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function(d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function(d){
    if(d != null && d.color != null) {
      return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
    } else {
      return 1;
    }
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, colorset, legend) {

    var indicators = selectedIndicatorSet.indicators.filter(function(indicator){
      return indicator.list === false;
    }).sort(function(a,b){
      return a.listIndex - b.listIndex;
    }).slice(0,2);

    return Object.keys(layer.districts).filter(function(districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function(districtUid) {
      var districtData = {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        barValue: {
          value: null
        },
        refValue: {
          value: null
        }
      };

      if(indicators.length < 2) {
        return districtData;
      }

      var refHasLegendText = (legend != null && legend.chart != null && legend.chart.scales[0] != null && legend.chart.scales[0].text !== '');
      var barHasLegendText = (legend != null && legend.chart != null && legend.chart.scales[1] != null && legend.chart.scales[1].text !== '');

      if(layer[districtUid] && layer[districtUid][indicators[0].uid] != null) {
        districtData.refValue = {
          value:(+layer[districtUid][indicators[0].uid]),
          name:  refHasLegendText ? legend.chart.scales[0].text : indicators[0].name,
          unit: indicators[0].unit,
          prefix: indicators[0].prefix,
          color: colorset[0],
          key: layer.districts[districtUid].key
        };
      }
      if(layer[districtUid] && layer[districtUid][indicators[1].uid] != null) {
        districtData.barValue = {
          value:(+layer[districtUid][indicators[1].uid]),
          unit: indicators[1].unit,
          name:  barHasLegendText ? legend.chart.scales[1].text : indicators[1].name,
          prefix: indicators[1].prefix,
          color: colorset[1],
          key: layer.districts[districtUid].key
        };
      }
      return districtData;
    });
  };

  var setRefPointBarChart = function () {
    var defaultIndicator = {},
      svgHeight = 200,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      refTip,
      redLines,
      decimals,
      maxAxisValue,
      barTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var maxDomainValue;
        var yAxisFormatter = decimals ? germanNumberFormat(',.'+decimals+'f') : germanNumberFormat(',');
        //var yFormatter = germanNumberFormat(',.'+(defaultIndicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces)+'f');

        var container = d3.select(this).datum([data]).classed('set-ref-point-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(refTip)) {
          refTip.destroy();
        }
        if (angular.isDefined(barTip)) {
          barTip.destroy();
        }

        barTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d,i,j) {
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var featureData = values[j].parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + germanNumberFormat(',.'+decimals+'f')(d.value)+'</span></div>';
          });

        refTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d,i,j) {
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var featureData = values[j].parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + germanNumberFormat(',.'+decimals+'f')(d.value)+'</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        if(maxAxisValue) {
          maxDomainValue = maxAxisValue;
        } else if(mapConfig.axisMaxValue != null) {
          maxDomainValue = mapConfig.axisMaxValue;
        } else {
          maxDomainValue = d3.max(data.map(function(d) {return Math.max(d.barValue.value, d.refValue.value);}));
        }

        var barScale = d3.scale.linear()
          .domain([0,maxDomainValue])
          .range([height,0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function(d){
            return defaultIndicator.prefix + yAxisFormatter(d).replace('%','');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        redLines = redLines ? redLines : mapConfig.redLines;

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));
        // g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));
        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, barScale, featureScale, width, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function(d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function(d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate('+(margin.left-7)+', 10)');

        svg.select('.axis-unit-label')
          .text(defaultIndicator.unit === '%' ? 'in %' : '');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function(d){
            return 'translate(' + featureScale(accessor('key')(d)) +',0)';
          });

        features
          .transition().duration(duration)
          .attr('transform', function(d){
            return 'translate(' + featureScale(accessor('key')(d)) +',0)';
          });



        var values = features.selectAll('.value')
          .data(function(d){return (d != null && d.barValue != null && d.barValue.value != null) ? [d.barValue] : [];}, accessor('key'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', featureScale.rangeBand())
          .attr('fill', accessor('color'))
          .attr('y', barScale(0))
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', accessor('color'))
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', function(d){
            return height - barScale(d.value);
          })
          .attr('y', function(d) {
            return barScale(d.value);
          })
          .attr('width', featureScale.rangeBand());

        if(values.size() > 0) {
          values.call(barTip);
          values.on('mouseover', function(d,i,j){
            if(d.color.toLowerCase() !== '#ffffff') {
              barTip.show(d,i,j);
            }
          }).on('mouseout', function(d){
            if(d.color.toLowerCase() !== '#ffffff') {
              barTip.hide(d);
            }
          });
        }

        var labels = features.selectAll('text.chart-value')
          .data(function(d){return (d != null && d.barValue != null && d.barValue.value != null) ? [d.barValue] : [];}, accessor('key'));

        if(displayValues) {
          labels.enter()
            .append('text')
            .attr('class', 'chart-value')
            .attr('y', 0);

          // update labels
          labels
            .attr("class", "chart-value")
            .text(function (d) {
              return germanNumberFormat('.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(accessor('value')(d));
            })
            .attr('y', function(d,i,j){
              // return height - barScale(d.offset/values[j].parentNode.__data__.sum)+12;
              return barScale(d.value) - 4;
            })
            .attr('x', function(d, i) {
              // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
              return (featureScale.rangeBand()/2);
            });

          // remove unused labels
          labels.exit()
            .remove();
        } else {
          labels
            .remove();
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        var refPoints = features.selectAll('.refpoint')
          .data(function(d){return (d != null && d.refValue != null && d.refValue.value != null) ? [d.refValue] : [];}, accessor('key'));

        refPoints.enter()
          .append('circle')
          .attr('class', 'refpoint')
          .attr('cx', featureScale.rangeBand() / 2)
          .attr('r', (featureScale.rangeBand() / 2) - 4)
          .attr('fill', accessor('color'))
          .attr('cy', barScale(0))
          .attr('fill-opacity', whiteToOpacity);

        refPoints.transition().duration(duration)
          .attr('fill', accessor('color'))
          .attr('fill-opacity', whiteToOpacity)
          .attr('cy', function(d) {
            return barScale(d.value);
          })
          .attr('cx', featureScale.rangeBand() / 2)
          .attr('r', (featureScale.rangeBand() / 2) - 4);

        if(refPoints.size() > 0) {
          refPoints.call(refTip);
          refPoints.on('mouseover', function(d,i,j){
            if(d.color.toLowerCase() !== '#ffffff') {
              refTip.show(d,i,j);
            }
          }).on('mouseout', function(d){
            if(d.color.toLowerCase() !== '#ffffff') {
              refTip.hide(d);
            }
          });
        }

        refPoints.exit().transition().duration(duration)
          .attr('r', 0)
          .remove();

        var refPointLabels = features.selectAll('text.ref-value')
          .data(function(d){return (d != null && d.refValue != null && d.refValue.value != null) ? [d.refValue] : [];}, accessor('key'));


        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));

        if(displayValues) {
          refPointLabels.enter()
            .append('text')
            .attr('class', 'ref-value')
            .attr('y', 0);

          // update labels
          refPointLabels
            .text(function (d) {
              return germanNumberFormat('.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(accessor('value')(d));
            })
            .attr('y', function(d,i,j){
              return barScale(d.value) + (((featureScale.rangeBand() / 2) - 5)/2);
            })
            .attr('x', function(d, i) {
              // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
              return (featureScale.rangeBand()/2);
            });

          // remove unused labels
          refPointLabels.exit()
            .remove();
        } else {
          refPointLabels
            .remove();
        }

        features.exit().remove();
      });
    };

    /**
     * getter/setter for defaultIndicator
     * @param {Array} [newDefaultIndicator] set of new defaultIndicator
     * @returns {*}
     */
    chart.defaultIndicator = function (newDefaultIndicator) {
      if (!arguments.length) {
        return defaultIndicator;
      } else {
        defaultIndicator = newDefaultIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function(newDisplayValues) {
      if(!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function(newRedLines) {
      if(!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return refTip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element, absolute) {
    var content = element.closest('.grid-stack-item-content-setRefPointBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setRefPointBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      useAbsoluteValues: '@',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var setRefPointBarChartFunction = setRefPointBarChart();

      var useAbsoluteValues = scope.useAbsoluteValues === '1';

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element, useAbsoluteValues);
        }

        var indicators = scope.indicators;
        var redLines = null;
        var decimals = null;
        var maxAxisValue = null;
        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if(scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function(colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function(color) {return color.color;});

              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if(legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, colorset, legend);

            setRefPointBarChartFunction
              .defaultIndicator(scope.selectedIndicatorSet.defaultIndicator)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(setRefPointBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        // remove tooltip dom element
        if (angular.isDefined(setRefPointBarChartFunction.tip())) {
          setRefPointBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('setTable', ['d3', 'mapConfig', 'IndicatorSetHandling', 'UtilityService', '$compile', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param sortedListsAndIndicators
   * @param setHasLists
   * @param numberOfIndicators
   * @returns {string}
   */
  function prepareTableHead(sortedListsAndIndicators, setHasLists, numberOfIndicators) {
    var defaultRowSpan = setHasLists ? 2 : 1;
    var defaultWidth = 90/numberOfIndicators;
    var odd = false;
    var tdClass = [];
    var thClasses = '';
    var headHtml = '<thead><tr><th width="10%" rowspan="'+ defaultRowSpan +'"></th>'+sortedListsAndIndicators.map(function(listOrIndicator, key) {
      tdClass = [];
      if(isList(listOrIndicator)) {
        odd = !odd;
        listOrIndicator.odd = odd;
        tdClass.push("line-left");
        tdClass.push("line-right");
        tdClass.push(odd ? 'set-odd' : 'set-even');
        thClasses = ' class="'+tdClass.join(' ')+'"';
      }
      if(!listOrIndicator.hasData) return;
      var filteredListIndicators = null;
      if(isList(listOrIndicator)) {
        filteredListIndicators = listOrIndicator.indicators.filter(function(ind){return ind.hasData;});
      }
      var width = filteredListIndicators ? filteredListIndicators.length * defaultWidth : defaultWidth;
      return '<th'+thClasses+' width="'+width+'%" rowspan="'+ (isList(listOrIndicator) ? 1 : defaultRowSpan) + '" colspan="' + (isList(listOrIndicator) ? filteredListIndicators.length : 1) + '">' +(listOrIndicator.name || listOrIndicator.title) + '</th>';
    }).join('') + '</tr>';
    if(setHasLists) {
      headHtml += '<tr>' + sortedListsAndIndicators
        .filter(isList)
        .map(function(list){
          return list.indicators.map(function(indicator, listIndex) {
            var tdClass = [];
            if(listIndex === 0) {
              tdClass.push("line-left");
            }
            if(listIndex === list.indicators.length-1) {
              tdClass.push("line-right");
            }
            tdClass.push(list.odd ? 'set-odd' : 'set-even');
            var thClasses = ' class="'+tdClass.join(' ')+'"';
            return indicator.hasData ? '<th'+thClasses+' width="'+defaultWidth+'%">' + indicator.name + '</th>' : '';
          // return list.indicators.map(function(indicator) {
          //   return indicator.hasData ? '<th width="'+defaultWidth+'%">' + indicator.name + '</th>' : '';
          })
        }).join('') + '</tr>';
    }
    headHtml += '</thead>';

    return headHtml;
  }

  /**
   *
   * @param layer
   * @param indicators
   * @param district
   * @param colorSets
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRowFromDistrict(layer, indicators, district, colorSets, selectedIndicator) {
    var isNumericValue = false;
    var tdCssClassAttribute = '';
    var odd = false;
    var decimals = false;
    var legend = false;

    return '<tr><td>'+district.key+'</td>' + indicators.map(function(indicator, key){
      var value = '-';
      var tooltip = '';
      var tdClass = [];

      if(indicator.type && indicator.list) {
        if((indicators[key-1] && indicators[key-1].list != indicator.list) || (indicator.list && !indicators[key-1])) {
          tdClass.push("line-left");
          odd = !odd;
        }
        if((indicators[key+1] && indicators[key+1].list != indicator.list) || (!indicators[key+1] && indicator.list)) {
          tdClass.push("line-right");
        }
      }
      tdClass.push(odd ? 'set-odd' : 'set-even');

      // has Legend
      if(layer.legend && layer.legend[selectedIndicator.uid] != null && layer.legend[selectedIndicator.uid].map != null) {
        legend = layer.legend[selectedIndicator.uid].map;
      }

      if(indicator.categorical) {
        // use icon as value
        if(legend && layer[district.uid]) {
          // icon plus tooltip
          if(layer[district.uid][indicator.uid] != null ) {
            value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg(UtilityService.scaleForValue(legend.scales, colorSets[legend.colorSet], layer[district.uid][indicator.uid])) + '</span>';
          } else {
            if(legend.hasNoValueText !== '') {
              value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg({icon:'no-value'}) + '</span>';
            } else {
              value = '<span style="display: block; text-align: center; height:16px;">-</span>';
            }
          }
          if(layer.descriptions[district.uid][indicator.uid]) {
            tooltip = layer.descriptions[district.uid][indicator.uid];
          }
        } else {
          // direct value
          if(layer.descriptions[district.uid][indicator.uid]) {
            value = layer.descriptions[district.uid][indicator.uid];
          }
        }
      } else {

        // decimals
        if (legend && legend.decimals && legend.decimals !== 0) {
          decimals = legend.decimals;
        } else {
          decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
        }

        // use normal values
        if(layer[district.uid][indicator.uid] != null) {
          isNumericValue = true;
          tdClass.push("numeric");
          value = ((indicator.unit === '%') ? (germanNumberFormat('.'+decimals+'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.'+decimals+'f')(+layer[district.uid][indicator.uid])));
          // wrap numeric value
          value = "<span class='centered-number'>"+value+"</span>";
          if(layer.descriptions[district.uid][indicator.uid]) {
            tooltip = layer.descriptions[district.uid][indicator.uid];
          }
        } else if(layer.descriptions[district.uid][indicator.uid] && layer.descriptions[district.uid][indicator.uid].length > 0) {
            value = layer.descriptions[district.uid][indicator.uid];
            if(value.length < 7) { //
              value = "<span class='centered-number'>"+value+"</span>";
            }
        } else {
          tdClass.push("numeric"); // value = "-" is also numeric
          value = "<span class='centered-number'>-</span>";
        }
      }
      if(tdClass.length) {
        tdCssClassAttribute = ' class="'+tdClass.join(' ')+'"';
      }
      return '<td'+tdCssClassAttribute+'><div tooltip-append-to-body="true" uib-tooltip-html="\'' + ((tooltip != null) ? tooltip : '') +  '\'">' + value + '</div></td>';
    }) + '</tr>';
  }

  /**
   * @param layer
   * @param indicators
   * @param districts
   * @param colorSets
   */
  function prepareTableBody(layer, indicators, districts, colorSets) {
    var selectedIndicator = indicators.filter(function(indicator){return indicator.isDefault;})[0];
    return districts.map(function(district) {
      return bodyRowFromDistrict(layer, indicators, district, colorSets, selectedIndicator);
    });
  }

  /**
   * @param indicators
   */
  function prepareUnitRow(indicators) {
    var filteredIndicators = indicators.filter(function(indicator){
      return indicator.hasData;
    });

    var rowTDs = '<td></td>';
    var colSpan = 1;
    filteredIndicators.forEach(function (indicator, index) {
      if (filteredIndicators[index+1] && indicator.unit === filteredIndicators[index+1].unit) {
        colSpan++;
      } else {
        var unitHead = "";
        if (indicator.unit === "%") {
          unitHead = 'Anteil in %';
        } else {
          unitHead = 'Anzahl';
        }
        rowTDs += '<td colspan="' + colSpan + '">' + unitHead + '</td>';
        colSpan = 1;
      }
    });
    return '<tr class="unit-table-row">'+rowTDs+'</tr>';
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      colorSets: '=',
      config: '=',
      exportData: '='
    },
    link: function (scope, element) {
      var sortedListsAndIndicators;
      var filterEmptyIndicators = function(indicator){
        if(indicator.class !== 'indicator') {
          var setHasData = false;
          indicator.indicators.map(hasData);
          indicator.indicators.forEach(function (subIndicator){
            if(subIndicator.hasData) setHasData = true;
          });
          indicator.hasData = setHasData;
        }
      };

      var hasData = function(indicator) {
        if(indicator.class === 'indicator') {
          indicator.hasData = false;
          angular.forEach(scope.layer.districts, function(district){
            if(scope.layer[district.uid][indicator.uid] || scope.layer.descriptions[district.uid][indicator.uid]) indicator.hasData = true;
          });
        }
      };

      function rerender() {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if(scope.selectedIndicatorSet != null && scope.layer != null && scope.disabledDistrictKeys != null && scope.colorSets != null) {
          sortedListsAndIndicators = IndicatorSetHandling.sortIndicatorsAndLists(scope.selectedIndicatorSet);

          var setHasLists = angular.isArray(scope.selectedIndicatorSet.lists) && scope.selectedIndicatorSet.lists.length > 0;
          if(setHasLists) {
            sortedListsAndIndicators.map(filterEmptyIndicators);
          }
          sortedListsAndIndicators.map(hasData);

          var sortedIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);
          var indicatorsWithData = sortedIndicators.filter(function(indicator){
            return indicator.hasData;
          });

          var head = prepareTableHead(sortedListsAndIndicators, setHasLists, indicatorsWithData.length);
          var districts = Object.keys(scope.layer.districts).map(function(districtUid){
            return scope.layer.districts[districtUid];
          }).filter(function(district) {
            return scope.disabledDistrictKeys.indexOf(district.key) === -1;
          });
          var unitRow = '';
          if(!jQuery('#communeUserData').data('hide-unit-row')) {
            unitRow = prepareUnitRow(indicatorsWithData);
          }

          var body = prepareTableBody(scope.layer, indicatorsWithData, districts, scope.colorSets.reduce(function(acc, colorSet){
            acc[colorSet.uid] = colorSet;
            return acc;
          }, {}));
          element.find('table').html(head + unitRow + body);
          $compile(element.find('table').contents())(scope);

          scope.exportData = getTableExportData(scope.layer, indicatorsWithData, districts);
        }
      }

      var getTableExportData = function(layer ,indicators, districts) {
        var data = [];
        var indicatorValues = [];
        indicatorValues.push("");
        indicators.forEach(function(indicator) {
          indicatorValues.push(indicator.name);
        });
        data.push(indicatorValues);
        districts.forEach(function(district) {
          var districtValues = [];
          districtValues.push(district.key);
          indicators.forEach(function(indicator){
            var value;
            if(layer[district.uid][indicator.uid] != null) {
              value = ((indicator.unit === '%') ? (germanNumberFormat('.'+mapConfig.relativeIndicatorsDecimalPlaces+'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(+layer[district.uid][indicator.uid])));
            } else if(layer.descriptions[district.uid][indicator.uid] != null) {
              value = layer.descriptions[district.uid][indicator.uid].replace(/<(?:.|\n)*?>/gm, '');
            } else {
              value = "";
            }

            districtValues.push(value);
          });
          data.push(districtValues)
        });

        return data;
      };

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var colorSetsWatcher = scope.$watchCollection('colorSets', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        disabledDistrictKeysWatcher();
        layerWatcher();
        colorSetsWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('settings', ['mapConfig', function(mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'settings.html',
    scope: {
      types: '=',
      widgetConfig: '='
    },
    link: function (scope, element) {
      scope.toggleSettings = function(section, $event) {
        var gridItem = element.closest('.grid-stack-item-content'),
              sectionSettings = gridItem.find(".settings " + section);

        element.find(".settings-menu a").removeClass("settings-active");
        if(sectionSettings.hasClass('settings-active')) {
          sectionSettings.removeClass('settings-active');
        } else {
          gridItem.find(".settings > div").removeClass("settings-active");
          jQuery($event.currentTarget).addClass("settings-active");
          sectionSettings.addClass('settings-active');
        }
      };
      scope.goFullscreen = function() {
        scope.widgetConfig['fullscreen'] = true;
        jQuery('html').addClass('fullscreen');
        jQuery(element).closest('.grid-stack-item').addClass('fullscreen-on');
      };
      scope.endFullscreen = function() {
        scope.widgetConfig['fullscreen'] = false;
        jQuery('html').removeClass('fullscreen');
        jQuery(element).closest('.grid-stack-item').removeClass('fullscreen-on');
      };
      scope.$watch('widgetConfig.fullscreen', function () {
        if(scope.widgetConfig['fullscreen'] && !jQuery('html').hasClass('fullscreen')) {
          scope.goFullscreen();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('stackedGroupedSetBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function (d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];

        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, colorset, legend) {

    var lists = selectedIndicatorSet.lists
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      }).map(function (list, index, allLists) {
        if (index === 0) {
          list.legendIndex = 0;
        } else {
          list.legendIndex = allLists[index - 1].indicators.length + allLists[index - 1].legendIndex + 1;
        }
        return list;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      return {
        // first level: districts
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        lists: lists.map(function (list, listIndex) {
          // second level: indicatorLists
          var subValues;

          var listName = list.title;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(list.legendIndex)) {
              listName = legend.chart.scales[list.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + list.legendIndex + ' using ' + listName + ' instead.');
            }
          }

          var scalesLength = legend.chart.scales.length;
          // get values for every indicator in the list
          subValues = list.indicators.map(function (indicator, index) {
            if (!layer[districtUid].hasOwnProperty(indicator.uid)) {
              return null;
            }
            // third level: values per indicator
            var valueLegendIndex = list.legendIndex + index + 1;
            var value = 0;
            if (layer[districtUid][indicator.uid] != null) {
              value = (+layer[districtUid][indicator.uid]);
            }

            var valueName = indicator.name;
            if (legend != null) {
              if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                valueName = legend.chart.scales[valueLegendIndex].text;
              } else {
                console.warn('Scale is missing index ' + list.legendIndex + '. Using ' + valueName + ' instead.');
              }
            }

            return {
              value: value,
              unit: indicator.unit,
              prefix: indicator.prefix,
              offset: 0,
              listName: listName,
              name: valueName,
              color: colorset[valueLegendIndex % colorset.length],
              legendIndex: valueLegendIndex,
              listIndex: listIndex,
              twinIndex: listIndex > 0 ? valueLegendIndex - (scalesLength/2) : valueLegendIndex + (scalesLength/2),
              barIndex: index,
              key: indicator.key
            };
          }).filter(function (value) {
            return value !== null;
          }).map(offsetMappingFunction('value'));

          return {
            name: listName,
            uid: list.uid,
            values: subValues
          };
        }).filter(function (list) {
          return list.values.length > 0;
        }).map(sumMappingFunction('value', 'values'))
      };
    });
  };

  var stackedGroupedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      redLines,
      decimals,
      maxAxisValue,
      mouseOverFeature = null,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var yFormatter = germanNumberFormat(',.' + (decimals ? decimals : mapConfig.relativeIndicatorsDecimalPlaces) + '%');
        var yAxisFormatter = decimals ? yFormatter : germanNumberFormat("%");

        var container = d3.select(this).datum([data]);//.classed('stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.listName.replace('<br/>', '') + '<br>' + d.name.replace('<br/>', '').replace('<br>', '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + ((d.unit === '%') ? yFormatter(d.value / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.value) + ' (' + yFormatter(d.value / featureData.sum) + ')')) + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        var listScale = d3.scale.ordinal()
          .rangeRoundBands([0, featureScale.rangeBand()], 0.1)
          .domain(data[0].lists.map(accessor('uid')));

        var barScale = d3.scale.linear()
          .domain([0, 1])
          .range([height, 0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + yAxisFormatter(d).replace('%', '');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));

        redLines = redLines ? redLines : mapConfig.redLines;

        var lineScale = d3.scale.linear()
          .domain([0, 100])
          .range([height, 0]);

        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, lineScale, featureScale, width, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)')
          .text('in %');

        function featureTransform(d) {
          return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
        }

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', featureTransform);

        features
          .transition().duration(duration)
          .attr('transform', featureTransform);

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('lists'), accessor('uid'));

        function listTransform(d) {
          return 'translate(' + listScale(accessor('uid')(d)) + ',0)';
        }

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', listTransform);

        lists.transition().duration(duration)
          .attr('transform', listTransform);

        lists.exit().remove();

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', function (d, i,  j) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
            //return "value " + d.key + ' focus-bar_' + (i+1);
            //return "value " + d.key + ' focus-bar_' + (d.barIndex+1);
          })
          .attr('x', 0)
          .attr('width', listScale.rangeBand())
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', function (d, i, j) {
            if (mouseOverFeature !== null && (mouseOverFeature) !== d.legendIndex && (mouseOverFeature) !== d.twinIndex) {
              return 0;
            } else {
              return whiteToOpacity(d);
            }
          })
          .attr('y', function (d, i, j) {
            if (mouseOverFeature !== null) {
              return barScale(d.value / values[j].parentNode.__data__.sum);
            } else {
              return height - barScale(d.offset / values[j].parentNode.__data__.sum);
            }
          })
          .attr('height', function (d, i, j) {
            return height - barScale(d.value / values[j].parentNode.__data__.sum);
          })
          .attr('width', listScale.rangeBand());

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.hide(d);
            }
          });
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        var labels = lists.selectAll('text')
          .data(accessor('values'));

        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addHorizontalHighlightLines(redLines, lineScale, width, duration));


        // new labels
        labels.enter()
          .append('text')
          .attr('class', 'value-label hanging')
          .attr('y', 0);

        // update labels
        labels
          .attr("class", "chart-value")
          .text(function (d) {
            return d.value ? d.unit === '%' ? yFormatter(d.value / 100) : germanNumberFormat(',.' + decimals + 'f')(d.value) : '';
            //return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
          })
          .attr('fill-opacity', function (d, i, j) {
            if (!displayValues && mouseOverFeature !== null && (mouseOverFeature) !== d.legendIndex && (mouseOverFeature) !== d.twinIndex) {
              return 0;
            } else {
              return whiteToOpacity(d);
            }
          })
          .attr('y', function (d, i, j) {
            if (mouseOverFeature !== null) {
              return barScale(d.value / values[j].parentNode.__data__.sum) - 4;
            } else {
              return height - barScale(d.offset / values[j].parentNode.__data__.sum);
            }
            //return height - barScale(d.offset / values[j].parentNode.__data__.sum) + 12;
          })
          .attr('x', function (d, i) {
            // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
            return (listScale.rangeBand() / 2);
          });

        // remove unused labels
        labels.exit()
          .remove();

      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for mouseOverFeature
     * @param {Function} [newMouseOverFeature] new mouseOverFeature function
     * @returns {*}
     */
    chart.mouseOverFeature = function (newMouseOverFeature) {
      if (!arguments.length) {
        return mouseOverFeature;
      } else {
        mouseOverFeature = newMouseOverFeature;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-stackedGroupedSetBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'stackedGroupedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var stackedGroupedSetBarChartFunction = stackedGroupedSetBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines = null;
        var decimals,
          maxAxisValue;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, colorset, legend);

            stackedGroupedSetBarChartFunction
              .indicators(indicators)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .mouseOverFeature(scope.mouseOverFeature)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(stackedGroupedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var mouseOverFeatureWatcher = scope.$watch('mouseOverFeature', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        mouseOverFeatureWatcher();

        // remove tooltip dom element
        if (angular.isDefined(stackedGroupedSetBarChartFunction.tip())) {
          stackedGroupedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('textfield', ['mapConfig', '$rootScope', '$timeout', function (mapConfig, $rootScope, $timeout) {
  'use strict';

  /**
   * Generates Math.random-based unique IDs
   * @returns {string}
   */
  function generateID() {
    // https://gist.github.com/gordonbrander/2230317
    return Math.random().toString(36).substr(2, 9);
  }
  return {
    templateUrl: mapConfig.templateBasePath + 'textfield.html',
    restrict: 'E',
    scope: {
      config: '=',
      dimensionX: '@',
      dimensionY: '@'
    },
    controller: ['$scope', function($scope) {
      $scope.uniqueIdentifier = generateID();
      $scope.disableEditMode = !angular.copy(mapConfig.registeredUserMode);
      $scope.loadLastBookmark = function() {
        $rootScope.$emit('loadLastLoadedBookmark');
      };
      if(!angular.copy(mapConfig.registeredUserMode)) {
        // this timeout is needed when widgets are loaded after the textwidget in the same bookmark
        $timeout(function(){
          $rootScope.$emit('startWatchingBookmarkConfig');
          $rootScope.$on('bookmarkConfigChanged', function() {
            $scope.showConfigChangedText = true;
          });
        }, 0);

      }
    }],
    link: function(scope, element){
      scope.toggleRenderContent = function() {
        scope.renderContent = !scope.renderContent;
      };

      var smallDimensionClass = 'textfield-small';
      scope.$watch('dimensionX', function(newValue) {
        var dimension = parseInt(newValue);
        if(dimension === 2) {
          element.addClass(smallDimensionClass);
        } else {
          element.removeClass(smallDimensionClass);
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('stackedSetBarChart', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function (d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];

        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }

      if (!listObject.hasOwnProperty('isList') && listObject.unit === "%") {
        listObject.nOffset = 100 - listObject.sum;
        listObject.sum = 100;
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, disabledListIndex, colorset, legend, useAbsoluteValues) {
    var indicatorsWithoutLists = selectedIndicatorSet.indicators.filter(function (indicator) {
      return indicator.list === false;
    });
    var listsAndIndicators = indicatorsWithoutLists
      .concat(selectedIndicatorSet.lists)
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      })
      .map(function (listOrIndicator, index, allElements) {
        var subElementsCount = 0;
        if (index === 0) {
          listOrIndicator.legendIndex = 0;
        } else {
          if (allElements[index - 1] && allElements[index - 1].hasOwnProperty('indicators')) {
            subElementsCount = allElements[index - 1].indicators.length;
          }
          listOrIndicator.legendIndex = allElements[index - 1].legendIndex + subElementsCount + 1;
        }
        return listOrIndicator;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var barIndex = -1;
      return {
        // first level: districts
        unit: useAbsoluteValues ? '' : '%',
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        listValues: listsAndIndicators.map(function (listOrIndicator, index) {
          // second level: indicatorLists
          var isList = listOrIndicator.hasOwnProperty('indicators');
          var subValues = null;
          var sum = 0;
          var prefix = isList ? (listOrIndicator.indicators[0] != null ? listOrIndicator.indicators[0].prefix : '') : listOrIndicator.prefix;
          barIndex++;

          var listOrIndicatorName = isList ? listOrIndicator.title : listOrIndicator.name;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(listOrIndicator.legendIndex)) {
              listOrIndicatorName = legend.chart.scales[listOrIndicator.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + listOrIndicator.legendIndex + ' using ' + listOrIndicatorName + ' instead.');
            }
          }

          if (isList) {
            // get values for every indicator in the list
            subValues = listOrIndicator.indicators.map(function (indicator, index) {
              barIndex++;
              if (!layer[districtUid] || !layer[districtUid].hasOwnProperty(indicator.uid)) {
                return null;
              }
              // third level: values per indicator
              var valueLegendIndex = listOrIndicator.legendIndex + index + 1;
              var value = 0;
              if (layer[districtUid][indicator.uid] != null) {
                value = (+layer[districtUid][indicator.uid]);
              }
              var description = '';
              if (layer['descriptions'][districtUid] && layer['descriptions'][districtUid][indicator.uid] != null) {
                description = layer['descriptions'][districtUid][indicator.uid];
              }

              var valueName = indicator.name;
              if (legend != null) {
                if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                  valueName = legend.chart.scales[valueLegendIndex].text;
                } else {
                  console.warn('Scale is missing index ' + listOrIndicator.legendIndex + '. Using ' + valueName + ' instead.');
                }
              }

              return {
                value: value,
                description: description,
                unit: indicator.unit,
                prefix: indicator.prefix,
                offset: 0,
                name: valueName,
                color: colorset[valueLegendIndex % colorset.length],
                legendIndex: valueLegendIndex,
                idx: barIndex,
                key: indicator.key
              };
            }).filter(function (value) {
              return value !== null;
            }).map(offsetMappingFunction('value'));
          } else {
            var description = '';
            if (layer['descriptions'][districtUid] && layer['descriptions'][districtUid][listOrIndicator.uid] != null) {
              description = layer['descriptions'][districtUid][listOrIndicator.uid];
            }
            // value for single indicator without list
            if (layer[districtUid] && layer[districtUid].hasOwnProperty(listOrIndicator.uid)) {
              sum = (+layer[districtUid][listOrIndicator.uid]);
            } else {
              sum = null;
            }
          }

          return {
            isList: isList,
            description: description,
            name: listOrIndicatorName,
            key: listOrIndicator.key,
            uid: listOrIndicator.uid,
            prefix: prefix,
            firstLevel: true,
            sum: sum,
            unit: listOrIndicator.unit,
            offset: 0,
            idx: barIndex,
            legendIndex: listOrIndicator.legendIndex,
            color: colorset[listOrIndicator.legendIndex % colorset.length],
            values: subValues
          };
        }).filter(function (item, idx) {
          return disabledListIndex.indexOf(idx) === -1;
        }).filter(function (listOrIndicator) {
          return (listOrIndicator.isList === false && listOrIndicator.sum !== null) || (listOrIndicator.isList && listOrIndicator.values.length > 0);
        }).map(sumMappingFunction('value', 'values'))
          .map(offsetMappingFunction('sum'))
          .map(function (listOrIndicator) {
            // add empty array for values in indicator
            if (!listOrIndicator.isList) {
              listOrIndicator.values = [];
            }
            return listOrIndicator;
          })
      };
    }).map(sumMappingFunction('sum', 'listValues'));
  };

  var stackedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      useAbsoluteValues = false,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip,
      redLines = null,
      decimals,
      maxAxisValue,
      mouseOverFeature = null,
      sumTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var yAxisFormatter = germanNumberFormat(useAbsoluteValues ? ',' : '%');
        var yFormatter = germanNumberFormat(',.' + (useAbsoluteValues ? mapConfig.absoluteIndicatorsDecimalPlaces : mapConfig.relativeIndicatorsDecimalPlaces) + '%');
        var getLabelBy = function (property, d, featureData) {
          return d.prefix + ((d.unit === '%') ? yFormatter(d[property] / 100) : (germanNumberFormat(',.' + decimals + 'f')(d[property]) + ' (' + yFormatter(d[property] / featureData.sum) + ')'));
        }

        var container = d3.select(this).datum([data]).classed('stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }
        if (angular.isDefined(sumTip)) {
          sumTip.destroy();
        }

        sumTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            var featureData = values[j].parentNode.parentNode.__data__;
            var value = '';
            if (d.description) {
              value = d.description;
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span class="tooltip-value">' + value + '</span></div>';
            } else {
              value = getLabelBy('sum', d, featureData);
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
            }
          });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            var value = '';
            if (d.description) {
              value = d.description;
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span class="tooltip-value">' + value + '</span></div>';
            } else {
              value = getLabelBy('value', d, featureData);
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
            }
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        var maxDomainValue = maxAxisValue ? maxAxisValue : useAbsoluteValues ? d3.max(data, accessor('sum')) : 1;

        var barScale = d3.scale.linear()
          .domain([0, maxDomainValue])
          .range([height, 0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + yAxisFormatter(d).replace('%', '');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));
        redLines = redLines ? redLines : mapConfig.redLines;

        if (useAbsoluteValues) {
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, barScale, featureScale, width, duration));
        }

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)')
          .text(useAbsoluteValues ? '' : 'in %');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function (d) {
            return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
          });

        features
          .transition().duration(duration)
          .attr('transform', function (d) {
            // update avoid 100% bars
            if (d.unit === '%' && d.nOffset && d.nOffset > 1) {
              //return 'translate(' + featureScale(accessor('key')(d)) + ', 0)';
              return 'translate(' + featureScale(accessor('key')(d)) + ',' + (barScale((100 - d.nOffset) / 100)) + ')';
            } else {
              return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
            }
          });

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('listValues'), accessor('uid'));

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', 'translate(0,' + barScale(0) + ')');

        lists.transition().duration(duration)
          .attr('transform', function (d, i, j) {
            // update avoid 100% bars
            var barValue = useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum - d.offset) / 100;
            var offsetValue= useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum ) / 100;
            if(mouseOverFeature !== null) {

              var barHeight = useAbsoluteValues ? d.sum : d.sum / 100;
              return 'translate(0,' + (barScale(barHeight)) + ')';
            } else {
              //var barValue = useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum - d.offset) / lists[j].parentNode.__data__.sum;
              return 'translate(0,' + barScale(barValue) + ')';
            }
          });

        lists.exit().remove();

        var sumBars = lists.selectAll('.sum')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              description: d.description,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        sumBars.enter()
          .append('rect')
          //.attr('class', 'sum')
          .attr('class', function (d) {
            return 'sum focus-bar_' + d.idx + (d.isList ? '' : ' sum__' + d.key);
          })
          .classed('sum-only', function (d) {
            return !d.isList;
          })
          .attr('y', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', featureScale.rangeBand())
          .attr('height', 0);

        sumBars.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', featureScale.rangeBand())
          .attr('height', function (d, i, j) {
            // update avoid 100% bars
            var barValue = useAbsoluteValues ? d.sum : d.sum / 100;

            // fetch sum from feature for scaling the sum
            //var barValue = useAbsoluteValues ? d.sum : d.sum / sumBars[j].parentNode.parentNode.__data__.sum;
            return height - barScale(barValue);
          });

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', featureScale.rangeBand())
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('class', function (d) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .attr('y', function (d, i, j) {
            // update avoid 100% bars
            var yValue = useAbsoluteValues ? d.offset : d.offset / 100;
            //var yValue = useAbsoluteValues ? d.offset : d.offset / values[j].parentNode.parentNode.__data__.sum;
            return height - barScale(yValue);
          })
          .attr('height', function (d, i, j) {
            // update avoid 100% bars
            var heightValue = useAbsoluteValues ? d.value : d.value / 100;
            //var heightValue = useAbsoluteValues ? d.value : d.value / values[j].parentNode.parentNode.__data__.sum;
            return height - barScale(heightValue);
          })
          .attr('width', featureScale.rangeBand());

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.hide(d);
            }
          });
        }

        var labels = lists.selectAll('text')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              description: d.description,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        labels.enter()
          .append('text')
          .attr('class', 'sum-label')
          .attr('y', 0);

        // update labels
        labels
          //.attr("class", "sum-label vertical")
          .attr('class', function (d) {
            return "sum-label vertical " + " focus-bar_" + d.idx;
          })
          .text(function (d,i,j) {
            var featureData = values[j].parentNode.parentNode.__data__;

            return getLabelBy('sum', d, featureData);
          })
          .attr('x', function (d, i) {
            return (featureScale.rangeBand() / 2) + (featureScale.rangeBand() * i);
          })
          .attr('dy', 12);
        // remove unused labels
        labels.exit()
          .remove();

        var sumOnly = lists.selectAll('.sum-only');
        if (sumOnly.size() > 0) {
          sumOnly.call(sumTip);
          lists.selectAll('.sum-only').on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.hide(d);
            }
          });
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        sumBars.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        if (useAbsoluteValues) {
          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for useAbsoluteValues
     * @param {int} [newUseAbsoluteValues] height of the diagram
     * @returns {*}
     */
    chart.useAbsoluteValues = function (newUseAbsoluteValues) {
      if (!arguments.length) {
        return useAbsoluteValues;
      } else {
        useAbsoluteValues = newUseAbsoluteValues;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for mouseOverFeature
     * @param {Function} [newMouseOverFeature] new mouseOverFeature function
     * @returns {*}
     */
    chart.mouseOverFeature = function (newMouseOverFeature) {
      if (!arguments.length) {
        return mouseOverFeature;
      } else {
        mouseOverFeature = newMouseOverFeature;
        return chart;
      }
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element, absolute) {
    var content = element.closest('.grid-stack-item-content-stackedSet' + (absolute ? 'Absolute' : '') + 'BarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'stackedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      useAbsoluteValues: '@',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.disabledListIndex = scope.disabledListIndex || [];

      var stackedSetBarChartFunction = stackedSetBarChart();

      var useAbsoluteValues = scope.useAbsoluteValues === '1';

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element, useAbsoluteValues);
        }

        var indicators = scope.indicators;
        var redLines;
        var decimals = null;
        var maxAxisValue = null;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }

              if (legend && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend, useAbsoluteValues);

            stackedSetBarChartFunction
              .indicators(indicators)
              .useAbsoluteValues(useAbsoluteValues)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .mouseOverFeature(scope.mouseOverFeature)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(stackedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var disabledListIndexWatcher = scope.$watch('disabledListIndex', rerender);
      var mouseOverFeatureWatcher = scope.$watch('mouseOverFeature', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();
        mouseOverFeatureWatcher();

        // remove tooltip dom element
        if (angular.isDefined(stackedSetBarChartFunction.tip())) {
          stackedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('transposedFeatureTable', ['d3', 'mapConfig', function (d3, mapConfig) {
  'use strict';

  var identity = d3.hyperion.accessor();
  var accessor = d3.hyperion.accessor;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var numberFormat = germanNumberFormat(',.2f');

  var transposedFeatureTable = function () {
    var indicators = [],
      colorSets = {},
      selectedDistrictKeys = [],
      disabledDistrictKeys = [];

    var table = function (selection) {
      selection.each(function (data) {
        var districtUids = Object.keys(data.districts).filter(function(d) {
          return disabledDistrictKeys.indexOf(data.districts[d].key) === -1;
        });

        var heads = [{key: '', hasNoGeoData: true}].concat(districtUids.map(function(uid){
          return data.districts[uid];
        }));

        var container = d3.select(this).data([data]);

        var thead = container.select('thead');
        var headings = thead.selectAll('tr').data([heads]);

        headings.enter()
          .append('tr');

        var th = headings.selectAll('th')
          .data(heads);


        th.enter()
          .append('th')
          .append('span');

        th
          .style('color', function(d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : 'inherit';
          });

        th.exit().remove();

        th.select('span')
          .html(accessor('key'));

        if (angular.isObject(data)) {
          var bodyData = [];
          for(var i = 0; i < indicators.length; i++) {
            bodyData.push([indicators[i].name].concat(
              districtUids.map(function(uid) {
                var value = data[uid][indicators[i].uid];
                if(value == null) {
                  return '-';
                } else {
                  if(indicators[i].categorical && indicators[i].defaultColorSet && colorSets[indicators[i].defaultColorSet]) {
                    value = '<span class="'+colorSets[indicators[i].defaultColorSet].colors[value].icon+'" style="color:'+colorSets[indicators[i].defaultColorSet].colors[value].color+';"></span>';
                  } else {
                    if(indicators[i].unit === '%') {
                      value = germanNumberFormat(',.'+mapConfig.relativeIndicatorsDecimalPlaces+'f')(value)+'%';
                    } else {
                      value = germanNumberFormat(',.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(value);
                    }
                  }
                }
                return value;
              })
            ));
          }

          var tbody = container.select('tbody');
          var rows = tbody.selectAll('tr').data(bodyData, function (d, i) {
            return i;
          });

          rows.enter()
            .append('tr');

          rows.exit().remove();

          var elements = rows.selectAll('td')
            .data(identity);

          elements.enter()
            .append('td');

          elements.exit().remove();

          elements
            .html(identity);
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    table.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return table;
      }
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newColorSets] set of new colorSets
     * @returns {*}
     */
    table.colorSets = function (newColorSets) {
      if (!arguments.length) {
        return colorSets;
      } else {
        colorSets = newColorSets;
        return table;
      }
    };

    /**
     * getter/setter for selectedDistrictKeys
     * @param {Array} [newSelectedDistrictKeys] set of new selectedDistrictKeys
     * @returns {*}
     */
    table.selectedDistrictKeys = function (newSelectedDistrictKeys) {
      if (!arguments.length) {
        return selectedDistrictKeys;
      } else {
        selectedDistrictKeys = newSelectedDistrictKeys;
        return table;
      }
    };

    /**
     * getter/setter for disabledDistrictKeys
     * @param {Array} [newDisabledDistrictKeys] set of new disabledDistrictKeys
     * @returns {*}
     */
    table.disabledDistrictKeys = function (newDisabledDistrictKeys) {
      if (!arguments.length) {
        return disabledDistrictKeys;
      } else {
        disabledDistrictKeys = newDisabledDistrictKeys;
        return table;
      }
    };

    return table;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'transposedFeatureTable.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      disabledDistrictKeys: '=',
      indicators: '=',
      colorSets: '=',
      config: '='
    },
    link: function (scope, element) {

      scope.config.fullscreen = scope.config.fullscreen || false;
      jQuery(element).find('.table-wrap').on('scroll', function(){
        jQuery(element).find('.table-overlay-wrap').find('table').css({'margin-left': -jQuery(this).scrollLeft()});
      });

      var transposedFeatureTableFunction = transposedFeatureTable();
      d3.select(element[0]).classed('feature-table', true);
      var rerender = function () {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        transposedFeatureTableFunction
          .disabledDistrictKeys(scope.disabledDistrictKeys)
          .indicators(scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
          }))
          .selectedDistrictKeys(scope.selectedDistricts.map(function(d) {
            return d.key;
          }))
          .colorSets(scope.colorSets.reduce(function(acc, colorset){
            acc[colorset.uid] = colorset;
            return acc;
          }, {}));


        var elementSelection = d3.select(element.find('.widget-inner:first')[0]);
        elementSelection.selectAll('table')
          .datum(scope.layer)
          .call(transposedFeatureTableFunction);
      };

      scope.fillExportFields = function () {
        // JSON for Table-Export
        scope.indicatorJson = angular.toJson(scope.indicators);
        scope.layerJson = angular.toJson(scope.layer);

        setTimeout(function(){
          scope.indicatorJson = scope.layerJson = '';
        }, 100);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        selectedDistrictsWatcher();
        disabledDistrictKeysWatcher();
        fullscreenWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('transposedSetTable', ['d3', 'mapConfig', 'IndicatorSetHandling', 'UtilityService', '$compile', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param districts
   * @returns {string}
   */
  function prepareTableHead(districts) {
    var numberOfDistricts = districts.length;
    var width = 86 / numberOfDistricts;
    return '<thead><tr><th width="15%"></th>' + districts.map(function (district) {
      return '<th width="' + width + '%">' + district.key + '</th>';
    }) + '</tr></thead>';
  }

  /**
   *
   * @param indicator
   * @param district
   * @param layer
   * @param colorSets
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRowDistrictField(indicator, district, layer, colorSets, selectedIndicator) {
    var value = '-';
    var tooltip = '';
    var tdClass = '';
    var decimals = false;
    var legend = false;

    // has Legend
    if (selectedIndicator && layer.legend && layer.legend[selectedIndicator.uid] != null && layer.legend[selectedIndicator.uid].map != null) {
      legend = layer.legend[selectedIndicator.uid].map;
    }

    if (indicator.categorical) {
      // use icon as value
      if (legend) {
        // icon plus tooltip
        if (layer[district.uid][indicator.uid] != null) {
          value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg(UtilityService.scaleForValue(layer.legend[selectedIndicator.uid].map.scales, colorSets[layer.legend[selectedIndicator.uid].map.colorSet], layer[district.uid][indicator.uid])) + '</span>';
        } else {
          if (layer.legend[selectedIndicator.uid].map.hasNoValueText !== '') {
            value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg({icon: 'no-value'}) + '</span>';
          } else {
            value = '<span style="display: block; text-align: center; height:16px;">-</span>';
          }
        }
        if (layer.descriptions[district.uid][indicator.uid] != null) {
          tooltip = layer.descriptions[district.uid][indicator.uid];
        }
      } else {
        // direct value
        if (layer.descriptions[district.uid][indicator.uid] != null) {
          value = layer.descriptions[district.uid][indicator.uid];
        } else {
          value = '<span style="display: block; text-align: center; height:16px;">-</span>';
        }
      }
    } else {
      tdClass = " class='numeric'";

      // decimals
      if (legend && legend.decimals && legend.decimals !== 0) {
        decimals = legend.decimals;
      } else {
        decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
      }

      // use normal values
      if (layer[district.uid][indicator.uid] != null) {
        value = ((indicator.unit === '%') ? (germanNumberFormat('.' + decimals + 'f')(+layer[district.uid][indicator.uid]) + '') : (germanNumberFormat(',.' + decimals + 'f')(+layer[district.uid][indicator.uid])));
        value = "<span class='centered-number'>" + value + "</span>";
        if (layer.descriptions[district.uid][indicator.uid]) {
          tooltip = layer.descriptions[district.uid][indicator.uid];
        }
      } else if (layer.descriptions[district.uid][indicator.uid] && layer.descriptions[district.uid][indicator.uid].length > 0) {
        value = layer.descriptions[district.uid][indicator.uid];
        // ToDo: auch hier zentrieren? Sind eigentlich texte - gelegentlich aber auch für werte genutzt (8-10, <3,...)
        if (value.replace(/<(?:.|\n)*?>/gm, '').length < 7) {
          value = "<span class='centered-number'>" + value + "</span>";
        }
      } else {
        value = "<span class='centered-number'>-</span>";
      }
    }

    return '<td' + tdClass + '><div tooltip-append-to-body="true" uib-tooltip-html="\'' + ((tooltip != null) ? tooltip : '') + '\'">' + value + '</div></td>';
  }

  /**
   *
   * @param indicator
   * @param districts
   * @param layer
   * @param colorSets
   * @param insideList
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRow(indicator, districts, layer, colorSets, insideList, selectedIndicator) {
    if (!indicator.hasData) return '';
    return '<tr class="' + (insideList ? 'inside-indicator-list-row' : 'indicator-row') + '"><td>' + indicator.name + '</td>' + districts.map(function (district) {
      return bodyRowDistrictField(indicator, district, layer, colorSets, selectedIndicator);
    }) + '</tr>';
  }

  /**
   * @param layer
   * @param indicatorsOrLists
   * @param districts
   * @param colorSets
   */
  function prepareTableBody(layer, indicatorsOrLists, districts, colorSets, flatIndicators) {
    var selectedIndicator = flatIndicators.filter(function (indicator) {
      return indicator.isDefault;
    })[0];
    return indicatorsOrLists.map(function (indicatorOrList) {
      var row = '';
      if (isList(indicatorOrList)) {
        row += '<tr class="indicator-list-row"><td><b>' + indicatorOrList.title + '</b></td>' + districts.map(function () {
          return '<td></td>';
        }) + '</tr>';
        row += indicatorOrList.indicators.map(function (indicator) {
          return bodyRow(indicator, districts, layer, colorSets, true, selectedIndicator);
        });
      } else {
        row += bodyRow(indicatorOrList, districts, layer, colorSets, false, selectedIndicator);
      }
      return row;
    });
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      colorSets: '=',
      config: '=',
      exportData: '='
    },
    link: function (scope, element) {

      var filterEmptyIndicators = function (indicator) {
        if (indicator.class !== 'indicator') {
          indicator.indicators = indicator.indicators.filter(function (indicator) {
            return hasData(indicator);
          });
        }
      };

      var hasData = function (indicator) {
        indicator.hasData = false;
        angular.forEach(scope.layer.districts, function (district) {
          if (scope.layer[district.uid][indicator.uid] || scope.layer.descriptions[district.uid][indicator.uid]) indicator.hasData = true;
        });
        return indicator.hasData;
      };

      function rerender() {
        if (scope.layer && scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (scope.selectedIndicatorSet != null && scope.layer != null && scope.disabledDistrictKeys != null && scope.colorSets != null) {
          var sortedListsAndIndicators = IndicatorSetHandling.sortIndicatorsAndLists(scope.selectedIndicatorSet);
          var flatIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);

          sortedListsAndIndicators = sortedListsAndIndicators.filter(function (indicator) {
            if (indicator.class === "indicator") {
              return hasData(indicator);
            }
            return true;
          });

          sortedListsAndIndicators.map(filterEmptyIndicators);
          var districts = Object.keys(scope.layer.districts).map(function (districtUid) {
            return scope.layer.districts[districtUid];
          }).filter(function (district) {
            return scope.disabledDistrictKeys.indexOf(district.key) === -1;
          });

          var head = prepareTableHead(districts);

          var body = prepareTableBody(scope.layer, sortedListsAndIndicators, districts, scope.colorSets.reduce(function (acc, colorSet) {
            acc[colorSet.uid] = colorSet;
            return acc;
          }, {}), flatIndicators);
          element.find('table').html(head + body);
          $compile(element.find('table').contents())(scope);

          scope.exportData = getTableExportData(scope.layer, sortedListsAndIndicators, districts);
        }
      }

      var getTableExportData = function (layer, indicators, districts) {
        var data = [];
        var districtRow = [];
        districtRow.push("");
        districts.forEach(function (district) {
          districtRow.push(district.key)
        });

        data.push(districtRow);
        indicators.forEach(function (indicator) {
          var districtValues = [];
          districtValues.push(indicator.name);
          if (!indicator.indicators) {
            districts.forEach(function (district) {
              var value;
              if (layer[district.uid][indicator.uid] != null) {
                value = ((indicator.unit === '%') ? (germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(+layer[district.uid][indicator.uid])));
              } else if (layer.descriptions[district.uid][indicator.uid] != null) {
                value = layer.descriptions[district.uid][indicator.uid].replace(/<(?:.|\n)*?>/gm, '');
              } else {
                value = "";
              }
              districtValues.push(value);
            });
          }
          data.push(districtValues);
        });

        return data;
      };

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var colorSetsWatcher = scope.$watchCollection('colorSets', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        disabledDistrictKeysWatcher();
        layerWatcher();
        colorSetsWatcher();
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('yearCheckboxes', ['mapConfig', '$interval', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'yearCheckboxes.html',
    restrict: 'E',
    scope: {
      disabledDataLayers: '=',
      layers: '=',
      selectedIndicator: '='
    },
    link: function (scope) {
      scope.years = [];
      // Toggle selection for a given fruit by name
      scope.toggleSelection = function toggleSelection(year) {
        var dataLayer = scope.layers[year];
        var index = scope.disabledDataLayers.indexOf(dataLayer.year);
        if (index !== -1) {
          scope.disabledDataLayers.splice(index, 1);
        } else {
          scope.disabledDataLayers.push(dataLayer.year);
        }
      };

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        angular.forEach(scope.layers, function (layer, year) {
          if (layer.indicators.indexOf(scope.selectedIndicator.uid) === -1) {
            if(scope.disabledDataLayers.indexOf(layer.year) === -1) scope.disabledDataLayers.push(layer.year);
            scope.years.splice(scope.years.indexOf(layer.year), 1);
          } else {
            if(scope.disabledDataLayers.indexOf(layer.year) !== -1) scope.disabledDataLayers.splice(scope.disabledDataLayers.indexOf(layer.year), 1);
          }
        });
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
      });

      function saveYearsInsideArray() {
        if(!scope.layers) return;
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('yearDoubleSlider', ['mapConfig', '$interval', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerDoubleSlider.html',
    restrict: 'E',
    scope: {
      disabledDataLayers: '=',
      layers: '=',
      selectedIndicator: '='
    },
    link: function (scope, element) {
      scope.layers = [];
      scope.years = Object.keys(scope.layers);
      //scope.yearsToHide = mapConfig.yearsToHide;

      function saveYearsInsideArray() {
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        angular.forEach(scope.layers, function (layer, year) {
          if (layer.indicators.indexOf(scope.selectedIndicator.uid) === -1) {
            scope.years.splice(scope.years.indexOf(year), 1);
          }
        });
        rebuildSlider();
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
        rebuildSlider();
      });

      function rebuildSlider() {
        var stepsArray = [];
        var availableYears = scope.years;
        //update: handles hidden years in mapInterface
        //availableYears = mapConfig.yearsToHide ? scope.years.filter(function (year) {
        //  return mapConfig.yearsToHide.indexOf(year) === -1;
        //}) : availableYears;

        angular.forEach(availableYears, function (year, index) {
          var legendString = '';

          if (availableYears.length > 5 && index > 0 && index < availableYears.length - 1) {
            legendString = "'" + year.substring(2);
          } else {
            legendString = year;
          }
          stepsArray.push({value: year, legend: legendString});
        });

        var yearSelection = scope.disabledDataLayers.length ? availableYears.filter(function(year){ return scope.disabledDataLayers.indexOf(year) === -1; }) : availableYears;

        scope.layersSlider.options.stepsArray = stepsArray;
        scope.layersSlider.options.floor = availableYears[0];
        scope.layersSlider.options.ceil = availableYears[availableYears.length-1];
        scope.layersSlider.minValue = yearSelection[0];
        scope.layersSlider.maxValue = yearSelection[yearSelection.length-1];

      }

      var toggleSelection = function toggleSelection(min, max) {
        scope.disabledDataLayers = scope.years.filter(function(year) {
          if(year < min || year > max) {
            return year;
          }
        });
      };

      scope.layersSlider = {
        options: {
          onChange: function () {
            toggleSelection(scope.layersSlider.minValue, scope.layersSlider.maxValue);
          },
          showSelectionBar: true,
          hidePointerLabels: true,
          showTicksValues: true
        }
      };
    }
  };
}]);

/* global L */
angular.module('Itao.IndicatorMap').controller(
  'IndicatorMapController',
  ['$scope', '$q', '$timeout', '$element', '$http', 'DistrictStyling', 'mapConfig', 'DataLayerService', 'UtilityService', 'd3', function ($scope,
            $q,
            $timeout,
            $element,
            $http,
            DistrictStyling,
            mapConfig,
            DataLayerService,
            UtilityService,
            d3) {
    'use strict';

    // init directive scope variables
    $scope.config = {};
    $scope.numberOfScaleOptions = [1, 2, 3, 4, 5, 6];

    if ($scope.indicatorToShow && ($scope.indicatorToShow.defaultScale || $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid])) {
      $scope.config.numberOfScales = $scope.indicatorToShow.length;
    } else {
      $scope.config.numberOfScales = $scope.config.numberOfScales || mapConfig.numberOfScales;
    }

    $scope.config.districtOpacity = $scope.config.districtOpacity || mapConfig.styling.default.fillOpacity;
    $scope.config.displayValues = $scope.config.displayValues || false;
    $scope.config.indicatorToShow = $scope.config.indicatorToShow || '';
    $scope.config.indicatorToShowInverted = $scope.config.indicatorToShowInverted === undefined ? false : $scope.config.indicatorToShowInverted;
    $scope.config.selectedColorSet = $scope.config.selectedColorSet || '';
    $scope.config.labelAlignment = $scope.config.labelAlignment || 'auto';
    $scope.config.selectedClassMethod = $scope.config.selectedClassMethod || mapConfig.defaultSelectedClassMethod;
    $scope.config.optionStates = $scope.config.optionStates || angular.copy(mapConfig.defaultLabels);
    $scope.config.legendMode = $scope.config.legendMode || 'small';
    $scope.config.fullscreen = $scope.config.fullscreen || false;
    $scope.selectedColorSet = null;
    $scope.indicatorToShow = null;
    $scope.config.showCharts = $scope.config.showCharts === undefined ? true : $scope.config.showCharts;
    $scope.scaleMethod = 'width';

    var mouseOverFeatureKey = '';
    var districtSingleSelection = '';
    var districtInfo = '';
    var info;
    var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
    var numberFormat = germanNumberFormat(',.2f');
    var groupDistricts = jQuery('#groupDistricts');
    var featureGroups;

    /**
     * re-colors features after indicator-select or clears features when all indicators are deselected
     * @param {Indicator} indicator
     */
    var indicatorToShowWatcher = $scope.$watch('config.indicatorToShow', function (indicator) {
      if (indicator) {
        germanNumberFormat = d3.hyperion.germanFormat.numberFormat('.' + getDecimals() + 'f');
        var indicatorToShowPosition = $scope.selectedIndicators.map(function (d) {
          return d.key;
        }).indexOf(indicator);
        if (indicatorToShowPosition !== -1) {

          $scope.indicatorToShow = $scope.selectedIndicators[indicatorToShowPosition];
          if ($scope.indicatorToShow) {
            if ($scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] != null && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map != null) {
              $scope.config.selectedColorSet = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'].colorSet;

            } else if ($scope.indicatorToShow.defaultColorSet) {
              $scope.config.selectedColorSet = $scope.indicatorToShow.defaultColorSet;
            }

            $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
            // check if colors have to be inverted
            if ($scope.indicatorToShow.inverted !== $scope.config.indicatorToShowInverted) {
              $scope.indicatorToShow.invertScale();
            }
          }

          $scope.colorDistrictsBasedOnIndicatorScale();
        } else {
          $scope.indicatorToShow = null;
          clearFeatures();
        }
      } else {
        $scope.indicatorToShow = null;
        if ($scope.geojson) {
          clearFeatures();
        }
      }
      $scope.changeTooltip();
    });

    var invertedWatcher = $scope.$watch('config.indicatorToShowInverted', function (newValue) {
      // TODO: find better mechanism to change order of applied changes
      $timeout(function () { // invert after all other changes
        if ($scope.indicatorToShow && ($scope.indicatorToShow.inverted !== newValue)) {
          $scope.indicatorToShow.invertScale();
          $scope.colorDistrictsBasedOnIndicatorScale();
        }
      }, 10);
    });

    /**
     * Render Indicator-Charts
     */
    var selectedIndicatorsWatcher = $scope.$watchCollection('selectedIndicators', function (selectedIndicators) {
      if (angular.isArray(selectedIndicators) && selectedIndicators.length > 0) {
        if ($scope.config.indicatorToShow === ''
          || $scope.config.indicatorToShow == null
          || selectedIndicators.map(function (d) {
            return d.key;
          }).indexOf($scope.config.indicatorToShow) === -1) {
          // select first as default
          // $scope.config.indicatorToShow = selectedIndicators[0].key;
          for (var i = 0, len = $scope.selectedIndicators.length; i < len; i++) {
            if (selectedIndicators[i].hasShapeData) {
              $scope.config.indicatorToShow = $scope.selectedIndicators[i].key;
              break;
            }
          }
        }
      } else {
        $scope.config.indicatorToShow = '';
      }
      $scope.changeTooltip();
    });

    /**
     * reprintMap with colors
     */
    var selectedColorSetWatcher = $scope.$watch('config.selectedColorSet', function (selectedColorSet) {
      if (angular.isArray($scope.colorSets) && $scope.colorSets.length > 0) {
        var colorSetIndex = $scope.colorSets.map(function (d) {
          return d.uid;
        }).indexOf(+selectedColorSet);

        //default to first colorSet
        if (colorSetIndex === -1) {
          colorSetIndex = 0;
        }
        $scope.numberOfScaleOptions = $scope.colorSets[colorSetIndex].colors.map(function (d, i) {
          return i + 1;
        });
        if ($scope.numberOfScaleOptions.indexOf($scope.config.numberOfScales) === -1) {
          $scope.config.numberOfScales = $scope.numberOfScaleOptions[$scope.numberOfScaleOptions.length - 1];
        }
        $scope.selectedColorSet = $scope.colorSets[colorSetIndex];
        if (!$scope.indicatorToShow) return;

        $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
        $scope.colorDistrictsBasedOnIndicatorScale();
      }
    });

    var colorSetsWatcher = $scope.$watchCollection('colorSets', function (newSets) {
      if (angular.isArray(newSets) && newSets.length > 0) {
        //default first
        var colorSetIndex = newSets.map(function (d) {
          return d.uid;
        }).indexOf($scope.config.selectedColorSet);
        if (colorSetIndex === -1) {
          colorSetIndex = 0;
        }
        $scope.config.selectedColorSet = newSets[colorSetIndex].uid;
      }
    });

    var selectedDistrictsWatcher = $scope.$watchCollection('selectedDistricts', function () {
      $scope.colorDistrictsBasedOnIndicatorScale();
    });

    var selectedAlignmentWatcher = $scope.$watch('config.labelAlignment', function (selectedLabelAlignment) {
      $scope.changeTooltip();
    });

    /**
     * redraws the map after dataLayer-changes
     */
    var selectedDataLayerWatcher = $scope.$watch('selectedDataLayer', function (datalayer) {
      if (!angular.isDefined(datalayer)) return;
      if (angular.isDefined($scope.config.dataLayerToShow) && !angular.isDefined($scope.dataLayerToShow) && angular.isObject($scope.layers) && $scope.layers.hasOwnProperty($scope.config.dataLayerToShow)) {
        // set datalayer from config
        $scope.setDataLayerData($scope.layers[$scope.config.dataLayerToShow]);
      } else {
        // set new datalayer
        $scope.setDataLayerData(datalayer);
      }
    });

    /**
     * inform leaflet that te dimensions of the map changed
     * this leads to recalculating, which tiles have to be shown etc.
     */
    var dimensionWatcher = $scope.$watchGroup(['dimensionX', 'dimensionY'], function () {
      jQuery($element).find('.map').height(jQuery($element).closest('.grid-stack-item-content-map').height());
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    /**
     * inform leaflet that te dimensions of the map changed
     * this leads to recalculating, which tiles have to be shown etc.
     */
    var fullscreenWatcher = $scope.$watch('config.fullscreen', function () {
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    jQuery(document).on("fullscreen", function (e) {
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    /**
     * @param {DataLayer} datalayer
     */
    $scope.setDataLayerData = function (datalayer) {
      if (!datalayer || angular.equals({}, datalayer)) {
        console.warn("Can't load DataLayerData without DataLayer");
        return;
      }
      $scope.config.dataLayerToShow = datalayer.year;
      $scope.dataLayerToShow = datalayer;
      $scope.numberOfDataLayers = Object.keys($scope.layers).length;
      clearMap();

      $scope.geojson = L.geoJson(JSON.parse($scope.dataLayerToShow.geo_json), {
        onEachFeature: onEachFeature
      }).addTo($scope.map);

      if (groupDistricts.length) {
        featureGroups = {};
        $scope.geojson.eachLayer(function (layer) {
          var districtKey = layer.feature.properties.key,
            blKey = '';
          if (districtKey && districtKey.length == 8 || districtKey.length == 5) {
            blKey = districtKey.substring(0, 2);
          } else if (districtKey) {
            blKey = '0' + districtKey.substring(0, 1);
          } else {
            return;
          }

          if (mapConfig.keyLandMapping.keys[blKey]) {
            var groupKey = mapConfig.keyLandMapping.keys[blKey].key;
            if (!featureGroups[groupKey]) {
              featureGroups[groupKey] = L.featureGroup();
            }
            layer.addTo(featureGroups[groupKey]);
          }
        });
      }

      if ($scope.indicatorToShow == null && angular.isArray($scope.selectedIndicators)) {
        var indicatorToShowPosition = $scope.selectedIndicators.map(function (d) {
          return d.key;
        }).indexOf($scope.config.indicatorToShow);
        $scope.indicatorToShow = $scope.selectedIndicators[indicatorToShowPosition];
      }

      if ($scope.indicatorToShow) {
        if ($scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] != null && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map != null) {
          $scope.config.selectedColorSet = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map.colorSet;
        } else if ($scope.indicatorToShow.defaultColorSet) {
          $scope.config.selectedColorSet = $scope.indicatorToShow.defaultColorSet;
        }

        $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
      }

      $scope.colorDistrictsBasedOnIndicatorScale();
      $scope.changeTooltip();
      $scope.centerMap();
    };

    /**
     * fit map-view to bounds
     */
    $scope.centerMap = function () {
      if ($scope.geojson && !$scope.blToZoom) {
        $scope.map.fitBounds($scope.geojson.getBounds());
      } else if (!$scope.geojson) {
        console.warn("No geoJSON found");
      }
    };

    /**
     * Binds mouse-events and labels to each feature
     * @param feature
     * @param layer
     */
    function onEachFeature(feature, layer) {
      // overwrite Feature Properties from district
      if (!$scope.layers[$scope.config.dataLayerToShow]) return;
      var district = $scope.layers[$scope.config.dataLayerToShow].districts[feature.properties.id];
      if (district) {
        feature.properties.key = district.key;
        feature.properties.name = district.name;
        feature.properties.uid = district.uid;
      }
      layer.on({
        mouseover: highlightFeature,
        mouseout: resetHighlight,
        click: selectDistrictAndZoomToFeature
      });
      layer.bindTooltip($scope.getTooltipFromFeature(feature), {permanent: true, direction: getLabelAlignment()});
    }

    function getLabelAlignment() {
      return $scope.config.labelAlignment === 'no-background' ? 'center' : $scope.config.labelAlignment;
    }

    /**
     * apply hover style
     *
     * @param {Event} e the mouseover event
     */
    function highlightFeature(e) {
      var key = e.target.feature.properties.key;
      if (mouseOverFeatureKey === key) return;
      mouseOverFeatureKey = key;
      var layer = e.target;
      var selected = isLayerSelected(layer);
      var roundedValue = null;
      if (layer.feature.properties.value != null) {
        roundedValue = +layer.feature.properties.value.toFixed(getDecimals());
      }

      var style = DistrictStyling.getStyleForIndicatorAndValue($scope.indicatorToShow, roundedValue, $scope.config.districtOpacity, selected, true);

      if (!$scope.blToZoom) layer.setStyle(style);

      info.update(layer.feature.properties, $scope.indicatorToShow);
      if (layer.bringToFront) {
        layer.bringToFront();
      }
    }

    /**
     * reset the hover style
     *
     * @param {Event} e the mouseout event
     */
    function resetHighlight(e) {
      mouseOverFeatureKey = '';
      var layer = e.target;
      var selected = isLayerSelected(layer);

      var roundedValue = null;
      if (layer.feature.properties.value != null) {
        roundedValue = +layer.feature.properties.value.toFixed(getDecimals());
      }
      var style = DistrictStyling.getStyleForIndicatorAndValue($scope.indicatorToShow, roundedValue, $scope.config.districtOpacity, selected, false)
      if (!$scope.blToZoom) layer.setStyle(style);
      info.update();
      if (!selected && !L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
        layer.bringToBack();
      }
    }

    /**
     * get decimals from legend or default map-config
     * @returns {number|*}
     */
    function getDecimals() {
      var legend = $scope.selectedDataLayer && $scope.indicatorToShow && $scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] ? $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'] : null;
      if (legend && legend.hasOwnProperty('decimals') && legend.decimals !== null) {
        return legend.decimals;
      } else {
        return $scope.indicatorToShow.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
      }
    }

    /**
     * @param {Event} e
     */
    function selectDistrictAndZoomToFeature(e) {
      var key = e.target.feature.properties.key;
      if (districtSingleSelection) resetHighlight(e);
      if (districtSingleSelection !== key) {
        highlightFeature(e);
        districtSingleSelection = key;
        $scope.singleSelectDistrict({district: key});
      }
    }

    /**
     * Based on the selected indicator and data layer we
     * color the districts based on their indicator scale
     */
    $scope.colorDistrictsBasedOnIndicatorScale = function () {
      if (!$scope.geojson) return;
      var dataLayer = $scope.dataLayerToShow;
      var indicator = $scope.indicatorToShow;
      var selectedKeys = $scope.selectedDistricts.map(function (district) {
        return district.key;
      });

      $scope.geojson.eachLayer(function (layer) {
        var uid = layer.feature.properties.id;
        var value = null;
        if (indicator) {
          value = DataLayerService.getValueForDistrictAndIndicator(dataLayer, uid, indicator.uid);
        }

        var selected = selectedKeys.indexOf(layer.feature.properties.key) !== -1;
        var roundedValue = null;
        if (value != null) {
          roundedValue = +value.toFixed(getDecimals());
        }

        var style = DistrictStyling.getStyleForIndicatorAndValue(indicator, roundedValue, $scope.config.districtOpacity, selected, false);

        layer.setStyle(style);
        layer.feature.properties.value = roundedValue;
        if (indicator) {
          layer.feature.properties.unit = indicator.unit;
          layer.feature.properties.prefix = indicator.prefix;
          layer.feature.properties.description = dataLayer.descriptions[uid][indicator.uid];
          layer.feature.properties.indicator = indicator;
        }

        if (selected && !L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      });

      if ($scope.blToZoom) {
        zoomToBl($scope.blToZoom);
      }
    };

    /**
     * Based on the selected indicator and data layer we
     * color the districts based on their indicator scale
     */
    function clearFeatures() {
      if (!$scope.geojson) {
        return;
      }
      $scope.geojson.eachLayer(function (layer) {
        var selected = isLayerSelected(layer);
        layer.setStyle(DistrictStyling.getStyleForIndicatorAndValue(null, null, $scope.config.districtOpacity, selected, false));
        layer.feature.properties.value = undefined;
      });
    }

    /**
     * Creates Tooltip from feature-properties
     * @param feature
     * @returns {string}
     */
    $scope.getTooltipFromFeature = function (feature) {
      return getToolTipTemplate(feature.properties.key, feature.properties.name, feature.properties.value, feature.properties.unit);
    };

    /**
     * Selects explicit Indicator for this Map-Widget
     */
    $scope.selectMapIndicator = function () {
      if (!$scope.config.indicatorToShow) return;
      $scope.config.indicatorToShow.scales = UtilityService.buildIndicatorScales($scope.selectedDataLayer, $scope.config.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales, $scope.config.indicatorToShow.inverted);
      $scope.colorDistrictsBasedOnIndicatorScale();
      $scope.changeTooltip();
    };

    /**
     * Changes Shape-Tooltip
     */
    $scope.changeTooltip = function () {
      if (!$scope.geojson) return;
      var indicator = $scope.indicatorToShow,
        dataLayer = $scope.dataLayerToShow;

      $scope.geojson.eachLayer(function (layer) {
        var uid = layer.feature.properties.id;
        var value = null;
        if (indicator) {
          value = DataLayerService.getValueForDistrictAndIndicator(dataLayer, uid, indicator.uid);
        }

        var label = getToolTipTemplate(layer.feature.properties.key, layer.feature.properties.name, value, indicator ? indicator.unit : '');
        layer.getTooltip().options.direction = getLabelAlignment();
        layer.setTooltipContent(label);
        jQuery('.chart-column').on('mouseover', function () {
          var properties = {};
          properties.key = jQuery(this).data('key');
          properties.name = jQuery(this).data('district');
          properties.value = jQuery(this).data('value');
          properties.unit = jQuery(this).data('unit');
          info.update(properties);
        });
      });
    };

    /**
     * deletes all geo-layers
     */
    function clearMap() {
      if (!$scope.geojson) return;
      $scope.geojson.eachLayer(function (layer) {
        $scope.map.removeLayer(layer);
      });
    }

    var blToZoomWatcher = $scope.$watch('blToZoom', function (blKey) {
      if (!featureGroups) return;
      zoomToBl(blKey);
    });

    function zoomToBl(blKey) {
      angular.forEach(featureGroups, function (features, key) {
        if (blKey == key) {
          features.setStyle({
            fillOpacity: $scope.config.districtOpacity
          });
        } else if (!blKey) {
          features.setStyle({
            fillOpacity: $scope.config.districtOpacity
          });
        } else {
          features.setStyle({
            fillOpacity: 0.05
          });
        }
      });
      if (blKey) {
        $scope.map.fitBounds(featureGroups[blKey].getBounds());
      } else {
        $scope.map.fitBounds($scope.geojson.getBounds());
      }
    }

    /**
     * initialize Leaflet-Map
     * Adds tile-layer-control
     */
    function initializeMap() {
      jQuery($element).find('.map').height(jQuery($element).closest('.grid-stack-item-content-map').height() - 10);
      $scope.mapContainer = $element[0].querySelectorAll('.map')[0];
      $scope.map = L.map(
        $scope.mapContainer
      );

      // disable mouseScroll
      $scope.map.scrollWheelZoom.disable();

      info = L.control({position: 'topleft'});

      info.onAdd = function () {
        districtInfo = L.DomUtil.create('div', 'district-info');
        this.update();
        return districtInfo;
      };

      info.update = function (properties, indicatorToShow) {
        var legend = false;
        if (properties) {
          var content = '<div class="district-info-content"><b>' + properties.name + '</b><br />';
          if (properties.key) {
            content += '<span class="info-district-key">Schlüssel: ' + properties.key + '<br/></span>';
          }

          // legend
          if ($scope.indicatorToShow && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map']) {
            legend = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'];
          }

          // show all indicatortype values in hover
          if (mapConfig.showIndicatorTypeInMapHover && indicatorToShow != null && indicatorToShow.isDefault) {
            var setToShow = $scope.indicatorSets.filter(function (set) {
              return set.uid === indicatorToShow.type;
            })[0];

            if (angular.isArray(setToShow.indicators)) {
              content += '<span class="info-indicator-type">';
              content += setToShow.indicators.sort(function (a, b) {
                return a.listIndex - b.listIndex;
              }).map(function (indicator) {
                var value = $scope.selectedDataLayer[properties.id][indicator.uid];
                if (value == null) {
                  var description = $scope.selectedDataLayer['descriptions'][properties.id][indicator.uid] ? $scope.selectedDataLayer['descriptions'][properties.id][indicator.uid] : null;
                  return description ? indicator.name + ': ' + description : null;
                }
                var roundedValue;

                if (indicator.categorical && legend) {

                  // show label from legend instead of value for categorical indicators
                  roundedValue = legend.scales.reduce(function (accu, scale) {
                    return (value >= scale.from && value < scale.to) ? scale.text : accu;
                  }, '');
                } else if (indicator.unit === '%') {
                  //roundedValue = (legend && legend.decimals && legend.decimals !== 0 ? germanNumberFormat(',.' + legend.decimals + 'f')(value) : numberFormatRelative(value)) + '%';
                  roundedValue = germanNumberFormat(value) + '%';
                } else {
                  roundedValue = germanNumberFormat(value);
                }
                return indicator.name + ': ' + indicator.prefix + roundedValue;
              }).filter(function (value) {
                return value != null;
              }).join('<br/>');
              content += '</span>';
            }
          } else if (properties.value !== null) {
            // show only main value
            var roundedValue;
            if (properties.indicator && properties.indicator.categorical && legend) {
              // show label from legend instead of value for categorical indicators
              roundedValue = legend.scales.reduce(function (accu, scale) {
                return properties.value >= scale.from && properties.value < scale.to ? scale.text : accu;
              }, '');
            } else if (properties.unit === '%') {
              roundedValue = germanNumberFormat(properties.value) + '%';
            } else {
              roundedValue = germanNumberFormat(properties.value);
            }
            content += $scope.indicatorToShow.name + ': ' + properties.prefix + roundedValue;
          } else if (properties.description) {
            content += $scope.indicatorToShow.name + ': ' + properties.description.replace(/<(?:.|\n)*?>/gm, ''); // strip html-tags with jQuery-Function text()
          }
          content += '</div>';
          districtInfo.innerHTML = content;
        } else {
          districtInfo.innerHTML = '';
        }
      };

      info.addTo($scope.map);
    }

    /**
     * Returns Tooltip-HTML-String
     * @param {string} key
     * @param {string} name
     * @param {string} value
     * @param {string} unit
     * @returns {string}
     */
    function getToolTipTemplate(key, name, value, unit) {
      if (value != null) {
        if (unit) {
          value = numberFormat(value);
        }
        value += unit;
      } else {
        value = '';
      }

      var keyHTML = $scope.config.optionStates.showId ? '<div><b>' + key + '</b></div>' : '';
      var nameHTML = $scope.config.optionStates.showTitle ? '<div>' + name + '</div>' : '';
      var valueHTML = value && $scope.config.optionStates.showValue && $scope.config.indicatorToShow ? '<div>' + value + '</div>' : '';

      var content = keyHTML + nameHTML + valueHTML;

      return content ? '<div class="tooltip-content">' + keyHTML + nameHTML + valueHTML + '</div>' : ' ';
    }

    /**
     * checks if a given layer is currently selected
     *
     * @param {Object} layer the layer to check
     * @returns {boolean}
     */
    function isLayerSelected(layer) {
      var selectedKeys = $scope.selectedDistricts.map(function (district) {
        return district.key;
      });

      return selectedKeys.indexOf(layer.feature.properties.key) !== -1;
    }

    initializeMap();

    // cleanup watcher on destroy-event of the element
    // this is called when the gridelement is removed
    $element.on('$destroy', function () {
      dimensionWatcher();
      indicatorToShowWatcher();
      selectedIndicatorsWatcher();
      selectedColorSetWatcher();
      colorSetsWatcher();
      selectedDataLayerWatcher();
      invertedWatcher();
      selectedDistrictsWatcher();
      selectedAlignmentWatcher();
      fullscreenWatcher();
      blToZoomWatcher();
    });
  }]
);

angular.module('Itao.IndicatorMap').controller('BookmarkModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.categories = data.categories;

  $scope.newBookmark = {};

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new bookmark
   * @param {object} newBookmark object consisting of title and category id
   */
  $scope.create = function (newBookmark) {
    $uibModalInstance.close(newBookmark);
  };

}]);

window.jsPDF = window.jspdf.jsPDF;
angular.module('Itao.IndicatorMap').controller('ExportPreviewModalController', ['$scope', '$timeout', '$window', '$uibModalInstance', 'data', function ($scope, $timeout, $window, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.export = data;
  $scope.exportConfig = {};
  var grids = $scope.export.config.gridContainer.grids;
  var gridItem = grids[Object.keys(grids)[0]];

  var widgetContainer;
  var previewContainer;
  // var gridItemElement;

  if (gridItem) {
    $scope.gridConfig = gridItem;
    $scope.widgetConfig = gridItem.widget ? gridItem.widget : {};
    $scope.exportGridContainer = angular.copy($scope.export.config.gridContainer);
  }

  // defaults
  $scope.exportConfig.source = "<b>Quelle (Datenauswertung):</b> Ländermonitor Frühkindliche Bildungssysteme, www.laendermonitor.de";
  $scope.exportConfig.exportFormat = 'png';

  $timeout(function () {
    widgetContainer = angular.element(document.querySelector("#widgetContent"));
    previewContainer = angular.element(document.querySelector("#exportWidgetPreview"));
    widgetContainer.children().appendTo(previewContainer);

    $scope.widgetConfig.displayValues = true;
    $scope.widgetConfig.displayValues = false;
  });

  /**
   * Closes the modal window and returns the data for the new bookmark
   */
  $scope.exportPreview = function (exportConfig) {
    if ($scope.widgetConfig) {
      $scope.widgetConfig.displayValues = false;
    }

    console.log("exportConfig", exportConfig);

    if (exportConfig.exportFormat === 'pdf') {
      convertHtmlToPdf();
    } else {
      convertHtmlToPng();
    }
  };

  function convertHtmlToPng() {
    html2canvas(document.querySelector("#exportContent"), {
      letterRendering: 1
    }).then(function (canvas) {
      var imgData = canvas.toDataURL('image/png');

      // Create a link element and trigger a download
      var downloadLink = document.createElement('a');
      downloadLink.href = imgData;
      downloadLink.download = 'diagramm_export.png';
      downloadLink.click();

      previewContainer.children().appendTo(widgetContainer);
      $uibModalInstance.close();
    });
  }

  function convertHtmlToPdf() {
    html2canvas(document.querySelector("#exportContent"), {
      letterRendering: 1
    }).then(function (canvas) {
      var imgData = canvas.toDataURL('image/png');
      generatePDF(imgData);
    });
  }

  function generatePDF(imageData) {
    var pdf = new window.jsPDF('landscape', 'mm', 'a4'); // Portrait orientation, millimeters, A4 size
    var imgWidth = pdf.internal.pageSize.getWidth();
    var imgHeight = pdf.internal.pageSize.getHeight();

    // Set margins (adjust as needed)
    var topMargin = 0;
    var leftMargin = 10;

    // Add image with margins
    pdf.addImage(imageData, 'PNG', leftMargin, topMargin, imgWidth - 20, imgHeight - 20);

    var blob = new Blob([pdf.output('blob')], {type: 'application/pdf'});

    var downloadLink = $window.document.createElement('a');
    downloadLink.href = $window.URL.createObjectURL(blob);
    downloadLink.download = 'diagramm_export.pdf';

    // Trigger the download
    downloadLink.click();

    previewContainer.children().appendTo(widgetContainer);
    $uibModalInstance.close();
  }

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    previewContainer.children().appendTo(widgetContainer);
    if ($scope.widgetConfig) {
      $scope.widgetConfig.displayValues = false;
      $scope.widgetConfig.withoutArea = false;
    }
    $uibModalInstance.dismiss('cancel');
  };

  $scope.$watch('widgetConfig.withoutArea', function () {
    var numberOfRects = jQuery('g.feature rect').length;
    $scope.canShowValues = numberOfRects < 65;
  });
}]);

angular.module('Itao.IndicatorMap').controller('GridController', ['$scope', '$compile', 'GridItemConfig','mapConfig', function($scope, $compile, GridItemConfig, mapConfig) {
  'use strict';
  var gridstack = null;
  var defaultItem = {'x': '0', 'y': '0', 'width': '6', 'height': '1'};
  var defaultGridStackOptions = {
    cellHeight: 300,
    verticalMargin: 10,
    width: 6,
    handleClass: 'drag-handle-button',
    resizable: {
      handles: 'e, se, s, sw, w'
    }
  };

  /**
   * Adds a listener to create and append new griditems to the given container element
   * @param {jQuery} gridContainerElement container of gridstack
   */
  function registerAddListener(gridContainerElement) {
    $scope.$on('createNewWidget', function(event, data) {
      if(data.type === 'map' || data.type === 'lineChart') {
        defaultItem.height = '2';
      } else {
        defaultItem.height = '' + mapConfig.defaultGridWidgetHeight;
      }
      var gridItemConfiguration = angular.extend({}, defaultItem, data);
      var gridItemName = GridItemConfig.generateUniqueItemName();
      $scope.config.grids[gridItemName] = gridItemConfiguration;
      gridContainerElement.prepend(generateGridItemElement(gridItemName, 0));
    });
  }

  /**
   * Adds a listener to rerender the grid by the current config in the given container element
   * @param {jQuery} gridContainerElement container of gridstack
   */
  this.registerRenderListener = function(gridContainerElement) {
    var that = this;
    $scope.$on('renderGrid', function(event, data) {
      angular.forEach(gridContainerElement.children(), function(element) {
        that.removeItem(element);
      });

      angular.forEach($scope.config.grids, function(value) {
        that.removeFromCollection(value.propertyName);
      });

      $scope.config.grids = data.config.gridContainer.grids;
      renderGridFromConfig(gridContainerElement, $scope.config.grids);
    });
  };

  /**
   * Rerenders the grid by a given configuration in the container element
   * @param {jQuery} gridContainerElement container of gridstack
   * @param {Object} gridConfig Object with grid configuration
   */
  function renderGridFromConfig(gridContainerElement, gridConfig) {
    // Sort grid items for y and x, so no gaps will appear
    var sortedGridItems = GridItemConfig.sortGridConfigs(gridConfig);

    // create and append griditems as DOM elements
    angular.forEach(sortedGridItems, function(value) {
      gridContainerElement.append(generateGridItemElement(value.propertyName, 0));
    });
  }

  /**
   *
   * @param {String} gridItemName name of the griditem's property in scope.config
   * @param {Integer} autoPosition Indicates if item should auto-positioned
   * @returns {jQuery}
   */
  function generateGridItemElement(gridItemName, autoPosition) {
    return $compile('<grid-item class="grid-stack-item" grid-item-name="' + gridItemName+ '" config="config.grids.' + gridItemName + '" diagram-data="diagramData" data-gs-min-width="2" data-gs-max-width="6" data-gs-auto-position="' + autoPosition +'" select-district="selectDistrict(district)" deselect-district="deselectDistrict(district)"></grid-item>')($scope);
  }

  /**
   * Returns the gridstack height of a griditem jQuery DOM element
   * @param {jQuery} element element with gridstack attributes
   * @returns {Integer}
   */
  function getGridStackHeight(element) {
    return parseInt(element.attr('data-gs-height'));
  }

  /**
   * Initializes gridstack on a DOM element, appends griditems from configuration and set up listeners
   * @param {jQuery} gridContainerElement DOM element which should be the gridstack container
   * @param {Object} options Options to configure gridstack
   * @returns {*}
   */
  this.init = function(gridContainerElement, options) {
    var gridStackOptions = angular.extend({}, defaultGridStackOptions, options);

    // Initialize gridstack container
    gridstack = gridContainerElement.gridstack(gridStackOptions).data('gridstack');

    // Render grid from current config
    renderGridFromConfig(gridContainerElement, $scope.config.grids);

    // register listener for adding new events
    registerAddListener(gridContainerElement);
    // register listener for rerender from config
    this.registerRenderListener(gridContainerElement);

    return gridstack;
  };

  /**
   * Removes a grid item (as jQuery DOM element) from gridstack and the DOM
   * @param {jQuery} element element which should be removed
   * @returns {*}
   */
  this.removeItem = function(element) {
    if(gridstack) {
      return gridstack.removeWidget(element, true);
    }
    return null;
  };

  /**
   * Removes a griditem from the griditem configuration object by name
   * @param {String} gridItemName unique name of the griditem
   */
  this.removeFromCollection = function(gridItemName) {
    delete $scope.config.grids[gridItemName];
  };

  /**
   * Makes a DOM element inside a gridstack container to a real griditem
   * @param {jQuery} element DOM element inside a gridstack container
   * @returns {*}
   */
  this.makeWidget = function(element) {
    if(gridstack) {
      gridstack.makeWidget(element);
      return element;
    }
    return null;
  };

  /**
   * Decrements the height of a gridstack item
   * @param {jQuery} element DOM element inside a gridstack container
   */
  this.decreaseWidgetHeight = function(element) {
    var currentHeight = getGridStackHeight(element);
    if(currentHeight === 1) {
      return;
    }
    gridstack.resize(element, null, currentHeight - 1);
  };

  /**
   * Increments the height of a gridstack item
   * @param {jQuery} element DOM element inside a gridstack container
   */
  this.increaseWidgetHeight = function(element) {
    var currentHeight = getGridStackHeight(element);
    gridstack.resize(element, null, currentHeight + 1);
  };

}]);

angular.module('Itao.IndicatorMap').controller('ShareLinkModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.link = data.link;
  setTimeout(function(){
    var copyTextarea = document.querySelector('#link-to-copy');
    copyTextarea.select();
  }, 100);

  $scope.copyToClipBoard = function () {
    var copyTextarea = document.querySelector('#link-to-copy');
    copyTextarea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('unable to copy');
    }

    $uibModalInstance.close();
  };

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
}]);

angular.module('Itao.IndicatorMap').controller('TextfieldModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';

  $scope.data = data;

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new bookmark
   * @param {object} link object consisting of title and category id
   */
  $scope.create = function (link) {
    $uibModalInstance.close(link);
  };

}]);

angular.module('Itao.IndicatorMap').controller('CustomModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply data to scope so you can use the input date in your modal template
  $scope.data = data;

  /**
   * Closes the dialog as a dismiss result
   */
  $scope.close = function () {
    $uibModalInstance.dismiss();
  };

  /**
   * Closes the dialog as a close (success) result
   */
  $scope.accept = function () {
    $uibModalInstance.close();
  };

}]);

// we need to set the template base path were all templates for the
// directives are stored

var MAP_TEMPLATE_BASE_PATH = jQuery('#communeUserData').data('template-folder');
var app = angular.module('Itao.HyperionAtlas', ['Itao.IndicatorMap']);

app.config(['mapConfigProvider', 'communeConfigProvider', '$compileProvider', '$httpProvider', function (mapConfigProvider, communeConfigProvider, $compileProvider, $httpProvider) {
  'use strict';
  var communeUserData = jQuery('#communeUserData');
  $compileProvider.debugInfoEnabled(false);
  mapConfigProvider.setConfig('styling', {
    default: {
      weight: 0.5,
      opacity: 1,
      color: 'white',
      dashArray: '0',
      fillOpacity: 0.95,
      fillColor: '#ddd',
      complexColorSet: ['#23bb1e', '#2adb24', '#54e250', '#7fea7b', '#aaf1a7', '#d4f8d3']
    },
    selected: {
      weight: 0,
      color: 'black',
      dashArray: '0',
      fillColor: '#c80b2f'
    },
    hover: {
      weight: 2,
      dashArray: '0',
      fillOpacity: 1
    }
  });
  mapConfigProvider.setConfig("keyLandMapping", {
    labels: [
      {index: '08', key: 'BW', name: 'Baden-Württemberg'},
      {index: '09', key: 'BY', name: 'Bayern'},
      {index: '11', key: 'BE', name: 'Berlin'},
      {index: '12', key: 'BB', name: 'Brandenburg'},
      {index: '04', key: 'HB', name: 'Bremen'},
      {index: '02', key: 'HH', name: 'Hamburg'},
      {index: '06', key: 'HE', name: 'Hessen'},
      {index: '13', key: 'MV', name: 'Mecklenburg-Vorpommern'},
      {index: '03', key: 'NI', name: 'Niedersachsen'},
      {index: '05', key: 'NW', name: 'Nordrhein-Westfalen'},
      {index: '07', key: 'RP', name: 'Rheinland-Pfalz'},
      {index: '10', key: 'SL', name: 'Saarland'},
      {index: '14', key: 'SN', name: 'Sachsen'},
      {index: '15', key: 'ST', name: 'Sachsen-Anhalt'},
      {index: '01', key: 'SH', name: 'Schleswig-Holstein'},
      {index: '16', key: 'TH', name: 'Thüringen'}
    ],
    keys: {
      '01': {key: 'SH'},
      '02': {key: 'HH'},
      '03': {key: 'NI'},
      '04': {key: 'HB'},
      '05': {key: 'NW'},
      '06': {key: 'HE'},
      '07': {key: 'RP'},
      '08': {key: 'BW'},
      '09': {key: 'BY'},
      '10': {key: 'SL'},
      '11': {key: 'BE'},
      '12': {key: 'BB'},
      '13': {key: 'MV'},
      '14': {key: 'SN'},
      '15': {key: 'ST'},
      '16': {key: 'TH'}
    }
  });

  mapConfigProvider.setConfig('templateBasePath', MAP_TEMPLATE_BASE_PATH);
  mapConfigProvider.setConfig('registeredUserMode', angular.isNumber(communeUserData.data('user-id')));
  mapConfigProvider.setConfig('defaultSelectedClassMethod', 'width');
  mapConfigProvider.setConfig('defaultBaseLayer', 'Kein Hintergrund');
  mapConfigProvider.setConfig('widgetExport', {
    cssUrl: location.origin + '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/dist/css/hyperion.css',
    remoteUrl: 'https://export.keck-atlas.de/v1/generateImage'
  });
  mapConfigProvider.setConfig('defaultGridWidgetHeight', angular.isNumber(communeUserData.data('default-grid-widget-height')) ? communeUserData.data('default-grid-widget-height') : 1);
  mapConfigProvider.setConfig('axisMaxValue', angular.isNumber(communeUserData.data('axis-max-value')) ? communeUserData.data('axis-max-value') : null);
  if (angular.isNumber(communeUserData.data('absolute-indicators-decimal-places'))) {
    mapConfigProvider.setConfig('absoluteIndicatorsDecimalPlaces', communeUserData.data('absolute-indicators-decimal-places'));
  }
  if (angular.isNumber(communeUserData.data('relative-indicators-decimal-places'))) {
    mapConfigProvider.setConfig('relativeIndicatorsDecimalPlaces', communeUserData.data('relative-indicators-decimal-places'));
  }
  if (communeUserData.data('available-data-layer-type-uids') != null) {
    var availableDataLayerTypes = ('' + communeUserData.data('available-data-layer-type-uids')).split(',').map( Number );
    mapConfigProvider.setConfig('availableDataLayerTypeUids', availableDataLayerTypes);
    communeConfigProvider.setConfig('availableDataLayerTypeUids', availableDataLayerTypes);
  }
  if (communeUserData.data('red-lines') != null && communeUserData.data('red-lines') !== '') {
    mapConfigProvider.setConfig('redLines', ('' + communeUserData.data('red-lines')).split(';').map(function (value) {
      return +value.replace(',', '.');
    }));
  }
  if (communeUserData.data('years-to-hide') != null && communeUserData.data('years-to-hide') !== '') {
    mapConfigProvider.setConfig('yearsToHide', ('' + communeUserData.data('yearsToHide')).split(';').map(function (value) {
      return value;
    }));
  }

  mapConfigProvider.setConfig('showIndicatorTypeInMapHover', communeUserData.data('show-indicator-type-in-map-hover') === 1);

  communeConfigProvider.setConfig('communeID', communeUserData.data('commune-id'));
  communeConfigProvider.setConfig('userID', communeUserData.data('user-id'));
  communeConfigProvider.setConfig('showEditOptions', communeUserData.data('show-edit-options') === 1);
  communeConfigProvider.setConfig('published', communeUserData.data('published') === 1);
  communeConfigProvider.setConfig('selectInitialIndicator', (communeUserData.data('select-initial-indicator') === 1 && !communeUserData.data('enable-district-report')));
  communeConfigProvider.setConfig('selectInitialIndicatorSet', communeUserData.data('select-initial-indicator-set') === 1);

  var initialIndicatorUids = communeUserData.data('initial-indicator-uids');
  if (initialIndicatorUids == null) {
    initialIndicatorUids = [];
  } else if (angular.isNumber(initialIndicatorUids)) {
    initialIndicatorUids = [initialIndicatorUids];
  } else if (angular.isString(initialIndicatorUids)) {
    initialIndicatorUids = initialIndicatorUids.split(',');
  }
  communeConfigProvider.setConfig('selectInitialIndicatorUids', initialIndicatorUids);
  communeConfigProvider.setConfig('ajaxTargetPid', communeUserData.data('ajax-target-pid'));
  communeConfigProvider.setConfig('fastDownload', communeUserData.data('fast-download-url'));
  $httpProvider.interceptors.push('LoadingInterceptor');
}]);

// We need to create a controller
// which will communicate with the "webservices" to insert our sample data
app.controller('HyperionAtlasController', ['$scope', '$rootScope', '$http', '$q', '$filter', '$location', 'mapConfig', 'HyperionDataService', 'IndicatorService', 'UtilityService', 'communeConfig', 'ModalService', function ($scope, $rootScope, $http, $q, $filter, $location, mapConfig, HyperionDataService, IndicatorService, UtilityService, communeConfig, ModalService) {
  'use strict';

  /**
   * Calculates the selected data-layer by getting the last year
   * @param {Object} dataLayers data-layers to search in
   * @returns {Object} the dataLayerObject
   */
  function calculateSelectedDataLayer(dataLayers) {
    var years = Object.keys(dataLayers);

    return dataLayers['' + Math.max.apply(null, years.map(function (n) {
      return parseInt(n, 10);
    }))];
  }

  $scope.formatDecimalToTime = function (number) {
    if (!number) return '';
    var hoursAndMinutes = number.toString().split('.');
    var hours = hoursAndMinutes[0];
    var minutes = hoursAndMinutes[1] ? (hoursAndMinutes[1] / 10 * 6).toString().substr(0, 2) : '00';
    minutes = minutes.length < 2 ? minutes + '0' : minutes;

    return hours + ":" + minutes;
  };

  $scope.selectedIndicators = [];
  $scope.dataLayerIndicators = [];
  $scope.indicatorKeys = [];
  $scope.indicatorSets = [];
  $scope.years = [];
  $scope.districtKeyUidMapping = [];
  $scope.fastDownload = communeConfig.fastDownload;

  $scope.diagramData = {
    indicators: $scope.selectedIndicators,
    yearsToShow: $scope.years,
    indicatorSets: $scope.indicatorSets,
    mouseOverDistrict: null,
    mouseOverYear: null,
    mouseOverFeature: null,
    layers: {},
    colorSets: [],
    selectedDataLayer: {},
    selectedIndicatorSet: $scope.selectedIndicatorSet,
    disabledDataLayers: [],
    noDataDistricts: [],
    selectedDistricts: [],
    disabledDistrictKeys: [],
    selectedChartColorset: null
  };

  $scope.config = {
    'gridContainer': {
      'grids': {}
    },
    'selectedIndicatorIds': [],
    'selectedDistrictKeys': []
  };
  // used for resetting to the last bookmark in the public atlas when textwidgets are used
  $scope.lastLoadedBookmark = {};
  var communeData = jQuery('#communeUserData');

  var indicatorsFromCategory = communeData.data('indicators-from-category');
  var indicatorSetsFromCategory = communeData.data('indicator-sets-from-category');
  var toggleIndicatorsFromCategory = communeData.data('toggle-indicators-from-category');
  var toggleIndicatorSetsFromCategory = communeData.data('toggle-indicator-sets-from-category');
  var enableYearlyMode = communeData.data('yearly-mode');
  var urlParams = $location.search();
  var isDistrictReport = communeData.data('enable-district-report');
  var singleDataDistrict;

  if (urlParams.disabledDistricts) {
    $scope.diagramData.disabledDistrictKeys = urlParams.disabledDistricts.split('_');
  }
  if (urlParams.disabledLayers) {
    $scope.diagramData.disabledDataLayers = urlParams.disabledLayers.split('_');
  }

  var initialDataLayerType = communeData.data('selectedDataLayerTypeUid');
  var category, toggleCategory;
  // Plugin-View or Grid-View

  if ((indicatorsFromCategory || indicatorSetsFromCategory) && (initialDataLayerType || communeConfig.availableDataLayerTypeUids)) {
    if (isDistrictReport) {

      category = [95, 94, 88, 97, 96, 90, 87, 91, 89, 109, 174, 175, 176, 177, 178, 179, 180, 184, 185, 186, 187]; // ToDo: typoscript-config
      // add categories for new indicators...
      singleDataDistrict = -1; // -1 --> do not load initially
    } else {
      category = indicatorsFromCategory ? [indicatorsFromCategory] : [indicatorSetsFromCategory];

      if (toggleIndicatorsFromCategory || toggleIndicatorSetsFromCategory) {
        toggleCategory = toggleIndicatorsFromCategory ? toggleIndicatorsFromCategory : toggleIndicatorSetsFromCategory;
      }
    }

    if (urlParams && urlParams.layerType) {
      initialDataLayerType = urlParams.layerType;
    } else {
      initialDataLayerType = initialDataLayerType ? initialDataLayerType : communeConfig.availableDataLayerTypeUids[0];
    }

    // ToDo: Overview - multiple DataLayerTypes (select DL-Type - give array of selected types to function)
    var dataLayerTypeInitialPromise;
    if (communeConfig.availableDataLayerTypeUids) {
      dataLayerTypeInitialPromise = HyperionDataService.getDataLayerTypes(communeConfig.availableDataLayerTypeUids)
        .then(function (dataLayerTypes) {
          if (!dataLayerTypes) return;
          $scope.dataLayerTypes = dataLayerTypes;
        });
    } else {
      dataLayerTypeInitialPromise = HyperionDataService.getDataLayerTypes([initialDataLayerType])
        .then(function (dataLayerType) {
          if (!dataLayerType) return;
          $scope.dataLayerTypes = dataLayerType;
        });
    }

    var dataLayerInitialPromise = HyperionDataService.getDataLayersForDataLayerType(initialDataLayerType, communeData.data('filter-districts'), toggleCategory ? category.concat([toggleCategory]) : category, singleDataDistrict)
      .then(function (dataLayers) {
        $scope.layers = dataLayers;
      });

    $q.all([dataLayerInitialPromise, dataLayerTypeInitialPromise]).then(function () {
      $scope.dataLayerTypes.forEach(function (dlType) {
        if (dlType.uid == initialDataLayerType) {
          dlType.layers = $scope.layers;
          $scope.selectDataLayerType(dlType, undefined);
        }
      });
    });

    var indicatorSetsInitialPromise = false;
    if (indicatorSetsFromCategory) {
      indicatorSetsInitialPromise = HyperionDataService.getIndicatorSetsFromCategory(indicatorSetsFromCategory, toggleCategory).then(
        function (indicatorSets) {

          $scope.indicatorSets = indicatorSets;
          if (toggleCategory && indicatorSets) {
            $scope.toggleIndicatorSets = [];
            $scope.indicatorSets = $scope.indicatorSets.filter(function (indicatorSet) {
              if (indicatorSet.category == toggleCategory) {
                $scope.toggleIndicatorSets.push(indicatorSet);
                return false;
              } else {
                return true;
              }
            });
          }

          $scope.numberOfIndicatorSets = indicatorSets.length;
          return indicatorSets;
        });
    }

    var indicatorsInitialPromise = HyperionDataService.getIndicatorsFromCategory(indicatorsFromCategory ? indicatorsFromCategory : indicatorSetsFromCategory, toggleCategory)
      .then(function (indicators) {
        $scope.indicators = {};

        if (toggleCategory) {
          $scope.toggleIndicators = {};
          for (var uid in indicators) {
            var indicator = indicators[uid];
            if (indicator.category == toggleCategory) {
              $scope.toggleIndicators[uid] = indicator;
            } else {
              $scope.indicators[uid] = indicator;
            }
          }
        } else {
          $scope.indicators = indicators;
        }
        return indicators;
      });

    /**
     * get colorset in array by uid using filter
     * @param colorsetUid
     * @return {*}
     */
    var getColorsetByUid = function (colorsetUid) {
      return $scope.diagramData.colorSets.filter(function (colorset) {
        return (+colorset.uid) === (+colorsetUid);
      })[0];
    };

    /**
     * get last active layer
     * using for displaying multiple years
     * area- and line-charts need this for legend
     * @param disabledLayers
     * @return {*}
     */
    var getLastActiveLayer = function (disabledLayers) {
      if (!$scope.layers) return;
      var uids = [];
      $scope.years = [];

      for (var layerUid in $scope.layers) {
        var layer = $scope.layers[layerUid];
        //if (disabledLayers.indexOf(layer.year) === -1) { --> always use last last legend
        uids.push(layerUid);
        //}
        if ((!mapConfig.yearsToHide || (mapConfig.yearsToHide && mapConfig.yearsToHide.indexOf(layer.year+'') === -1)) && $scope.selectedIndicator && layer.indicators.indexOf($scope.selectedIndicator.uid) !== -1) {
          $scope.years.push(layer.year);
        }
      }

      return $scope.layers[uids[uids.length - 1]];
    };

    /**
     * sets the last active colorset to diagramData
     * sets override for decimals and max-axis-value from legend
     *
     * @param layer
     */
    var setLastActiveColorset = function (layer) {
      var activeLegend = getActiveLegend(layer, $scope.selectedIndicator, 'chart');

      if(activeLegend && activeLegend.disabledYears) {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers).filter(function(year) { return activeLegend.disabledYears.indexOf(parseInt(year)) === -1; });
      } else if(mapConfig.yearsToHide) {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers).filter(function(year) { return mapConfig.yearsToHide.indexOf(year) === -1; });
      } else {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers);
      }

      $scope.layers = {};
      $scope.years.forEach(function(year){
        $scope.layers[year] = $scope.selectedDataLayerType.layers[year];
      });

      if (activeLegend && +activeLegend.colorSet) {
        $scope.activeLegend = activeLegend;
        $scope.diagramData.selectedChartColorset = getColorsetByUid(activeLegend.colorSet);
        $scope.diagramData.decimalsOverride = activeLegend.decimals;
        $scope.diagramData.maxAxisValueOverride = activeLegend.maxAxisValue;
      } else if (angular.isNumber(colorsetUid)) {
        $scope.activeLegend = undefined;
        $scope.diagramData.selectedChartColorset = getColorsetByUid(colorsetUid);
        delete $scope.diagramData.decimalsOverride;
        delete $scope.diagramData.maxAxisValueOverride;
      } else {
        $scope.activeLegend = undefined;
        delete $scope.diagramData.decimalsOverride;
        delete $scope.diagramData.maxAxisValueOverride;
      }
    };

    /**
     * set active legend
     *
     * @param disabledDataLayers
     */
    var setActiveLegend = function (disabledDataLayers) {
      $scope.lastActiveLayer = getLastActiveLayer(disabledDataLayers);
      if ($scope.lastActiveLayer) {
        setLastActiveColorset($scope.lastActiveLayer);

        if (enableYearlyMode) {
          $scope.diagramData.enableYearlyMode = true;
          $scope.diagramData.selectedDistrictKey = $scope.lastActiveLayer.districts[Object.keys($scope.lastActiveLayer.districts)[0]].key;
        }
      }
    };

    $scope.toggle = false;

    /**
     * toggle indicators to show
     */
    $scope.toggleIndicatorsToShow = function () {
      if ($scope.toggle) {
        setScopeIndicators($scope.indicators, $scope.indicatorSets);
      } else {
        setScopeIndicators($scope.toggleIndicators, $scope.toggleIndicatorSets);
      }

      $scope.toggle = !$scope.toggle;
      setSubtitle();
    };

    var colorsetUid = communeData.data('selected-colorset-uid');
    //var colorSetInitialPromise = HyperionDataService.getColorSets(colorsetUid)
    var colorSetInitialPromise = HyperionDataService.getColorSets()
      .then(function (colorSets) {
        $scope.diagramData.colorSets = colorSets;
        return colorSets;
      });

    $q.all([dataLayerInitialPromise, indicatorsInitialPromise, dataLayerTypeInitialPromise, colorSetInitialPromise]).then(function () {
      var initialWidget = communeData.data('initial-widget');
      if (initialWidget) {
        $rootScope.$broadcast('createNewWidget', {
          type: initialWidget
        });
      } else {
        $rootScope.$broadcast('createNewWidget', {
          type: 'map'
        });
      }
    });

    $scope.hasToggleData = function () {
      if (!$scope.toggleIndicators || !Object.keys($scope.toggleIndicators).length || !$scope.selectedDataLayer) return false;

      for (var uid in IndicatorService.filterIndicatorsByUids($scope.toggleIndicators, $scope.selectedDataLayer.indicators, [])) {
        if ($scope.toggleIndicators[uid].hasShapeData) {
          return true;
        }
      }

      return false;
    };

    var setScopeIndicators = function (indicators, indicatorSets) {
      var indicatorUids = $scope.selectedDataLayer.indicators;

      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids(indicators, indicatorUids, []);
      $scope.selectAbleIndicators = IndicatorService.filterOutSetIndicators($scope.dataLayerIndicators);
      $scope.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, indicatorSets);
      $scope.diagramData.selectAbleIndicatorSets = $scope.selectAbleIndicatorSets;

      // find first indicator after sorting
      var selectableIndicatorsArray = Object.keys($scope.selectAbleIndicators)
        .map(function (uid) {
          return $scope.selectAbleIndicators[uid];
        })
        .sort(function (a, b) {
          var sortingValueA = 0;
          var sortingValueB = 0;

          if (a.isDefault && $scope.indicatorSets != null) {
            sortingValueA = getIndicatorSetSortingByDefaultIndicatorUid(a.uid);
          } else {
            sortingValueA = a.sorting;
          }

          if (b.isDefault && $scope.indicatorSets != null) {
            sortingValueB = getIndicatorSetSortingByDefaultIndicatorUid(b.uid);
          } else {
            sortingValueB = b.sorting;
          }

          return sortingValueA - sortingValueB;
        });

      var firstIndicatorUid = null;
      if ($scope.selectAbleIndicatorSets && $scope.selectAbleIndicatorSets[0] && $scope.selectAbleIndicatorSets[0].indicators[0]) {
        firstIndicatorUid = $scope.selectAbleIndicatorSets[0].indicators.filter(function (indicator) {
          return indicator.isDefault;
        })[0].uid;
      } else if (selectableIndicatorsArray.length > 0) {
        firstIndicatorUid = selectableIndicatorsArray[0].uid;
      }

      // deselect all
      $scope.deselectAllIndicators();

      if (communeConfig.selectInitialIndicatorUids.length > 0) {
        if (urlParams.indicator) {
          $scope.selectIndicator(urlParams.indicator);
          $scope.selectedIndicator = $scope.selectAbleIndicators[urlParams.indicator];
        } else {
          angular.forEach(communeConfig.selectInitialIndicatorUids, function (uid) {
            if ($scope.selectAbleIndicators.hasOwnProperty(uid)) {
              $scope.selectIndicator($scope.selectAbleIndicators[uid]);
              $scope.selectedIndicator = $scope.selectAbleIndicators[uid];
            }
          });
        }
      } else if (firstIndicatorUid && communeConfig.selectInitialIndicator) {
        if (urlParams.indicator) {
          $scope.selectIndicator(urlParams.indicator);
          $scope.selectedIndicator = $scope.selectAbleIndicators[urlParams.indicator];
        } else {
          $scope.selectIndicator($scope.selectAbleIndicators[firstIndicatorUid]);
          $scope.selectedIndicator = $scope.selectAbleIndicators[firstIndicatorUid];
        }
      } else if (communeConfig.selectInitialIndicatorSet && $scope.indicatorSets.length > 0) {
        if (urlParams.indicatorSet) {
          var indicatorSetToSelect = $scope.selectAbleIndicatorSets.reduce(function (acc, curr) {
            if (curr.uid == urlParams.indicatorSet) return curr;
          });
          $scope.selectIndicatorSet(indicatorSetToSelect);
          $scope.selectedIndicatorSet = indicatorSetToSelect;
        } else {
          $scope.selectIndicatorSet($scope.selectAbleIndicatorSets[0]);
          $scope.selectedIndicatorSet = $scope.selectAbleIndicatorSets[0];
        }
      }
    };

    $q.all([indicatorsInitialPromise, indicatorSetsInitialPromise, dataLayerInitialPromise, colorSetInitialPromise]).then(function () {
      $scope.indicatorSets.forEach(function (indicatorSet) {
        indicatorSet.addIndicators($scope.indicators);
        indicatorSet.populateColorSets($scope.diagramData.colorSets);
      });

      if ($scope.toggleIndicatorSets) {
        $scope.toggleIndicatorSets.forEach(function (indicatorSet) {
          indicatorSet.addIndicators($scope.toggleIndicators);
          indicatorSet.populateColorSets($scope.diagramData.colorSets);
        });
      }

      $scope.diagramData.indicatorSets = $scope.indicatorSets;

      if ($scope.selectedDataLayer && $scope.indicators && !isDistrictReport) {
        setScopeIndicators($scope.indicators, $scope.indicatorSets);

      } else {
        if (!$scope.selectedDataLayer) console.warn("No DataLayer selected");
        if (!$scope.indicators) console.warn("No indicators loaded");
      }
    });

  }

  function getIndicatorSetSortingByDefaultIndicatorUid(uid) {
    var indicatorSetSorting = 0;
    $scope.indicatorSets.forEach(function (indicatorSet) {
      if (indicatorSet.defaultIndicator && indicatorSet.defaultIndicator.uid === uid) {
        indicatorSetSorting = indicatorSet.sorting;
      }
    });
    return indicatorSetSorting;
  }

  function setSubtitle() {
    if (!$scope.selectedIndicatorSet && !$scope.selectedIndicator) return;
    var hasToggleData = $scope.hasToggleData();
    var indicatorName = $scope.selectedIndicatorSet ? $scope.selectedIndicatorSet.name : $scope.selectedIndicator.name;
    var activeLegend = getActiveLegend($scope.selectedDataLayer, $scope.selectedIndicator);

    if (activeLegend && activeLegend.indicatorSubtitle) {
      $scope.subtitle = activeLegend.indicatorSubtitle;
      return;
    }

    // begin: quick & dirty for indicators 320 & 321 & 667
    // TODO: replace this subtitle with new legend-function
    if ($scope.selectedIndicator && ($scope.selectedIndicator.uid == 320 || $scope.selectedIndicator.uid == 321) && !hasToggleData) {
      $scope.subtitle = 'KiTas ohne Horte';
      return;
    }

    // TODO: replace this subtitle with new legend-function
    if ($scope.selectedIndicator && $scope.selectedIndicator.uid == 667) {
      $scope.subtitle = 'KiTas mit Horten';
      return;
    }
    // end: quick & dirty for indicators 320 & 321 & 667

    if ($scope.toggle && hasToggleData) {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName + ', KiTas ohne Horte' : 'KiTas ohne Horte';
    } else if (!$scope.toggle && $scope.toggleIndicators) {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName + ', KiTas mit Horten' : 'KiTas mit Horten';
    } else {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName : '';
    }
  }

  /**
   * returns map- or chart-legend from data-layer and indicator
   * @param dataLayer
   * @param indicator
   * @param type
   * @return {null|*}
   */
  function getActiveLegend(dataLayer, indicator, type) {
    if (!type) {
      type = 'map';
    }

    if (dataLayer && dataLayer.legend && indicator && dataLayer.legend[indicator.uid] && dataLayer.legend[indicator.uid][type]) {
      return dataLayer.legend[indicator.uid].chart || dataLayer.legend[indicator.uid][type];
    }

    return null;
  }

  /* eslint-enable no-unused-vars */
  /**
   * Sets the current dataLayer
   * @param {object} dataLayer the datalayer to select
   */
  $scope.selectDataLayer = function (dataLayer) {
    if (!dataLayer) return;
    $scope.selectedDataLayer = dataLayer;
    $scope.config.selectedDataLayerYear = dataLayer.year;
    $scope.diagramData.selectedDataLayer = dataLayer;

    if (isDistrictReport) {
      initializeDistricts(dataLayer);
      if (dataLayer.year > 2018 && $scope.activeReportTab === 'all') {
        $scope.activeReportTab = 'kita';
        $scope.hideLower2018Report = true;
      } else if (dataLayer.year <= 2018) {
        $scope.activeReportTab = 'all';
        $scope.hideLower2018Report = false;
      }
      return;
    }

    var indicatorUids = $scope.selectedDataLayer.indicators;

    if ($scope.toggle && $scope.hasToggleData()) {
      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids($scope.toggleIndicators, indicatorUids);
      $scope.selectAbleIndicatorSets = $scope.diagramData.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, $scope.toggleIndicatorSets);
    } else {
      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids($scope.indicators, indicatorUids);
      $scope.selectAbleIndicatorSets = $scope.diagramData.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, $scope.indicatorSets);
    }

    $scope.selectAbleIndicators = $scope.diagramData.selectAbleIndicators = IndicatorService.filterOutSetIndicators($scope.dataLayerIndicators);

    if ((!indicatorSetsFromCategory && indicatorsFromCategory && angular.equals($scope.selectAbleIndicators, {})) ||
      (!indicatorsFromCategory && indicatorSetsFromCategory && !$scope.selectAbleIndicatorSets.length) ||
      (indicatorsFromCategory && indicatorSetsFromCategory && !$scope.selectAbleIndicatorSets.length && angular.equals($scope.selectAbleIndicators, {}))) {
      var years = Object.keys($scope.layers);
      var index = years.indexOf($scope.selectedDataLayer.year);
      if ($scope.selectedDataLayerType.layers) {
        delete $scope.selectedDataLayerType.layers[$scope.selectedDataLayer.year];
        delete $scope.layers[$scope.selectedDataLayer.year];
      }
      $scope.selectDataLayer($scope.layers[years[index - 1]]);
    }

    if (communeConfig.selectInitialIndicator && $scope.selectAbleIndicators && $scope.selectAbleIndicators != {}) {
      if (!$scope.selectedIndicator || !$scope.selectAbleIndicators[$scope.selectedIndicator.uid]) {
        var firstIndicatorUid = Object.keys($scope.selectAbleIndicators)[0];
        $scope.deselectAllIndicators();
        $scope.selectIndicator($scope.selectAbleIndicators[firstIndicatorUid]);
        $scope.selectedIndicator = $scope.selectAbleIndicators[firstIndicatorUid];
      } else {
        // if another DL-Type is selected - reselect indicator
        $scope.deselectAllIndicators();
        $scope.selectIndicator($scope.selectedIndicator);
      }
    } else if (communeConfig.selectInitialIndicatorSet && $scope.indicatorSets.length > 0) {
      if ($scope.selectAbleIndicatorSets.indexOf($scope.selectedIndicatorSet) === -1) {
        $scope.deselectAllIndicators();
        $scope.selectIndicatorSet($scope.selectAbleIndicatorSets[0]);
        $scope.selectedIndicatorSet = $scope.selectAbleIndicatorSets[0];
      }
    }

    initializeDistricts(dataLayer);
    setSubtitle();

    if (urlParams.blToZoom) {
      $scope.blToZoom = urlParams.blToZoom;
    }
  };

  function initializeDistricts(dataLayer) {
    if (angular.isObject(dataLayer) && dataLayer.hasOwnProperty('districts') && !isDistrictReport) {
      $scope.diagramData.selectedDistricts = [];
      $scope.diagramData.unselectedDistricts = [];
      // get all keys available in the layer
      var layerKeys = [];
      for (var districtUid in dataLayer.districts) {
        var districtKey = dataLayer.districts[districtUid].key;
        layerKeys.push(districtKey);
        $scope.districtKeyUidMapping[districtKey] = districtUid;
      }

      // remove selected keys that are not available
      var filteredSelectedKeys = $scope.config.selectedDistrictKeys.filter(function (key) {
        return layerKeys.indexOf(key) !== -1;
      });

      if (urlParams.selectedDistrict) {
        $scope.config.selectedDistrictKeys[0] = urlParams.selectedDistrict;
      } else {
        $scope.config.selectedDistrictKeys = filteredSelectedKeys;
      }
    } else if ($scope.config.selectedDistrictKeys[0]) {
      $scope.diagramData.selectedDistricts = [];
      $scope.diagramData.unselectedDistricts = [];
      if (urlParams.selectedDistrict) {
        $scope.config.selectedDistrictKeys[0] = urlParams.selectedDistrict;
      }
    }
    updateDistrictSelection($scope.config.selectedDistrictKeys);
  }

  var updateDistrictSelection = function (newSelectedDistrictKeys) {
    $scope.diagramData.selectedDistricts = [];
    $scope.diagramData.unselectedDistricts = [];
    for (var districtUid in $scope.selectedDataLayer.districts) {
      var districtKey = $scope.selectedDataLayer.districts[districtUid].key;
      if (newSelectedDistrictKeys.indexOf(districtKey) !== -1) {
        $scope.diagramData.selectedDistricts.push(angular.copy($scope.selectedDataLayer.districts[districtUid]));
      } else {
        $scope.diagramData.unselectedDistricts.push(angular.copy($scope.selectedDataLayer.districts[districtUid]));
      }
    }
  };

  $scope.toggleAtlasControl = function ($event, controlId) {
    var control = jQuery('#' + controlId);
    control.toggleClass('active');
    jQuery('.app-menu').find('.' + controlId).toggleClass('active');

    if (jQuery('.app-menu a.active').length > 0) {
      jQuery('.atlas-control-right').addClass('active');
    } else {
      jQuery('.atlas-control-right').removeClass('active');
    }
  };

  $scope.toggleControlContent = function ($event) {
    var heading = jQuery($event.currentTarget).closest('.atlas-control-group-heading');
    heading.next('.atlas-control-group-content').toggleClass('active');
    heading.toggleClass('active');
  };

  /**
   * Sets the current dataLayerType and fetches the according dataLayers
   * @param {DataLayerType} dataLayerType the data-layer-type to select
   * @param {int} singleDataDistrict
   * @returns {Promise}
   */
  $scope.selectDataLayerType = function (dataLayerType, singleDataDistrict) {
    if(isDistrictReport && !singleDataDistrict) {
      singleDataDistrict = -1;
    }

    if (!dataLayerType || ($scope.selectedDataLayerType && dataLayerType.uid === $scope.selectedDataLayerType.uid && !singleDataDistrict)) {
      return $q.when(null);
    }
    // remove all indicators on switch
    $scope.deselectAllIndicators();

    $scope.selectedDataLayerType = dataLayerType;
    $scope.config.selectedDataLayerTypeId = dataLayerType.uid;
    $scope.config.selectedDataLayerTypeName = dataLayerType.name;

    if (dataLayerType.layers && !singleDataDistrict) {
      $scope.diagramData.layers = angular.copy(dataLayerType.layers);
      $scope.layers = $scope.diagramData.layers;

      if (urlParams.year) {
        $scope.selectDataLayer($scope.layers[urlParams.year]);
      } else {
        $scope.selectDataLayer(calculateSelectedDataLayer($scope.layers));
      }
      $scope.config.selectedDataLayerYear = $scope.selectedDataLayer.year;
      $scope.diagramData.selectedDataLayer = $scope.selectedDataLayer;
    } else {
      return HyperionDataService.getDataLayersForDataLayerType(dataLayerType.uid, communeData.data('filter-districts'), toggleCategory ? category.concat([toggleCategory]) : category, singleDataDistrict)
        .then(function (dataLayers) {
          dataLayerType.layers = dataLayers;
          $scope.layers = dataLayers;
          $scope.diagramData.layers = $scope.layers;
          if (urlParams.year) {
            $scope.selectDataLayer(dataLayers[urlParams.year]);
          } else {
            $scope.selectDataLayer(calculateSelectedDataLayer(dataLayers));
          }
          $scope.config.selectedDataLayerYear = $scope.selectedDataLayer.year;
          $scope.diagramData.selectedDataLayer = $scope.selectedDataLayer;
        });
    }
  };

  function getUid(item) {
    return item.uid;
  }

  $scope.selectIndicatorSet = function (indicatorSet) {
    if (!indicatorSet) {
      console.warn("selectIndicatorSet: indicatorSet is undefined");
      return;
    }

    var defaultIndicator = indicatorSet.getDefaultIndicator();

    $scope.selectedIndicatorSet = indicatorSet;
    $scope.diagramData.selectedIndicatorSet = indicatorSet;
    $scope.selectIndicator(defaultIndicator);
  };

  $scope.selectSingleDistrict = function (district) {
    $scope.config.selectedDistrictKeys = [];
    $scope.selectDistrict(district);
  };

  /**
   * Selects another district
   * @param {string} district the indicator to set
   */
  $scope.selectDistrict = function (district) {
    if ($scope.config.selectedDistrictKeys.indexOf(district) === -1) {
      $scope.config.selectedDistrictKeys.push(district);
    }
    selectDistrictFromKeys($scope.config.selectedDistrictKeys);

    if(isDistrictReport && district) {
      $scope.selectDataLayerType($scope.selectedDataLayerType, district);
    }
  };

  $scope.deselectDistrict = function (districtKey) {
    var index = $scope.config.selectedDistrictKeys.indexOf(districtKey);
    if (index !== -1) {
      $scope.config.selectedDistrictKeys.splice(index, 1);
    }
    selectDistrictFromKeys($scope.config.selectedDistrictKeys);
  };

  function selectDistrictFromKeys(newSelectedDistrictKeys) {
    if (angular.isArray(newSelectedDistrictKeys) && angular.isObject($scope.selectedDataLayer)) {
      updateDistrictSelection(newSelectedDistrictKeys);
    }
  }

  /**
   * Sets the current indicator and build the default scale
   * @param {Indicator} indicator the indicator to set
   */
  $scope.selectIndicator = function (indicator) {
    if (!indicator) return;

    if ($scope.toggle && $scope.hasToggleData()) {
    } else if ($scope.toggle && $scope.toggleIndicators) {
      $scope.toggle = false;
    }

    if (indicator.class === 'indicator') {
      if ($scope.selectedIndicators.map(getUid).indexOf(indicator.uid) < 0) {

        $scope.selectedIndicators.push(indicator);
        if ($scope.selectedIndicators.length === 1) {
          $scope.selectedIndicator = indicator;
        }
        $scope.config.selectedIndicatorIds.push(indicator.uid);
      }
    } else if (indicator.class === 'indicator-type') {
      if ($scope.selectedIndicators.map(getUid).indexOf(indicator.defaultIndicator.uid) < 0) {
        $scope.selectedIndicators.push(indicator.defaultIndicator);
        $scope.config.selectedIndicatorIds.push(indicator.defaultIndicator.uid);
      }
    }

    setSubtitle();
    setActiveLegend($scope.diagramData.disabledDataLayers);
  };

  /**
   * Deselect an indicator
   * @param {Indicator} indicator the indicator to deselect
   */
  $scope.deselectIndicator = function (indicator) {
    var indicatorIndex = $scope.selectedIndicators.map(getUid).indexOf(indicator.uid);
    $scope.selectedIndicators.splice(indicatorIndex, 1);

    var indicatorIdIndex = $scope.config.selectedIndicatorIds.indexOf(indicator.uid);
    $scope.config.selectedIndicatorIds.splice(indicatorIdIndex, 1);

    if (!$scope.selectedIndicators.length) {
      $scope.config.selectedIndicatorUid = null;
    } else if (indicatorIndex === 0) {
      $scope.config.selectedIndicatorUid = $scope.selectedIndicators[0].uid;
    }
  };

  /**
   * Deselect all indicators
   */
  $scope.deselectAllIndicators = function () {
    if (angular.isArray($scope.selectedIndicators)) {
      $scope.selectedIndicators.splice(0, $scope.selectedIndicators.length);
    }
    if (angular.isArray($scope.config.selectedIndicatorIds)) {
      $scope.config.selectedIndicatorIds.splice(0, $scope.config.selectedIndicatorIds.length);
    }
  };
  // watch disabled layers --> get last active layer --> get last active colorset --> set to active chart color set - fallback plugin colorset

  $scope.$watchCollection('diagramData.disabledDataLayers', function (newDisabledDataLayers) {
    setActiveLegend(newDisabledDataLayers);
  });


  $scope.buildShareLink = function () {
    var link = window.location.href;
    link = link.split('#')[0]; // deletes old params

    link += "#?layerType=" + $scope.selectedDataLayer.data_layer_type;
    link += "&year=" + $scope.selectedDataLayer.year;
    if ($scope.selectedIndicatorSet) {
      link += "&indicatorSet=" + $scope.selectedIndicatorSet.uid;
    } else if ($scope.selectedIndicator) {
      link += "&indicator=" + $scope.selectedIndicator.uid;
    }

    if ($scope.diagramData.disabledDistrictKeys.length) {
      link += "&disabledDistricts=" + $scope.diagramData.disabledDistrictKeys.join('_');
    }
    if ($scope.diagramData.disabledDataLayers.length) {
      link += "&disabledLayers=" + $scope.diagramData.disabledDataLayers.join('_');
    }

    if ($scope.diagramData.selectedDistricts && $scope.diagramData.selectedDistricts[0]) {
      link += "&selectedDistrict=" + $scope.diagramData.selectedDistricts[0].key;
    }

    if ($scope.blToZoom) {
      link += "&blToZoom=" + $scope.blToZoom;
    }

    ModalService.createCustomModal({
      link: link
    }, {
      templateUrl: MAP_TEMPLATE_BASE_PATH + 'modals/shareLink.html',
      controller: 'ShareLinkModalController'
    })
      .result
      .then(function (bookmarkData) {
      })
      .catch(function (dismissReason) {
        console.log(dismissReason);
      });
  };
}]);

app.filter('highlight', ['$sce', function ($sce) {
  'use strict';
  return function (text, phrase) {
    if (phrase) {
      text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
        '<span class="highlighted">$1</span>');
    }
    return $sce.trustAsHtml(text);
  };
}]);

app.filter('numKeys', function () {
  return function (object) {
    if (!object) return;
    var keys = Object.keys(object);
    return keys.length;
  };
});

angular.module('Itao.HyperionAtlas').factory('HyperionDataService', [
  '$http',
  '$httpParamSerializerJQLike',
  'IndicatorService',
  'IndicatorCategoryService',
  'IndicatorSetService',
  'ColorSetService',
  'communeConfig',
  function ($http, $httpParamSerializerJQLike, IndicatorService, IndicatorCategoryService, IndicatorSetService, ColorSetService, communeConfig) {
    'use strict';
    //var rootUri = jQuery('#communeUserData').data('root-uri');
    var commune = communeConfig.communeID;
    var rootUri = '/de/api/';
    var publishedVersion = communeConfig.published;
    var ajaxTargetPid = 0;

    function getApiUrl(actionName, commune) {
      return rootUri + actionName + '/' + commune;
    }

    /**
     * Fetches DataLayerType data
     * @param typeUids
     * @returns {Promise} When resolved, an array of raw DataLayerTypes
     */
    function fetchDataLayerTypes(typeUids) {
      return $http
        .get(getApiUrl('listDataLayerTypes', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listDataLayerTypes',
            'arguments[commune]': commune,
            'arguments[typeUids]': typeUids ? typeUids.join(',') : '',
            'arguments[showUnpublished]': publishedVersion ? '0' : '1'
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('DataLayerTypes could not be loaded', response);
        });
    }

    /**
     * Fetches dataLayer data for a specific dataLayerTypeId
     * @param {int} dataLayerTypeUid the dataLayerType to fetch
     * @param {String} filterDistricts
     * @param indicatorCategory
     * @param {int} singleDataDistrict
     * @returns {Promise} When resolved, an array of raw DataLayers
     */
    function fetchDataLayersForType(dataLayerTypeUid, filterDistricts, indicatorCategory, singleDataDistrict) {
      return $http
        .get(getApiUrl('listDataLayers', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listDataLayers',
            'arguments[commune]': commune,
            'arguments[dataLayerType]': dataLayerTypeUid,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1',
            'arguments[filterDistricts]': filterDistricts == null ? '' : filterDistricts,
            'arguments[indicatorCategory]': indicatorCategory ? indicatorCategory.join(',') : '',
            'arguments[singleDataDistrict]': singleDataDistrict || null
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('DataLayers for Type ' + dataLayerTypeUid + ' could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicators() {
      return $http
        .get(getApiUrl('listIndicators', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicators',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Indicators could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicatorsFromCategory(category) {
      return $http
        .get(getApiUrl('listIndicatorsFromCategory', commune), {
          params: {
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorsFromCategory',
            'arguments[commune]': commune,
            'arguments[category]': category
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Indicators from Category could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicatorSetsFromCategory(category) {
      return $http
        .get(getApiUrl('listIndicatorSetsFromCategory', commune), {
          params: {
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorSetsFromCategory',
            'arguments[commune]': commune,
            'arguments[category]': category
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Sets from Category could not be loaded', response);
        });
    }

    /**
     * Fetches indicator-category data
     * @returns {Promise} When resolved, an array of raw IndicatorCategories
     */
    function fetchIndicatorCategories() {
      return $http
        .get(getApiUrl('listIndicatorCategories', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorCategories',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Categories could not be loaded', response);
        });
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function fetchIndicatorSets() {
      return $http
        .get(getApiUrl('listIndicatorSets', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorSets',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Sets could not be loaded', response);
        });
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function fetchColorSets(uid) {
      return $http
        .get(getApiUrl('listColorSets', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listColorSets',
            'arguments[commune]': commune,
            'arguments[uid]': uid
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Colorsets could not be loaded', response);
        });
    }

    /**
     * creates the Indicator objects from raw Indicator data
     * @param {Object} response the indicators as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorsToIndicators(response) {
      var indicatorObject = {};
      for (var indicatorUid in response) {
        if (response.hasOwnProperty(indicatorUid)) {
          var rawIndicator = response[indicatorUid];
          indicatorObject[indicatorUid] = IndicatorService.createIndicator(
            rawIndicator.uid,
            rawIndicator.name,
            rawIndicator.indicatorKey,
            rawIndicator.unit,
            rawIndicator.category,
            rawIndicator.type,
            rawIndicator.list,
            rawIndicator.isDefault,
            rawIndicator.defaultScale,
            rawIndicator.defaultColorSet,
            rawIndicator.indication,
            rawIndicator.hint,
            rawIndicator.source,
            rawIndicator.statement,
            rawIndicator.calculation,
            rawIndicator.defaultInvert,
            rawIndicator.class,
            rawIndicator.sorting,
            rawIndicator.categorical,
            rawIndicator.listIndex,
            rawIndicator.prefix,
            rawIndicator.redLines
          );
        }
      }
      return indicatorObject;
    }

    /**
     * creates the Indicator objects from raw Indicator data
     * @param {Object} response the indicatorCategories as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorCategoriesToIndicatorCategories(response) {
      var categoriesObject = {};
      for (var indicatorCategoryUid in response) {
        if (response.hasOwnProperty(indicatorCategoryUid)) {
          var rawIndicatorCategory = response[indicatorCategoryUid];
          categoriesObject[indicatorCategoryUid] = IndicatorCategoryService.createIndicatorCategory(
            rawIndicatorCategory.uid,
            rawIndicatorCategory.name,
            rawIndicatorCategory.parent,
            rawIndicatorCategory.class,
            rawIndicatorCategory.sorting
          );
        }
      }
      return categoriesObject;
    }

    /**
     * creates the IndicatorSet objects from raw IndicatorSet data
     * @param {Object} response the indicatorSets as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorSetsToIndicatorSets(response) {
      return response.map(function (rawIndicatorSet) {
        return IndicatorSetService.createIndicatorSet(
          rawIndicatorSet.uid,
          rawIndicatorSet.title,
          rawIndicatorSet.lists,
          rawIndicatorSet.category,
          rawIndicatorSet.class,
          rawIndicatorSet.colorSet,
          rawIndicatorSet.sorting
        );
      });
    }

    /**
     * creates the ColorSet objects from raw ColorSet data
     * @param {Object} response the indicatorSets as given by the JSON API
     * @returns {Array}
     */
    function mapRawColorSetsToColorSets(response) {
      return response.map(function (rawColorSet) {
        return ColorSetService.createColorSet(
          rawColorSet.uid,
          rawColorSet.name,
          rawColorSet.colors
        );
      });
    }

    function mapRawDataLayers(data) {
      if (!data) return {};
      return Object.keys(data).reduce(function (years, year) {
        years[year] = data[year];
        var parsedJson = years[year].geo_json ? JSON.parse(years[year].geo_json) : null;
        var keysInJson = [];
        if (parsedJson != null && parsedJson.hasOwnProperty('features')) {
          keysInJson = parsedJson.features
            .map(function (feature) {
              return feature.properties.key;
            });
        }
        years[year].districts = Object.keys(years[year].districts).reduce(function (districts, districtUid) {
          districts[districtUid] = years[year].districts[districtUid];
          districts[districtUid].hasNoGeoData = keysInJson.indexOf(districts[districtUid].key) === -1;
          return districts;
        }, {});
        return years;
      }, {});
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function convertHtml(code, context) {
      return $http
        .post(rootUri, {
          'code': code,
          'context': context
        }, {
          headers: {'Content-Type': 'application/json; charset=utf-8'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'convertHtmlToPdf'
          }
        });
    }

    return {

      /**
       * Fetches all dataLayerTypes data
       * @returns {Promise} When resolved, an array of DataLayerTypes
       */
      getDataLayerTypes: fetchDataLayerTypes,

      /**
       * Fetches dataLayer data for a specific DataLayerType object and transforms it to DataLayerTypes
       * @param {int} dataLayerTypeUid the dataLayerType to fetch
       * @param {string} filterDistricts
       * @param indicatorCategory
       * @param {int} singleDataDistrict
       * @returns {Promise} When resolved, an array of DataLayers
       */
      getDataLayersForDataLayerType: function (type, filterDistricts, indicatorCategory, singleDataDistrict) {
        return fetchDataLayersForType(type, filterDistricts, indicatorCategory, singleDataDistrict)
          .then(mapRawDataLayers);
      },

      /**
       * Fetches all indicator data and transforms it to Indicators
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicators: function () {
        return fetchIndicators()
          .then(mapRawIndicatorsToIndicators);
      },

      /**
       * Fetches all indicator from a specified Category data and transforms it to Indicators
       * @param {int} category the categoryUid
       * @param {int} toggleCategory the categoryUid
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorsFromCategory: function (category, toggleCategory) {
        return fetchIndicatorsFromCategory(toggleCategory ? category + ',' + toggleCategory : category)
          .then(mapRawIndicatorsToIndicators);
      },

      /**
       * Fetches all indicator from a specified Category data and transforms it to Indicators
       * @param {int} category the categoryUid
       * @param {int} toggleCategory the categoryUid
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorSetsFromCategory: function (category, toggleCategory) {
        return fetchIndicatorSetsFromCategory(toggleCategory ? category + ',' + toggleCategory : category)
          .then(mapRawIndicatorSetsToIndicatorSets);
      },

      /**
       * Fetches all indicator-categories data and transforms it to IndicatorCategories
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorCategories: function () {
        return fetchIndicatorCategories()
          .then(mapRawIndicatorCategoriesToIndicatorCategories);
      },

      /**
       * Fetches all indicator-sets data and transforms it to IndicatorSets
       * @returns {Promise} When resolved, an array of IndicatorSets
       */
      getIndicatorSets: function () {
        return fetchIndicatorSets()
          .then(mapRawIndicatorSetsToIndicatorSets);
      },

      /**
       * Fetches all indicator-sets data and transforms it to IndicatorSets
       * @returns {Promise} When resolved, an array of IndicatorSets
       */
      getColorSets: function (uid) {
        return fetchColorSets(uid)
          .then(mapRawColorSetsToColorSets);
      },

      /**
       *
       */
      convertHtml: function (code, context) {
        return convertHtml(code, context);
      }
    };
  }
]);

angular.module('Itao.IndicatorMap').directive('indicatorRadioGroup', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorRadioGroup.html',
    restrict: 'E',
    scope: {
      indicators: '=',
      indicatorSets: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {

      scope.openDropdown = function () {
        jQuery('#indicatorDropdown').closest('.dropdown').toggleClass('open');
      };

      scope.indicatorsToArray = function() {
        var indicatorsArray = [];
        angular.forEach(scope.indicators, function(val, key) {
          indicatorsArray.push(val);
        });
        return indicatorsArray.sort(function(a,b) {
          var sortingValueA = 0;
          var sortingValueB = 0;

          if(a.isDefault && scope.indicatorSets != null) {
            sortingValueA = getIndicatorSetSortingByDefaultIndicatorUid(a.uid);
          } else {
            sortingValueA = a.sorting;
          }

          if(b.isDefault && scope.indicatorSets != null) {
            sortingValueB = getIndicatorSetSortingByDefaultIndicatorUid(b.uid);
          } else {
            sortingValueB = b.sorting;
          }

          return sortingValueA - sortingValueB;
        });
      };

      function getIndicatorSetSortingByDefaultIndicatorUid(uid) {
        var indicatorSetSorting = 0;
        scope.indicatorSets.forEach(function(indicatorSet){
          if(indicatorSet.defaultIndicator.uid === uid) {
            indicatorSetSorting = indicatorSet.sorting;
          }
        });
        return indicatorSetSorting;
      }

      scope.selectIndicator = function (indicator) {
        if(!indicator) return;
        scope.deselectAllIndicators();
        scope.onIndicatorSelect({indicator: indicator});
        scope.selectedIndicator = indicator;
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorSelectBox', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSelectBox.html',
    restrict: 'E',
    scope: {
      indicators: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {
      scope.selectIndicator = function (indicator) {
        scope.deselectAllIndicators();
        scope.onIndicatorSelect({indicator: indicator})
      };
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorSetRadioGroup', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSetRadioGroup.html',
    restrict: 'E',
    scope: {
      indicatorSets: '=',
      selectedIndicatorSet: '=',
      onIndicatorSetSelect: '&',
      deselectAllIndicators: '&'
    },
    link: function (scope) {
      scope.openDropdown = function () {
        jQuery('#indicatorDropdown').closest('.dropdown').toggleClass('open');
      };

      scope.selectIndicatorSet = function (indicatorSet) {
        if(!indicatorSet) return;
        scope.deselectAllIndicators();
        scope.onIndicatorSetSelect({indicatorSet: indicatorSet});
      };
    }
  };
}]);

angular.module('Itao.IndicatorMap').directive('indicatorSetSelectBox', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSetSelectBox.html',
    restrict: 'E',
    scope: {
      indicatorSets: '=',
      selectedIndicatorSet: '=',
      onIndicatorSetSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {
      scope.selectIndicatorSet = function (indicatorSet) {
        scope.deselectAllIndicators();
        scope.onIndicatorSetSelect({indicatorSet: indicatorSet});
      };
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
}]);

angular.module('Itao.HyperionAtlas').factory('BookmarkService', ['$http', '$httpParamSerializerJQLike', 'communeConfig', function($http, $httpParamSerializerJQLike, communeConfig){
  'use strict';
  var communeID = communeConfig.communeID;
  var userID = communeConfig.userID;
  var publishedVersion = communeConfig.published;
  var rootUri = jQuery('#communeUserData').data('root-uri');
  var ajaxTargetPid = 0;

  /**
   * Tries parsing a string as JSON
   * @param {String} value value containing possible JSON
   * @returns {Object|String}
   */
  function parseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  /**
   * map a bookmark response to an internal bookmark object
   *
   * @param {Object} bookmark the bookmark response
   * @returns {{id: number, title: string, uri: string, category: number}}
   */
  function mapBookmark(bookmark) {
    return {
      id: bookmark.uid,
      title: bookmark.title,
      uri: generateBookmarkUri(bookmark.uid),
      category: bookmark.category,
      config: parseJSON(bookmark.config)
    };
  }

  /**
   * Returns a URL to the current atlas with the bookmark set to the given id
   *
   * @param {int} id the uid of the bookmark
   * @returns {string} the uri to the given bookmark
   */
  function generateBookmarkUri(id) {
    return window.location.protocol + '//' + window.location.host + window.location.pathname + '?tx_itaohyperion_pi0[action]=index&tx_itaohyperion_pi0[controller]=Atlas&tx_itaohyperion_pi0[bookmark]=' + id + '&tx_itaohyperion_pi0[selectedCommune]=' + communeID;
  }

  /**
   * map a bookmarkCategory response to an internal bookmarkCategory object
   *
   * @param {Object} bookmarkCategory the bookmarkCategory response
   * @returns {{id: number, title: string}}
   */
  function mapBookmarkCategory(bookmarkCategory) {
    return {
      id: bookmarkCategory.uid,
      title: bookmarkCategory.title
    };
  }

  return {
    createBookmark: function (title, categoryId, config) {

      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[bookmark]': {
            commune: communeID,
            user: userID,
            title: title,
            category: categoryId,
            config: JSON.stringify(config)
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'createBookmark'
          }
        }).then(function(response){
          return mapBookmark(response.data);
        }, function(response){
          console.warn(response);
          return null;
        });
    },
    deleteBookmark: function(bookmark) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[uid]': bookmark
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteBookmark'
          }
        });
    },
    getBookmarks: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarks',
            'arguments[commune]': communeID,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1' // only show unpublished bookmarks in internal atlas
          }
        }).then(function(response) {
          return response.data.map(mapBookmark);
        });
    },
    getAllBookmarks: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoHyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarks',
            'arguments[commune]': communeID,
            'arguments[all]': true,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1' // only show unpublished bookmarks in internal atlas
          }
        }).then(function(response) {
          return response.data.map(mapBookmark);
        });
    },
    getBookmarkCategories: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarkCategories',
            'arguments[commune]': communeID
          }
        }).then(function(response) {
          return response.data.map(mapBookmarkCategory);
        });
    }
  };

}]);

angular.module('Itao.HyperionAtlas').service('LoadingInterceptor', ['$q',
  function ($q) {
    'use strict';

    var ignoredUrls = ['items_renderer.html'];
    var openRequests = 0;
    var $overlay = jQuery('#loadingoverlay');
    var overlayTimeout;

    /**
     * check if the request/response is relevant for showing the loading overlay
     *
     * @param {object} config configObject of the request/response
     * @returns {boolean}
     */
    function isRelevant(config) {
      return ignoredUrls.indexOf(config.url) === -1;
    }


    /**
     * update the status of the loading overlay
     */
    function updateStatus() {
      if(openRequests > 0) {
        $overlay.addClass('show');
      } else {
        $overlay.removeClass('show');
      }
    }

    /**
     * update the timeout
     * this timeout is used to prevent flickering and showing the overlay for very short requests
     *
     * @param {integer} mseconds number of milliseconds to wait
     */
    function updateTimeout(mseconds) {
      if(overlayTimeout != null) {
        clearTimeout(overlayTimeout);
      }

      overlayTimeout = setTimeout(updateStatus, mseconds);

    }

    return {
      request: function (config) {
        if(isRelevant(config)) {
          openRequests++;
          updateTimeout(100);
        }
        return config;
      },
      requestError: function (rejection) {
        openRequests--;
        updateTimeout(0);
        return $q.reject(rejection);
      },
      response: function (response) {
        if(isRelevant(response.config)) {
          openRequests--;
          updateTimeout(200);
        }
        return response;
      },
      responseError: function (rejection) {
        openRequests--;
        updateTimeout(0);
        return $q.reject(rejection);
      }
    };
  }]);

angular.module('Itao.HyperionAtlas').provider('communeConfig', function () {
  'use strict';

  var config = {
    userID: null,
    communeID: null,
    published: null,
    showEditOptions: false,
    ajaxTargetPid: 0,
    selectInitialIndicator: false,
    selectInitialIndicatorSet: false,
    selectInitialIndicatorUids: []
  };
  return {
    setConfig: function (configName, value) {
      config[configName] = value;
    },
    $get: function () {
      return config;
    }
  };
});

angular.module('List', ['ui.select', 'ngRoute', 'ui.tree', 'ui.tree-filter']);

angular.module('List').config(['$routeProvider',
    function($routeProvider) {
        $routeProvider.
            when('/indikatoren', {
                templateUrl: templatePath+'IndicatorList.html',
                controller: 'IndicatorListController'
            }).
            when('/indikatoren-bereiche', {
                templateUrl: templatePath+'CategoryList.html',
                controller: 'CategoryListController'
            }).
            when('/indikatoren-sets', {
                templateUrl: templatePath+'IndicatorTypeList.html',
                controller: 'IndicatorTypeListController'
            }).
            when('/indikatoren-baum', {
                templateUrl: templatePath+'IndicatorTree.html',
                controller: 'IndicatorTreeController'
            }).
            otherwise({
                redirectTo: '/indikatoren-baum'
            });
    }
]);

// delete Cache
localStorage.removeItem('hyperionIndicatorList');
localStorage.removeItem('hyperionIndicatorTypeList');
localStorage.removeItem('hyperionIndicatorCategoryList');
localStorage.removeItem('hyperionIndicatorTree');

angular.module('List').filter("trust", ['$sce', function($sce) {
    return function(htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]);

angular.module('List').controller('CategoryListController', [
    '$scope',
    '$filter',
    '$sce',
    '$timeout',
    'DataService',
    function ($scope, $filter, $sce, $timeout, DataService) {
        $scope.loading = true;
        $scope.filters = {};
        $scope.filterCommunes = {};
        $scope.predicate = 'name';
        $scope.reverse = false;

        $scope.disabled = undefined;

        $scope.enable = function() {
            $scope.disabled = false;
        };

        $scope.disable = function() {
            $scope.disabled = true;
        };

        $scope.order = function(predicate) {
            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
            $scope.predicate = predicate;
        };

        $scope.parent = {};
        $scope.parent.selected = undefined;
        $scope.clearFilters = function() {
            $scope.filter = undefined;
            $scope.searchText = '';
            $scope.parent = {};
            $scope.parentFilter = undefined;
        };

        $scope.category = {};
        $scope.loadList = function() {
            var cache = localStorage.getItem('hyperionIndicatorCategoryList')
            if(cache) {
                var data = JSON.parse(cache);
                $scope.setData(data);
            } else {
                DataService.categoryList()
                    .then(function (data) {
                        $scope.setData(data);
                    });
            }
        };

        $scope.setData = function(data) {
            $scope.categories = data['categories'];
            $scope.parents = data['parents'];

            $scope.loading = false;
        };
}]);

angular.module('List').filter('highlight', ['$sce', function($sce) {
    return function(text, phrase) {
        if (phrase && text) text = text.replace(new RegExp('('+phrase+')', 'gi'),
            '<span class="highlighted">$1</span>');

        return $sce.trustAsHtml(text)
    }
}]);

angular.module('List').filter('propsFilter', function() {
    return function(items, props) {
        var out = [];

        if (angular.isArray(items)) {
            items.forEach(function(item) {
                var itemMatches = false;

                var keys = Object.keys(props);
                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    }
});

angular.module('List').filter('categoryFilter', function() {
    return function(indicators, category) {
        if(indicators && indicators.length) {
            var result = {};
            angular.forEach(indicators, function(indicator, key) {
                if (indicator.category && indicator.category.uid in filterCommunes) {
                    result[key] = indicator;
                }
            });

            return result;
        } else {
            return indicators;
        }
    }
});

angular.module('List').filter("trust", ['$sce', function($sce) {
    return function(htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]);

angular.module('List').controller('IndicatorListController', [
    '$scope',
    '$filter',
    '$sce',
    '$timeout',
    'DataService',
    function ($scope, $filter, $sce, $timeout, DataService) {
        $scope.loading = true;
        $scope.filters = {};
        $scope.filterCommunes = {};
        $scope.predicate = 'name';
        $scope.reverse = false;

        $scope.disabled = undefined;

        $scope.enable = function() {
            $scope.disabled = false;
        };

        $scope.disable = function() {
            $scope.disabled = true;
        };

        $scope.order = function(predicate) {
            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
            $scope.predicate = predicate;
        };
        $scope.setCategorySearchLabel = function(category) {
            //console.info(category);
            //console.info($scope.categories[category.uid].name);
            $scope.categorySearchLabel = $scope.categories[category.uid].name;
        };
        $scope.clearFilters = function() {
            $scope.filter = undefined;
            $scope.searchText = '';
            $scope.category = {};
            $scope.filterTags.tags = [];
            $scope.activeTags = undefined;
        };

        $scope.filterTags = {};
        $scope.category = {};
        $scope.filterTags.tags = [];
        $scope.activeTags = undefined;

        $scope.addTagToFilter = function(tags) {
            $scope.activeTags = {};
            angular.forEach(tags, function(tag) {
                $scope.activeTags[tag.uid] = {
                    'uid': tag.uid,
                    'title': tag.title
                };
            });
            if(Object.keys($scope.activeTags).length == 0) {
                $scope.activeTags = undefined;
            }
        };
        $scope.loadList = function() {
            var cache = localStorage.getItem('hyperionIndicatorList')
            if(cache) {
                var data = JSON.parse(cache);
                $scope.setData(data);
            } else {
                DataService.indicatorList()
                    .then(function (data) {
                        $scope.setData(data);
                    });
            }
        };

        $scope.setData = function(data) {
            $scope.indicators = data['indicators'];
            $scope.categories = data['categories'];
            $scope.tags = data['tags'];
            $scope.loading = false;
        }
}]);

angular.module('List').filter('highlight', ['$sce', function($sce) {
    return function(text, phrase) {
        if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
            '<span class="highlighted">$1</span>');

        return $sce.trustAsHtml(text)
    }
}]);

angular.module('List').filter('propsFilter', function() {
    return function(items, props) {
        var out = [];

        if (angular.isArray(items)) {
            items.forEach(function(item) {
                var itemMatches = false;

                var keys = Object.keys(props);
                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    }
});

angular.module('List').filter('categoryFilter', function() {
    return function(indicators, category) {
        if(indicators && indicators.length) {
            var result = {};
            angular.forEach(indicators, function(indicator, key) {
                if (indicator.category && indicator.category.uid in filterCommunes) {
                    result[key] = indicator;
                }
            });

            return result;
        } else {
            return indicators;
        }
    }
});

angular.module('List').controller('IndicatorTreeController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  'DataService',
  function ($scope, $filter, $sce, $timeout, DataService) {
    $scope.loading = true;

    $scope.pattern;
    $scope.treeFilter = $filter('uiTreeFilter');

    $scope.treeOptions = {
      accept: function (sourceNodeScope, destNodesScope, destIndex) {
        if (sourceNodeScope.item.class == "indicator" && !destNodesScope.item) {
          return false;
        }
        return true;
      },
      dropped: function (event) {
        console.info($scope.data);
        var index = event.dest.index,
          source = event.source.nodeScope.item,
          dest = event.dest.nodesScope.item,
          items = event.dest.nodesScope.$modelValue;
        var next = items[index + 1],
          prev = items[index - 1];

        var followingItems = {};
        angular.forEach(items, function (node, key) {
          if (source['class'] === node['class'] && key > index) {
            followingItems[key] = node;
          }
        });

        // get new Sorting
        var itemsNeedToUpdate = $scope.getNewSorting(source, prev, followingItems, items, index);
        DataService.moveItem(source, dest, next, prev, itemsNeedToUpdate).then(function () {
          event.source.nodeScope.item.parent = event.dest.nodesScope.item ? event.dest.nodesScope.item.uid : 0;
        });
      }
    };

    $scope.getNewSorting = function (source, prev, followingItems, items, index) {
      var itemsNeedToUpdate = {};
      var newSorting = prev ? parseInt(prev['sorting']) + 1 : 0;
      itemsNeedToUpdate[source['uid']] = items[index]['sorting'] = newSorting;
      angular.forEach(followingItems, function (item, index) {
        if (newSorting >= parseInt(item['sorting'])) {
          newSorting = newSorting + 1;
          itemsNeedToUpdate[item['uid']] = items[index]['sorting'] = newSorting;
        }
      });

      return itemsNeedToUpdate;
    };

    $scope.loadList = function () {
      var cache = localStorage.getItem('hyperionIndicatorTree')
      if (cache) {
        var data = JSON.parse(cache);
        $scope.setData(data);
      } else {
        DataService.indicatorTree()
          .then(function (data) {
            $scope.setData(data);
          });
      }
    };

    $scope.setData = function (data) {
      $scope.data = data;
      $scope.loading = false;
    };

    $scope.unlock = function (item) {
      DataService.setHidden(item.class, item.uid, 'unlock').then(function () {
        item.hidden = 0;
      });
    };

    $scope.lock = function (item) {
      DataService.setHidden(item.class, item.uid, 'lock').then(function () {
        item.hidden = 1;
      });
    };

    $scope.$watch('pattern', function (newValue, oldValue) {
      if (newValue != undefined) {
        if (newValue.length > 0) {
          $scope.$broadcast('angular-ui-tree:expand-all');
        } else {
          $scope.$broadcast('angular-ui-tree:collapse-all');
        }
      }
    });
  }
]);

angular.module('List').controller('IndicatorTypeListController', [
    '$scope',
    'DataService',
    function ($scope, DataService) {
        $scope.loading = true;
        $scope.loadList = function() {
            var cache = localStorage.getItem('hyperionIndicatorTypeList')
            if(cache) {
                var data = JSON.parse(cache);
                $scope.setData(data);
            } else {
                DataService.indicatorTypeList()
                    .then(function (data) {
                        $scope.setData(data);
                    });
            }
        };

        $scope.setData = function(data) {
            $scope.indicatorTypes = data['types'];
            $scope.loading = false;
        };
}]);

angular.module('List').controller('ListsController', [
    '$scope',
    '$location',
    function ($scope, $location) {
        $scope.$location = $location;
}]);

angular.module('List').directive('tabNavigation', function() {
   return {
       restrict: 'E',
       scope: {
           location: '='
       },
       templateUrl: templatePath+'directiveTabNavigation.html'
   }
});

(function(){
	'use strict';
	var app = angular.module('IndicatorStructure', ['ui.tree','ui.tree-filter']);

	app.filter("trust", ['$sce', function($sce) {
		return function(htmlCode) {
			return $sce.trustAsHtml(htmlCode);
		};
	}]);

	app.filter('getByTag', function() {
		return function(input, id) {
			var i=0, len=input.length;
			for (; i<len; i++) {
				if (+input[i].id == +id) {
					return input[i];
				}
			}
			return null;
		}
	});

	app.controller('IndicatorStructureController', ['$scope', '$filter', '$sce', '$timeout', 'DataService', function ($scope, $filter, $sce, $timeout, DataService) {
		$scope.loading = true;
		$scope.pattern;
		$scope.treeFilter = $filter('uiTreeFilter');

		$scope.availableFields = ['title'];
		$scope.supportedFields = ['title'];

		$scope.filters = {};
		$scope.filterCommunes = {};

		$scope.activeIndicator = false;
		$scope.setActiveIndicator = function(indicator) {
			if(indicator) {
				$scope.activeIndicator = indicator;
			} else {
				$scope.activeIndicator = null;
			}
		};

		$scope.deleteCommuneFilter = function(uid) {
			delete $scope.filterCommunes[uid];
		};

		$scope.deleteFilter = function(key, uid) {
			delete $scope.filters[key][uid];
			if(!Object.keys($scope.filters[key]).length) delete $scope.filters[key];
		};

		$scope.copyToCommune = function(indicator, category) {
            var confirmed;
			if(indicator.hasOwnProperty('set')) {
				confirmed = confirm('Sind Sie sicher, dass Sie das Indikator-Set "' + indicator.title + '" in den Bereich "' + category.title + '" kopieren wollen?');
				if(confirmed) {
					$scope.loading = true;
					DataService.copyToCommune(indicator.uid, category.id, 1)
						.then(function(data){
							$scope.activeIndicator = null;
							if(data == 'indicator.error.duplicatedCommuneKey') {
								$scope.addError('Ein Indikator-Set mit diesem Key existiert bereits.');
							} else {
								$scope.addSuccess('Das Indikator-Set wurde erfolgreich in die Kommune kopiert.');
							}
							$scope.loading = false;
						});
				}
			} else {
				confirmed = confirm('Sind Sie sicher, dass Sie den Indikator "' + indicator.title + '" in den Bereich "' + category.title + '" kopieren wollen?');
				if(confirmed) {
					$scope.loading = true;
					DataService.copyToCommune(indicator.uid, category.id, 0)
						.then(function(data){
							$scope.activeIndicator = null;
							if(data == 'indicator.error.duplicatedCommuneKey') {
								$scope.addError('Ein Indikator mit diesem Key existiert bereits.');
							}else {
								$scope.addSuccess('Der Indikator wurde erfolgreich in die Kommune kopiert.');
							}
							$scope.loading = false;
						});
				}
			}
		};

		$scope.countByProperty = function(property, value, actualObjectList) {
			var count = 0;
			angular.forEach(actualObjectList, function(indicator){
				if(property == 'commune') {
					if(indicator[property].uid == value) {
						count += 1;
					}
				} else if(indicator[property][value]) {
					count += 1;
				}

			});
			return count;
		};

		$scope.addError = function(error){
			$scope.error = error;
			$timeout(function(){ $scope.error = ''; }, 3000);
		};

		$scope.addSuccess = function(successMessage){
			$scope.successMessage = successMessage;
			$timeout(function(){ $scope.successMessage = ''; }, 3000);
		};

		$scope.loadList = function() {
			DataService.list()
				.then(function (data) {
					$scope.indicators = data;

					// define Tags
					var tags = {};
					var productTags = {};
					var communes = {};
					angular.forEach(data, function(indicator, key){
						angular.forEach(indicator.tags, function (tag, uid) {
							tags[uid] = tag;
						});
						angular.forEach(indicator.productTags, function (productTag, uid) {
							productTags[uid] = productTag;
						});

						if(indicator.commune) communes[indicator.commune.uid] = indicator.commune.name;
					});

					$scope.tags = tags;
					$scope.productTags = productTags;
					$scope.communes = communes;
					$scope.loading = false;
				});

			DataService.categoryTree()
				.then(function (data) {
					$scope.data = data;
					console.info(data);
				});
		};

		$scope.getFullTree = function(){
			DataService.fullTree()
				.then(function (data) {
					console.info(data);
					$scope.fullTree = data;

					// define Tags
					var tags = {};
					var productTags = {};
					var communes = {};
					angular.forEach(data, function(indicator, key){
						angular.forEach(indicator.tags, function (tag, uid) {
							tags[uid] = tag;
						});
						angular.forEach(indicator.productTags, function (productTag, uid) {
							productTags[uid] = productTag;
						});

						if(indicator.commune) communes[indicator.commune.uid] = indicator.commune.name;
					});

					$scope.tags = tags;
					$scope.productTags = productTags;
					$scope.communes = communes;
					$scope.loading = false;
				});
		};

		$scope.toggleSupport = function (propertyName) {
			return $scope.supportedFields.indexOf(propertyName) > -1 ?
				$scope.supportedFields.splice($scope.supportedFields.indexOf(propertyName), 1) :
				$scope.supportedFields.push(propertyName);
		};
	}]);

	app.filter('searchCommune', function() {
		return function(indicators, filterCommunes) {
			if(filterCommunes && Object.keys(filterCommunes).length) {
				var result = {};
				angular.forEach(indicators, function(indicator, key) {
					if (indicator.commune && indicator.commune.uid in filterCommunes) {
						result[key] = indicator;
					}
				});

				return result;
			} else {
				return indicators;
			}
		}
	})
	.filter('highlight', ['$sce', function($sce) {
		return function(text, phrase) {
			if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
				'<span class="highlighted">$1</span>');

			return $sce.trustAsHtml(text)
		}
	}]);
})();

angular.module('IndicatorType', ['dndLists', 'ui.bootstrap', 'IndicatorTree']);

angular.module('IndicatorType').factory('IndicatorTypeService', ['$http', '$httpParamSerializerJQLike', function ($http, $httpParamSerializerJQLike) {
  'use strict';

  var rootUri = '';
  var communeID = jQuery('#commune-id').data('commune-id');
  var ajaxTargetPid = 0;
  return {
    writeIndicatorType: function (indicatorType, deletedLists, deletedIndicators) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[indicatorType]': indicatorType,
          'arguments[deletedLists]': deletedLists,
          'arguments[deletedIndicators]': deletedIndicators
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'writeIndicatorType'
          }
        });
    },
    deleteIndicatorType: function (indicatorType) {
      if(!indicatorType) return;
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[indicatorType]': indicatorType
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteIndicatorType'
          }
        });
    },
    getIndicatorCategories: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorCategories',
            'arguments[commune]': communeID,
            'arguments[all]': true
          }
        }).then(function (response) {
          return response.data;
        });
    },
    getIndicatorKeys: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getIndicatorKeys',
            'arguments[commune]': communeID
          }
        }).then(function (response) {
          return response.data;
        });
    }
  }
}]);

angular.module('IndicatorType').controller('IndicatorModalController', ['$scope', '$uibModalInstance', '$filter', 'data', function($scope, $uibModalInstance, $filter, data) {
  'use strict';

  $scope.indicator = data.indicator;
  $scope.existingKeys = data.keys;
  $scope.editKey = undefined;
  if(data.indicator.edit) {
    $scope.editKey = data.indicator.key;
    $scope.backup = angular.copy($scope.indicator);
  }

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    // if editing-mode - reset the indicator-values on cancel
    if($scope.indicator.edit) {
      $scope.indicator.title = $scope.backup.title;
      $scope.indicator.key = $scope.backup.key;
      $scope.indicator.default = $scope.backup.default;
      $scope.indicator.unit = $scope.backup.unit;
    }
    $uibModalInstance.dismiss($scope.indicator);
  };

  /**
   * Closes the modal window and returns the data for the new indicator
   * @param {object} indicator object consisting of title and category id
   */
  $scope.updateIndicator = function (indicator) {
    indicator.added = true;
    $uibModalInstance.close(indicator);
  };

  $scope.validateIndicatorKey = function (key) {

  };
}]);

angular.module('IndicatorType').controller('IndicatorSetModalController', ['$scope', '$uibModalInstance', '$filter', 'data', function($scope, $uibModalInstance, $filter, data) {
  'use strict';

  $scope.indicatorSet = data.indicatorSet;
  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss($scope.indicatorSet);
  };

  /**
   * Closes the modal window and returns the data for the new indicatorSet
   * @param {object} indicatorSet object consisting of title and category id
   */
  $scope.updateIndicatorSet = function (indicatorSet) {
    indicatorSet.added = true;
    $uibModalInstance.close(indicatorSet);
  };
}]);

angular.module('IndicatorType').controller('IndicatorTypeController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  '$q',
  'IndicatorTypeService',
  'IndicatorTreeService',
  function ($scope, $filter, $sce, $timeout, $uibModal, $q, IndicatorTypeService, IndicatorTreeService) {
    var categoryPromise = IndicatorTypeService.getIndicatorCategories()
      .then(function (categories) {
        $scope.categories = categories;
        $scope.categoryTree = IndicatorTreeService.buildCategoryTree(categories);
      });
    var indicatorKeysPromise = IndicatorTypeService.getIndicatorKeys()
      .then(function (keys) {
        $scope.indicatorKeys = keys;
      });

    var indicatorType = jQuery('#indicator-type-data'),
        deletedIndicators = [],
        deletedLists = [];
    if(indicatorType.length) {
      $scope.indicatorType = indicatorType.data('indicator-type');
    } else {
      $scope.indicatorType = {
        title: '',
        indicatorTypeKey: '',
        category: {},
        list: []
      };
    }

    $scope.templates = [
      {
        type: "indicator",
        typeLabel: "Indikator",
        id: 2,
        title: '',
        key: '',
        unit: 0,
        defaultValue: 0
      },
      {
        type: "set",
        typeLabel: "Indikator Set",
        id: 1,
        indicators: []
      }
    ];

    $scope.addItem = function (index, item) {
      if (!item.added && !item.uid) {
        if (item.type === 'set') {
          $scope.openIndicatorSet(item);
        } else {
          $scope.openIndicator(item);
        }
      }
    };

    $scope.openIndicatorSet = function (indicatorSet) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorSetModal.html',
        size: 'lg',
        controller: 'IndicatorSetModalController',
        resolve: {
          data: function () {
            return {
              indicatorSet: indicatorSet
            }
          }
        }
      })
        .result
        .then(function (indicatorSet) {})
        .catch(function(indicatorSet){
          $scope.indicatorType.list.splice($scope.indicatorType.list.indexOf(indicatorSet), 1);
        });
    };

    $scope.editIndicator = function(indicator){
      indicator.edit = true;
      $scope.openIndicator(indicator);
    };

    $scope.openIndicator = function (indicator) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorModal.html',
        size: 'lg',
        controller: 'IndicatorModalController',
        backdrop  : 'static',
        resolve: {
          data: function () {
            return {
              indicator: indicator,
              keys: $scope.indicatorKeys
            }
          }
        }
      })
        .result
        .then(function (indicator) {
          if(indicator.edit) $scope.indicatorKeys.splice($scope.indicatorKeys.indexOf(indicator.key), 1);
          $scope.indicatorKeys.push(indicator.key);
          if(indicator.default) {
            // set every default-indicator to zero expect of this one
            $scope.indicatorType.list.map(function(item){
              if(item.indicators) {
                item.indicators.map(function(setIndicator){
                  setIndicator.default = false;
                })
              } else {
                item.default = false;
              }
            });
            indicator.default = true;
          }
        })
        .catch(function(indicator){
          if(!indicator.edit) deleteIndicatorFromAnyList(indicator);
          indicator.edit = false;
        });
    };

    function deleteIndicatorFromAnyList(indicator) {
      $scope.indicatorType.list.map(function(item){
        if(item.indicators) {
            item.indicators.splice(item.indicators.indexOf(indicator), 1);
        } else {
            $scope.indicatorType.list.splice($scope.indicatorType.list.indexOf(indicator), 1);
        }
      });
    }

    $scope.writeIndicatorType = function () {
      IndicatorTypeService.writeIndicatorType($scope.indicatorType, deletedLists, deletedIndicators)
        .then(function(){
          $scope.backToList();
        });
    };

    $scope.backToList = function() {
      window.location.replace(window.location.pathname);
    };

    $scope.deleteListItem = function (item, $index) {
      $scope.indicatorType.list.splice($index, 1);
      if(item.key) $scope.existingKeys.splice(item.key,1);
      if(item.uid) {
        deletedLists.push(item.uid);
        for(var i = 0; item.indicators.length > i; i++) {
          var indicator = item.indicators[i];
          if(indicator.uid && deletedIndicators.indexOf(indicator.uid) === -1) {
            deletedIndicators.push(indicator.uid);
          }
        }
      }
    };

    $scope.deleteIndicator = function (item, indicator, $index) {
      if(item.indicators) {
        item.indicators.splice($index, 1);
      } else {
        $scope.indicatorType.list.splice($index, 1);
      }

      if(indicator.uid) {
        deletedIndicators.push(indicator.uid);
      }
    };

    $scope.deleteIndicatorType = function () {
      IndicatorTypeService.deleteIndicatorType($scope.indicatorType)
        .then(function () {
          $scope.backToList();
        });
    };

    $scope.$watch('indicatorType', function (model) {
      $scope.modelAsJson = angular.toJson(model, true);
    }, true);
  }
]);

angular.module('IndicatorType').directive('indicatorType', function () {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorTypeForm.html',
    controller: 'IndicatorTypeController',
    scope: {
      indicatorType: '='
    },
    link: function (scope, element, attrs) {

    }
  };
});

angular.module('IndicatorTree', ['ui.tree', 'ui.tree-filter', 'ui.bootstrap', 'rzModule']);

angular.module('IndicatorTree').filter('highlight', ['$sce', function ($sce) {
  'use strict';
  return function (text, phrase) {
    if (phrase) {
      text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
        '<span class="highlighted">$1</span>');
    }
    return $sce.trustAsHtml(text);
  };
}]);

angular.module('IndicatorTree').config(['uiTreeFilterSettingsProvider', function (uiTreeFilterSettingsProvider) {
  uiTreeFilterSettingsProvider.addresses = ['title'];
}]);

angular.module('IndicatorTree').factory('IndicatorTreeService', function () {
  'use strict';

  /**
   * category Tree constructor
   * @param {Object} categories the categories
   * @returns {Array}
   */
  function buildCategoryTree(categories) {
    var categoriesObject = angular.copy(categories);
    return buildTreeFromFlatCategories(categoriesObject);
  }

  /**
   * IndicatorTree constructor
   * @param {Object} categories the categories
   * @returns {Array}
   */
  function buildIndicatorTree(categories) {
    var categoriesObject = angular.copy(categories);
    return filterAndSortTree(buildTreeFromFlatCategories(categoriesObject));
  }

  /**
   * Builds a tree from a flat categoriesObject
   *
   * @param {Object} categoriesObject the categories
   * @returns {Array} the tree
   */
  function buildTreeFromFlatCategories(categoriesObject) {
    var tree = [];
    for(var categoryUid in categoriesObject) {
      if(categoriesObject.hasOwnProperty(categoryUid)) {
        var category = categoriesObject[categoryUid];
        category.title = category.name;
        category.class = "category";

        var parentUid = category.parent;
        if(parentUid && categoriesObject.hasOwnProperty(parentUid)) {
          var parent = categoriesObject[parentUid];
          if(!parent.items) {
            parent.items = [];
          }
          parent.items.push(category);
          parent.items.sort(compareItemsForSorting); // sorting is done here to prevent from walking the complete tree for sorting
        } else {
          tree.push(category); // rootcategories
        }
      }
    }

    return tree;
  }

  /**
   * filter for null values
   * @param {*} item item to check
   * @returns {boolean}
   */
  function filterNull(item) {
    return item != null;
  }

  /**
   * filter empty categories and sort by 'compareItemsForSorting'
   * @param {Array} tree the tree to filter
   * @returns {Array}
   */
  function filterAndSortTree(tree) {
    for(var i= 0; i < tree.length; i++) {
      var node = tree[i];
      if(node.class === 'category') {
        if(!angular.isArray(tree[i].items)) {
          tree[i] = null; // remove category without items
        } else {
          var subItems = filterAndSortTree(node.items);
          if(subItems.length === 0) {
            tree[i] = null; // remove category with all items filtered out
          } else {
            tree[i].items = subItems;
          }
        }
      }
    }

    return tree.filter(filterNull).sort(compareItemsForSorting);
  }

  /**
   * comparefunction for sorting tree items
   * categories are sorted first, after that it`s alphabetically
   *
   * @param {Object} a first item
   * @param {Object} b second item
   * @returns {number}
   */
  function compareItemsForSorting(a, b) {
    if(a.class === 'category' && b.class !== 'category') {
      return -1;
    }
    if(a.class !== 'category' && b.class === 'category') {
      return 1;
    }
    var sortResult = 0;
    if(a.hasOwnProperty('sorting') && a.sorting != null && b.hasOwnProperty('sorting') && b.sorting != null) {
      sortResult = a.sorting - b.sorting;
    }
    if(angular.isNumber(sortResult) && sortResult !== 0) {
      return sortResult;
    } else {
      return a.title.localeCompare(b.title);
    }
  }

  return {

    /**
     * Returns the Indicator-Tree
     * @param indicators
     * @param categories
     * @param indicatorSets
     * @returns {IndicatorTree}
     */
    buildIndicatorTree: buildIndicatorTree,
    buildCategoryTree: buildCategoryTree
  }
});

angular.module('IndicatorTree').controller('IndicatorTreeController', [
  '$scope',
  '$filter',
  '$sce',
  '$uibModal',
  function ($scope, $filter, $sce, $uibModal, $q) {
    $scope.treeFilter = $filter('uiTreeFilter');
    $scope.showSelection = false;
    $scope.selectItem = function (item) {
      $scope.selectedItem = item;
      $scope.showSelection = false;
    };

    $scope.toggleSelection = function() {
      $scope.showSelection = !$scope.showSelection;
    };
  }
]);

angular.module('IndicatorTree').directive('categoryTree', function () {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorTree/CategoryTree.html',
    controller: 'IndicatorTreeController',
    scope: {
      data: '=',
      selectedItem: '='
    },
    link: function (scope) {

    }
  };
});

angular.module('LegendSettings', ['ui.bootstrap', 'textAngular']);

angular.module('LegendSettings').controller('LegendController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  'LegendService',
  '$q',
  function ($scope, $filter, $sce, $timeout, $uibModal, LegendService, $q) {
    var settings = jQuery('#settings');
    var mapLegend = settings.data('map-legend');
    var chartLegend = settings.data('chart-legend');
    var relatedMapLegends = settings.data('related-map-legends') ? settings.data('related-map-legends') : false;
    var relatedChartLegends = settings.data('related-chart-legends') ? settings.data('related-chart-legends') : false;
    var layerUid = settings.data('layer-uid');
    var colorSetPromise;
    var mapLegendPromise;
    var chartLegendPromise;
    var districtPromise;
    var indicatorTypeUid = settings.data('indicator-type');

    $scope.loading = true;
    $scope.disable = function () {
      $scope.disabled = true;
    };

    districtPromise = LegendService.getDistrictsFromLayer(layerUid)
      .then(function (data) {
        $scope.districts = data;
      });

    $scope.loadData = function () {
      if (mapLegend) {
        mapLegendPromise = LegendService.getLegend(mapLegend)
          .then(function (data) {
            $scope.mapLegend = data;
          });
      } else if (relatedMapLegends) {
        LegendService.getRelated(relatedMapLegends)
          .then(function (data) {
            $scope.relatedMapLegends = data;
          });
        mapLegendPromise = true;
      } else {
        mapLegendPromise = true;
      }

      if (chartLegend) {
        chartLegendPromise = LegendService.getLegend(chartLegend)
          .then(function (data) {
            $scope.chartLegend = data;
          });
      } else if (relatedChartLegends) {
        LegendService.getRelated(relatedChartLegends)
          .then(function (data) {
            $scope.relatedChartLegends = data;
          });
        chartLegendPromise = true;
      } else {
        chartLegendPromise = true;
      }

      colorSetPromise = LegendService.getColorSets()
        .then(function (data) {
          $scope.colorSets = data;
        });

      if (indicatorTypeUid) {
        LegendService.getIndicatorTypeLists(indicatorTypeUid)
          .then(function (data) {
            $scope.indicatorType = data;
          });
      }

      $q.all([mapLegendPromise, colorSetPromise]).then(function () {
        $scope.mapColorSet = getColorSet($scope.mapLegend);
      });

      $q.all([chartLegendPromise, colorSetPromise]).then(function () {
        $scope.chartColorSet = getColorSet($scope.chartLegend);
      });
    };

    $scope.getColorSet = function (legend) {
      return getColorSet(legend);
    };

    $scope.copyLegend = function (legendUid, type) {
      LegendService.copyLegend(legendUid, type)
        .then(function (data) {
          if (data) {
            if (type === 'map_legend') {
              mapLegend = data;
              settings.data('map-legend', data);
            } else if (type === 'chart_legend') {
              chartLegend = data;
              settings.data('chart-legend', data);
            }
          }
          $scope.loadData();
        });
    };

    function getColorSet(legend) {
      if (!legend) return;
      var colorSetId = legend.colorSet;
      var result = 0;
      if (colorSetId) {
        angular.forEach($scope.colorSets, function (colorSet) {
          if (colorSetId == colorSet.uid) {
            result = colorSet;
          }
        });
        return result;
      }
    }

    $scope.createLegend = function (type) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/LegendSettings/CreateLegend.html',
        size: 'lg',
        controller: 'LegendModalController',
        resolve: {
          data: function () {
            return {
              legend: type === 'map_legend' ? $scope.mapLegend : $scope.chartLegend,
              type: type,
              colorSets: $scope.colorSets,
              indicatorType: $scope.indicatorType,
              districts: $scope.districts
            };
          }
        }
      }).result
        .then(function (legend) {
          if (type === 'map_legend') {
            $scope.mapLegend = angular.copy(legend);
            $scope.mapColorSet = getColorSet($scope.mapLegend);
          } else {
            $scope.chartLegend = angular.copy(legend);
            $scope.chartColorSet = getColorSet($scope.chartLegend);
          }

          return LegendService.persistLegend(legend, type).then(function (newLegendUid) {
            if (type === 'map_legend') {
              mapLegend = newLegendUid;
            } else {
              chartLegend = newLegendUid;
            }
            $scope.loadData();
          });
        });
    };

    $scope.updateLegend = function (type, legend, colorSet) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/LegendSettings/CreateLegend.html',
        size: 'lg',
        controller: 'LegendModalController',
        resolve: {
          data: function () {
            return {
              legend: legend,
              type: type,
              selectedColorSet: colorSet,
              colorSets: $scope.colorSets,
              indicatorType: $scope.indicatorType,
              districts: $scope.districts
            };
          }
        }
      }).result
        .then(function (legend) {
          if (type === 'map_legend') {
            $scope.mapLegend = angular.copy(legend);
            $scope.mapColorSet = getColorSet($scope.mapLegend);
          } else {
            $scope.chartLegend = angular.copy(legend);
            $scope.chartColorSet = getColorSet($scope.chartLegend);
          }
          return LegendService.persistLegend(legend, type).then(function () {
            $scope.loadData();
          });
        });
    };

    $scope.removeLegend = function (legend, type) {
      var test = confirm('Sind Sie sicher, dass Sie die Legende löschen wollen?');
      if (test) {
        if ($scope.mapLegend && legend.uid == $scope.mapLegend.uid) {
          $scope.mapLegend = null;
          settings.data('map-legend', 0);
          mapLegend = 0;
        }
        if ($scope.chartLegend && legend.uid == $scope.chartLegend.uid) {
          $scope.chartLegend = null;
          settings.data('chart-legend', 0);
          chartLegend = 0;
        }
        LegendService.removeLegend(legend.uid, type).then(function () {
          $scope.loadData();
        });
      }
    };
  }]);

angular.module('LegendSettings').controller('LegendModalController', ['$scope', '$uibModalInstance', '$filter', '$timeout', 'data', function ($scope, $uibModalInstance, $filter, $timeout, data) {
  'use strict';
  $scope.colorSets = data.colorSets;
  $scope.legend = data.legend ? angular.copy(data.legend) : {};
  $scope.type = data.type;
  $scope.indicatorType = data.indicatorType;
  $scope.selectedColorSet = data.selectedColorSet ? data.selectedColorSet : {};
  $scope.scales = [];
  $scope.districts = data.districts;

  $scope.updateDistrictLegend = function() {
    if ($scope.legend.districtLegend && $scope.legend) {
      if(!$scope.legend.scales) {
        $scope.legend.scales = {};
      }

      angular.forEach($scope.districts, function (district, idx) {
        if(!$scope.legend.scales[idx]) {
          $scope.legend.scales[idx] = {
            text: district.key
          };
        } else {
          $scope.legend.scales[idx].text = $scope.legend.scales[idx].text ? $scope.legend.scales[idx].text : $scope.districts[idx].key;
        }
      });
    } else if ($scope.legend.districtLegend === false) {
      delete $scope.legend.scales;
    }
  };

  $scope.selectColorSet = function (colorSet) {
    $scope.selectedColorSet = colorSet;
    $scope.legend.colorSet = colorSet.uid;
  };

  $scope.hasErrors = false;

  var errorCheck = function () {
    $scope.hasErrors = jQuery('.has-error').length > 0;
  };

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $scope.legend = data.legend;
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new legend
   * @param {object} legend object consisting of title and category id
   */
  $scope.create = function (legend) {
    if (legend.districtLegend) {
      if (!Array.isArray(legend.scales)) {
        var tempScales = [];
        Object.keys(legend.scales).forEach(function (idx) {
          tempScales.push(legend.scales[idx]);
        });

        legend.scales = tempScales;
      }

      legend.scales.map(function (item, idx) {
        item.district = data.districts[idx].key;
      });
    }
    if (errorCheck()) {
      $scope.hasErrors = true;
    } else {
      $scope.hasErrors = false;
      $uibModalInstance.close(legend);
    }
  };
}]);

angular.module('LegendSettings').factory('LegendService', ['$http', '$httpParamSerializerJQLike', function ($http, $httpParamSerializerJQLike) {
  'use strict';
  var settings = jQuery('#settings');
  var rootUri = settings.data('root-uri') ? settings.data('root-uri') : '';
  var commune = settings.data('commune-id');
  var indicatorData = settings.data('indicator-data') ? settings.data('indicator-data') : 0;
  var ajaxTargetPid = 0;

  return {
    persistLegend: function (legend, type) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[data]': {
            legend: legend,
            type: type,
            indicatorData: indicatorData
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'persistLegend'
          }
        }).then(function (response) {
          return response.data;
        });
    },
    removeLegend: function (legend, type) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteLegend',
            'arguments[legendUid]': legend,
            'arguments[indicatorDataUid]': indicatorData,
            'arguments[type]': type
          }
        });
    },
    getLegend: function (id) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getLegend',
            'arguments[legendUid]': id
          }
        }).then(function (response) {
          if (response.data.uid) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    getDistrictsFromLayer: function (layerUid) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getDistrictsFromLayer',
            'arguments[layerUid]': layerUid
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    getRelated: function (ids) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getRelatedLegends',
            'arguments[legendUids]': JSON.stringify(ids)
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    copyLegend: function (uid, type) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'copyLegend',
            'arguments[legendUid]': uid,
            'arguments[indicatorDataUid]': indicatorData,
            'arguments[type]': type
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },

    /**
     * Fetches all indicator-sets data and transforms it to IndicatorSets
     * @returns {Promise} When resolved, an array of IndicatorSets
     */
    getColorSets: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listColorSets',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.map(mapColorSets);
        });
    },

    /**
     * Fetches all indicator-sets data and transforms it to IndicatorSets
     * @param {int} indicatorTypeUid
     * @returns {Promise} When resolved, an array of IndicatorSets
     */
    getIndicatorTypeLists: function (indicatorTypeUid) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorTypeLists',
            'arguments[indicatorTypeUid]': indicatorTypeUid
          }
        }).then(function (response) {
          return response.data;
        });
    }
  };

  /**
   * creates the ColorSet objects from raw ColorSet data
   * @param {Object} rawColorSet
   * @returns {Array}
   */
  function mapColorSets(rawColorSet) {
    return {
      uid: rawColorSet.uid,
      name: rawColorSet.name,
      colors: rawColorSet.colors
    }
  }
}]);

angular.module('IndicatorSearch', ['ui.bootstrap']);

angular.module('IndicatorSearch').controller('IndicatorSearchController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  '$q',
  'SearchTrackingService',
  function ($scope, $filter, $sce, $timeout, $uibModal, $q, SearchTrackingService) {
    var searchData = jQuery('#hyperionSearch').data('json');
    var trackingId = Date.now() + makeid();
    var hyphenate = createHyphenator(hyphenationPatternsDe, {hyphenChar:'|'});
    var lastWord;
    var matchedMetaTags = [];
    $scope.loading = false;

    $scope.themes = searchData.themes;
    $scope.searchItems = searchData.results;
    $scope.tags = searchData.tags;
    $scope.types = searchData.types;
    $scope.typeUids = Object.keys(searchData.types);
    $scope.searchResults = [];
    $scope.searching = false;
    var lowercaseTags = [];
    for (var i = 0; i < searchData.tags.length; i++) {
      if (searchData.tags[i]) {
        lowercaseTags.push(searchData.tags[i].toLowerCase());
      }
    }

    $scope.searchInTitle = function () {
      $scope.tag = $scope.theme = '';
      $scope.searching = false;
    };

    $scope.searchInTheme = function () {
      $scope.tag = $scope.searchWord = '';
    };

    $scope.searchInTags = function () {
      $scope.theme = $scope.searchWord = '';
    };

    $scope.resultCount = function (type) {
      return function (item) {
        return item.types && item.types.indexOf(type) !== -1;
      };
    };

    const punctationless = function(string) {
      if(!string) return '';
      return string.replace(/[.,\/#!$?%\^&\*;:{}=\-_`~()]/g, "");
    };

    function filterStopWords(string) {
      if(!string) return '';
      return string.replace(/\b(aber|abermals|abgerufen|abgerufene|abgerufener|abgerufenes|ähnlich|alle|allein|allem|allemal|allen|allenfalls|allenthalben|aller|allerdings|allerlei|alles|allesamt|allgemein|allmählich|allzu|als|alsbald|also|alt|am|an|andauernd|andere|anderem|anderen|anderer|andererseits|anderes|andern|andernfalls|anders|anerkannt|anerkannte|anerkannter|anerkanntes|angesetzt|angesetzte|angesetzter|anscheinend|anstatt|auch|auf|auffallend|aufgrund|aufs|augenscheinlich|aus|ausdrücklich|ausdrückt|ausdrückte|ausgedrückt|ausgenommen|ausgerechnet|ausnahmslos|außen|außer|außerdem|außerhalb|äußerst|bald|bei|beide|beiden|beiderlei|beides|beim|beinahe|bekannt|bekannte|bekannter|bekanntlich|bereits|besonders|besser|bestenfalls|bestimmt|beträchtlich|bevor|bezüglich|bin|bis|bisher|bislang|bist|bloß|Bsp|bzw|ca|Co|da|dabei|dadurch|dafür|dagegen|daher|dahin|damals|damit|danach|daneben|dank|danke|dann|dannen|daran|darauf|daraus|darf|darfst|darin|darüber|darum|darunter|das|dass|dasselbe|davon|davor|dazu|dein|deine|deinem|deinen|deiner|deines|dem|demgegenüber|demgemäß|demnach|demselben|den|denen|denkbar|denn|dennoch|denselben|der|derart|derartig|deren|derer|derjenige|derjenigen|derselbe|derselben|derzeit|des|deshalb|desselben|dessen|desto|deswegen|dich|die|diejenige|dies|diese|dieselbe|dieselben|diesem|diesen|dieser|dieses|diesmal|diesseits|dir|direkt|direkte|direkten|direkter|doch|dort|dorther|dorthin|drin|drüber|drunter|du|dunklen|durch|durchaus|durchweg|eben|ebenfalls|ebenso|ehe|eher|eigenen|eigenes|eigentlich|ein|eine|einem|einen|einer|einerseits|eines|einfach|einig|einige|einigem|einigen|einiger|einigermaßen|einiges|einmal|einseitig|einseitige|einseitigen|einseitiger|einst|einstmals|einzig|e. K.|entsprechend|entweder|er|ergo|erhält|erheblich|erneut|erst|ersten|es|etc|etliche|etwa|etwas|euch|euer|eure|eurem|euren|eurer|eures|falls|fast|ferner|folgende|folgenden|folgender|folgendermaßen|folgendes|folglich|förmlich|fortwährend|fraglos|frei|freie|freies|freilich|für|gab|gängig|gängige|gängigen|gängiger|gängiges|ganz|ganze|ganzem|ganzen|ganzer|ganzes|gänzlich|gar|GbR|GbdR|geehrte|geehrten|geehrter|gefälligst|gegen|gehabt|gekonnt|gelegentlich|gemacht|gemäß|gemeinhin|gemocht|genau|genommen|genügend|genug|geradezu|gern|gestrige|getan|geteilt|geteilte|getragen|gewesen|gewiss|gewisse|gewissermaßen|gewollt|geworden|ggf|gib|gibt|gleich|gleichsam|gleichwohl|gleichzeitig|glücklicherweise|GmbH|Gott sei Dank|größtenteils|Grunde|gute|guten|hab|habe|halb|hallo|halt|hast|hat|hatte|hätte|hätte|hätten|hattest|hattet|häufig|heraus|herein|heute|heutige|hier|hiermit|hiesige|hin|hinein|hingegen|hinlänglich|hinten|hinter|hinterher|hoch|höchst|höchstens|ich|ihm|ihn|ihnen|ihr|ihre|ihrem|ihren|ihrer|ihres|im|immer|immerhin|immerzu|in|indem|indessen|infolge|infolgedessen|innen|innerhalb|ins|insbesondere|insofern|insofern|inzwischen|irgend|irgendein|irgendeine|irgendjemand|irgendwann|irgendwas|irgendwen|irgendwer|irgendwie|irgendwo|ist|ja|jährig|jährige|jährigen|jähriges|je|jede|jedem|jeden|jedenfalls|jeder|jederlei|jedes|jedoch|jemals|jemand|jene|jenem|jenen|jener|jenes|jenseits|jetzt|kam|kann|kannst|kaum|kein|keine|keinem|keinen|keiner|keinerlei|keines|keines|keinesfalls|keineswegs|KG|klar|klare|klaren|klares|klein|kleinen|kleiner|kleines|konkret|konkrete|konkreten|konkreter|konkretes|können|könnt|konnte|könnte|konnten|könnten|künftig|lag|lagen|langsam|längst|längstens|lassen|laut|lediglich|leer|leicht|leider|lesen|letzten|letztendlich|letztens|letztes|letztlich|lichten|links|Ltd|mag|magst|mal|man|manche|manchem|manchen|mancher|mancherorts|manches|manchmal|mehr|mehrere|mehrfach|mein|meine|meinem|meinen|meiner|meines|meinetwegen|meist|meiste|meisten|meistens|meistenteils|meta|mich|mindestens|mir|mit|mithin|mitunter|möglich|mögliche|möglichen|möglicher|möglicherweise|möglichst|morgen|morgige|muss|müssen|musst|müsst|musste|müsste|müssten|nach|nachdem|nachher|nachhinein|nächste|nämlich|naturgemäß|natürlich|neben|nebenan|nebenbei|nein|neu|neue|neuem|neuen|neuer|neuerdings|neuerlich|neues|neulich|nicht|nichts|nichtsdestotrotz|nichtsdestoweniger|nie|niemals|niemand|nimm|nimmer|nimmt|nirgends|nirgendwo|noch|nötigenfalls|nun|nunmehr|nur|ob|oben|oberhalb|obgleich|obschon|obwohl|oder|offenbar|offenkundig|offensichtlich|oft|ohne|ohnedies|OHG|OK|partout|per|persönlich|plötzlich|praktisch|pro|quasi|recht|rechts|regelmäßig|reichlich|relativ|restlos|richtiggehend|riesig|rund|rundheraus|rundum|sämtliche|sattsam|schätzen|schätzt|schätzte|schätzten|schlechter|schlicht|schlichtweg|schließlich|schlussendlich|schnell|schon|schwerlich|schwierig|sehr|sei|seid|sein|seine|seinem|seinen|seiner|seines|seit|seitdem|Seite|Seiten|seither|selber|selbst|selbstredend|selbstverständlich|selten|seltsamerweise|sich|sicher|sicherlich|sie|siehe|sieht|sind|so|sobald|sodass|soeben|sofern|sofort|sog|sogar|solange|solch|solche|solchem|solchen|solcher|solches|soll|sollen|sollst|sollt|sollte|sollten|solltest|somit|sondern|sonders|sonst|sooft|soviel|soweit|sowie|sowieso|sowohl|sozusagen|später|spielen|startet|startete|starteten|statt|stattdessen|steht|stellenweise|stets|tat|tatsächlich|tatsächlichen|tatsächlicher|tatsächliches|teile|total|trotzdem|übel|über|überall|überallhin|überaus|überdies|überhaupt|üblicher|übrig|übrigens|um|umso|umstandshalber|umständehalber|unbedingt|unbeschreiblich|und|unerhört|ungefähr|ungemein|ungewöhnlich|ungleich|unglücklicherweise|unlängst|unmaßgeblich|unmöglich|unmögliche|unmöglichen|unmöglicher|unnötig|uns|unsagbar|unsäglich|unser|unsere|unserem|unseren|unserer|unseres|unserm|unstreitig|unten|unter|unterbrach|unterbrechen|unterhalb|unwichtig|unzweifelhaft|usw|vergleichsweise|vermutlich|viel|viele|vielen|vieler|vieles|vielfach|vielleicht|vielmals|voll|vollends|völlig|vollkommen|vollständig|vom|von|vor|voran|vorbei|vorher|vorne|vorüber|während|währenddessen|wahrscheinlich|wann|war|wäre|waren|wären|warst|warum|was|weder|weg|wegen|weidlich|weil|Weise|weiß|weitem|weiter|weitere|weiterem|weiteren|weiterer|weiteres|weiterhin|weitgehend|welche|welchem|welchen|welcher|welches|wem|wen|wenig|wenige|weniger|wenigstens|wenn|wenngleich|wer|werde|werden|werdet|weshalb|wessen|wichtig|wie|wieder|wiederum|wieso|wiewohl|will|willst|wir|wird|wirklich|wirst|wo|wodurch|wogegen|woher|wohin|wohingegen|wohl|wohlgemerkt|wohlweislich|wollen|wollt|wollte|wollten|wolltest|wolltet|womit|womöglich|woraufhin|woraus|worin|wurde|würde|würden|z. B.|zahlreich|zeitweise|ziemlich|zu|zudem|zuerst|zufolge|zugegeben|zugleich|zuletzt|zum|zumal|zumeist|zur|zurück|zusammen|zusehends|zuvor|zuweilen|zwar|zweifellos|zweifelsfrei|zweifelsohne|zwischen)\b/gi, "");
    }

    const hyphanetedRegEx = function(string) {
      var test = new RegExp(hyphenate('(' + string.split(' ').join(')|(') + ')'), 'gi');
      return test;
    };

    $scope.searchFilter = function (item) {
      if ($scope.theme && item.themes && item.themes.indexOf($scope.theme) !== -1) {
        return true;
      }

      // // not used yet
      // if ($scope.tag && item.tags.indexOf($scope.tag) !== -1) {
      //   return true;
      // }
      // if ($scope.searchWord && $scope.searchWord.length > 1 && lowercaseTags.indexOf($scope.searchWord.toLowerCase()) !== -1) {
      //   $scope.tag = $scope.tags[lowercaseTags.indexOf($scope.searchWord.toLowerCase())];
      //   $scope.searchWord = '';
      //   $scope.searchFilter(item);
      // }
      if ($scope.searchWord) {
        var workingInput = punctationless(filterStopWords($scope.searchWord)).trim();
        if (!workingInput || workingInput.length < 3) return false;
        var workingTitle = punctationless(filterStopWords(item.title)).trim();

        // console.log("-- PercentageMatching: " + item.title);
        percentageMatching(item, workingInput);

        var regexp = hyphanetedRegEx(workingTitle);
        var matches = workingInput.match(regexp);
        item.titleMatching = matches ? matches.join('').length/workingTitle.length : 0;

        if (item.tagHits > 0) return true;
        if (item.themeHits > 0) return true;
        if (item.title && workingInput && item.title.toLowerCase().indexOf(workingInput.toLowerCase()) !== -1) return true;
      }

      return false;
    };

    $scope.$watch('searchWord', function (searchWord) {
      if (!searchWord) return;
      lastWord = searchWord;

      setTimeout(function () {
        if (lastWord == searchWord) {
          SearchTrackingService.writeLog(trackingId, searchWord, $scope.theme, matchedMetaTags || []);
          matchedMetaTags = [];
        }
      }, 3000);
    });

    $scope.$watch('theme', function (theme) {
      if (!theme) return;
      SearchTrackingService.writeLog(trackingId, $scope.searchWord, theme);
    });

    function filterByMatch(input) {
      return function(string) {
        var regexp = hyphanetedRegEx(string),
          searchWord,
          searchInput = input,
          matches = searchInput.match(regexp),
          percentToHit = .65;

        if (!string) return false;

        // if (matches) console.log("MATCHES:", matches, string, regexp);
        var percentMatch = matches ? matches.join('').length / searchInput.length : false;
        // if(matches) console.log("TAG:", string, "INPUT:", searchInput, "matches: ", matches, matches.join(''), "percent: " + matches.join('').length + " / " + searchInput.length + " = ", percentMatch);
        if (matches && percentMatch > percentToHit) {
          return true;
        }
        var searchWords = searchInput.split(' ');
        for (var i = 0; i < searchWords.length; i++) {
          searchWord = searchWords[i];
          matches = searchWord.match(regexp);
          if (!matches || !string) return false;
          // if (matches) console.log("MATCHES Words:", matches, string);
          percentMatch = matches.join('').length / searchWord.length;
          if (percentMatch > percentToHit) return true;
        }
      }
    }

    // personalschlüssel
    function percentageMatching(item, input) {
      if(item.metaTags) {
        var filteredTags = item.metaTags.filter(filterByMatch(input));
        item.tagHits = filteredTags.length;
        matchedMetaTags = matchedMetaTags.concat(filteredTags);
        // if(matchedMetaTags.length) console.log("matchedMetaTags", matchedMetaTags.unique());
      } else {
        item.tagHits = 0;
      }
      item.themeHits = item.themes ? item.themes.filter(filterByMatch(input)).length : 0;
    }

    function makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }

  }]);

/**
 * This service serves as an interface how a real BookmarkService should be implemented! Do not use in Production!
 */
angular.module('IndicatorSearch').factory('SearchTrackingService', ['$http', '$httpParamSerializerJQLike', function($http, $httpParamSerializerJQLike){
  'use strict';

  var rootUri = '/de/api-search/';
  var ajaxTargetPid = 0;
  return {
    writeLog: function (trackingId, title, theme, metaTags) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[log]': {
            title: title,
            theme: theme,
            trackingId: trackingId,
            metaTags: metaTags
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        });
    }
  };
}]);

var ajaxRootUri = "";
var ajaxTargetPid = 0;

angular.module('IndicatorStructure').factory('DataService', [
  '$http',
  '$q',
  function ($http, $q) {
    'use strict';
    return {
      list: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'Indicator',
              'actionName': 'listModelJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      copyToCommune: function (indicator, category, isSet) {
        var deferred = $q.defer();
        var paramms = {
          'id': ajaxTargetPid,
          'extensionName': 'Itaohyperion',
          'pluginName': 'Pi102',
          'controllerName': 'Indicator',
          'actionName': 'copyModelToCommune',
          'arguments[indicator]': JSON.stringify(indicator),
          'arguments[category]': JSON.stringify(category)
        };
        if (isSet) {
          paramms.actionName = 'copyTypeToCommune';
        }
        $http
          .get(ajaxRootUri, {
            params: paramms
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      categoryTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorCategory',
              'actionName': 'getCategoryTreeJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      fullTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorCategory',
              'actionName': 'getFullTreeJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      tree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'Indicator',
              'actionName': 'getAtlasTreeList',
              'arguments': {
                'dataLayer': 11,
                'published': 0,
                'commune': 14
              }
            }
          })
          .success(
            function (data) {

            }
          ).error(deferred.reject);

        return deferred.promise;
      }
    };
  }
]);

/*global commune*/
var ajaxRootUri = "";
var ajaxTargetPid = 0;
angular.module('List').factory('DataService', [
  '$http',
  '$q',
  function ($http, $q) {
    'use strict';
    return {
      indicatorList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function (data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      categoryList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'CategoryListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function (data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorCategoryList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      indicatorTypeList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTypeListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorTypeList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      indicatorTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorTree', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      setHidden: function (type, uid, action) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': action,
              'arguments[type]': type,
              'arguments[uid]': uid,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            console.info(data);
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      moveItem: function(source, dest, next, prev, itemsNeedToUpdate) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': 'moveItem',
              'arguments[source][uid]': source.uid,
              'arguments[source][parent]': source.parent,
              'arguments[source][type]': source.class,
              'arguments[dest][uid]': dest ? dest.uid : 0,
              'arguments[dest][parent]': dest ? dest.parent : 0,
              'arguments[next][uid]': next ? next.uid : 0,
              'arguments[next][type]': next ? next.class : 0,
              'arguments[next][sorting]': next ? next.sorting : 0,
              'arguments[prev][uid]': prev ? prev.uid : 0,
              'arguments[prev][type]': prev ? prev.class : 0,
              'arguments[prev][sorting]': prev ? prev.sorting : 0,
              'arguments[itemsNeedToUpdate]': JSON.stringify(itemsNeedToUpdate),
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      }
    };
  }
]);
